function h(n) {
  const e = n;
  return i(e) && (typeof e.city > "u" || typeof e.city == "string") && (typeof e._city > "u" || i(e._city)) && (typeof e.country > "u" || typeof e.country == "string") && (typeof e._country > "u" || i(e._country)) && (typeof e.district > "u" || typeof e.district == "string") && (typeof e._district > "u" || i(e._district)) && (typeof e.line > "u" || Array.isArray(e.line) && e.line.every(
    (t) => typeof t == "string"
  )) && (typeof e._line > "u" || Array.isArray(e._line) && e._line.every(
    (t) => i(t)
  )) && (typeof e.period > "u" || y(e.period)) && (typeof e.postalCode > "u" || typeof e.postalCode == "string") && (typeof e._postalCode > "u" || i(e._postalCode)) && (typeof e.state > "u" || typeof e.state == "string") && (typeof e._state > "u" || i(e._state)) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || i(e._text)) && (typeof e.type > "u" || e.type === "postal" || e.type === "physical" || e.type === "both") && (typeof e._type > "u" || i(e._type)) && (typeof e.use > "u" || e.use === "home" || e.use === "work" || e.use === "temp" || e.use === "old" || e.use === "billing") && (typeof e._use > "u" || i(e._use));
}
function C(n) {
  return u(n);
}
function l(n) {
  const e = n;
  return i(e) && (typeof e.authorReference > "u" || o(e.authorReference)) && (typeof e.authorString > "u" || typeof e.authorString == "string") && (typeof e._authorString > "u" || i(e._authorString)) && typeof e.text == "string" && (typeof e._text > "u" || i(e._text)) && (typeof e.time > "u" || typeof e.time == "string") && (typeof e._time > "u" || i(e._time));
}
function g(n) {
  const e = n;
  return i(e) && (typeof e.contentType > "u" || typeof e.contentType == "string") && (typeof e._contentType > "u" || i(e._contentType)) && (typeof e.creation > "u" || typeof e.creation == "string") && (typeof e._creation > "u" || i(e._creation)) && (typeof e.data > "u" || typeof e.data == "string") && (typeof e._data > "u" || i(e._data)) && (typeof e.hash > "u" || typeof e.hash == "string") && (typeof e._hash > "u" || i(e._hash)) && (typeof e.language > "u" || typeof e.language == "string") && (typeof e._language > "u" || i(e._language)) && (typeof e.size > "u" || typeof e.size == "number") && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url));
}
function d(n) {
  const e = n;
  return i(e) && (typeof e.modifierExtension > "u" || Array.isArray(e.modifierExtension) && e.modifierExtension.every(
    (t) => B(t)
  ));
}
function r(n) {
  const e = n;
  return i(e) && (typeof e.coding > "u" || Array.isArray(e.coding) && e.coding.every(
    (t) => s(t)
  )) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || i(e._text));
}
function s(n) {
  const e = n;
  return i(e) && (typeof e.code > "u" || typeof e.code == "string") && (typeof e._code > "u" || i(e._code)) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || i(e._display)) && (typeof e.system > "u" || typeof e.system == "string") && (typeof e._system > "u" || i(e._system)) && (typeof e.userSelected > "u" || e.userSelected === !1 || e.userSelected === !0) && (typeof e._userSelected > "u" || i(e._userSelected)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function p(n) {
  const e = n;
  return i(e) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => I(t)
  ));
}
function I(n) {
  const e = n;
  return i(e) && (typeof e.period > "u" || y(e.period)) && (typeof e.rank > "u" || typeof e.rank == "number") && (typeof e.system > "u" || e.system === "phone" || e.system === "fax" || e.system === "email" || e.system === "pager" || e.system === "url" || e.system === "sms" || e.system === "other") && (typeof e._system > "u" || i(e._system)) && (typeof e.use > "u" || e.use === "home" || e.use === "work" || e.use === "temp" || e.use === "old" || e.use === "mobile") && (typeof e._use > "u" || i(e._use)) && (typeof e.value > "u" || typeof e.value == "string") && (typeof e._value > "u" || i(e._value));
}
function F(n) {
  const e = n;
  return i(e) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (e.type === "author" || e.type === "editor" || e.type === "reviewer" || e.type === "endorser") && (typeof e._type > "u" || i(e._type));
}
function H(n) {
  return u(n);
}
function mi(n) {
  const e = n;
  return i(e) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => s(t)
  )) && (typeof e.path > "u" || typeof e.path == "string") && (typeof e._path > "u" || i(e._path)) && (typeof e.searchParam > "u" || typeof e.searchParam == "string") && (typeof e._searchParam > "u" || i(e._searchParam)) && (typeof e.valueSet > "u" || typeof e.valueSet == "string") && (typeof e._valueSet > "u" || i(e._valueSet));
}
function gi(n) {
  const e = n;
  return i(e) && (typeof e.path > "u" || typeof e.path == "string") && (typeof e._path > "u" || i(e._path)) && (typeof e.searchParam > "u" || typeof e.searchParam == "string") && (typeof e._searchParam > "u" || i(e._searchParam)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || i(e._valueDateTime)) && (typeof e.valuePeriod > "u" || y(e.valuePeriod)) && (typeof e.valueDuration > "u" || _(e.valueDuration));
}
function _i(n) {
  const e = n;
  return i(e) && (e.direction === "ascending" || e.direction === "descending") && (typeof e._direction > "u" || i(e._direction)) && typeof e.path == "string" && (typeof e._path > "u" || i(e._path));
}
function D(n) {
  const e = n;
  return i(e) && (typeof e.codeFilter > "u" || Array.isArray(e.codeFilter) && e.codeFilter.every(
    (t) => mi(t)
  )) && (typeof e.dateFilter > "u" || Array.isArray(e.dateFilter) && e.dateFilter.every(
    (t) => gi(t)
  )) && (typeof e.limit > "u" || typeof e.limit == "number") && (typeof e.mustSupport > "u" || Array.isArray(e.mustSupport) && e.mustSupport.every(
    (t) => typeof t == "string"
  )) && (typeof e._mustSupport > "u" || Array.isArray(e._mustSupport) && e._mustSupport.every(
    (t) => i(t)
  )) && (typeof e.profile > "u" || Array.isArray(e.profile) && e.profile.every(
    (t) => typeof t == "string"
  )) && (typeof e._profile > "u" || Array.isArray(e._profile) && e._profile.every(
    (t) => i(t)
  )) && (typeof e.sort > "u" || Array.isArray(e.sort) && e.sort.every(
    (t) => _i(t)
  )) && (typeof e.subjectCodeableConcept > "u" || r(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || o(e.subjectReference)) && typeof e.type == "string" && (typeof e._type > "u" || i(e._type));
}
function M(n) {
  return u(n);
}
function Ai(n) {
  const e = n;
  return i(e) && (typeof e.doseRange > "u" || v(e.doseRange)) && (typeof e.doseQuantity > "u" || u(e.doseQuantity)) && (typeof e.rateRatio > "u" || b(e.rateRatio)) && (typeof e.rateRange > "u" || v(e.rateRange)) && (typeof e.rateQuantity > "u" || u(e.rateQuantity)) && (typeof e.type > "u" || r(e.type));
}
function E(n) {
  const e = n;
  return d(e) && (typeof e.additionalInstruction > "u" || Array.isArray(e.additionalInstruction) && e.additionalInstruction.every(
    (t) => r(t)
  )) && (typeof e.asNeededBoolean > "u" || e.asNeededBoolean === !1 || e.asNeededBoolean === !0) && (typeof e._asNeededBoolean > "u" || i(e._asNeededBoolean)) && (typeof e.asNeededCodeableConcept > "u" || r(e.asNeededCodeableConcept)) && (typeof e.doseAndRate > "u" || Array.isArray(e.doseAndRate) && e.doseAndRate.every(
    (t) => Ai(t)
  )) && (typeof e.maxDosePerAdministration > "u" || u(e.maxDosePerAdministration)) && (typeof e.maxDosePerLifetime > "u" || u(e.maxDosePerLifetime)) && (typeof e.maxDosePerPeriod > "u" || b(e.maxDosePerPeriod)) && (typeof e.method > "u" || r(e.method)) && (typeof e.patientInstruction > "u" || typeof e.patientInstruction == "string") && (typeof e._patientInstruction > "u" || i(e._patientInstruction)) && (typeof e.route > "u" || r(e.route)) && (typeof e.sequence > "u" || typeof e.sequence == "number") && (typeof e.site > "u" || r(e.site)) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || i(e._text)) && (typeof e.timing > "u" || A(e.timing));
}
function _(n) {
  return u(n);
}
function i(n) {
  const e = n;
  return (e !== null && typeof e == "object" || typeof e == "function") && (typeof e.extension > "u" || Array.isArray(e.extension) && e.extension.every(
    (t) => B(t)
  )) && (typeof e.id > "u" || typeof e.id == "string") && (typeof e._id > "u" || i(e._id));
}
function bi(n) {
  const e = n;
  return i(e) && typeof e.path == "string" && (typeof e._path > "u" || i(e._path)) && (e.type === "value" || e.type === "exists" || e.type === "pattern" || e.type === "type" || e.type === "profile") && (typeof e._type > "u" || i(e._type));
}
function Ii(n) {
  const e = n;
  return i(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.discriminator > "u" || Array.isArray(e.discriminator) && e.discriminator.every(
    (t) => bi(t)
  )) && (typeof e.ordered > "u" || e.ordered === !1 || e.ordered === !0) && (typeof e._ordered > "u" || i(e._ordered)) && (e.rules === "closed" || e.rules === "open" || e.rules === "openAtEnd") && (typeof e._rules > "u" || i(e._rules));
}
function hi(n) {
  const e = n;
  return i(e) && typeof e.max == "string" && (typeof e._max > "u" || i(e._max)) && typeof e.min == "number" && typeof e.path == "string" && (typeof e._path > "u" || i(e._path));
}
function wi(n) {
  const e = n;
  return i(e) && (typeof e.aggregation > "u" || Array.isArray(e.aggregation) && e.aggregation.every(
    (t) => t === "contained" || t === "referenced" || t === "bundled"
  )) && (typeof e._aggregation > "u" || Array.isArray(e._aggregation) && e._aggregation.every(
    (t) => i(t)
  )) && typeof e.code == "string" && (typeof e._code > "u" || i(e._code)) && (typeof e.profile > "u" || Array.isArray(e.profile) && e.profile.every(
    (t) => typeof t == "string"
  )) && (typeof e._profile > "u" || Array.isArray(e._profile) && e._profile.every(
    (t) => i(t)
  )) && (typeof e.targetProfile > "u" || Array.isArray(e.targetProfile) && e.targetProfile.every(
    (t) => typeof t == "string"
  )) && (typeof e._targetProfile > "u" || Array.isArray(e._targetProfile) && e._targetProfile.every(
    (t) => i(t)
  )) && (typeof e.versioning > "u" || e.versioning === "either" || e.versioning === "independent" || e.versioning === "specific") && (typeof e._versioning > "u" || i(e._versioning));
}
function Ri(n) {
  const e = n;
  return i(e) && typeof e.label == "string" && (typeof e._label > "u" || i(e._label)) && (typeof e.valueBase64Binary > "u" || typeof e.valueBase64Binary == "string") && (typeof e._valueBase64Binary > "u" || i(e._valueBase64Binary)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean)) && (typeof e.valueCanonical > "u" || typeof e.valueCanonical == "string") && (typeof e._valueCanonical > "u" || i(e._valueCanonical)) && (typeof e.valueCode > "u" || typeof e.valueCode == "string") && (typeof e._valueCode > "u" || i(e._valueCode)) && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || i(e._valueDate)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || i(e._valueDateTime)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueId > "u" || typeof e.valueId == "string") && (typeof e._valueId > "u" || i(e._valueId)) && (typeof e.valueInstant > "u" || typeof e.valueInstant == "string") && (typeof e._valueInstant > "u" || i(e._valueInstant)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueMarkdown > "u" || typeof e.valueMarkdown == "string") && (typeof e._valueMarkdown > "u" || i(e._valueMarkdown)) && (typeof e.valueOid > "u" || typeof e.valueOid == "string") && (typeof e._valueOid > "u" || i(e._valueOid)) && (typeof e.valuePositiveInt > "u" || typeof e.valuePositiveInt == "number") && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || i(e._valueTime)) && (typeof e.valueUnsignedInt > "u" || typeof e.valueUnsignedInt == "number") && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || i(e._valueUri)) && (typeof e.valueUrl > "u" || typeof e.valueUrl == "string") && (typeof e._valueUrl > "u" || i(e._valueUrl)) && (typeof e.valueUuid > "u" || typeof e.valueUuid == "string") && (typeof e._valueUuid > "u" || i(e._valueUuid)) && (typeof e.valueAddress > "u" || h(e.valueAddress)) && (typeof e.valueAge > "u" || C(e.valueAge)) && (typeof e.valueAnnotation > "u" || l(e.valueAnnotation)) && (typeof e.valueAttachment > "u" || g(e.valueAttachment)) && (typeof e.valueCodeableConcept > "u" || r(e.valueCodeableConcept)) && (typeof e.valueCoding > "u" || s(e.valueCoding)) && (typeof e.valueContactPoint > "u" || I(e.valueContactPoint)) && (typeof e.valueCount > "u" || H(e.valueCount)) && (typeof e.valueDistance > "u" || M(e.valueDistance)) && (typeof e.valueDuration > "u" || _(e.valueDuration)) && (typeof e.valueHumanName > "u" || S(e.valueHumanName)) && (typeof e.valueIdentifier > "u" || a(e.valueIdentifier)) && (typeof e.valueMoney > "u" || c(e.valueMoney)) && (typeof e.valuePeriod > "u" || y(e.valuePeriod)) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueRange > "u" || v(e.valueRange)) && (typeof e.valueRatio > "u" || b(e.valueRatio)) && (typeof e.valueReference > "u" || o(e.valueReference)) && (typeof e.valueSampledData > "u" || x(e.valueSampledData)) && (typeof e.valueSignature > "u" || O(e.valueSignature)) && (typeof e.valueTiming > "u" || A(e.valueTiming)) && (typeof e.valueContactDetail > "u" || p(e.valueContactDetail)) && (typeof e.valueContributor > "u" || F(e.valueContributor)) && (typeof e.valueDataRequirement > "u" || D(e.valueDataRequirement)) && (typeof e.valueExpression > "u" || R(e.valueExpression)) && (typeof e.valueParameterDefinition > "u" || P(e.valueParameterDefinition)) && (typeof e.valueRelatedArtifact > "u" || w(e.valueRelatedArtifact)) && (typeof e.valueTriggerDefinition > "u" || T(e.valueTriggerDefinition)) && (typeof e.valueUsageContext > "u" || m(e.valueUsageContext)) && (typeof e.valueDosage > "u" || E(e.valueDosage)) && (typeof e.valueMeta > "u" || j(e.valueMeta));
}
function Ci(n) {
  const e = n;
  return i(e) && (typeof e.expression > "u" || typeof e.expression == "string") && (typeof e._expression > "u" || i(e._expression)) && typeof e.human == "string" && (typeof e._human > "u" || i(e._human)) && typeof e.key == "string" && (typeof e._key > "u" || i(e._key)) && (typeof e.requirements > "u" || typeof e.requirements == "string") && (typeof e._requirements > "u" || i(e._requirements)) && (e.severity === "error" || e.severity === "warning") && (typeof e._severity > "u" || i(e._severity)) && (typeof e.source > "u" || typeof e.source == "string") && (typeof e._source > "u" || i(e._source)) && (typeof e.xpath > "u" || typeof e.xpath == "string") && (typeof e._xpath > "u" || i(e._xpath));
}
function Di(n) {
  const e = n;
  return i(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (e.strength === "required" || e.strength === "extensible" || e.strength === "preferred" || e.strength === "example") && (typeof e._strength > "u" || i(e._strength)) && (typeof e.valueSet > "u" || typeof e.valueSet == "string") && (typeof e._valueSet > "u" || i(e._valueSet));
}
function Si(n) {
  const e = n;
  return i(e) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment)) && typeof e.identity == "string" && (typeof e._identity > "u" || i(e._identity)) && (typeof e.language > "u" || typeof e.language == "string") && (typeof e._language > "u" || i(e._language)) && typeof e.map == "string" && (typeof e._map > "u" || i(e._map));
}
function qn(n) {
  const e = n;
  return d(e) && (typeof e.alias > "u" || Array.isArray(e.alias) && e.alias.every(
    (t) => typeof t == "string"
  )) && (typeof e._alias > "u" || Array.isArray(e._alias) && e._alias.every(
    (t) => i(t)
  )) && (typeof e.base > "u" || hi(e.base)) && (typeof e.binding > "u" || Di(e.binding)) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => s(t)
  )) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment)) && (typeof e.condition > "u" || Array.isArray(e.condition) && e.condition.every(
    (t) => typeof t == "string"
  )) && (typeof e._condition > "u" || Array.isArray(e._condition) && e._condition.every(
    (t) => i(t)
  )) && (typeof e.constraint > "u" || Array.isArray(e.constraint) && e.constraint.every(
    (t) => Ci(t)
  )) && (typeof e.contentReference > "u" || typeof e.contentReference == "string") && (typeof e._contentReference > "u" || i(e._contentReference)) && (typeof e.defaultValueBase64Binary > "u" || typeof e.defaultValueBase64Binary == "string") && (typeof e._defaultValueBase64Binary > "u" || i(e._defaultValueBase64Binary)) && (typeof e.defaultValueBoolean > "u" || e.defaultValueBoolean === !1 || e.defaultValueBoolean === !0) && (typeof e._defaultValueBoolean > "u" || i(e._defaultValueBoolean)) && (typeof e.defaultValueCanonical > "u" || typeof e.defaultValueCanonical == "string") && (typeof e._defaultValueCanonical > "u" || i(e._defaultValueCanonical)) && (typeof e.defaultValueCode > "u" || typeof e.defaultValueCode == "string") && (typeof e._defaultValueCode > "u" || i(e._defaultValueCode)) && (typeof e.defaultValueDate > "u" || typeof e.defaultValueDate == "string") && (typeof e._defaultValueDate > "u" || i(e._defaultValueDate)) && (typeof e.defaultValueDateTime > "u" || typeof e.defaultValueDateTime == "string") && (typeof e._defaultValueDateTime > "u" || i(e._defaultValueDateTime)) && (typeof e.defaultValueDecimal > "u" || typeof e.defaultValueDecimal == "number") && (typeof e.defaultValueId > "u" || typeof e.defaultValueId == "string") && (typeof e._defaultValueId > "u" || i(e._defaultValueId)) && (typeof e.defaultValueInstant > "u" || typeof e.defaultValueInstant == "string") && (typeof e._defaultValueInstant > "u" || i(e._defaultValueInstant)) && (typeof e.defaultValueInteger > "u" || typeof e.defaultValueInteger == "number") && (typeof e.defaultValueMarkdown > "u" || typeof e.defaultValueMarkdown == "string") && (typeof e._defaultValueMarkdown > "u" || i(e._defaultValueMarkdown)) && (typeof e.defaultValueOid > "u" || typeof e.defaultValueOid == "string") && (typeof e._defaultValueOid > "u" || i(e._defaultValueOid)) && (typeof e.defaultValuePositiveInt > "u" || typeof e.defaultValuePositiveInt == "number") && (typeof e.defaultValueString > "u" || typeof e.defaultValueString == "string") && (typeof e._defaultValueString > "u" || i(e._defaultValueString)) && (typeof e.defaultValueTime > "u" || typeof e.defaultValueTime == "string") && (typeof e._defaultValueTime > "u" || i(e._defaultValueTime)) && (typeof e.defaultValueUnsignedInt > "u" || typeof e.defaultValueUnsignedInt == "number") && (typeof e.defaultValueUri > "u" || typeof e.defaultValueUri == "string") && (typeof e._defaultValueUri > "u" || i(e._defaultValueUri)) && (typeof e.defaultValueUrl > "u" || typeof e.defaultValueUrl == "string") && (typeof e._defaultValueUrl > "u" || i(e._defaultValueUrl)) && (typeof e.defaultValueUuid > "u" || typeof e.defaultValueUuid == "string") && (typeof e._defaultValueUuid > "u" || i(e._defaultValueUuid)) && (typeof e.defaultValueAddress > "u" || h(e.defaultValueAddress)) && (typeof e.defaultValueAge > "u" || C(e.defaultValueAge)) && (typeof e.defaultValueAnnotation > "u" || l(e.defaultValueAnnotation)) && (typeof e.defaultValueAttachment > "u" || g(e.defaultValueAttachment)) && (typeof e.defaultValueCodeableConcept > "u" || r(e.defaultValueCodeableConcept)) && (typeof e.defaultValueCoding > "u" || s(e.defaultValueCoding)) && (typeof e.defaultValueContactPoint > "u" || I(e.defaultValueContactPoint)) && (typeof e.defaultValueCount > "u" || H(e.defaultValueCount)) && (typeof e.defaultValueDistance > "u" || M(e.defaultValueDistance)) && (typeof e.defaultValueDuration > "u" || _(e.defaultValueDuration)) && (typeof e.defaultValueHumanName > "u" || S(e.defaultValueHumanName)) && (typeof e.defaultValueIdentifier > "u" || a(e.defaultValueIdentifier)) && (typeof e.defaultValueMoney > "u" || c(e.defaultValueMoney)) && (typeof e.defaultValuePeriod > "u" || y(e.defaultValuePeriod)) && (typeof e.defaultValueQuantity > "u" || u(e.defaultValueQuantity)) && (typeof e.defaultValueRange > "u" || v(e.defaultValueRange)) && (typeof e.defaultValueRatio > "u" || b(e.defaultValueRatio)) && (typeof e.defaultValueReference > "u" || o(e.defaultValueReference)) && (typeof e.defaultValueSampledData > "u" || x(e.defaultValueSampledData)) && (typeof e.defaultValueSignature > "u" || O(e.defaultValueSignature)) && (typeof e.defaultValueTiming > "u" || A(e.defaultValueTiming)) && (typeof e.defaultValueContactDetail > "u" || p(e.defaultValueContactDetail)) && (typeof e.defaultValueContributor > "u" || F(e.defaultValueContributor)) && (typeof e.defaultValueDataRequirement > "u" || D(e.defaultValueDataRequirement)) && (typeof e.defaultValueExpression > "u" || R(e.defaultValueExpression)) && (typeof e.defaultValueParameterDefinition > "u" || P(e.defaultValueParameterDefinition)) && (typeof e.defaultValueRelatedArtifact > "u" || w(e.defaultValueRelatedArtifact)) && (typeof e.defaultValueTriggerDefinition > "u" || T(e.defaultValueTriggerDefinition)) && (typeof e.defaultValueUsageContext > "u" || m(e.defaultValueUsageContext)) && (typeof e.defaultValueDosage > "u" || E(e.defaultValueDosage)) && (typeof e.defaultValueMeta > "u" || j(e.defaultValueMeta)) && (typeof e.definition > "u" || typeof e.definition == "string") && (typeof e._definition > "u" || i(e._definition)) && (typeof e.example > "u" || Array.isArray(e.example) && e.example.every(
    (t) => Ri(t)
  )) && (typeof e.fixedBase64Binary > "u" || typeof e.fixedBase64Binary == "string") && (typeof e._fixedBase64Binary > "u" || i(e._fixedBase64Binary)) && (typeof e.fixedBoolean > "u" || e.fixedBoolean === !1 || e.fixedBoolean === !0) && (typeof e._fixedBoolean > "u" || i(e._fixedBoolean)) && (typeof e.fixedCanonical > "u" || typeof e.fixedCanonical == "string") && (typeof e._fixedCanonical > "u" || i(e._fixedCanonical)) && (typeof e.fixedCode > "u" || typeof e.fixedCode == "string") && (typeof e._fixedCode > "u" || i(e._fixedCode)) && (typeof e.fixedDate > "u" || typeof e.fixedDate == "string") && (typeof e._fixedDate > "u" || i(e._fixedDate)) && (typeof e.fixedDateTime > "u" || typeof e.fixedDateTime == "string") && (typeof e._fixedDateTime > "u" || i(e._fixedDateTime)) && (typeof e.fixedDecimal > "u" || typeof e.fixedDecimal == "number") && (typeof e.fixedId > "u" || typeof e.fixedId == "string") && (typeof e._fixedId > "u" || i(e._fixedId)) && (typeof e.fixedInstant > "u" || typeof e.fixedInstant == "string") && (typeof e._fixedInstant > "u" || i(e._fixedInstant)) && (typeof e.fixedInteger > "u" || typeof e.fixedInteger == "number") && (typeof e.fixedMarkdown > "u" || typeof e.fixedMarkdown == "string") && (typeof e._fixedMarkdown > "u" || i(e._fixedMarkdown)) && (typeof e.fixedOid > "u" || typeof e.fixedOid == "string") && (typeof e._fixedOid > "u" || i(e._fixedOid)) && (typeof e.fixedPositiveInt > "u" || typeof e.fixedPositiveInt == "number") && (typeof e.fixedString > "u" || typeof e.fixedString == "string") && (typeof e._fixedString > "u" || i(e._fixedString)) && (typeof e.fixedTime > "u" || typeof e.fixedTime == "string") && (typeof e._fixedTime > "u" || i(e._fixedTime)) && (typeof e.fixedUnsignedInt > "u" || typeof e.fixedUnsignedInt == "number") && (typeof e.fixedUri > "u" || typeof e.fixedUri == "string") && (typeof e._fixedUri > "u" || i(e._fixedUri)) && (typeof e.fixedUrl > "u" || typeof e.fixedUrl == "string") && (typeof e._fixedUrl > "u" || i(e._fixedUrl)) && (typeof e.fixedUuid > "u" || typeof e.fixedUuid == "string") && (typeof e._fixedUuid > "u" || i(e._fixedUuid)) && (typeof e.fixedAddress > "u" || h(e.fixedAddress)) && (typeof e.fixedAge > "u" || C(e.fixedAge)) && (typeof e.fixedAnnotation > "u" || l(e.fixedAnnotation)) && (typeof e.fixedAttachment > "u" || g(e.fixedAttachment)) && (typeof e.fixedCodeableConcept > "u" || r(e.fixedCodeableConcept)) && (typeof e.fixedCoding > "u" || s(e.fixedCoding)) && (typeof e.fixedContactPoint > "u" || I(e.fixedContactPoint)) && (typeof e.fixedCount > "u" || H(e.fixedCount)) && (typeof e.fixedDistance > "u" || M(e.fixedDistance)) && (typeof e.fixedDuration > "u" || _(e.fixedDuration)) && (typeof e.fixedHumanName > "u" || S(e.fixedHumanName)) && (typeof e.fixedIdentifier > "u" || a(e.fixedIdentifier)) && (typeof e.fixedMoney > "u" || c(e.fixedMoney)) && (typeof e.fixedPeriod > "u" || y(e.fixedPeriod)) && (typeof e.fixedQuantity > "u" || u(e.fixedQuantity)) && (typeof e.fixedRange > "u" || v(e.fixedRange)) && (typeof e.fixedRatio > "u" || b(e.fixedRatio)) && (typeof e.fixedReference > "u" || o(e.fixedReference)) && (typeof e.fixedSampledData > "u" || x(e.fixedSampledData)) && (typeof e.fixedSignature > "u" || O(e.fixedSignature)) && (typeof e.fixedTiming > "u" || A(e.fixedTiming)) && (typeof e.fixedContactDetail > "u" || p(e.fixedContactDetail)) && (typeof e.fixedContributor > "u" || F(e.fixedContributor)) && (typeof e.fixedDataRequirement > "u" || D(e.fixedDataRequirement)) && (typeof e.fixedExpression > "u" || R(e.fixedExpression)) && (typeof e.fixedParameterDefinition > "u" || P(e.fixedParameterDefinition)) && (typeof e.fixedRelatedArtifact > "u" || w(e.fixedRelatedArtifact)) && (typeof e.fixedTriggerDefinition > "u" || T(e.fixedTriggerDefinition)) && (typeof e.fixedUsageContext > "u" || m(e.fixedUsageContext)) && (typeof e.fixedDosage > "u" || E(e.fixedDosage)) && (typeof e.fixedMeta > "u" || j(e.fixedMeta)) && (typeof e.isModifier > "u" || e.isModifier === !1 || e.isModifier === !0) && (typeof e._isModifier > "u" || i(e._isModifier)) && (typeof e.isModifierReason > "u" || typeof e.isModifierReason == "string") && (typeof e._isModifierReason > "u" || i(e._isModifierReason)) && (typeof e.isSummary > "u" || e.isSummary === !1 || e.isSummary === !0) && (typeof e._isSummary > "u" || i(e._isSummary)) && (typeof e.label > "u" || typeof e.label == "string") && (typeof e._label > "u" || i(e._label)) && (typeof e.mapping > "u" || Array.isArray(e.mapping) && e.mapping.every(
    (t) => Si(t)
  )) && (typeof e.max > "u" || typeof e.max == "string") && (typeof e._max > "u" || i(e._max)) && (typeof e.maxLength > "u" || typeof e.maxLength == "number") && (typeof e.maxValueDate > "u" || typeof e.maxValueDate == "string") && (typeof e._maxValueDate > "u" || i(e._maxValueDate)) && (typeof e.maxValueDateTime > "u" || typeof e.maxValueDateTime == "string") && (typeof e._maxValueDateTime > "u" || i(e._maxValueDateTime)) && (typeof e.maxValueInstant > "u" || typeof e.maxValueInstant == "string") && (typeof e._maxValueInstant > "u" || i(e._maxValueInstant)) && (typeof e.maxValueTime > "u" || typeof e.maxValueTime == "string") && (typeof e._maxValueTime > "u" || i(e._maxValueTime)) && (typeof e.maxValueDecimal > "u" || typeof e.maxValueDecimal == "number") && (typeof e.maxValueInteger > "u" || typeof e.maxValueInteger == "number") && (typeof e.maxValuePositiveInt > "u" || typeof e.maxValuePositiveInt == "number") && (typeof e.maxValueUnsignedInt > "u" || typeof e.maxValueUnsignedInt == "number") && (typeof e.maxValueQuantity > "u" || u(e.maxValueQuantity)) && (typeof e.meaningWhenMissing > "u" || typeof e.meaningWhenMissing == "string") && (typeof e._meaningWhenMissing > "u" || i(e._meaningWhenMissing)) && (typeof e.min > "u" || typeof e.min == "number") && (typeof e.minValueDate > "u" || typeof e.minValueDate == "string") && (typeof e._minValueDate > "u" || i(e._minValueDate)) && (typeof e.minValueDateTime > "u" || typeof e.minValueDateTime == "string") && (typeof e._minValueDateTime > "u" || i(e._minValueDateTime)) && (typeof e.minValueInstant > "u" || typeof e.minValueInstant == "string") && (typeof e._minValueInstant > "u" || i(e._minValueInstant)) && (typeof e.minValueTime > "u" || typeof e.minValueTime == "string") && (typeof e._minValueTime > "u" || i(e._minValueTime)) && (typeof e.minValueDecimal > "u" || typeof e.minValueDecimal == "number") && (typeof e.minValueInteger > "u" || typeof e.minValueInteger == "number") && (typeof e.minValuePositiveInt > "u" || typeof e.minValuePositiveInt == "number") && (typeof e.minValueUnsignedInt > "u" || typeof e.minValueUnsignedInt == "number") && (typeof e.minValueQuantity > "u" || u(e.minValueQuantity)) && (typeof e.mustSupport > "u" || e.mustSupport === !1 || e.mustSupport === !0) && (typeof e._mustSupport > "u" || i(e._mustSupport)) && (typeof e.orderMeaning > "u" || typeof e.orderMeaning == "string") && (typeof e._orderMeaning > "u" || i(e._orderMeaning)) && typeof e.path == "string" && (typeof e._path > "u" || i(e._path)) && (typeof e.patternBase64Binary > "u" || typeof e.patternBase64Binary == "string") && (typeof e._patternBase64Binary > "u" || i(e._patternBase64Binary)) && (typeof e.patternBoolean > "u" || e.patternBoolean === !1 || e.patternBoolean === !0) && (typeof e._patternBoolean > "u" || i(e._patternBoolean)) && (typeof e.patternCanonical > "u" || typeof e.patternCanonical == "string") && (typeof e._patternCanonical > "u" || i(e._patternCanonical)) && (typeof e.patternCode > "u" || typeof e.patternCode == "string") && (typeof e._patternCode > "u" || i(e._patternCode)) && (typeof e.patternDate > "u" || typeof e.patternDate == "string") && (typeof e._patternDate > "u" || i(e._patternDate)) && (typeof e.patternDateTime > "u" || typeof e.patternDateTime == "string") && (typeof e._patternDateTime > "u" || i(e._patternDateTime)) && (typeof e.patternDecimal > "u" || typeof e.patternDecimal == "number") && (typeof e.patternId > "u" || typeof e.patternId == "string") && (typeof e._patternId > "u" || i(e._patternId)) && (typeof e.patternInstant > "u" || typeof e.patternInstant == "string") && (typeof e._patternInstant > "u" || i(e._patternInstant)) && (typeof e.patternInteger > "u" || typeof e.patternInteger == "number") && (typeof e.patternMarkdown > "u" || typeof e.patternMarkdown == "string") && (typeof e._patternMarkdown > "u" || i(e._patternMarkdown)) && (typeof e.patternOid > "u" || typeof e.patternOid == "string") && (typeof e._patternOid > "u" || i(e._patternOid)) && (typeof e.patternPositiveInt > "u" || typeof e.patternPositiveInt == "number") && (typeof e.patternString > "u" || typeof e.patternString == "string") && (typeof e._patternString > "u" || i(e._patternString)) && (typeof e.patternTime > "u" || typeof e.patternTime == "string") && (typeof e._patternTime > "u" || i(e._patternTime)) && (typeof e.patternUnsignedInt > "u" || typeof e.patternUnsignedInt == "number") && (typeof e.patternUri > "u" || typeof e.patternUri == "string") && (typeof e._patternUri > "u" || i(e._patternUri)) && (typeof e.patternUrl > "u" || typeof e.patternUrl == "string") && (typeof e._patternUrl > "u" || i(e._patternUrl)) && (typeof e.patternUuid > "u" || typeof e.patternUuid == "string") && (typeof e._patternUuid > "u" || i(e._patternUuid)) && (typeof e.patternAddress > "u" || h(e.patternAddress)) && (typeof e.patternAge > "u" || C(e.patternAge)) && (typeof e.patternAnnotation > "u" || l(e.patternAnnotation)) && (typeof e.patternAttachment > "u" || g(e.patternAttachment)) && (typeof e.patternCodeableConcept > "u" || r(e.patternCodeableConcept)) && (typeof e.patternCoding > "u" || s(e.patternCoding)) && (typeof e.patternContactPoint > "u" || I(e.patternContactPoint)) && (typeof e.patternCount > "u" || H(e.patternCount)) && (typeof e.patternDistance > "u" || M(e.patternDistance)) && (typeof e.patternDuration > "u" || _(e.patternDuration)) && (typeof e.patternHumanName > "u" || S(e.patternHumanName)) && (typeof e.patternIdentifier > "u" || a(e.patternIdentifier)) && (typeof e.patternMoney > "u" || c(e.patternMoney)) && (typeof e.patternPeriod > "u" || y(e.patternPeriod)) && (typeof e.patternQuantity > "u" || u(e.patternQuantity)) && (typeof e.patternRange > "u" || v(e.patternRange)) && (typeof e.patternRatio > "u" || b(e.patternRatio)) && (typeof e.patternReference > "u" || o(e.patternReference)) && (typeof e.patternSampledData > "u" || x(e.patternSampledData)) && (typeof e.patternSignature > "u" || O(e.patternSignature)) && (typeof e.patternTiming > "u" || A(e.patternTiming)) && (typeof e.patternContactDetail > "u" || p(e.patternContactDetail)) && (typeof e.patternContributor > "u" || F(e.patternContributor)) && (typeof e.patternDataRequirement > "u" || D(e.patternDataRequirement)) && (typeof e.patternExpression > "u" || R(e.patternExpression)) && (typeof e.patternParameterDefinition > "u" || P(e.patternParameterDefinition)) && (typeof e.patternRelatedArtifact > "u" || w(e.patternRelatedArtifact)) && (typeof e.patternTriggerDefinition > "u" || T(e.patternTriggerDefinition)) && (typeof e.patternUsageContext > "u" || m(e.patternUsageContext)) && (typeof e.patternDosage > "u" || E(e.patternDosage)) && (typeof e.patternMeta > "u" || j(e.patternMeta)) && (typeof e.representation > "u" || Array.isArray(e.representation) && e.representation.every(
    (t) => t === "xmlAttr" || t === "xmlText" || t === "typeAttr" || t === "cdaText" || t === "xhtml"
  )) && (typeof e._representation > "u" || Array.isArray(e._representation) && e._representation.every(
    (t) => i(t)
  )) && (typeof e.requirements > "u" || typeof e.requirements == "string") && (typeof e._requirements > "u" || i(e._requirements)) && (typeof e.short > "u" || typeof e.short == "string") && (typeof e._short > "u" || i(e._short)) && (typeof e.sliceIsConstraining > "u" || e.sliceIsConstraining === !1 || e.sliceIsConstraining === !0) && (typeof e._sliceIsConstraining > "u" || i(e._sliceIsConstraining)) && (typeof e.sliceName > "u" || typeof e.sliceName == "string") && (typeof e._sliceName > "u" || i(e._sliceName)) && (typeof e.slicing > "u" || Ii(e.slicing)) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => wi(t)
  ));
}
function R(n) {
  const e = n;
  return i(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.expression > "u" || typeof e.expression == "string") && (typeof e._expression > "u" || i(e._expression)) && typeof e.language == "string" && (typeof e._language > "u" || i(e._language)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.reference > "u" || typeof e.reference == "string") && (typeof e._reference > "u" || i(e._reference));
}
function B(n) {
  const e = n;
  return i(e) && typeof e.url == "string" && (typeof e._url > "u" || i(e._url)) && (typeof e.valueBase64Binary > "u" || typeof e.valueBase64Binary == "string") && (typeof e._valueBase64Binary > "u" || i(e._valueBase64Binary)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean)) && (typeof e.valueCanonical > "u" || typeof e.valueCanonical == "string") && (typeof e._valueCanonical > "u" || i(e._valueCanonical)) && (typeof e.valueCode > "u" || typeof e.valueCode == "string") && (typeof e._valueCode > "u" || i(e._valueCode)) && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || i(e._valueDate)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || i(e._valueDateTime)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueId > "u" || typeof e.valueId == "string") && (typeof e._valueId > "u" || i(e._valueId)) && (typeof e.valueInstant > "u" || typeof e.valueInstant == "string") && (typeof e._valueInstant > "u" || i(e._valueInstant)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueMarkdown > "u" || typeof e.valueMarkdown == "string") && (typeof e._valueMarkdown > "u" || i(e._valueMarkdown)) && (typeof e.valueOid > "u" || typeof e.valueOid == "string") && (typeof e._valueOid > "u" || i(e._valueOid)) && (typeof e.valuePositiveInt > "u" || typeof e.valuePositiveInt == "number") && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || i(e._valueTime)) && (typeof e.valueUnsignedInt > "u" || typeof e.valueUnsignedInt == "number") && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || i(e._valueUri)) && (typeof e.valueUrl > "u" || typeof e.valueUrl == "string") && (typeof e._valueUrl > "u" || i(e._valueUrl)) && (typeof e.valueUuid > "u" || typeof e.valueUuid == "string") && (typeof e._valueUuid > "u" || i(e._valueUuid)) && (typeof e.valueAddress > "u" || h(e.valueAddress)) && (typeof e.valueAge > "u" || C(e.valueAge)) && (typeof e.valueAnnotation > "u" || l(e.valueAnnotation)) && (typeof e.valueAttachment > "u" || g(e.valueAttachment)) && (typeof e.valueCodeableConcept > "u" || r(e.valueCodeableConcept)) && (typeof e.valueCoding > "u" || s(e.valueCoding)) && (typeof e.valueContactPoint > "u" || I(e.valueContactPoint)) && (typeof e.valueCount > "u" || H(e.valueCount)) && (typeof e.valueDistance > "u" || M(e.valueDistance)) && (typeof e.valueDuration > "u" || _(e.valueDuration)) && (typeof e.valueHumanName > "u" || S(e.valueHumanName)) && (typeof e.valueIdentifier > "u" || a(e.valueIdentifier)) && (typeof e.valueMoney > "u" || c(e.valueMoney)) && (typeof e.valuePeriod > "u" || y(e.valuePeriod)) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueRange > "u" || v(e.valueRange)) && (typeof e.valueRatio > "u" || b(e.valueRatio)) && (typeof e.valueReference > "u" || o(e.valueReference)) && (typeof e.valueSampledData > "u" || x(e.valueSampledData)) && (typeof e.valueSignature > "u" || O(e.valueSignature)) && (typeof e.valueTiming > "u" || A(e.valueTiming)) && (typeof e.valueContactDetail > "u" || p(e.valueContactDetail)) && (typeof e.valueContributor > "u" || F(e.valueContributor)) && (typeof e.valueDataRequirement > "u" || D(e.valueDataRequirement)) && (typeof e.valueExpression > "u" || R(e.valueExpression)) && (typeof e.valueParameterDefinition > "u" || P(e.valueParameterDefinition)) && (typeof e.valueRelatedArtifact > "u" || w(e.valueRelatedArtifact)) && (typeof e.valueTriggerDefinition > "u" || T(e.valueTriggerDefinition)) && (typeof e.valueUsageContext > "u" || m(e.valueUsageContext)) && (typeof e.valueDosage > "u" || E(e.valueDosage)) && (typeof e.valueMeta > "u" || j(e.valueMeta));
}
function S(n) {
  const e = n;
  return i(e) && (typeof e.family > "u" || typeof e.family == "string") && (typeof e._family > "u" || i(e._family)) && (typeof e.given > "u" || Array.isArray(e.given) && e.given.every(
    (t) => typeof t == "string"
  )) && (typeof e._given > "u" || Array.isArray(e._given) && e._given.every(
    (t) => i(t)
  )) && (typeof e.period > "u" || y(e.period)) && (typeof e.prefix > "u" || Array.isArray(e.prefix) && e.prefix.every(
    (t) => typeof t == "string"
  )) && (typeof e._prefix > "u" || Array.isArray(e._prefix) && e._prefix.every(
    (t) => i(t)
  )) && (typeof e.suffix > "u" || Array.isArray(e.suffix) && e.suffix.every(
    (t) => typeof t == "string"
  )) && (typeof e._suffix > "u" || Array.isArray(e._suffix) && e._suffix.every(
    (t) => i(t)
  )) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || i(e._text)) && (typeof e.use > "u" || e.use === "temp" || e.use === "old" || e.use === "usual" || e.use === "official" || e.use === "nickname" || e.use === "anonymous" || e.use === "maiden") && (typeof e._use > "u" || i(e._use));
}
function a(n) {
  const e = n;
  return i(e) && (typeof e.assigner > "u" || o(e.assigner)) && (typeof e.period > "u" || y(e.period)) && (typeof e.system > "u" || typeof e.system == "string") && (typeof e._system > "u" || i(e._system)) && (typeof e.type > "u" || r(e.type)) && (typeof e.use > "u" || e.use === "temp" || e.use === "old" || e.use === "usual" || e.use === "official" || e.use === "secondary") && (typeof e._use > "u" || i(e._use)) && (typeof e.value > "u" || typeof e.value == "string") && (typeof e._value > "u" || i(e._value));
}
function kn(n) {
  const e = n;
  return d(e) && r(e.country) && y(e.dateRange) && (typeof e.jurisdiction > "u" || r(e.jurisdiction)) && (typeof e.restoreDate > "u" || typeof e.restoreDate == "string") && (typeof e._restoreDate > "u" || i(e._restoreDate)) && r(e.status);
}
function j(n) {
  const e = n;
  return i(e) && (typeof e.lastUpdated > "u" || typeof e.lastUpdated == "string") && (typeof e._lastUpdated > "u" || i(e._lastUpdated)) && (typeof e.profile > "u" || Array.isArray(e.profile) && e.profile.every(
    (t) => typeof t == "string"
  )) && (typeof e._profile > "u" || Array.isArray(e._profile) && e._profile.every(
    (t) => i(t)
  )) && (typeof e.security > "u" || Array.isArray(e.security) && e.security.every(
    (t) => s(t)
  )) && (typeof e.source > "u" || typeof e.source == "string") && (typeof e._source > "u" || i(e._source)) && (typeof e.tag > "u" || Array.isArray(e.tag) && e.tag.every(
    (t) => s(t)
  )) && (typeof e.versionId > "u" || typeof e.versionId == "string") && (typeof e._versionId > "u" || i(e._versionId));
}
function c(n) {
  const e = n;
  return i(e) && (typeof e.currency > "u" || typeof e.currency == "string") && (typeof e._currency > "u" || i(e._currency)) && (typeof e.value > "u" || typeof e.value == "number");
}
function Bn(n) {
  const e = n;
  return i(e) && typeof e.div == "string" && (typeof e._div > "u" || i(e._div)) && (e.status === "generated" || e.status === "extensions" || e.status === "additional" || e.status === "empty") && (typeof e._status > "u" || i(e._status));
}
function P(n) {
  const e = n;
  return i(e) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || i(e._documentation)) && (typeof e.max > "u" || typeof e.max == "string") && (typeof e._max > "u" || i(e._max)) && (typeof e.min > "u" || typeof e.min == "number") && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.profile > "u" || typeof e.profile == "string") && (typeof e._profile > "u" || i(e._profile)) && typeof e.type == "string" && (typeof e._type > "u" || i(e._type)) && (e.use === "in" || e.use === "out") && (typeof e._use > "u" || i(e._use));
}
function y(n) {
  const e = n;
  return i(e) && (typeof e.end > "u" || typeof e.end == "string") && (typeof e._end > "u" || i(e._end)) && (typeof e.start > "u" || typeof e.start == "string") && (typeof e._start > "u" || i(e._start));
}
function On(n) {
  const e = n;
  return d(e) && (typeof e.ageRange > "u" || v(e.ageRange)) && (typeof e.ageCodeableConcept > "u" || r(e.ageCodeableConcept)) && (typeof e.gender > "u" || r(e.gender)) && (typeof e.physiologicalCondition > "u" || r(e.physiologicalCondition)) && (typeof e.race > "u" || r(e.race));
}
function En(n) {
  const e = n;
  return d(e) && (typeof e.color > "u" || Array.isArray(e.color) && e.color.every(
    (t) => typeof t == "string"
  )) && (typeof e._color > "u" || Array.isArray(e._color) && e._color.every(
    (t) => i(t)
  )) && (typeof e.depth > "u" || u(e.depth)) && (typeof e.externalDiameter > "u" || u(e.externalDiameter)) && (typeof e.height > "u" || u(e.height)) && (typeof e.image > "u" || Array.isArray(e.image) && e.image.every(
    (t) => g(t)
  )) && (typeof e.imprint > "u" || Array.isArray(e.imprint) && e.imprint.every(
    (t) => typeof t == "string"
  )) && (typeof e._imprint > "u" || Array.isArray(e._imprint) && e._imprint.every(
    (t) => i(t)
  )) && (typeof e.nominalVolume > "u" || u(e.nominalVolume)) && (typeof e.scoring > "u" || r(e.scoring)) && (typeof e.shape > "u" || typeof e.shape == "string") && (typeof e._shape > "u" || i(e._shape)) && (typeof e.weight > "u" || u(e.weight)) && (typeof e.width > "u" || u(e.width));
}
function Vn(n) {
  const e = n;
  return d(e) && (typeof e.identifier > "u" || a(e.identifier)) && u(e.period) && (typeof e.specialPrecautionsForStorage > "u" || Array.isArray(e.specialPrecautionsForStorage) && e.specialPrecautionsForStorage.every(
    (t) => r(t)
  )) && r(e.type);
}
function u(n) {
  const e = n;
  return i(e) && (typeof e.code > "u" || typeof e.code == "string") && (typeof e._code > "u" || i(e._code)) && (typeof e.comparator > "u" || e.comparator === "<" || e.comparator === "<=" || e.comparator === ">=" || e.comparator === ">") && (typeof e._comparator > "u" || i(e._comparator)) && (typeof e.system > "u" || typeof e.system == "string") && (typeof e._system > "u" || i(e._system)) && (typeof e.unit > "u" || typeof e.unit == "string") && (typeof e._unit > "u" || i(e._unit)) && (typeof e.value > "u" || typeof e.value == "number");
}
function v(n) {
  const e = n;
  return i(e) && (typeof e.high > "u" || u(e.high)) && (typeof e.low > "u" || u(e.low));
}
function b(n) {
  const e = n;
  return i(e) && (typeof e.denominator > "u" || u(e.denominator)) && (typeof e.numerator > "u" || u(e.numerator));
}
function o(n) {
  const e = n;
  return i(e) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || i(e._display)) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.reference > "u" || typeof e.reference == "string") && (typeof e._reference > "u" || i(e._reference)) && (typeof e.type > "u" || typeof e.type == "string") && (typeof e._type > "u" || i(e._type));
}
function w(n) {
  const e = n;
  return i(e) && (typeof e.citation > "u" || typeof e.citation == "string") && (typeof e._citation > "u" || i(e._citation)) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || i(e._display)) && (typeof e.document > "u" || g(e.document)) && (typeof e.label > "u" || typeof e.label == "string") && (typeof e._label > "u" || i(e._label)) && (typeof e.resource > "u" || typeof e.resource == "string") && (typeof e._resource > "u" || i(e._resource)) && (e.type === "documentation" || e.type === "justification" || e.type === "citation" || e.type === "predecessor" || e.type === "successor" || e.type === "derived-from" || e.type === "depends-on" || e.type === "composed-of") && (typeof e._type > "u" || i(e._type)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url));
}
function x(n) {
  const e = n;
  return i(e) && (typeof e.data > "u" || typeof e.data == "string") && (typeof e._data > "u" || i(e._data)) && typeof e.dimensions == "number" && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.lowerLimit > "u" || typeof e.lowerLimit == "number") && u(e.origin) && typeof e.period == "number" && (typeof e.upperLimit > "u" || typeof e.upperLimit == "number");
}
function O(n) {
  const e = n;
  return i(e) && (typeof e.data > "u" || typeof e.data == "string") && (typeof e._data > "u" || i(e._data)) && (typeof e.onBehalfOf > "u" || o(e.onBehalfOf)) && (typeof e.sigFormat > "u" || typeof e.sigFormat == "string") && (typeof e._sigFormat > "u" || i(e._sigFormat)) && (typeof e.targetFormat > "u" || typeof e.targetFormat == "string") && (typeof e._targetFormat > "u" || i(e._targetFormat)) && Array.isArray(e.type) && e.type.every(
    (t) => s(t)
  ) && typeof e.when == "string" && (typeof e._when > "u" || i(e._when)) && o(e.who);
}
function Oi(n) {
  const e = n;
  return i(e) && (typeof e.highLimit > "u" || u(e.highLimit)) && (typeof e.lowLimit > "u" || u(e.lowLimit));
}
function Tn(n) {
  const e = n;
  return d(e) && (typeof e.amountQuantity > "u" || u(e.amountQuantity)) && (typeof e.amountRange > "u" || v(e.amountRange)) && (typeof e.amountString > "u" || typeof e.amountString == "string") && (typeof e._amountString > "u" || i(e._amountString)) && (typeof e.amountText > "u" || typeof e.amountText == "string") && (typeof e._amountText > "u" || i(e._amountText)) && (typeof e.amountType > "u" || r(e.amountType)) && (typeof e.referenceRange > "u" || Oi(e.referenceRange));
}
function Ei(n) {
  const e = n;
  return i(e) && (typeof e.boundsDuration > "u" || _(e.boundsDuration)) && (typeof e.boundsRange > "u" || v(e.boundsRange)) && (typeof e.boundsPeriod > "u" || y(e.boundsPeriod)) && (typeof e.count > "u" || typeof e.count == "number") && (typeof e.countMax > "u" || typeof e.countMax == "number") && (typeof e.dayOfWeek > "u" || Array.isArray(e.dayOfWeek) && e.dayOfWeek.every(
    (t) => t === "mon" || t === "tue" || t === "wed" || t === "thu" || t === "fri" || t === "sat" || t === "sun"
  )) && (typeof e._dayOfWeek > "u" || Array.isArray(e._dayOfWeek) && e._dayOfWeek.every(
    (t) => i(t)
  )) && (typeof e.duration > "u" || typeof e.duration == "number") && (typeof e.durationMax > "u" || typeof e.durationMax == "number") && (typeof e.durationUnit > "u" || e.durationUnit === "s" || e.durationUnit === "min" || e.durationUnit === "h" || e.durationUnit === "d" || e.durationUnit === "wk" || e.durationUnit === "mo" || e.durationUnit === "a") && (typeof e._durationUnit > "u" || i(e._durationUnit)) && (typeof e.frequency > "u" || typeof e.frequency == "number") && (typeof e.frequencyMax > "u" || typeof e.frequencyMax == "number") && (typeof e.offset > "u" || typeof e.offset == "number") && (typeof e.period > "u" || typeof e.period == "number") && (typeof e.periodMax > "u" || typeof e.periodMax == "number") && (typeof e.periodUnit > "u" || e.periodUnit === "s" || e.periodUnit === "min" || e.periodUnit === "h" || e.periodUnit === "d" || e.periodUnit === "wk" || e.periodUnit === "mo" || e.periodUnit === "a") && (typeof e._periodUnit > "u" || i(e._periodUnit)) && (typeof e.timeOfDay > "u" || Array.isArray(e.timeOfDay) && e.timeOfDay.every(
    (t) => typeof t == "string"
  )) && (typeof e._timeOfDay > "u" || Array.isArray(e._timeOfDay) && e._timeOfDay.every(
    (t) => i(t)
  )) && (typeof e.when > "u" || Array.isArray(e.when) && e.when.every(
    (t) => typeof t == "string"
  )) && (typeof e._when > "u" || Array.isArray(e._when) && e._when.every(
    (t) => i(t)
  ));
}
function A(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || r(e.code)) && (typeof e.event > "u" || Array.isArray(e.event) && e.event.every(
    (t) => typeof t == "string"
  )) && (typeof e._event > "u" || Array.isArray(e._event) && e._event.every(
    (t) => i(t)
  )) && (typeof e.repeat > "u" || Ei(e.repeat));
}
function T(n) {
  const e = n;
  return i(e) && (typeof e.condition > "u" || R(e.condition)) && (typeof e.data > "u" || Array.isArray(e.data) && e.data.every(
    (t) => D(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.timingTiming > "u" || A(e.timingTiming)) && (typeof e.timingReference > "u" || o(e.timingReference)) && (typeof e.timingDate > "u" || typeof e.timingDate == "string") && (typeof e._timingDate > "u" || i(e._timingDate)) && (typeof e.timingDateTime > "u" || typeof e.timingDateTime == "string") && (typeof e._timingDateTime > "u" || i(e._timingDateTime)) && (e.type === "named-event" || e.type === "periodic" || e.type === "data-changed" || e.type === "data-added" || e.type === "data-modified" || e.type === "data-removed" || e.type === "data-accessed" || e.type === "data-access-ended") && (typeof e._type > "u" || i(e._type));
}
function m(n) {
  const e = n;
  return i(e) && s(e.code) && (typeof e.valueCodeableConcept > "u" || r(e.valueCodeableConcept)) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueRange > "u" || v(e.valueRange)) && (typeof e.valueReference > "u" || o(e.valueReference));
}
function Ti(n) {
  const e = n;
  return d(e) && o(e.coverage) && (typeof e.priority > "u" || typeof e.priority == "number");
}
function xi(n) {
  const e = n;
  return d(e) && (typeof e.onHold > "u" || e.onHold === !1 || e.onHold === !0) && (typeof e._onHold > "u" || i(e._onHold)) && o(e.party) && (typeof e.period > "u" || y(e.period));
}
function V(n) {
  const e = n;
  return f(e) && e.resourceType === "Account" && (typeof e.coverage > "u" || Array.isArray(e.coverage) && e.coverage.every(
    (t) => Ti(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.guarantor > "u" || Array.isArray(e.guarantor) && e.guarantor.every(
    (t) => xi(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.owner > "u" || o(e.owner)) && (typeof e.partOf > "u" || o(e.partOf)) && (typeof e.servicePeriod > "u" || y(e.servicePeriod)) && (e.status === "active" || e.status === "inactive" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown") && (typeof e._status > "u" || i(e._status)) && (typeof e.subject > "u" || Array.isArray(e.subject) && e.subject.every(
    (t) => o(t)
  )) && (typeof e.type > "u" || r(e.type));
}
function ji(n) {
  const e = n;
  return d(e) && (typeof e.role > "u" || r(e.role)) && (e.type === "patient" || e.type === "practitioner" || e.type === "related-person" || e.type === "device") && (typeof e._type > "u" || i(e._type));
}
function Pi(n) {
  const e = n;
  return d(e) && R(e.expression) && typeof e.path == "string" && (typeof e._path > "u" || i(e._path));
}
function U(n) {
  const e = n;
  return f(e) && e.resourceType === "ActivityDefinition" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || i(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => p(t)
  )) && (typeof e.bodySite > "u" || Array.isArray(e.bodySite) && e.bodySite.every(
    (t) => r(t)
  )) && (typeof e.code > "u" || r(e.code)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.doNotPerform > "u" || e.doNotPerform === !1 || e.doNotPerform === !0) && (typeof e._doNotPerform > "u" || i(e._doNotPerform)) && (typeof e.dosage > "u" || Array.isArray(e.dosage) && e.dosage.every(
    (t) => E(t)
  )) && (typeof e.dynamicValue > "u" || Array.isArray(e.dynamicValue) && e.dynamicValue.every(
    (t) => Pi(t)
  )) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => p(t)
  )) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => p(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.intent > "u" || e.intent === "proposal" || e.intent === "plan" || e.intent === "directive" || e.intent === "order" || e.intent === "original-order" || e.intent === "reflex-order" || e.intent === "filler-order" || e.intent === "instance-order" || e.intent === "option") && (typeof e._intent > "u" || i(e._intent)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.kind > "u" || typeof e.kind == "string") && (typeof e._kind > "u" || i(e._kind)) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || i(e._lastReviewDate)) && (typeof e.library > "u" || Array.isArray(e.library) && e.library.every(
    (t) => typeof t == "string"
  )) && (typeof e._library > "u" || Array.isArray(e._library) && e._library.every(
    (t) => i(t)
  )) && (typeof e.location > "u" || o(e.location)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.observationRequirement > "u" || Array.isArray(e.observationRequirement) && e.observationRequirement.every(
    (t) => o(t)
  )) && (typeof e.observationResultRequirement > "u" || Array.isArray(e.observationResultRequirement) && e.observationResultRequirement.every(
    (t) => o(t)
  )) && (typeof e.participant > "u" || Array.isArray(e.participant) && e.participant.every(
    (t) => ji(t)
  )) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || i(e._priority)) && (typeof e.productReference > "u" || o(e.productReference)) && (typeof e.productCodeableConcept > "u" || r(e.productCodeableConcept)) && (typeof e.profile > "u" || typeof e.profile == "string") && (typeof e._profile > "u" || i(e._profile)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => w(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => p(t)
  )) && (typeof e.specimenRequirement > "u" || Array.isArray(e.specimenRequirement) && e.specimenRequirement.every(
    (t) => o(t)
  )) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.subjectCodeableConcept > "u" || r(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || o(e.subjectReference)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || i(e._subtitle)) && (typeof e.timingTiming > "u" || A(e.timingTiming)) && (typeof e.timingDateTime > "u" || typeof e.timingDateTime == "string") && (typeof e._timingDateTime > "u" || i(e._timingDateTime)) && (typeof e.timingAge > "u" || C(e.timingAge)) && (typeof e.timingPeriod > "u" || y(e.timingPeriod)) && (typeof e.timingRange > "u" || v(e.timingRange)) && (typeof e.timingDuration > "u" || _(e.timingDuration)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => r(t)
  )) && (typeof e.transform > "u" || typeof e.transform == "string") && (typeof e._transform > "u" || i(e._transform)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.usage > "u" || typeof e.usage == "string") && (typeof e._usage > "u" || i(e._usage)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function Fi(n) {
  const e = n;
  return d(e) && (typeof e.assessment > "u" || r(e.assessment)) && (typeof e.author > "u" || o(e.author)) && (typeof e.method > "u" || r(e.method)) && (typeof e.productRelatedness > "u" || typeof e.productRelatedness == "string") && (typeof e._productRelatedness > "u" || i(e._productRelatedness));
}
function Hi(n) {
  const e = n;
  return d(e) && (typeof e.causality > "u" || Array.isArray(e.causality) && e.causality.every(
    (t) => Fi(t)
  )) && o(e.instance);
}
function N(n) {
  const e = n;
  return f(e) && e.resourceType === "AdverseEvent" && (e.actuality === "actual" || e.actuality === "potential") && (typeof e._actuality > "u" || i(e._actuality)) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && (typeof e.contributor > "u" || Array.isArray(e.contributor) && e.contributor.every(
    (t) => o(t)
  )) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.detected > "u" || typeof e.detected == "string") && (typeof e._detected > "u" || i(e._detected)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.event > "u" || r(e.event)) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.location > "u" || o(e.location)) && (typeof e.outcome > "u" || r(e.outcome)) && (typeof e.recordedDate > "u" || typeof e.recordedDate == "string") && (typeof e._recordedDate > "u" || i(e._recordedDate)) && (typeof e.recorder > "u" || o(e.recorder)) && (typeof e.referenceDocument > "u" || Array.isArray(e.referenceDocument) && e.referenceDocument.every(
    (t) => o(t)
  )) && (typeof e.resultingCondition > "u" || Array.isArray(e.resultingCondition) && e.resultingCondition.every(
    (t) => o(t)
  )) && (typeof e.seriousness > "u" || r(e.seriousness)) && (typeof e.severity > "u" || r(e.severity)) && (typeof e.study > "u" || Array.isArray(e.study) && e.study.every(
    (t) => o(t)
  )) && o(e.subject) && (typeof e.subjectMedicalHistory > "u" || Array.isArray(e.subjectMedicalHistory) && e.subjectMedicalHistory.every(
    (t) => o(t)
  )) && (typeof e.suspectEntity > "u" || Array.isArray(e.suspectEntity) && e.suspectEntity.every(
    (t) => Hi(t)
  ));
}
function Mi(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.exposureRoute > "u" || r(e.exposureRoute)) && Array.isArray(e.manifestation) && e.manifestation.every(
    (t) => r(t)
  ) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.onset > "u" || typeof e.onset == "string") && (typeof e._onset > "u" || i(e._onset)) && (typeof e.severity > "u" || e.severity === "mild" || e.severity === "moderate" || e.severity === "severe") && (typeof e._severity > "u" || i(e._severity)) && (typeof e.substance > "u" || r(e.substance));
}
function L(n) {
  const e = n;
  return f(e) && e.resourceType === "AllergyIntolerance" && (typeof e.asserter > "u" || o(e.asserter)) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => t === "food" || t === "medication" || t === "environment" || t === "biologic"
  )) && (typeof e._category > "u" || Array.isArray(e._category) && e._category.every(
    (t) => i(t)
  )) && (typeof e.clinicalStatus > "u" || r(e.clinicalStatus)) && (typeof e.code > "u" || r(e.code)) && (typeof e.criticality > "u" || e.criticality === "low" || e.criticality === "high" || e.criticality === "unable-to-assess") && (typeof e._criticality > "u" || i(e._criticality)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.lastOccurrence > "u" || typeof e.lastOccurrence == "string") && (typeof e._lastOccurrence > "u" || i(e._lastOccurrence)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.onsetDateTime > "u" || typeof e.onsetDateTime == "string") && (typeof e._onsetDateTime > "u" || i(e._onsetDateTime)) && (typeof e.onsetAge > "u" || C(e.onsetAge)) && (typeof e.onsetPeriod > "u" || y(e.onsetPeriod)) && (typeof e.onsetRange > "u" || v(e.onsetRange)) && (typeof e.onsetString > "u" || typeof e.onsetString == "string") && (typeof e._onsetString > "u" || i(e._onsetString)) && o(e.patient) && (typeof e.reaction > "u" || Array.isArray(e.reaction) && e.reaction.every(
    (t) => Mi(t)
  )) && (typeof e.recordedDate > "u" || typeof e.recordedDate == "string") && (typeof e._recordedDate > "u" || i(e._recordedDate)) && (typeof e.recorder > "u" || o(e.recorder)) && (typeof e.type > "u" || e.type === "allergy" || e.type === "intolerance") && (typeof e._type > "u" || i(e._type)) && (typeof e.verificationStatus > "u" || r(e.verificationStatus));
}
function qi(n) {
  const e = n;
  return d(e) && (typeof e.actor > "u" || o(e.actor)) && (typeof e.period > "u" || y(e.period)) && (typeof e.required > "u" || e.required === "required" || e.required === "optional" || e.required === "information-only") && (typeof e._required > "u" || i(e._required)) && (e.status === "accepted" || e.status === "declined" || e.status === "tentative" || e.status === "needs-action") && (typeof e._status > "u" || i(e._status)) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => r(t)
  ));
}
function G(n) {
  const e = n;
  return f(e) && e.resourceType === "Appointment" && (typeof e.appointmentType > "u" || r(e.appointmentType)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.cancelationReason > "u" || r(e.cancelationReason)) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment)) && (typeof e.created > "u" || typeof e.created == "string") && (typeof e._created > "u" || i(e._created)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.end > "u" || typeof e.end == "string") && (typeof e._end > "u" || i(e._end)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.minutesDuration > "u" || typeof e.minutesDuration == "number") && Array.isArray(e.participant) && e.participant.every(
    (t) => qi(t)
  ) && (typeof e.patientInstruction > "u" || typeof e.patientInstruction == "string") && (typeof e._patientInstruction > "u" || i(e._patientInstruction)) && (typeof e.priority > "u" || typeof e.priority == "number") && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.requestedPeriod > "u" || Array.isArray(e.requestedPeriod) && e.requestedPeriod.every(
    (t) => y(t)
  )) && (typeof e.serviceCategory > "u" || Array.isArray(e.serviceCategory) && e.serviceCategory.every(
    (t) => r(t)
  )) && (typeof e.serviceType > "u" || Array.isArray(e.serviceType) && e.serviceType.every(
    (t) => r(t)
  )) && (typeof e.slot > "u" || Array.isArray(e.slot) && e.slot.every(
    (t) => o(t)
  )) && (typeof e.specialty > "u" || Array.isArray(e.specialty) && e.specialty.every(
    (t) => r(t)
  )) && (typeof e.start > "u" || typeof e.start == "string") && (typeof e._start > "u" || i(e._start)) && (e.status === "entered-in-error" || e.status === "proposed" || e.status === "pending" || e.status === "booked" || e.status === "arrived" || e.status === "fulfilled" || e.status === "cancelled" || e.status === "noshow" || e.status === "checked-in" || e.status === "waitlist") && (typeof e._status > "u" || i(e._status)) && (typeof e.supportingInformation > "u" || Array.isArray(e.supportingInformation) && e.supportingInformation.every(
    (t) => o(t)
  ));
}
function z(n) {
  const e = n;
  return f(e) && e.resourceType === "AppointmentResponse" && (typeof e.actor > "u" || o(e.actor)) && o(e.appointment) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment)) && (typeof e.end > "u" || typeof e.end == "string") && (typeof e._end > "u" || i(e._end)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (e.participantStatus === "accepted" || e.participantStatus === "declined" || e.participantStatus === "tentative" || e.participantStatus === "needs-action") && (typeof e._participantStatus > "u" || i(e._participantStatus)) && (typeof e.participantType > "u" || Array.isArray(e.participantType) && e.participantType.every(
    (t) => r(t)
  )) && (typeof e.start > "u" || typeof e.start == "string") && (typeof e._start > "u" || i(e._start));
}
function ki(n) {
  const e = n;
  return d(e) && (typeof e.address > "u" || typeof e.address == "string") && (typeof e._address > "u" || i(e._address)) && (typeof e.type > "u" || typeof e.type == "string") && (typeof e._type > "u" || i(e._type));
}
function Bi(n) {
  const e = n;
  return d(e) && (typeof e.altId > "u" || typeof e.altId == "string") && (typeof e._altId > "u" || i(e._altId)) && (typeof e.location > "u" || o(e.location)) && (typeof e.media > "u" || s(e.media)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.network > "u" || ki(e.network)) && (typeof e.policy > "u" || Array.isArray(e.policy) && e.policy.every(
    (t) => typeof t == "string"
  )) && (typeof e._policy > "u" || Array.isArray(e._policy) && e._policy.every(
    (t) => i(t)
  )) && (typeof e.purposeOfUse > "u" || Array.isArray(e.purposeOfUse) && e.purposeOfUse.every(
    (t) => r(t)
  )) && typeof e.requestor == "boolean" && (typeof e._requestor > "u" || i(e._requestor)) && (typeof e.role > "u" || Array.isArray(e.role) && e.role.every(
    (t) => r(t)
  )) && (typeof e.type > "u" || r(e.type)) && (typeof e.who > "u" || o(e.who));
}
function Vi(n) {
  const e = n;
  return d(e) && o(e.observer) && (typeof e.site > "u" || typeof e.site == "string") && (typeof e._site > "u" || i(e._site)) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => s(t)
  ));
}
function Ui(n) {
  const e = n;
  return d(e) && typeof e.type == "string" && (typeof e._type > "u" || i(e._type)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueBase64Binary > "u" || typeof e.valueBase64Binary == "string") && (typeof e._valueBase64Binary > "u" || i(e._valueBase64Binary));
}
function Ni(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => Ui(t)
  )) && (typeof e.lifecycle > "u" || s(e.lifecycle)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.query > "u" || typeof e.query == "string") && (typeof e._query > "u" || i(e._query)) && (typeof e.role > "u" || s(e.role)) && (typeof e.securityLabel > "u" || Array.isArray(e.securityLabel) && e.securityLabel.every(
    (t) => s(t)
  )) && (typeof e.type > "u" || s(e.type)) && (typeof e.what > "u" || o(e.what));
}
function Q(n) {
  const e = n;
  return f(e) && e.resourceType === "AuditEvent" && (typeof e.action > "u" || typeof e.action == "string") && (typeof e._action > "u" || i(e._action)) && Array.isArray(e.agent) && e.agent.every(
    (t) => Bi(t)
  ) && (typeof e.entity > "u" || Array.isArray(e.entity) && e.entity.every(
    (t) => Ni(t)
  )) && (typeof e.outcome > "u" || typeof e.outcome == "string") && (typeof e._outcome > "u" || i(e._outcome)) && (typeof e.outcomeDesc > "u" || typeof e.outcomeDesc == "string") && (typeof e._outcomeDesc > "u" || i(e._outcomeDesc)) && (typeof e.period > "u" || y(e.period)) && (typeof e.purposeOfEvent > "u" || Array.isArray(e.purposeOfEvent) && e.purposeOfEvent.every(
    (t) => r(t)
  )) && typeof e.recorded == "string" && (typeof e._recorded > "u" || i(e._recorded)) && Vi(e.source) && (typeof e.subtype > "u" || Array.isArray(e.subtype) && e.subtype.every(
    (t) => s(t)
  )) && s(e.type);
}
function W(n) {
  const e = n;
  return f(e) && e.resourceType === "Basic" && (typeof e.author > "u" || o(e.author)) && r(e.code) && (typeof e.created > "u" || typeof e.created == "string") && (typeof e._created > "u" || i(e._created)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.subject > "u" || o(e.subject));
}
function K(n) {
  const e = n;
  return Yt(e) && e.resourceType === "Binary" && typeof e.contentType == "string" && (typeof e._contentType > "u" || i(e._contentType)) && (typeof e.data > "u" || typeof e.data == "string") && (typeof e._data > "u" || i(e._data)) && (typeof e.securityContext > "u" || o(e.securityContext));
}
function Li(n) {
  const e = n;
  return d(e) && (typeof e.collectedDateTime > "u" || typeof e.collectedDateTime == "string") && (typeof e._collectedDateTime > "u" || i(e._collectedDateTime)) && (typeof e.collectedPeriod > "u" || y(e.collectedPeriod)) && (typeof e.collector > "u" || o(e.collector)) && (typeof e.source > "u" || o(e.source));
}
function Gi(n) {
  const e = n;
  return d(e) && (typeof e.additive > "u" || o(e.additive)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.procedure > "u" || r(e.procedure)) && (typeof e.timeDateTime > "u" || typeof e.timeDateTime == "string") && (typeof e._timeDateTime > "u" || i(e._timeDateTime)) && (typeof e.timePeriod > "u" || y(e.timePeriod));
}
function zi(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.timeDateTime > "u" || typeof e.timeDateTime == "string") && (typeof e._timeDateTime > "u" || i(e._timeDateTime)) && (typeof e.timePeriod > "u" || y(e.timePeriod));
}
function Qi(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.duration > "u" || y(e.duration)) && (typeof e.scale > "u" || e.scale === "farenheit" || e.scale === "celsius" || e.scale === "kelvin") && (typeof e._scale > "u" || i(e._scale)) && (typeof e.temperature > "u" || typeof e.temperature == "number");
}
function J(n) {
  const e = n;
  return f(e) && e.resourceType === "BiologicallyDerivedProduct" && (typeof e.collection > "u" || Li(e.collection)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.manipulation > "u" || zi(e.manipulation)) && (typeof e.parent > "u" || Array.isArray(e.parent) && e.parent.every(
    (t) => o(t)
  )) && (typeof e.processing > "u" || Array.isArray(e.processing) && e.processing.every(
    (t) => Gi(t)
  )) && (typeof e.productCategory > "u" || e.productCategory === "organ" || e.productCategory === "tissue" || e.productCategory === "fluid" || e.productCategory === "cells" || e.productCategory === "biologicalAgent") && (typeof e._productCategory > "u" || i(e._productCategory)) && (typeof e.productCode > "u" || r(e.productCode)) && (typeof e.quantity > "u" || typeof e.quantity == "number") && (typeof e.request > "u" || Array.isArray(e.request) && e.request.every(
    (t) => o(t)
  )) && (typeof e.status > "u" || e.status === "available" || e.status === "unavailable") && (typeof e._status > "u" || i(e._status)) && (typeof e.storage > "u" || Array.isArray(e.storage) && e.storage.every(
    (t) => Qi(t)
  ));
}
function X(n) {
  const e = n;
  return f(e) && e.resourceType === "BodyStructure" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || i(e._active)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.image > "u" || Array.isArray(e.image) && e.image.every(
    (t) => g(t)
  )) && (typeof e.location > "u" || r(e.location)) && (typeof e.locationQualifier > "u" || Array.isArray(e.locationQualifier) && e.locationQualifier.every(
    (t) => r(t)
  )) && (typeof e.morphology > "u" || r(e.morphology)) && o(e.patient);
}
function Un(n) {
  const e = n;
  return d(e) && typeof e.relation == "string" && (typeof e._relation > "u" || i(e._relation)) && typeof e.url == "string" && (typeof e._url > "u" || i(e._url));
}
function Wi(n) {
  const e = n;
  return d(e) && (typeof e.mode > "u" || e.mode === "match" || e.mode === "include" || e.mode === "outcome") && (typeof e._mode > "u" || i(e._mode)) && (typeof e.score > "u" || typeof e.score == "number");
}
function Ki(n) {
  const e = n;
  return d(e) && (typeof e.ifMatch > "u" || typeof e.ifMatch == "string") && (typeof e._ifMatch > "u" || i(e._ifMatch)) && (typeof e.ifModifiedSince > "u" || typeof e.ifModifiedSince == "string") && (typeof e._ifModifiedSince > "u" || i(e._ifModifiedSince)) && (typeof e.ifNoneExist > "u" || typeof e.ifNoneExist == "string") && (typeof e._ifNoneExist > "u" || i(e._ifNoneExist)) && (typeof e.ifNoneMatch > "u" || typeof e.ifNoneMatch == "string") && (typeof e._ifNoneMatch > "u" || i(e._ifNoneMatch)) && (e.method === "GET" || e.method === "HEAD" || e.method === "POST" || e.method === "PUT" || e.method === "DELETE" || e.method === "PATCH") && (typeof e._method > "u" || i(e._method)) && typeof e.url == "string" && (typeof e._url > "u" || i(e._url));
}
function Ji(n) {
  const e = n;
  return d(e) && (typeof e.etag > "u" || typeof e.etag == "string") && (typeof e._etag > "u" || i(e._etag)) && (typeof e.lastModified > "u" || typeof e.lastModified == "string") && (typeof e._lastModified > "u" || i(e._lastModified)) && (typeof e.location > "u" || typeof e.location == "string") && (typeof e._location > "u" || i(e._location)) && (typeof e.outcome > "u" || V(e.outcome) || U(e.outcome) || N(e.outcome) || L(e.outcome) || G(e.outcome) || z(e.outcome) || Q(e.outcome) || W(e.outcome) || K(e.outcome) || J(e.outcome) || X(e.outcome) || Y(e.outcome) || Z(e.outcome) || $(e.outcome) || ee(e.outcome) || te(e.outcome) || ne(e.outcome) || ie(e.outcome) || re(e.outcome) || oe(e.outcome) || de(e.outcome) || ae(e.outcome) || fe(e.outcome) || ye(e.outcome) || ue(e.outcome) || pe(e.outcome) || se(e.outcome) || ce(e.outcome) || le(e.outcome) || ve(e.outcome) || me(e.outcome) || ge(e.outcome) || _e(e.outcome) || Ae(e.outcome) || be(e.outcome) || Ie(e.outcome) || he(e.outcome) || we(e.outcome) || Re(e.outcome) || Ce(e.outcome) || De(e.outcome) || Se(e.outcome) || Oe(e.outcome) || Ee(e.outcome) || Te(e.outcome) || xe(e.outcome) || je(e.outcome) || Pe(e.outcome) || Fe(e.outcome) || He(e.outcome) || Me(e.outcome) || qe(e.outcome) || ke(e.outcome) || Be(e.outcome) || Ve(e.outcome) || Ue(e.outcome) || Ne(e.outcome) || Le(e.outcome) || Ge(e.outcome) || ze(e.outcome) || Qe(e.outcome) || We(e.outcome) || Ke(e.outcome) || Je(e.outcome) || Xe(e.outcome) || Ye(e.outcome) || Ze(e.outcome) || $e(e.outcome) || et(e.outcome) || tt(e.outcome) || nt(e.outcome) || it(e.outcome) || rt(e.outcome) || ot(e.outcome) || dt(e.outcome) || at(e.outcome) || ft(e.outcome) || yt(e.outcome) || ut(e.outcome) || pt(e.outcome) || st(e.outcome) || ct(e.outcome) || lt(e.outcome) || vt(e.outcome) || mt(e.outcome) || gt(e.outcome) || _t(e.outcome) || At(e.outcome) || bt(e.outcome) || It(e.outcome) || ht(e.outcome) || wt(e.outcome) || Rt(e.outcome) || Ct(e.outcome) || Dt(e.outcome) || St(e.outcome) || Ot(e.outcome) || Et(e.outcome) || Tt(e.outcome) || xt(e.outcome) || jt(e.outcome) || Pt(e.outcome) || Ft(e.outcome) || Ht(e.outcome) || Mt(e.outcome) || qt(e.outcome) || kt(e.outcome) || Bt(e.outcome) || Vt(e.outcome) || Ut(e.outcome) || Nt(e.outcome) || Lt(e.outcome) || Gt(e.outcome) || zt(e.outcome) || Qt(e.outcome) || Wt(e.outcome) || Kt(e.outcome) || Jt(e.outcome) || Xt(e.outcome) || Zt(e.outcome) || $t(e.outcome) || en(e.outcome) || tn(e.outcome) || nn(e.outcome) || rn(e.outcome) || on(e.outcome) || dn(e.outcome) || an(e.outcome) || fn(e.outcome) || yn(e.outcome) || un(e.outcome) || pn(e.outcome) || sn(e.outcome) || cn(e.outcome) || ln(e.outcome) || vn(e.outcome) || mn(e.outcome) || gn(e.outcome) || _n(e.outcome) || An(e.outcome) || bn(e.outcome) || In(e.outcome) || hn(e.outcome) || wn(e.outcome) || Rn(e.outcome) || Cn(e.outcome)) && typeof e.status == "string" && (typeof e._status > "u" || i(e._status));
}
function Xi(n) {
  const e = n;
  return d(e) && (typeof e.fullUrl > "u" || typeof e.fullUrl == "string") && (typeof e._fullUrl > "u" || i(e._fullUrl)) && (typeof e.link > "u" || Array.isArray(e.link) && e.link.every(
    (t) => Un(t)
  )) && (typeof e.request > "u" || Ki(e.request)) && (typeof e.resource > "u" || V(e.resource) || U(e.resource) || N(e.resource) || L(e.resource) || G(e.resource) || z(e.resource) || Q(e.resource) || W(e.resource) || K(e.resource) || J(e.resource) || X(e.resource) || Y(e.resource) || Z(e.resource) || $(e.resource) || ee(e.resource) || te(e.resource) || ne(e.resource) || ie(e.resource) || re(e.resource) || oe(e.resource) || de(e.resource) || ae(e.resource) || fe(e.resource) || ye(e.resource) || ue(e.resource) || pe(e.resource) || se(e.resource) || ce(e.resource) || le(e.resource) || ve(e.resource) || me(e.resource) || ge(e.resource) || _e(e.resource) || Ae(e.resource) || be(e.resource) || Ie(e.resource) || he(e.resource) || we(e.resource) || Re(e.resource) || Ce(e.resource) || De(e.resource) || Se(e.resource) || Oe(e.resource) || Ee(e.resource) || Te(e.resource) || xe(e.resource) || je(e.resource) || Pe(e.resource) || Fe(e.resource) || He(e.resource) || Me(e.resource) || qe(e.resource) || ke(e.resource) || Be(e.resource) || Ve(e.resource) || Ue(e.resource) || Ne(e.resource) || Le(e.resource) || Ge(e.resource) || ze(e.resource) || Qe(e.resource) || We(e.resource) || Ke(e.resource) || Je(e.resource) || Xe(e.resource) || Ye(e.resource) || Ze(e.resource) || $e(e.resource) || et(e.resource) || tt(e.resource) || nt(e.resource) || it(e.resource) || rt(e.resource) || ot(e.resource) || dt(e.resource) || at(e.resource) || ft(e.resource) || yt(e.resource) || ut(e.resource) || pt(e.resource) || st(e.resource) || ct(e.resource) || lt(e.resource) || vt(e.resource) || mt(e.resource) || gt(e.resource) || _t(e.resource) || At(e.resource) || bt(e.resource) || It(e.resource) || ht(e.resource) || wt(e.resource) || Rt(e.resource) || Ct(e.resource) || Dt(e.resource) || St(e.resource) || Ot(e.resource) || Et(e.resource) || Tt(e.resource) || xt(e.resource) || jt(e.resource) || Pt(e.resource) || Ft(e.resource) || Ht(e.resource) || Mt(e.resource) || qt(e.resource) || kt(e.resource) || Bt(e.resource) || Vt(e.resource) || Ut(e.resource) || Nt(e.resource) || Lt(e.resource) || Gt(e.resource) || zt(e.resource) || Qt(e.resource) || Wt(e.resource) || Kt(e.resource) || Jt(e.resource) || Xt(e.resource) || Zt(e.resource) || $t(e.resource) || en(e.resource) || tn(e.resource) || nn(e.resource) || rn(e.resource) || on(e.resource) || dn(e.resource) || an(e.resource) || fn(e.resource) || yn(e.resource) || un(e.resource) || pn(e.resource) || sn(e.resource) || cn(e.resource) || ln(e.resource) || vn(e.resource) || mn(e.resource) || gn(e.resource) || _n(e.resource) || An(e.resource) || bn(e.resource) || In(e.resource) || hn(e.resource) || wn(e.resource) || Rn(e.resource) || Cn(e.resource)) && (typeof e.response > "u" || Ji(e.response)) && (typeof e.search > "u" || Wi(e.search));
}
function Y(n) {
  const e = n;
  return Yt(e) && e.resourceType === "Bundle" && (typeof e.entry > "u" || Array.isArray(e.entry) && e.entry.every(
    (t) => Xi(t)
  )) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.link > "u" || Array.isArray(e.link) && e.link.every(
    (t) => Un(t)
  )) && (typeof e.signature > "u" || O(e.signature)) && (typeof e.timestamp > "u" || typeof e.timestamp == "string") && (typeof e._timestamp > "u" || i(e._timestamp)) && (typeof e.total > "u" || typeof e.total == "number") && (e.type === "document" || e.type === "message" || e.type === "transaction" || e.type === "transaction-response" || e.type === "batch" || e.type === "batch-response" || e.type === "history" || e.type === "searchset" || e.type === "collection") && (typeof e._type > "u" || i(e._type));
}
function Yi(n) {
  const e = n;
  return d(e) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.releaseDate > "u" || typeof e.releaseDate == "string") && (typeof e._releaseDate > "u" || i(e._releaseDate)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function Zi(n) {
  const e = n;
  return d(e) && (typeof e.custodian > "u" || o(e.custodian)) && typeof e.description == "string" && (typeof e._description > "u" || i(e._description)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url));
}
function $i(n) {
  const e = n;
  return d(e) && (typeof e.cors > "u" || e.cors === !1 || e.cors === !0) && (typeof e._cors > "u" || i(e._cors)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.service > "u" || Array.isArray(e.service) && e.service.every(
    (t) => r(t)
  ));
}
function er(n) {
  const e = n;
  return d(e) && (e.code === "read" || e.code === "vread" || e.code === "update" || e.code === "patch" || e.code === "delete" || e.code === "history-instance" || e.code === "history-type" || e.code === "create" || e.code === "search-type") && (typeof e._code > "u" || i(e._code)) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || i(e._documentation));
}
function Nn(n) {
  const e = n;
  return d(e) && (typeof e.definition > "u" || typeof e.definition == "string") && (typeof e._definition > "u" || i(e._definition)) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || i(e._documentation)) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (e.type === "string" || e.type === "number" || e.type === "date" || e.type === "token" || e.type === "reference" || e.type === "composite" || e.type === "quantity" || e.type === "uri" || e.type === "special") && (typeof e._type > "u" || i(e._type));
}
function Ln(n) {
  const e = n;
  return d(e) && typeof e.definition == "string" && (typeof e._definition > "u" || i(e._definition)) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || i(e._documentation)) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name));
}
function tr(n) {
  const e = n;
  return d(e) && (typeof e.conditionalCreate > "u" || e.conditionalCreate === !1 || e.conditionalCreate === !0) && (typeof e._conditionalCreate > "u" || i(e._conditionalCreate)) && (typeof e.conditionalDelete > "u" || e.conditionalDelete === "not-supported" || e.conditionalDelete === "single" || e.conditionalDelete === "multiple") && (typeof e._conditionalDelete > "u" || i(e._conditionalDelete)) && (typeof e.conditionalRead > "u" || e.conditionalRead === "not-supported" || e.conditionalRead === "modified-since" || e.conditionalRead === "not-match" || e.conditionalRead === "full-support") && (typeof e._conditionalRead > "u" || i(e._conditionalRead)) && (typeof e.conditionalUpdate > "u" || e.conditionalUpdate === !1 || e.conditionalUpdate === !0) && (typeof e._conditionalUpdate > "u" || i(e._conditionalUpdate)) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || i(e._documentation)) && (typeof e.interaction > "u" || Array.isArray(e.interaction) && e.interaction.every(
    (t) => er(t)
  )) && (typeof e.operation > "u" || Array.isArray(e.operation) && e.operation.every(
    (t) => Ln(t)
  )) && (typeof e.profile > "u" || typeof e.profile == "string") && (typeof e._profile > "u" || i(e._profile)) && (typeof e.readHistory > "u" || e.readHistory === !1 || e.readHistory === !0) && (typeof e._readHistory > "u" || i(e._readHistory)) && (typeof e.referencePolicy > "u" || Array.isArray(e.referencePolicy) && e.referencePolicy.every(
    (t) => t === "literal" || t === "logical" || t === "resolves" || t === "enforced" || t === "local"
  )) && (typeof e._referencePolicy > "u" || Array.isArray(e._referencePolicy) && e._referencePolicy.every(
    (t) => i(t)
  )) && (typeof e.searchInclude > "u" || Array.isArray(e.searchInclude) && e.searchInclude.every(
    (t) => typeof t == "string"
  )) && (typeof e._searchInclude > "u" || Array.isArray(e._searchInclude) && e._searchInclude.every(
    (t) => i(t)
  )) && (typeof e.searchParam > "u" || Array.isArray(e.searchParam) && e.searchParam.every(
    (t) => Nn(t)
  )) && (typeof e.searchRevInclude > "u" || Array.isArray(e.searchRevInclude) && e.searchRevInclude.every(
    (t) => typeof t == "string"
  )) && (typeof e._searchRevInclude > "u" || Array.isArray(e._searchRevInclude) && e._searchRevInclude.every(
    (t) => i(t)
  )) && (typeof e.supportedProfile > "u" || Array.isArray(e.supportedProfile) && e.supportedProfile.every(
    (t) => typeof t == "string"
  )) && (typeof e._supportedProfile > "u" || Array.isArray(e._supportedProfile) && e._supportedProfile.every(
    (t) => i(t)
  )) && typeof e.type == "string" && (typeof e._type > "u" || i(e._type)) && (typeof e.updateCreate > "u" || e.updateCreate === !1 || e.updateCreate === !0) && (typeof e._updateCreate > "u" || i(e._updateCreate)) && (typeof e.versioning > "u" || e.versioning === "no-version" || e.versioning === "versioned" || e.versioning === "versioned-update") && (typeof e._versioning > "u" || i(e._versioning));
}
function nr(n) {
  const e = n;
  return d(e) && (e.code === "transaction" || e.code === "batch" || e.code === "search-system" || e.code === "history-system") && (typeof e._code > "u" || i(e._code)) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || i(e._documentation));
}
function ir(n) {
  const e = n;
  return d(e) && (typeof e.compartment > "u" || Array.isArray(e.compartment) && e.compartment.every(
    (t) => typeof t == "string"
  )) && (typeof e._compartment > "u" || Array.isArray(e._compartment) && e._compartment.every(
    (t) => i(t)
  )) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || i(e._documentation)) && (typeof e.interaction > "u" || Array.isArray(e.interaction) && e.interaction.every(
    (t) => nr(t)
  )) && (e.mode === "client" || e.mode === "server") && (typeof e._mode > "u" || i(e._mode)) && (typeof e.operation > "u" || Array.isArray(e.operation) && e.operation.every(
    (t) => Ln(t)
  )) && (typeof e.resource > "u" || Array.isArray(e.resource) && e.resource.every(
    (t) => tr(t)
  )) && (typeof e.searchParam > "u" || Array.isArray(e.searchParam) && e.searchParam.every(
    (t) => Nn(t)
  )) && (typeof e.security > "u" || $i(e.security));
}
function rr(n) {
  const e = n;
  return d(e) && typeof e.address == "string" && (typeof e._address > "u" || i(e._address)) && s(e.protocol);
}
function or(n) {
  const e = n;
  return d(e) && typeof e.definition == "string" && (typeof e._definition > "u" || i(e._definition)) && (e.mode === "sender" || e.mode === "receiver") && (typeof e._mode > "u" || i(e._mode));
}
function dr(n) {
  const e = n;
  return d(e) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || i(e._documentation)) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => rr(t)
  )) && (typeof e.reliableCache > "u" || typeof e.reliableCache == "number") && (typeof e.supportedMessage > "u" || Array.isArray(e.supportedMessage) && e.supportedMessage.every(
    (t) => or(t)
  ));
}
function ar(n) {
  const e = n;
  return d(e) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || i(e._documentation)) && (e.mode === "producer" || e.mode === "consumer") && (typeof e._mode > "u" || i(e._mode)) && typeof e.profile == "string" && (typeof e._profile > "u" || i(e._profile));
}
function Z(n) {
  const e = n;
  return f(e) && e.resourceType === "CapabilityStatement" && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && typeof e.date == "string" && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.document > "u" || Array.isArray(e.document) && e.document.every(
    (t) => ar(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && typeof e.fhirVersion == "string" && (typeof e._fhirVersion > "u" || i(e._fhirVersion)) && Array.isArray(e.format) && e.format.every(
    (t) => typeof t == "string"
  ) && (typeof e._format > "u" || Array.isArray(e._format) && e._format.every(
    (t) => i(t)
  )) && (typeof e.implementation > "u" || Zi(e.implementation)) && (typeof e.implementationGuide > "u" || Array.isArray(e.implementationGuide) && e.implementationGuide.every(
    (t) => typeof t == "string"
  )) && (typeof e._implementationGuide > "u" || Array.isArray(e._implementationGuide) && e._implementationGuide.every(
    (t) => i(t)
  )) && (typeof e.imports > "u" || Array.isArray(e.imports) && e.imports.every(
    (t) => typeof t == "string"
  )) && (typeof e._imports > "u" || Array.isArray(e._imports) && e._imports.every(
    (t) => i(t)
  )) && (typeof e.instantiates > "u" || Array.isArray(e.instantiates) && e.instantiates.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiates > "u" || Array.isArray(e._instantiates) && e._instantiates.every(
    (t) => i(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (e.kind === "instance" || e.kind === "capability" || e.kind === "requirements") && (typeof e._kind > "u" || i(e._kind)) && (typeof e.messaging > "u" || Array.isArray(e.messaging) && e.messaging.every(
    (t) => dr(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.patchFormat > "u" || Array.isArray(e.patchFormat) && e.patchFormat.every(
    (t) => typeof t == "string"
  )) && (typeof e._patchFormat > "u" || Array.isArray(e._patchFormat) && e._patchFormat.every(
    (t) => i(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (typeof e.rest > "u" || Array.isArray(e.rest) && e.rest.every(
    (t) => ir(t)
  )) && (typeof e.software > "u" || Yi(e.software)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function fr(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || r(e.code)) && (typeof e.dailyAmount > "u" || u(e.dailyAmount)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.doNotPerform > "u" || e.doNotPerform === !1 || e.doNotPerform === !0) && (typeof e._doNotPerform > "u" || i(e._doNotPerform)) && (typeof e.goal > "u" || Array.isArray(e.goal) && e.goal.every(
    (t) => o(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => i(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => i(t)
  )) && (typeof e.kind > "u" || e.kind === "Appointment" || e.kind === "CommunicationRequest" || e.kind === "DeviceRequest" || e.kind === "MedicationRequest" || e.kind === "NutritionOrder" || e.kind === "Task" || e.kind === "ServiceRequest" || e.kind === "VisionPrescription") && (typeof e._kind > "u" || i(e._kind)) && (typeof e.location > "u" || o(e.location)) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => o(t)
  )) && (typeof e.productCodeableConcept > "u" || r(e.productCodeableConcept)) && (typeof e.productReference > "u" || o(e.productReference)) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.scheduledTiming > "u" || A(e.scheduledTiming)) && (typeof e.scheduledPeriod > "u" || y(e.scheduledPeriod)) && (typeof e.scheduledString > "u" || typeof e.scheduledString == "string") && (typeof e._scheduledString > "u" || i(e._scheduledString)) && (e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "cancelled" || e.status === "not-started" || e.status === "scheduled" || e.status === "in-progress" || e.status === "completed" || e.status === "stopped") && (typeof e._status > "u" || i(e._status)) && (typeof e.statusReason > "u" || r(e.statusReason));
}
function yr(n) {
  const e = n;
  return d(e) && (typeof e.detail > "u" || fr(e.detail)) && (typeof e.outcomeCodeableConcept > "u" || Array.isArray(e.outcomeCodeableConcept) && e.outcomeCodeableConcept.every(
    (t) => r(t)
  )) && (typeof e.outcomeReference > "u" || Array.isArray(e.outcomeReference) && e.outcomeReference.every(
    (t) => o(t)
  )) && (typeof e.progress > "u" || Array.isArray(e.progress) && e.progress.every(
    (t) => l(t)
  )) && (typeof e.reference > "u" || o(e.reference));
}
function $(n) {
  const e = n;
  return f(e) && e.resourceType === "CarePlan" && (typeof e.activity > "u" || Array.isArray(e.activity) && e.activity.every(
    (t) => yr(t)
  )) && (typeof e.addresses > "u" || Array.isArray(e.addresses) && e.addresses.every(
    (t) => o(t)
  )) && (typeof e.author > "u" || o(e.author)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.careTeam > "u" || Array.isArray(e.careTeam) && e.careTeam.every(
    (t) => o(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && (typeof e.contributor > "u" || Array.isArray(e.contributor) && e.contributor.every(
    (t) => o(t)
  )) && (typeof e.created > "u" || typeof e.created == "string") && (typeof e._created > "u" || i(e._created)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.goal > "u" || Array.isArray(e.goal) && e.goal.every(
    (t) => o(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => i(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => i(t)
  )) && (e.intent === "proposal" || e.intent === "plan" || e.intent === "order" || e.intent === "option") && (typeof e._intent > "u" || i(e._intent)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => o(t)
  )) && (typeof e.period > "u" || y(e.period)) && (typeof e.replaces > "u" || Array.isArray(e.replaces) && e.replaces.every(
    (t) => o(t)
  )) && (e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "draft" || e.status === "completed" || e.status === "revoked") && (typeof e._status > "u" || i(e._status)) && o(e.subject) && (typeof e.supportingInfo > "u" || Array.isArray(e.supportingInfo) && e.supportingInfo.every(
    (t) => o(t)
  )) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title));
}
function ur(n) {
  const e = n;
  return d(e) && (typeof e.member > "u" || o(e.member)) && (typeof e.onBehalfOf > "u" || o(e.onBehalfOf)) && (typeof e.period > "u" || y(e.period)) && (typeof e.role > "u" || Array.isArray(e.role) && e.role.every(
    (t) => r(t)
  ));
}
function ee(n) {
  const e = n;
  return f(e) && e.resourceType === "CareTeam" && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.managingOrganization > "u" || Array.isArray(e.managingOrganization) && e.managingOrganization.every(
    (t) => o(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.participant > "u" || Array.isArray(e.participant) && e.participant.every(
    (t) => ur(t)
  )) && (typeof e.period > "u" || y(e.period)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.status > "u" || e.status === "active" || e.status === "inactive" || e.status === "entered-in-error" || e.status === "proposed" || e.status === "suspended") && (typeof e._status > "u" || i(e._status)) && (typeof e.subject > "u" || o(e.subject)) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => I(t)
  ));
}
function pr(n) {
  const e = n;
  return d(e) && o(e.item) && (e.relationtype === "triggers" || e.relationtype === "is-replaced-by") && (typeof e._relationtype > "u" || i(e._relationtype));
}
function te(n) {
  const e = n;
  return f(e) && e.resourceType === "CatalogEntry" && (typeof e.additionalCharacteristic > "u" || Array.isArray(e.additionalCharacteristic) && e.additionalCharacteristic.every(
    (t) => r(t)
  )) && (typeof e.additionalClassification > "u" || Array.isArray(e.additionalClassification) && e.additionalClassification.every(
    (t) => r(t)
  )) && (typeof e.additionalIdentifier > "u" || Array.isArray(e.additionalIdentifier) && e.additionalIdentifier.every(
    (t) => a(t)
  )) && (typeof e.classification > "u" || Array.isArray(e.classification) && e.classification.every(
    (t) => r(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.lastUpdated > "u" || typeof e.lastUpdated == "string") && (typeof e._lastUpdated > "u" || i(e._lastUpdated)) && typeof e.orderable == "boolean" && (typeof e._orderable > "u" || i(e._orderable)) && o(e.referencedItem) && (typeof e.relatedEntry > "u" || Array.isArray(e.relatedEntry) && e.relatedEntry.every(
    (t) => pr(t)
  )) && (typeof e.status > "u" || e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.type > "u" || r(e.type)) && (typeof e.validityPeriod > "u" || y(e.validityPeriod)) && (typeof e.validTo > "u" || typeof e.validTo == "string") && (typeof e._validTo > "u" || i(e._validTo));
}
function sr(n) {
  const e = n;
  return d(e) && o(e.actor) && (typeof e.function > "u" || r(e.function));
}
function ne(n) {
  const e = n;
  return f(e) && e.resourceType === "ChargeItem" && (typeof e.account > "u" || Array.isArray(e.account) && e.account.every(
    (t) => o(t)
  )) && (typeof e.bodysite > "u" || Array.isArray(e.bodysite) && e.bodysite.every(
    (t) => r(t)
  )) && r(e.code) && (typeof e.context > "u" || o(e.context)) && (typeof e.costCenter > "u" || o(e.costCenter)) && (typeof e.definitionCanonical > "u" || Array.isArray(e.definitionCanonical) && e.definitionCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._definitionCanonical > "u" || Array.isArray(e._definitionCanonical) && e._definitionCanonical.every(
    (t) => i(t)
  )) && (typeof e.definitionUri > "u" || Array.isArray(e.definitionUri) && e.definitionUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._definitionUri > "u" || Array.isArray(e._definitionUri) && e._definitionUri.every(
    (t) => i(t)
  )) && (typeof e.enteredDate > "u" || typeof e.enteredDate == "string") && (typeof e._enteredDate > "u" || i(e._enteredDate)) && (typeof e.enterer > "u" || o(e.enterer)) && (typeof e.factorOverride > "u" || typeof e.factorOverride == "number") && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || i(e._occurrenceDateTime)) && (typeof e.occurrencePeriod > "u" || y(e.occurrencePeriod)) && (typeof e.occurrenceTiming > "u" || A(e.occurrenceTiming)) && (typeof e.overrideReason > "u" || typeof e.overrideReason == "string") && (typeof e._overrideReason > "u" || i(e._overrideReason)) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => o(t)
  )) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => sr(t)
  )) && (typeof e.performingOrganization > "u" || o(e.performingOrganization)) && (typeof e.priceOverride > "u" || c(e.priceOverride)) && (typeof e.productReference > "u" || o(e.productReference)) && (typeof e.productCodeableConcept > "u" || r(e.productCodeableConcept)) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.reason > "u" || Array.isArray(e.reason) && e.reason.every(
    (t) => r(t)
  )) && (typeof e.requestingOrganization > "u" || o(e.requestingOrganization)) && (typeof e.service > "u" || Array.isArray(e.service) && e.service.every(
    (t) => o(t)
  )) && (e.status === "entered-in-error" || e.status === "unknown" || e.status === "planned" || e.status === "billable" || e.status === "not-billable" || e.status === "aborted" || e.status === "billed") && (typeof e._status > "u" || i(e._status)) && o(e.subject) && (typeof e.supportingInformation > "u" || Array.isArray(e.supportingInformation) && e.supportingInformation.every(
    (t) => o(t)
  ));
}
function Gn(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.expression > "u" || typeof e.expression == "string") && (typeof e._expression > "u" || i(e._expression)) && (typeof e.language > "u" || typeof e.language == "string") && (typeof e._language > "u" || i(e._language));
}
function cr(n) {
  const e = n;
  return d(e) && (typeof e.amount > "u" || c(e.amount)) && (typeof e.code > "u" || r(e.code)) && (typeof e.factor > "u" || typeof e.factor == "number") && (e.type === "base" || e.type === "surcharge" || e.type === "deduction" || e.type === "discount" || e.type === "tax" || e.type === "informational") && (typeof e._type > "u" || i(e._type));
}
function lr(n) {
  const e = n;
  return d(e) && (typeof e.applicability > "u" || Array.isArray(e.applicability) && e.applicability.every(
    (t) => Gn(t)
  )) && (typeof e.priceComponent > "u" || Array.isArray(e.priceComponent) && e.priceComponent.every(
    (t) => cr(t)
  ));
}
function ie(n) {
  const e = n;
  return f(e) && e.resourceType === "ChargeItemDefinition" && (typeof e.applicability > "u" || Array.isArray(e.applicability) && e.applicability.every(
    (t) => Gn(t)
  )) && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || i(e._approvalDate)) && (typeof e.code > "u" || r(e.code)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.derivedFromUri > "u" || Array.isArray(e.derivedFromUri) && e.derivedFromUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._derivedFromUri > "u" || Array.isArray(e._derivedFromUri) && e._derivedFromUri.every(
    (t) => i(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.instance > "u" || Array.isArray(e.instance) && e.instance.every(
    (t) => o(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || i(e._lastReviewDate)) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => typeof t == "string"
  )) && (typeof e._partOf > "u" || Array.isArray(e._partOf) && e._partOf.every(
    (t) => i(t)
  )) && (typeof e.propertyGroup > "u" || Array.isArray(e.propertyGroup) && e.propertyGroup.every(
    (t) => lr(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.replaces > "u" || Array.isArray(e.replaces) && e.replaces.every(
    (t) => typeof t == "string"
  )) && (typeof e._replaces > "u" || Array.isArray(e._replaces) && e._replaces.every(
    (t) => i(t)
  )) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && typeof e.url == "string" && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function vr(n) {
  const e = n;
  return d(e) && (typeof e.claim > "u" || o(e.claim)) && (typeof e.reference > "u" || a(e.reference)) && (typeof e.relationship > "u" || r(e.relationship));
}
function mr(n) {
  const e = n;
  return d(e) && (typeof e.party > "u" || o(e.party)) && r(e.type);
}
function gr(n) {
  const e = n;
  return d(e) && o(e.provider) && (typeof e.qualification > "u" || r(e.qualification)) && (typeof e.responsible > "u" || e.responsible === !1 || e.responsible === !0) && (typeof e._responsible > "u" || i(e._responsible)) && (typeof e.role > "u" || r(e.role)) && typeof e.sequence == "number";
}
function _r(n) {
  const e = n;
  return d(e) && r(e.category) && (typeof e.code > "u" || r(e.code)) && (typeof e.reason > "u" || r(e.reason)) && typeof e.sequence == "number" && (typeof e.timingDate > "u" || typeof e.timingDate == "string") && (typeof e._timingDate > "u" || i(e._timingDate)) && (typeof e.timingPeriod > "u" || y(e.timingPeriod)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueAttachment > "u" || g(e.valueAttachment)) && (typeof e.valueReference > "u" || o(e.valueReference));
}
function Ar(n) {
  const e = n;
  return d(e) && (typeof e.diagnosisCodeableConcept > "u" || r(e.diagnosisCodeableConcept)) && (typeof e.diagnosisReference > "u" || o(e.diagnosisReference)) && (typeof e.onAdmission > "u" || r(e.onAdmission)) && (typeof e.packageCode > "u" || r(e.packageCode)) && typeof e.sequence == "number" && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => r(t)
  ));
}
function br(n) {
  const e = n;
  return d(e) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.procedureCodeableConcept > "u" || r(e.procedureCodeableConcept)) && (typeof e.procedureReference > "u" || o(e.procedureReference)) && typeof e.sequence == "number" && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => r(t)
  )) && (typeof e.udi > "u" || Array.isArray(e.udi) && e.udi.every(
    (t) => o(t)
  ));
}
function Ir(n) {
  const e = n;
  return d(e) && (typeof e.businessArrangement > "u" || typeof e.businessArrangement == "string") && (typeof e._businessArrangement > "u" || i(e._businessArrangement)) && (typeof e.claimResponse > "u" || o(e.claimResponse)) && o(e.coverage) && typeof e.focal == "boolean" && (typeof e._focal > "u" || i(e._focal)) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.preAuthRef > "u" || Array.isArray(e.preAuthRef) && e.preAuthRef.every(
    (t) => typeof t == "string"
  )) && (typeof e._preAuthRef > "u" || Array.isArray(e._preAuthRef) && e._preAuthRef.every(
    (t) => i(t)
  )) && typeof e.sequence == "number";
}
function hr(n) {
  const e = n;
  return d(e) && typeof e.date == "string" && (typeof e._date > "u" || i(e._date)) && (typeof e.locationAddress > "u" || h(e.locationAddress)) && (typeof e.locationReference > "u" || o(e.locationReference)) && (typeof e.type > "u" || r(e.type));
}
function wr(n) {
  const e = n;
  return d(e) && (typeof e.category > "u" || r(e.category)) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => r(t)
  )) && (typeof e.net > "u" || c(e.net)) && r(e.productOrService) && (typeof e.programCode > "u" || Array.isArray(e.programCode) && e.programCode.every(
    (t) => r(t)
  )) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.revenue > "u" || r(e.revenue)) && typeof e.sequence == "number" && (typeof e.udi > "u" || Array.isArray(e.udi) && e.udi.every(
    (t) => o(t)
  )) && (typeof e.unitPrice > "u" || c(e.unitPrice));
}
function Rr(n) {
  const e = n;
  return d(e) && (typeof e.category > "u" || r(e.category)) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => r(t)
  )) && (typeof e.net > "u" || c(e.net)) && r(e.productOrService) && (typeof e.programCode > "u" || Array.isArray(e.programCode) && e.programCode.every(
    (t) => r(t)
  )) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.revenue > "u" || r(e.revenue)) && typeof e.sequence == "number" && (typeof e.subDetail > "u" || Array.isArray(e.subDetail) && e.subDetail.every(
    (t) => wr(t)
  )) && (typeof e.udi > "u" || Array.isArray(e.udi) && e.udi.every(
    (t) => o(t)
  )) && (typeof e.unitPrice > "u" || c(e.unitPrice));
}
function Cr(n) {
  const e = n;
  return d(e) && (typeof e.bodySite > "u" || r(e.bodySite)) && (typeof e.careTeamSequence > "u" || Array.isArray(e.careTeamSequence) && e.careTeamSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.category > "u" || r(e.category)) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => Rr(t)
  )) && (typeof e.diagnosisSequence > "u" || Array.isArray(e.diagnosisSequence) && e.diagnosisSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.encounter > "u" || Array.isArray(e.encounter) && e.encounter.every(
    (t) => o(t)
  )) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.informationSequence > "u" || Array.isArray(e.informationSequence) && e.informationSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.locationCodeableConcept > "u" || r(e.locationCodeableConcept)) && (typeof e.locationAddress > "u" || h(e.locationAddress)) && (typeof e.locationReference > "u" || o(e.locationReference)) && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => r(t)
  )) && (typeof e.net > "u" || c(e.net)) && (typeof e.procedureSequence > "u" || Array.isArray(e.procedureSequence) && e.procedureSequence.every(
    (t) => typeof t == "number"
  )) && r(e.productOrService) && (typeof e.programCode > "u" || Array.isArray(e.programCode) && e.programCode.every(
    (t) => r(t)
  )) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.revenue > "u" || r(e.revenue)) && typeof e.sequence == "number" && (typeof e.servicedDate > "u" || typeof e.servicedDate == "string") && (typeof e._servicedDate > "u" || i(e._servicedDate)) && (typeof e.servicedPeriod > "u" || y(e.servicedPeriod)) && (typeof e.subSite > "u" || Array.isArray(e.subSite) && e.subSite.every(
    (t) => r(t)
  )) && (typeof e.udi > "u" || Array.isArray(e.udi) && e.udi.every(
    (t) => o(t)
  )) && (typeof e.unitPrice > "u" || c(e.unitPrice));
}
function re(n) {
  const e = n;
  return f(e) && e.resourceType === "Claim" && (typeof e.accident > "u" || hr(e.accident)) && (typeof e.billablePeriod > "u" || y(e.billablePeriod)) && (typeof e.careTeam > "u" || Array.isArray(e.careTeam) && e.careTeam.every(
    (t) => gr(t)
  )) && typeof e.created == "string" && (typeof e._created > "u" || i(e._created)) && (typeof e.diagnosis > "u" || Array.isArray(e.diagnosis) && e.diagnosis.every(
    (t) => Ar(t)
  )) && (typeof e.enterer > "u" || o(e.enterer)) && (typeof e.facility > "u" || o(e.facility)) && (typeof e.fundsReserve > "u" || r(e.fundsReserve)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && Array.isArray(e.insurance) && e.insurance.every(
    (t) => Ir(t)
  ) && (typeof e.insurer > "u" || o(e.insurer)) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => Cr(t)
  )) && (typeof e.originalPrescription > "u" || o(e.originalPrescription)) && o(e.patient) && (typeof e.payee > "u" || mr(e.payee)) && (typeof e.prescription > "u" || o(e.prescription)) && r(e.priority) && (typeof e.procedure > "u" || Array.isArray(e.procedure) && e.procedure.every(
    (t) => br(t)
  )) && o(e.provider) && (typeof e.referral > "u" || o(e.referral)) && (typeof e.related > "u" || Array.isArray(e.related) && e.related.every(
    (t) => vr(t)
  )) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || i(e._status)) && (typeof e.subType > "u" || r(e.subType)) && (typeof e.supportingInfo > "u" || Array.isArray(e.supportingInfo) && e.supportingInfo.every(
    (t) => _r(t)
  )) && (typeof e.total > "u" || c(e.total)) && r(e.type) && (e.use === "claim" || e.use === "preauthorization" || e.use === "predetermination") && (typeof e._use > "u" || i(e._use));
}
function q(n) {
  const e = n;
  return d(e) && (typeof e.amount > "u" || c(e.amount)) && r(e.category) && (typeof e.reason > "u" || r(e.reason)) && (typeof e.value > "u" || typeof e.value == "number");
}
function Dr(n) {
  const e = n;
  return d(e) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => q(t)
  )) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && typeof e.subDetailSequence == "number";
}
function Sr(n) {
  const e = n;
  return d(e) && Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => q(t)
  ) && typeof e.detailSequence == "number" && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && (typeof e.subDetail > "u" || Array.isArray(e.subDetail) && e.subDetail.every(
    (t) => Dr(t)
  ));
}
function Or(n) {
  const e = n;
  return d(e) && Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => q(t)
  ) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => Sr(t)
  )) && typeof e.itemSequence == "number" && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  ));
}
function Er(n) {
  const e = n;
  return d(e) && Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => q(t)
  ) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => r(t)
  )) && (typeof e.net > "u" || c(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && r(e.productOrService) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.unitPrice > "u" || c(e.unitPrice));
}
function Tr(n) {
  const e = n;
  return d(e) && Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => q(t)
  ) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => r(t)
  )) && (typeof e.net > "u" || c(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && r(e.productOrService) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.subDetail > "u" || Array.isArray(e.subDetail) && e.subDetail.every(
    (t) => Er(t)
  )) && (typeof e.unitPrice > "u" || c(e.unitPrice));
}
function xr(n) {
  const e = n;
  return d(e) && Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => q(t)
  ) && (typeof e.bodySite > "u" || r(e.bodySite)) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => Tr(t)
  )) && (typeof e.detailSequence > "u" || Array.isArray(e.detailSequence) && e.detailSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.itemSequence > "u" || Array.isArray(e.itemSequence) && e.itemSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.locationCodeableConcept > "u" || r(e.locationCodeableConcept)) && (typeof e.locationAddress > "u" || h(e.locationAddress)) && (typeof e.locationReference > "u" || o(e.locationReference)) && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => r(t)
  )) && (typeof e.net > "u" || c(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && r(e.productOrService) && (typeof e.programCode > "u" || Array.isArray(e.programCode) && e.programCode.every(
    (t) => r(t)
  )) && (typeof e.provider > "u" || Array.isArray(e.provider) && e.provider.every(
    (t) => o(t)
  )) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.servicedDate > "u" || typeof e.servicedDate == "string") && (typeof e._servicedDate > "u" || i(e._servicedDate)) && (typeof e.servicedPeriod > "u" || y(e.servicedPeriod)) && (typeof e.subdetailSequence > "u" || Array.isArray(e.subdetailSequence) && e.subdetailSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.subSite > "u" || Array.isArray(e.subSite) && e.subSite.every(
    (t) => r(t)
  )) && (typeof e.unitPrice > "u" || c(e.unitPrice));
}
function jr(n) {
  const e = n;
  return d(e) && c(e.amount) && r(e.category);
}
function Pr(n) {
  const e = n;
  return d(e) && (typeof e.adjustment > "u" || c(e.adjustment)) && (typeof e.adjustmentReason > "u" || r(e.adjustmentReason)) && c(e.amount) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.identifier > "u" || a(e.identifier)) && r(e.type);
}
function Fr(n) {
  const e = n;
  return d(e) && (typeof e.language > "u" || r(e.language)) && (typeof e.number > "u" || typeof e.number == "number") && typeof e.text == "string" && (typeof e._text > "u" || i(e._text)) && (typeof e.type > "u" || e.type === "display" || e.type === "print" || e.type === "printoper") && (typeof e._type > "u" || i(e._type));
}
function Hr(n) {
  const e = n;
  return d(e) && (typeof e.businessArrangement > "u" || typeof e.businessArrangement == "string") && (typeof e._businessArrangement > "u" || i(e._businessArrangement)) && (typeof e.claimResponse > "u" || o(e.claimResponse)) && o(e.coverage) && typeof e.focal == "boolean" && (typeof e._focal > "u" || i(e._focal)) && typeof e.sequence == "number";
}
function Mr(n) {
  const e = n;
  return d(e) && r(e.code) && (typeof e.detailSequence > "u" || typeof e.detailSequence == "number") && (typeof e.itemSequence > "u" || typeof e.itemSequence == "number") && (typeof e.subDetailSequence > "u" || typeof e.subDetailSequence == "number");
}
function oe(n) {
  const e = n;
  return f(e) && e.resourceType === "ClaimResponse" && (typeof e.addItem > "u" || Array.isArray(e.addItem) && e.addItem.every(
    (t) => xr(t)
  )) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => q(t)
  )) && (typeof e.communicationRequest > "u" || Array.isArray(e.communicationRequest) && e.communicationRequest.every(
    (t) => o(t)
  )) && typeof e.created == "string" && (typeof e._created > "u" || i(e._created)) && (typeof e.disposition > "u" || typeof e.disposition == "string") && (typeof e._disposition > "u" || i(e._disposition)) && (typeof e.error > "u" || Array.isArray(e.error) && e.error.every(
    (t) => Mr(t)
  )) && (typeof e.form > "u" || g(e.form)) && (typeof e.formCode > "u" || r(e.formCode)) && (typeof e.fundsReserve > "u" || r(e.fundsReserve)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.insurance > "u" || Array.isArray(e.insurance) && e.insurance.every(
    (t) => Hr(t)
  )) && o(e.insurer) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => Or(t)
  )) && (e.outcome === "error" || e.outcome === "queued" || e.outcome === "complete" || e.outcome === "partial") && (typeof e._outcome > "u" || i(e._outcome)) && o(e.patient) && (typeof e.payeeType > "u" || r(e.payeeType)) && (typeof e.payment > "u" || Pr(e.payment)) && (typeof e.preAuthPeriod > "u" || y(e.preAuthPeriod)) && (typeof e.preAuthRef > "u" || typeof e.preAuthRef == "string") && (typeof e._preAuthRef > "u" || i(e._preAuthRef)) && (typeof e.processNote > "u" || Array.isArray(e.processNote) && e.processNote.every(
    (t) => Fr(t)
  )) && (typeof e.request > "u" || o(e.request)) && (typeof e.requestor > "u" || o(e.requestor)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || i(e._status)) && (typeof e.subType > "u" || r(e.subType)) && (typeof e.total > "u" || Array.isArray(e.total) && e.total.every(
    (t) => jr(t)
  )) && r(e.type) && (e.use === "claim" || e.use === "preauthorization" || e.use === "predetermination") && (typeof e._use > "u" || i(e._use));
}
function qr(n) {
  const e = n;
  return d(e) && r(e.code) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => o(t)
  ));
}
function kr(n) {
  const e = n;
  return d(e) && (typeof e.basis > "u" || typeof e.basis == "string") && (typeof e._basis > "u" || i(e._basis)) && (typeof e.itemCodeableConcept > "u" || r(e.itemCodeableConcept)) && (typeof e.itemReference > "u" || o(e.itemReference));
}
function de(n) {
  const e = n;
  return f(e) && e.resourceType === "ClinicalImpression" && (typeof e.assessor > "u" || o(e.assessor)) && (typeof e.code > "u" || r(e.code)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.effectiveDateTime > "u" || typeof e.effectiveDateTime == "string") && (typeof e._effectiveDateTime > "u" || i(e._effectiveDateTime)) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.finding > "u" || Array.isArray(e.finding) && e.finding.every(
    (t) => kr(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.investigation > "u" || Array.isArray(e.investigation) && e.investigation.every(
    (t) => qr(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.previous > "u" || o(e.previous)) && (typeof e.problem > "u" || Array.isArray(e.problem) && e.problem.every(
    (t) => o(t)
  )) && (typeof e.prognosisCodeableConcept > "u" || Array.isArray(e.prognosisCodeableConcept) && e.prognosisCodeableConcept.every(
    (t) => r(t)
  )) && (typeof e.prognosisReference > "u" || Array.isArray(e.prognosisReference) && e.prognosisReference.every(
    (t) => o(t)
  )) && (typeof e.protocol > "u" || Array.isArray(e.protocol) && e.protocol.every(
    (t) => typeof t == "string"
  )) && (typeof e._protocol > "u" || Array.isArray(e._protocol) && e._protocol.every(
    (t) => i(t)
  )) && (e.status === "entered-in-error" || e.status === "in-progress" || e.status === "completed") && (typeof e._status > "u" || i(e._status)) && (typeof e.statusReason > "u" || r(e.statusReason)) && o(e.subject) && (typeof e.summary > "u" || typeof e.summary == "string") && (typeof e._summary > "u" || i(e._summary)) && (typeof e.supportingInfo > "u" || Array.isArray(e.supportingInfo) && e.supportingInfo.every(
    (t) => o(t)
  ));
}
function Br(n) {
  const e = n;
  return d(e) && typeof e.code == "string" && (typeof e._code > "u" || i(e._code)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && Array.isArray(e.operator) && e.operator.every(
    (t) => t === "exists" || t === "in" || t === "=" || t === "is-a" || t === "descendent-of" || t === "is-not-a" || t === "regex" || t === "not-in" || t === "generalizes"
  ) && (typeof e._operator > "u" || Array.isArray(e._operator) && e._operator.every(
    (t) => i(t)
  )) && typeof e.value == "string" && (typeof e._value > "u" || i(e._value));
}
function Vr(n) {
  const e = n;
  return d(e) && typeof e.code == "string" && (typeof e._code > "u" || i(e._code)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (e.type === "string" || e.type === "boolean" || e.type === "code" || e.type === "Coding" || e.type === "integer" || e.type === "dateTime" || e.type === "decimal") && (typeof e._type > "u" || i(e._type)) && (typeof e.uri > "u" || typeof e.uri == "string") && (typeof e._uri > "u" || i(e._uri));
}
function Ur(n) {
  const e = n;
  return d(e) && (typeof e.language > "u" || typeof e.language == "string") && (typeof e._language > "u" || i(e._language)) && (typeof e.use > "u" || s(e.use)) && typeof e.value == "string" && (typeof e._value > "u" || i(e._value));
}
function Nr(n) {
  const e = n;
  return d(e) && typeof e.code == "string" && (typeof e._code > "u" || i(e._code)) && (typeof e.valueCode > "u" || typeof e.valueCode == "string") && (typeof e._valueCode > "u" || i(e._valueCode)) && (typeof e.valueCoding > "u" || s(e.valueCoding)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || i(e._valueDateTime)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number");
}
function zn(n) {
  const e = n;
  return d(e) && typeof e.code == "string" && (typeof e._code > "u" || i(e._code)) && (typeof e.concept > "u" || Array.isArray(e.concept) && e.concept.every(
    (t) => zn(t)
  )) && (typeof e.definition > "u" || typeof e.definition == "string") && (typeof e._definition > "u" || i(e._definition)) && (typeof e.designation > "u" || Array.isArray(e.designation) && e.designation.every(
    (t) => Ur(t)
  )) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || i(e._display)) && (typeof e.property > "u" || Array.isArray(e.property) && e.property.every(
    (t) => Nr(t)
  ));
}
function ae(n) {
  const e = n;
  return f(e) && e.resourceType === "CodeSystem" && (typeof e.caseSensitive > "u" || e.caseSensitive === !1 || e.caseSensitive === !0) && (typeof e._caseSensitive > "u" || i(e._caseSensitive)) && (typeof e.compositional > "u" || e.compositional === !1 || e.compositional === !0) && (typeof e._compositional > "u" || i(e._compositional)) && (typeof e.concept > "u" || Array.isArray(e.concept) && e.concept.every(
    (t) => zn(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (e.content === "example" || e.content === "complete" || e.content === "not-present" || e.content === "fragment" || e.content === "supplement") && (typeof e._content > "u" || i(e._content)) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.count > "u" || typeof e.count == "number") && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.filter > "u" || Array.isArray(e.filter) && e.filter.every(
    (t) => Br(t)
  )) && (typeof e.hierarchyMeaning > "u" || e.hierarchyMeaning === "is-a" || e.hierarchyMeaning === "grouped-by" || e.hierarchyMeaning === "part-of" || e.hierarchyMeaning === "classified-with") && (typeof e._hierarchyMeaning > "u" || i(e._hierarchyMeaning)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.property > "u" || Array.isArray(e.property) && e.property.every(
    (t) => Vr(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.supplements > "u" || typeof e.supplements == "string") && (typeof e._supplements > "u" || i(e._supplements)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.valueSet > "u" || typeof e.valueSet == "string") && (typeof e._valueSet > "u" || i(e._valueSet)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version)) && (typeof e.versionNeeded > "u" || e.versionNeeded === !1 || e.versionNeeded === !0) && (typeof e._versionNeeded > "u" || i(e._versionNeeded));
}
function Lr(n) {
  const e = n;
  return d(e) && (typeof e.contentString > "u" || typeof e.contentString == "string") && (typeof e._contentString > "u" || i(e._contentString)) && (typeof e.contentAttachment > "u" || g(e.contentAttachment)) && (typeof e.contentReference > "u" || o(e.contentReference));
}
function fe(n) {
  const e = n;
  return f(e) && e.resourceType === "Communication" && (typeof e.about > "u" || Array.isArray(e.about) && e.about.every(
    (t) => o(t)
  )) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.inResponseTo > "u" || Array.isArray(e.inResponseTo) && e.inResponseTo.every(
    (t) => o(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => i(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => i(t)
  )) && (typeof e.medium > "u" || Array.isArray(e.medium) && e.medium.every(
    (t) => r(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => o(t)
  )) && (typeof e.payload > "u" || Array.isArray(e.payload) && e.payload.every(
    (t) => Lr(t)
  )) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || i(e._priority)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.received > "u" || typeof e.received == "string") && (typeof e._received > "u" || i(e._received)) && (typeof e.recipient > "u" || Array.isArray(e.recipient) && e.recipient.every(
    (t) => o(t)
  )) && (typeof e.sender > "u" || o(e.sender)) && (typeof e.sent > "u" || typeof e.sent == "string") && (typeof e._sent > "u" || i(e._sent)) && (e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "in-progress" || e.status === "completed" || e.status === "stopped" || e.status === "preparation" || e.status === "not-done") && (typeof e._status > "u" || i(e._status)) && (typeof e.statusReason > "u" || r(e.statusReason)) && (typeof e.subject > "u" || o(e.subject)) && (typeof e.topic > "u" || r(e.topic));
}
function Gr(n) {
  const e = n;
  return d(e) && (typeof e.contentString > "u" || typeof e.contentString == "string") && (typeof e._contentString > "u" || i(e._contentString)) && (typeof e.contentAttachment > "u" || g(e.contentAttachment)) && (typeof e.contentReference > "u" || o(e.contentReference));
}
function ye(n) {
  const e = n;
  return f(e) && e.resourceType === "CommunicationRequest" && (typeof e.about > "u" || Array.isArray(e.about) && e.about.every(
    (t) => o(t)
  )) && (typeof e.authoredOn > "u" || typeof e.authoredOn == "string") && (typeof e._authoredOn > "u" || i(e._authoredOn)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && (typeof e.doNotPerform > "u" || e.doNotPerform === !1 || e.doNotPerform === !0) && (typeof e._doNotPerform > "u" || i(e._doNotPerform)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.groupIdentifier > "u" || a(e.groupIdentifier)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.medium > "u" || Array.isArray(e.medium) && e.medium.every(
    (t) => r(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || i(e._occurrenceDateTime)) && (typeof e.occurrencePeriod > "u" || y(e.occurrencePeriod)) && (typeof e.payload > "u" || Array.isArray(e.payload) && e.payload.every(
    (t) => Gr(t)
  )) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || i(e._priority)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.recipient > "u" || Array.isArray(e.recipient) && e.recipient.every(
    (t) => o(t)
  )) && (typeof e.replaces > "u" || Array.isArray(e.replaces) && e.replaces.every(
    (t) => o(t)
  )) && (typeof e.requester > "u" || o(e.requester)) && (typeof e.sender > "u" || o(e.sender)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "draft" || e.status === "completed" || e.status === "revoked") && (typeof e._status > "u" || i(e._status)) && (typeof e.statusReason > "u" || r(e.statusReason)) && (typeof e.subject > "u" || o(e.subject));
}
function zr(n) {
  const e = n;
  return d(e) && typeof e.code == "string" && (typeof e._code > "u" || i(e._code)) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || i(e._documentation)) && (typeof e.param > "u" || Array.isArray(e.param) && e.param.every(
    (t) => typeof t == "string"
  )) && (typeof e._param > "u" || Array.isArray(e._param) && e._param.every(
    (t) => i(t)
  ));
}
function ue(n) {
  const e = n;
  return f(e) && e.resourceType === "CompartmentDefinition" && (e.code === "Patient" || e.code === "Encounter" || e.code === "RelatedPerson" || e.code === "Practitioner" || e.code === "Device") && (typeof e._code > "u" || i(e._code)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (typeof e.resource > "u" || Array.isArray(e.resource) && e.resource.every(
    (t) => zr(t)
  )) && typeof e.search == "boolean" && (typeof e._search > "u" || i(e._search)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && typeof e.url == "string" && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function Qr(n) {
  const e = n;
  return d(e) && (e.mode === "official" || e.mode === "personal" || e.mode === "professional" || e.mode === "legal") && (typeof e._mode > "u" || i(e._mode)) && (typeof e.party > "u" || o(e.party)) && (typeof e.time > "u" || typeof e.time == "string") && (typeof e._time > "u" || i(e._time));
}
function Wr(n) {
  const e = n;
  return d(e) && (e.code === "replaces" || e.code === "transforms" || e.code === "signs" || e.code === "appends") && (typeof e._code > "u" || i(e._code)) && (typeof e.targetIdentifier > "u" || a(e.targetIdentifier)) && (typeof e.targetReference > "u" || o(e.targetReference));
}
function Kr(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => r(t)
  )) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => o(t)
  )) && (typeof e.period > "u" || y(e.period));
}
function Qn(n) {
  const e = n;
  return d(e) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => o(t)
  )) && (typeof e.code > "u" || r(e.code)) && (typeof e.emptyReason > "u" || r(e.emptyReason)) && (typeof e.entry > "u" || Array.isArray(e.entry) && e.entry.every(
    (t) => o(t)
  )) && (typeof e.focus > "u" || o(e.focus)) && (typeof e.mode > "u" || e.mode === "working" || e.mode === "snapshot" || e.mode === "changes") && (typeof e._mode > "u" || i(e._mode)) && (typeof e.orderedBy > "u" || r(e.orderedBy)) && (typeof e.section > "u" || Array.isArray(e.section) && e.section.every(
    (t) => Qn(t)
  )) && (typeof e.text > "u" || Bn(e.text)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title));
}
function pe(n) {
  const e = n;
  return f(e) && e.resourceType === "Composition" && (typeof e.attester > "u" || Array.isArray(e.attester) && e.attester.every(
    (t) => Qr(t)
  )) && Array.isArray(e.author) && e.author.every(
    (t) => o(t)
  ) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && (typeof e.confidentiality > "u" || typeof e.confidentiality == "string") && (typeof e._confidentiality > "u" || i(e._confidentiality)) && (typeof e.custodian > "u" || o(e.custodian)) && typeof e.date == "string" && (typeof e._date > "u" || i(e._date)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.event > "u" || Array.isArray(e.event) && e.event.every(
    (t) => Kr(t)
  )) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.relatesTo > "u" || Array.isArray(e.relatesTo) && e.relatesTo.every(
    (t) => Wr(t)
  )) && (typeof e.section > "u" || Array.isArray(e.section) && e.section.every(
    (t) => Qn(t)
  )) && (e.status === "entered-in-error" || e.status === "preliminary" || e.status === "final" || e.status === "amended") && (typeof e._status > "u" || i(e._status)) && (typeof e.subject > "u" || o(e.subject)) && typeof e.title == "string" && (typeof e._title > "u" || i(e._title)) && r(e.type);
}
function Hn(n) {
  const e = n;
  return d(e) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || i(e._display)) && typeof e.property == "string" && (typeof e._property > "u" || i(e._property)) && (typeof e.system > "u" || typeof e.system == "string") && (typeof e._system > "u" || i(e._system)) && typeof e.value == "string" && (typeof e._value > "u" || i(e._value));
}
function Jr(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || typeof e.code == "string") && (typeof e._code > "u" || i(e._code)) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment)) && (typeof e.dependsOn > "u" || Array.isArray(e.dependsOn) && e.dependsOn.every(
    (t) => Hn(t)
  )) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || i(e._display)) && (e.equivalence === "relatedto" || e.equivalence === "equivalent" || e.equivalence === "equal" || e.equivalence === "wider" || e.equivalence === "subsumes" || e.equivalence === "narrower" || e.equivalence === "specializes" || e.equivalence === "inexact" || e.equivalence === "unmatched" || e.equivalence === "disjoint") && (typeof e._equivalence > "u" || i(e._equivalence)) && (typeof e.product > "u" || Array.isArray(e.product) && e.product.every(
    (t) => Hn(t)
  ));
}
function Xr(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || typeof e.code == "string") && (typeof e._code > "u" || i(e._code)) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || i(e._display)) && (typeof e.target > "u" || Array.isArray(e.target) && e.target.every(
    (t) => Jr(t)
  ));
}
function Yr(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || typeof e.code == "string") && (typeof e._code > "u" || i(e._code)) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || i(e._display)) && (e.mode === "provided" || e.mode === "fixed" || e.mode === "other-map") && (typeof e._mode > "u" || i(e._mode)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url));
}
function Zr(n) {
  const e = n;
  return d(e) && Array.isArray(e.element) && e.element.every(
    (t) => Xr(t)
  ) && (typeof e.source > "u" || typeof e.source == "string") && (typeof e._source > "u" || i(e._source)) && (typeof e.sourceVersion > "u" || typeof e.sourceVersion == "string") && (typeof e._sourceVersion > "u" || i(e._sourceVersion)) && (typeof e.target > "u" || typeof e.target == "string") && (typeof e._target > "u" || i(e._target)) && (typeof e.targetVersion > "u" || typeof e.targetVersion == "string") && (typeof e._targetVersion > "u" || i(e._targetVersion)) && (typeof e.unmapped > "u" || Yr(e.unmapped));
}
function se(n) {
  const e = n;
  return f(e) && e.resourceType === "ConceptMap" && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.group > "u" || Array.isArray(e.group) && e.group.every(
    (t) => Zr(t)
  )) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (typeof e.sourceUri > "u" || typeof e.sourceUri == "string") && (typeof e._sourceUri > "u" || i(e._sourceUri)) && (typeof e.sourceCanonical > "u" || typeof e.sourceCanonical == "string") && (typeof e._sourceCanonical > "u" || i(e._sourceCanonical)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.targetUri > "u" || typeof e.targetUri == "string") && (typeof e._targetUri > "u" || i(e._targetUri)) && (typeof e.targetCanonical > "u" || typeof e.targetCanonical == "string") && (typeof e._targetCanonical > "u" || i(e._targetCanonical)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function $r(n) {
  const e = n;
  return d(e) && (typeof e.assessment > "u" || Array.isArray(e.assessment) && e.assessment.every(
    (t) => o(t)
  )) && (typeof e.summary > "u" || r(e.summary)) && (typeof e.type > "u" || r(e.type));
}
function eo(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => r(t)
  )) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => o(t)
  ));
}
function ce(n) {
  const e = n;
  return f(e) && e.resourceType === "Condition" && (typeof e.abatementDateTime > "u" || typeof e.abatementDateTime == "string") && (typeof e._abatementDateTime > "u" || i(e._abatementDateTime)) && (typeof e.abatementAge > "u" || C(e.abatementAge)) && (typeof e.abatementPeriod > "u" || y(e.abatementPeriod)) && (typeof e.abatementRange > "u" || v(e.abatementRange)) && (typeof e.abatementString > "u" || typeof e.abatementString == "string") && (typeof e._abatementString > "u" || i(e._abatementString)) && (typeof e.asserter > "u" || o(e.asserter)) && (typeof e.bodySite > "u" || Array.isArray(e.bodySite) && e.bodySite.every(
    (t) => r(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && (typeof e.clinicalStatus > "u" || r(e.clinicalStatus)) && (typeof e.code > "u" || r(e.code)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.evidence > "u" || Array.isArray(e.evidence) && e.evidence.every(
    (t) => eo(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.onsetDateTime > "u" || typeof e.onsetDateTime == "string") && (typeof e._onsetDateTime > "u" || i(e._onsetDateTime)) && (typeof e.onsetAge > "u" || C(e.onsetAge)) && (typeof e.onsetPeriod > "u" || y(e.onsetPeriod)) && (typeof e.onsetRange > "u" || v(e.onsetRange)) && (typeof e.onsetString > "u" || typeof e.onsetString == "string") && (typeof e._onsetString > "u" || i(e._onsetString)) && (typeof e.recordedDate > "u" || typeof e.recordedDate == "string") && (typeof e._recordedDate > "u" || i(e._recordedDate)) && (typeof e.recorder > "u" || o(e.recorder)) && (typeof e.severity > "u" || r(e.severity)) && (typeof e.stage > "u" || Array.isArray(e.stage) && e.stage.every(
    (t) => $r(t)
  )) && o(e.subject) && (typeof e.verificationStatus > "u" || r(e.verificationStatus));
}
function to(n) {
  const e = n;
  return d(e) && (typeof e.authority > "u" || typeof e.authority == "string") && (typeof e._authority > "u" || i(e._authority)) && (typeof e.uri > "u" || typeof e.uri == "string") && (typeof e._uri > "u" || i(e._uri));
}
function no(n) {
  const e = n;
  return d(e) && (typeof e.verificationDate > "u" || typeof e.verificationDate == "string") && (typeof e._verificationDate > "u" || i(e._verificationDate)) && typeof e.verified == "boolean" && (typeof e._verified > "u" || i(e._verified)) && (typeof e.verifiedWith > "u" || o(e.verifiedWith));
}
function io(n) {
  const e = n;
  return d(e) && o(e.reference) && r(e.role);
}
function ro(n) {
  const e = n;
  return d(e) && (e.meaning === "instance" || e.meaning === "related" || e.meaning === "dependents" || e.meaning === "authoredby") && (typeof e._meaning > "u" || i(e._meaning)) && o(e.reference);
}
function Wn(n) {
  const e = n;
  return d(e) && (typeof e.action > "u" || Array.isArray(e.action) && e.action.every(
    (t) => r(t)
  )) && (typeof e.actor > "u" || Array.isArray(e.actor) && e.actor.every(
    (t) => io(t)
  )) && (typeof e.class > "u" || Array.isArray(e.class) && e.class.every(
    (t) => s(t)
  )) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => r(t)
  )) && (typeof e.data > "u" || Array.isArray(e.data) && e.data.every(
    (t) => ro(t)
  )) && (typeof e.dataPeriod > "u" || y(e.dataPeriod)) && (typeof e.period > "u" || y(e.period)) && (typeof e.provision > "u" || Array.isArray(e.provision) && e.provision.every(
    (t) => Wn(t)
  )) && (typeof e.purpose > "u" || Array.isArray(e.purpose) && e.purpose.every(
    (t) => s(t)
  )) && (typeof e.securityLabel > "u" || Array.isArray(e.securityLabel) && e.securityLabel.every(
    (t) => s(t)
  )) && (typeof e.type > "u" || e.type === "deny" || e.type === "permit") && (typeof e._type > "u" || i(e._type));
}
function le(n) {
  const e = n;
  return f(e) && e.resourceType === "Consent" && Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  ) && (typeof e.dateTime > "u" || typeof e.dateTime == "string") && (typeof e._dateTime > "u" || i(e._dateTime)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.organization > "u" || Array.isArray(e.organization) && e.organization.every(
    (t) => o(t)
  )) && (typeof e.patient > "u" || o(e.patient)) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => o(t)
  )) && (typeof e.policy > "u" || Array.isArray(e.policy) && e.policy.every(
    (t) => to(t)
  )) && (typeof e.policyRule > "u" || r(e.policyRule)) && (typeof e.provision > "u" || Wn(e.provision)) && r(e.scope) && (typeof e.sourceAttachment > "u" || g(e.sourceAttachment)) && (typeof e.sourceReference > "u" || o(e.sourceReference)) && (e.status === "active" || e.status === "inactive" || e.status === "entered-in-error" || e.status === "draft" || e.status === "proposed" || e.status === "rejected") && (typeof e._status > "u" || i(e._status)) && (typeof e.verification > "u" || Array.isArray(e.verification) && e.verification.every(
    (t) => no(t)
  ));
}
function oo(n) {
  const e = n;
  return d(e) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.publicationDate > "u" || typeof e.publicationDate == "string") && (typeof e._publicationDate > "u" || i(e._publicationDate)) && (e.publicationStatus === "entered-in-error" || e.publicationStatus === "cancelled" || e.publicationStatus === "revoked" || e.publicationStatus === "amended" || e.publicationStatus === "rejected" || e.publicationStatus === "appended" || e.publicationStatus === "disputed" || e.publicationStatus === "executable" || e.publicationStatus === "executed" || e.publicationStatus === "negotiable" || e.publicationStatus === "offered" || e.publicationStatus === "policy" || e.publicationStatus === "renewed" || e.publicationStatus === "resolved" || e.publicationStatus === "terminated") && (typeof e._publicationStatus > "u" || i(e._publicationStatus)) && (typeof e.publisher > "u" || o(e.publisher)) && (typeof e.subType > "u" || r(e.subType)) && r(e.type);
}
function ao(n) {
  const e = n;
  return d(e) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => s(t)
  )) && s(e.classification) && (typeof e.control > "u" || Array.isArray(e.control) && e.control.every(
    (t) => s(t)
  )) && (typeof e.number > "u" || Array.isArray(e.number) && e.number.every(
    (t) => typeof t == "number"
  ));
}
function fo(n) {
  const e = n;
  return d(e) && Array.isArray(e.reference) && e.reference.every(
    (t) => o(t)
  ) && r(e.role);
}
function Kn(n) {
  const e = n;
  return d(e) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || i(e._valueDate)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || i(e._valueDateTime)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || i(e._valueTime)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || i(e._valueUri)) && (typeof e.valueAttachment > "u" || g(e.valueAttachment)) && (typeof e.valueCoding > "u" || s(e.valueCoding)) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueReference > "u" || o(e.valueReference));
}
function yo(n) {
  const e = n;
  return d(e) && (typeof e.answer > "u" || Array.isArray(e.answer) && e.answer.every(
    (t) => Kn(t)
  )) && (typeof e.decision > "u" || r(e.decision)) && (typeof e.decisionMode > "u" || Array.isArray(e.decisionMode) && e.decisionMode.every(
    (t) => r(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.linkId > "u" || Array.isArray(e.linkId) && e.linkId.every(
    (t) => typeof t == "string"
  )) && (typeof e._linkId > "u" || Array.isArray(e._linkId) && e._linkId.every(
    (t) => i(t)
  )) && (typeof e.party > "u" || Array.isArray(e.party) && e.party.every(
    (t) => fo(t)
  )) && (typeof e.securityLabelNumber > "u" || Array.isArray(e.securityLabelNumber) && e.securityLabelNumber.every(
    (t) => typeof t == "number"
  )) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || i(e._text)) && (typeof e.topic > "u" || o(e.topic)) && (typeof e.type > "u" || r(e.type));
}
function uo(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => r(t)
  )) && (typeof e.reference > "u" || o(e.reference)) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || i(e._text));
}
function po(n) {
  const e = n;
  return d(e) && (typeof e.effectiveTime > "u" || typeof e.effectiveTime == "string") && (typeof e._effectiveTime > "u" || i(e._effectiveTime)) && (typeof e.entityCodeableConcept > "u" || r(e.entityCodeableConcept)) && (typeof e.entityReference > "u" || o(e.entityReference)) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.linkId > "u" || Array.isArray(e.linkId) && e.linkId.every(
    (t) => typeof t == "string"
  )) && (typeof e._linkId > "u" || Array.isArray(e._linkId) && e._linkId.every(
    (t) => i(t)
  )) && (typeof e.net > "u" || c(e.net)) && (typeof e.payment > "u" || typeof e.payment == "string") && (typeof e._payment > "u" || i(e._payment)) && (typeof e.paymentDate > "u" || typeof e.paymentDate == "string") && (typeof e._paymentDate > "u" || i(e._paymentDate)) && (typeof e.points > "u" || typeof e.points == "number") && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.recipient > "u" || o(e.recipient)) && (typeof e.responsible > "u" || o(e.responsible)) && (typeof e.securityLabelNumber > "u" || Array.isArray(e.securityLabelNumber) && e.securityLabelNumber.every(
    (t) => typeof t == "number"
  )) && (typeof e.unitPrice > "u" || c(e.unitPrice));
}
function so(n) {
  const e = n;
  return d(e) && (typeof e.answer > "u" || Array.isArray(e.answer) && e.answer.every(
    (t) => Kn(t)
  )) && (typeof e.condition > "u" || typeof e.condition == "string") && (typeof e._condition > "u" || i(e._condition)) && (typeof e.context > "u" || Array.isArray(e.context) && e.context.every(
    (t) => uo(t)
  )) && (typeof e.linkId > "u" || Array.isArray(e.linkId) && e.linkId.every(
    (t) => typeof t == "string"
  )) && (typeof e._linkId > "u" || Array.isArray(e._linkId) && e._linkId.every(
    (t) => i(t)
  )) && (typeof e.period > "u" || Array.isArray(e.period) && e.period.every(
    (t) => y(t)
  )) && (typeof e.periodType > "u" || Array.isArray(e.periodType) && e.periodType.every(
    (t) => r(t)
  )) && (typeof e.relationship > "u" || s(e.relationship)) && (typeof e.scope > "u" || r(e.scope)) && (typeof e.securityLabelNumber > "u" || Array.isArray(e.securityLabelNumber) && e.securityLabelNumber.every(
    (t) => typeof t == "number"
  )) && (typeof e.subtype > "u" || Array.isArray(e.subtype) && e.subtype.every(
    (t) => r(t)
  )) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || i(e._text)) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => r(t)
  )) && (typeof e.typeReference > "u" || Array.isArray(e.typeReference) && e.typeReference.every(
    (t) => o(t)
  )) && (typeof e.usePeriod > "u" || Array.isArray(e.usePeriod) && e.usePeriod.every(
    (t) => y(t)
  )) && (typeof e.valuedItem > "u" || Array.isArray(e.valuedItem) && e.valuedItem.every(
    (t) => po(t)
  ));
}
function co(n) {
  const e = n;
  return d(e) && Array.isArray(e.reference) && e.reference.every(
    (t) => o(t)
  ) && (typeof e.role > "u" || r(e.role));
}
function lo(n) {
  const e = n;
  return d(e) && (typeof e.context > "u" || o(e.context)) && (typeof e.contextLinkId > "u" || Array.isArray(e.contextLinkId) && e.contextLinkId.every(
    (t) => typeof t == "string"
  )) && (typeof e._contextLinkId > "u" || Array.isArray(e._contextLinkId) && e._contextLinkId.every(
    (t) => i(t)
  )) && (typeof e.doNotPerform > "u" || e.doNotPerform === !1 || e.doNotPerform === !0) && (typeof e._doNotPerform > "u" || i(e._doNotPerform)) && r(e.intent) && (typeof e.linkId > "u" || Array.isArray(e.linkId) && e.linkId.every(
    (t) => typeof t == "string"
  )) && (typeof e._linkId > "u" || Array.isArray(e._linkId) && e._linkId.every(
    (t) => i(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || i(e._occurrenceDateTime)) && (typeof e.occurrencePeriod > "u" || y(e.occurrencePeriod)) && (typeof e.occurrenceTiming > "u" || A(e.occurrenceTiming)) && (typeof e.performer > "u" || o(e.performer)) && (typeof e.performerLinkId > "u" || Array.isArray(e.performerLinkId) && e.performerLinkId.every(
    (t) => typeof t == "string"
  )) && (typeof e._performerLinkId > "u" || Array.isArray(e._performerLinkId) && e._performerLinkId.every(
    (t) => i(t)
  )) && (typeof e.performerRole > "u" || r(e.performerRole)) && (typeof e.performerType > "u" || Array.isArray(e.performerType) && e.performerType.every(
    (t) => r(t)
  )) && (typeof e.reason > "u" || Array.isArray(e.reason) && e.reason.every(
    (t) => typeof t == "string"
  )) && (typeof e._reason > "u" || Array.isArray(e._reason) && e._reason.every(
    (t) => i(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonLinkId > "u" || Array.isArray(e.reasonLinkId) && e.reasonLinkId.every(
    (t) => typeof t == "string"
  )) && (typeof e._reasonLinkId > "u" || Array.isArray(e._reasonLinkId) && e._reasonLinkId.every(
    (t) => i(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.requester > "u" || Array.isArray(e.requester) && e.requester.every(
    (t) => o(t)
  )) && (typeof e.requesterLinkId > "u" || Array.isArray(e.requesterLinkId) && e.requesterLinkId.every(
    (t) => typeof t == "string"
  )) && (typeof e._requesterLinkId > "u" || Array.isArray(e._requesterLinkId) && e._requesterLinkId.every(
    (t) => i(t)
  )) && (typeof e.securityLabelNumber > "u" || Array.isArray(e.securityLabelNumber) && e.securityLabelNumber.every(
    (t) => typeof t == "number"
  )) && r(e.status) && (typeof e.subject > "u" || Array.isArray(e.subject) && e.subject.every(
    (t) => co(t)
  )) && r(e.type);
}
function Jn(n) {
  const e = n;
  return d(e) && (typeof e.action > "u" || Array.isArray(e.action) && e.action.every(
    (t) => lo(t)
  )) && (typeof e.applies > "u" || y(e.applies)) && (typeof e.asset > "u" || Array.isArray(e.asset) && e.asset.every(
    (t) => so(t)
  )) && (typeof e.group > "u" || Array.isArray(e.group) && e.group.every(
    (t) => Jn(t)
  )) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.issued > "u" || typeof e.issued == "string") && (typeof e._issued > "u" || i(e._issued)) && yo(e.offer) && (typeof e.securityLabel > "u" || Array.isArray(e.securityLabel) && e.securityLabel.every(
    (t) => ao(t)
  )) && (typeof e.subType > "u" || r(e.subType)) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || i(e._text)) && (typeof e.topicCodeableConcept > "u" || r(e.topicCodeableConcept)) && (typeof e.topicReference > "u" || o(e.topicReference)) && (typeof e.type > "u" || r(e.type));
}
function vo(n) {
  const e = n;
  return d(e) && o(e.party) && Array.isArray(e.signature) && e.signature.every(
    (t) => O(t)
  ) && s(e.type);
}
function mo(n) {
  const e = n;
  return d(e) && (typeof e.contentAttachment > "u" || g(e.contentAttachment)) && (typeof e.contentReference > "u" || o(e.contentReference));
}
function go(n) {
  const e = n;
  return d(e) && (typeof e.contentAttachment > "u" || g(e.contentAttachment)) && (typeof e.contentReference > "u" || o(e.contentReference));
}
function _o(n) {
  const e = n;
  return d(e) && (typeof e.contentAttachment > "u" || g(e.contentAttachment)) && (typeof e.contentReference > "u" || o(e.contentReference));
}
function ve(n) {
  const e = n;
  return f(e) && e.resourceType === "Contract" && (typeof e.alias > "u" || Array.isArray(e.alias) && e.alias.every(
    (t) => typeof t == "string"
  )) && (typeof e._alias > "u" || Array.isArray(e._alias) && e._alias.every(
    (t) => i(t)
  )) && (typeof e.applies > "u" || y(e.applies)) && (typeof e.author > "u" || o(e.author)) && (typeof e.authority > "u" || Array.isArray(e.authority) && e.authority.every(
    (t) => o(t)
  )) && (typeof e.contentDefinition > "u" || oo(e.contentDefinition)) && (typeof e.contentDerivative > "u" || r(e.contentDerivative)) && (typeof e.domain > "u" || Array.isArray(e.domain) && e.domain.every(
    (t) => o(t)
  )) && (typeof e.expirationType > "u" || r(e.expirationType)) && (typeof e.friendly > "u" || Array.isArray(e.friendly) && e.friendly.every(
    (t) => mo(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.instantiatesCanonical > "u" || o(e.instantiatesCanonical)) && (typeof e.instantiatesUri > "u" || typeof e.instantiatesUri == "string") && (typeof e._instantiatesUri > "u" || i(e._instantiatesUri)) && (typeof e.issued > "u" || typeof e.issued == "string") && (typeof e._issued > "u" || i(e._issued)) && (typeof e.legal > "u" || Array.isArray(e.legal) && e.legal.every(
    (t) => go(t)
  )) && (typeof e.legallyBindingAttachment > "u" || g(e.legallyBindingAttachment)) && (typeof e.legallyBindingReference > "u" || o(e.legallyBindingReference)) && (typeof e.legalState > "u" || r(e.legalState)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.relevantHistory > "u" || Array.isArray(e.relevantHistory) && e.relevantHistory.every(
    (t) => o(t)
  )) && (typeof e.rule > "u" || Array.isArray(e.rule) && e.rule.every(
    (t) => _o(t)
  )) && (typeof e.scope > "u" || r(e.scope)) && (typeof e.signer > "u" || Array.isArray(e.signer) && e.signer.every(
    (t) => vo(t)
  )) && (typeof e.site > "u" || Array.isArray(e.site) && e.site.every(
    (t) => o(t)
  )) && (typeof e.status > "u" || e.status === "entered-in-error" || e.status === "cancelled" || e.status === "revoked" || e.status === "amended" || e.status === "rejected" || e.status === "appended" || e.status === "disputed" || e.status === "executable" || e.status === "executed" || e.status === "negotiable" || e.status === "offered" || e.status === "policy" || e.status === "renewed" || e.status === "resolved" || e.status === "terminated") && (typeof e._status > "u" || i(e._status)) && (typeof e.subject > "u" || Array.isArray(e.subject) && e.subject.every(
    (t) => o(t)
  )) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || i(e._subtitle)) && (typeof e.subType > "u" || Array.isArray(e.subType) && e.subType.every(
    (t) => r(t)
  )) && (typeof e.supportingInfo > "u" || Array.isArray(e.supportingInfo) && e.supportingInfo.every(
    (t) => o(t)
  )) && (typeof e.term > "u" || Array.isArray(e.term) && e.term.every(
    (t) => Jn(t)
  )) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.topicCodeableConcept > "u" || r(e.topicCodeableConcept)) && (typeof e.topicReference > "u" || o(e.topicReference)) && (typeof e.type > "u" || r(e.type)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function Ao(n) {
  const e = n;
  return d(e) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && r(e.type) && typeof e.value == "string" && (typeof e._value > "u" || i(e._value));
}
function bo(n) {
  const e = n;
  return d(e) && (typeof e.period > "u" || y(e.period)) && r(e.type);
}
function Io(n) {
  const e = n;
  return d(e) && (typeof e.exception > "u" || Array.isArray(e.exception) && e.exception.every(
    (t) => bo(t)
  )) && (typeof e.type > "u" || r(e.type)) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueMoney > "u" || c(e.valueMoney));
}
function me(n) {
  const e = n;
  return f(e) && e.resourceType === "Coverage" && o(e.beneficiary) && (typeof e.class > "u" || Array.isArray(e.class) && e.class.every(
    (t) => Ao(t)
  )) && (typeof e.contract > "u" || Array.isArray(e.contract) && e.contract.every(
    (t) => o(t)
  )) && (typeof e.costToBeneficiary > "u" || Array.isArray(e.costToBeneficiary) && e.costToBeneficiary.every(
    (t) => Io(t)
  )) && (typeof e.dependent > "u" || typeof e.dependent == "string") && (typeof e._dependent > "u" || i(e._dependent)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.network > "u" || typeof e.network == "string") && (typeof e._network > "u" || i(e._network)) && (typeof e.order > "u" || typeof e.order == "number") && Array.isArray(e.payor) && e.payor.every(
    (t) => o(t)
  ) && (typeof e.period > "u" || y(e.period)) && (typeof e.policyHolder > "u" || o(e.policyHolder)) && (typeof e.relationship > "u" || r(e.relationship)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || i(e._status)) && (typeof e.subrogation > "u" || e.subrogation === !1 || e.subrogation === !0) && (typeof e._subrogation > "u" || i(e._subrogation)) && (typeof e.subscriber > "u" || o(e.subscriber)) && (typeof e.subscriberId > "u" || typeof e.subscriberId == "string") && (typeof e._subscriberId > "u" || i(e._subscriberId)) && (typeof e.type > "u" || r(e.type));
}
function ho(n) {
  const e = n;
  return d(e) && (typeof e.appliesToAll > "u" || e.appliesToAll === !1 || e.appliesToAll === !0) && (typeof e._appliesToAll > "u" || i(e._appliesToAll)) && o(e.information) && typeof e.sequence == "number";
}
function wo(n) {
  const e = n;
  return d(e) && (typeof e.businessArrangement > "u" || typeof e.businessArrangement == "string") && (typeof e._businessArrangement > "u" || i(e._businessArrangement)) && o(e.coverage) && (typeof e.focal > "u" || e.focal === !1 || e.focal === !0) && (typeof e._focal > "u" || i(e._focal));
}
function Ro(n) {
  const e = n;
  return d(e) && (typeof e.diagnosisCodeableConcept > "u" || r(e.diagnosisCodeableConcept)) && (typeof e.diagnosisReference > "u" || o(e.diagnosisReference));
}
function Co(n) {
  const e = n;
  return d(e) && (typeof e.category > "u" || r(e.category)) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => o(t)
  )) && (typeof e.diagnosis > "u" || Array.isArray(e.diagnosis) && e.diagnosis.every(
    (t) => Ro(t)
  )) && (typeof e.facility > "u" || o(e.facility)) && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => r(t)
  )) && (typeof e.productOrService > "u" || r(e.productOrService)) && (typeof e.provider > "u" || o(e.provider)) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.supportingInfoSequence > "u" || Array.isArray(e.supportingInfoSequence) && e.supportingInfoSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.unitPrice > "u" || c(e.unitPrice));
}
function ge(n) {
  const e = n;
  return f(e) && e.resourceType === "CoverageEligibilityRequest" && typeof e.created == "string" && (typeof e._created > "u" || i(e._created)) && (typeof e.enterer > "u" || o(e.enterer)) && (typeof e.facility > "u" || o(e.facility)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.insurance > "u" || Array.isArray(e.insurance) && e.insurance.every(
    (t) => wo(t)
  )) && o(e.insurer) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => Co(t)
  )) && o(e.patient) && (typeof e.priority > "u" || r(e.priority)) && (typeof e.provider > "u" || o(e.provider)) && Array.isArray(e.purpose) && e.purpose.every(
    (t) => t === "auth-requirements" || t === "benefits" || t === "discovery" || t === "validation"
  ) && (typeof e._purpose > "u" || Array.isArray(e._purpose) && e._purpose.every(
    (t) => i(t)
  )) && (typeof e.servicedDate > "u" || typeof e.servicedDate == "string") && (typeof e._servicedDate > "u" || i(e._servicedDate)) && (typeof e.servicedPeriod > "u" || y(e.servicedPeriod)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || i(e._status)) && (typeof e.supportingInfo > "u" || Array.isArray(e.supportingInfo) && e.supportingInfo.every(
    (t) => ho(t)
  ));
}
function Do(n) {
  const e = n;
  return d(e) && (typeof e.allowedUnsignedInt > "u" || typeof e.allowedUnsignedInt == "number") && (typeof e.allowedString > "u" || typeof e.allowedString == "string") && (typeof e._allowedString > "u" || i(e._allowedString)) && (typeof e.allowedMoney > "u" || c(e.allowedMoney)) && r(e.type) && (typeof e.usedUnsignedInt > "u" || typeof e.usedUnsignedInt == "number") && (typeof e.usedString > "u" || typeof e.usedString == "string") && (typeof e._usedString > "u" || i(e._usedString)) && (typeof e.usedMoney > "u" || c(e.usedMoney));
}
function So(n) {
  const e = n;
  return d(e) && (typeof e.authorizationRequired > "u" || e.authorizationRequired === !1 || e.authorizationRequired === !0) && (typeof e._authorizationRequired > "u" || i(e._authorizationRequired)) && (typeof e.authorizationSupporting > "u" || Array.isArray(e.authorizationSupporting) && e.authorizationSupporting.every(
    (t) => r(t)
  )) && (typeof e.authorizationUrl > "u" || typeof e.authorizationUrl == "string") && (typeof e._authorizationUrl > "u" || i(e._authorizationUrl)) && (typeof e.benefit > "u" || Array.isArray(e.benefit) && e.benefit.every(
    (t) => Do(t)
  )) && (typeof e.category > "u" || r(e.category)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.excluded > "u" || e.excluded === !1 || e.excluded === !0) && (typeof e._excluded > "u" || i(e._excluded)) && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => r(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.network > "u" || r(e.network)) && (typeof e.productOrService > "u" || r(e.productOrService)) && (typeof e.provider > "u" || o(e.provider)) && (typeof e.term > "u" || r(e.term)) && (typeof e.unit > "u" || r(e.unit));
}
function Oo(n) {
  const e = n;
  return d(e) && (typeof e.benefitPeriod > "u" || y(e.benefitPeriod)) && o(e.coverage) && (typeof e.inforce > "u" || e.inforce === !1 || e.inforce === !0) && (typeof e._inforce > "u" || i(e._inforce)) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => So(t)
  ));
}
function Eo(n) {
  const e = n;
  return d(e) && r(e.code);
}
function _e(n) {
  const e = n;
  return f(e) && e.resourceType === "CoverageEligibilityResponse" && typeof e.created == "string" && (typeof e._created > "u" || i(e._created)) && (typeof e.disposition > "u" || typeof e.disposition == "string") && (typeof e._disposition > "u" || i(e._disposition)) && (typeof e.error > "u" || Array.isArray(e.error) && e.error.every(
    (t) => Eo(t)
  )) && (typeof e.form > "u" || r(e.form)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.insurance > "u" || Array.isArray(e.insurance) && e.insurance.every(
    (t) => Oo(t)
  )) && o(e.insurer) && (e.outcome === "error" || e.outcome === "queued" || e.outcome === "complete" || e.outcome === "partial") && (typeof e._outcome > "u" || i(e._outcome)) && o(e.patient) && (typeof e.preAuthRef > "u" || typeof e.preAuthRef == "string") && (typeof e._preAuthRef > "u" || i(e._preAuthRef)) && Array.isArray(e.purpose) && e.purpose.every(
    (t) => t === "auth-requirements" || t === "benefits" || t === "discovery" || t === "validation"
  ) && (typeof e._purpose > "u" || Array.isArray(e._purpose) && e._purpose.every(
    (t) => i(t)
  )) && o(e.request) && (typeof e.requestor > "u" || o(e.requestor)) && (typeof e.servicedDate > "u" || typeof e.servicedDate == "string") && (typeof e._servicedDate > "u" || i(e._servicedDate)) && (typeof e.servicedPeriod > "u" || y(e.servicedPeriod)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || i(e._status));
}
function To(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => r(t)
  )) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => o(t)
  ));
}
function xo(n) {
  const e = n;
  return d(e) && r(e.action) && (typeof e.author > "u" || o(e.author)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date));
}
function Ae(n) {
  const e = n;
  return f(e) && e.resourceType === "DetectedIssue" && (typeof e.author > "u" || o(e.author)) && (typeof e.code > "u" || r(e.code)) && (typeof e.detail > "u" || typeof e.detail == "string") && (typeof e._detail > "u" || i(e._detail)) && (typeof e.evidence > "u" || Array.isArray(e.evidence) && e.evidence.every(
    (t) => To(t)
  )) && (typeof e.identifiedDateTime > "u" || typeof e.identifiedDateTime == "string") && (typeof e._identifiedDateTime > "u" || i(e._identifiedDateTime)) && (typeof e.identifiedPeriod > "u" || y(e.identifiedPeriod)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.implicated > "u" || Array.isArray(e.implicated) && e.implicated.every(
    (t) => o(t)
  )) && (typeof e.mitigation > "u" || Array.isArray(e.mitigation) && e.mitigation.every(
    (t) => xo(t)
  )) && (typeof e.patient > "u" || o(e.patient)) && (typeof e.reference > "u" || typeof e.reference == "string") && (typeof e._reference > "u" || i(e._reference)) && (typeof e.severity > "u" || e.severity === "moderate" || e.severity === "low" || e.severity === "high") && (typeof e._severity > "u" || i(e._severity)) && (e.status === "entered-in-error" || e.status === "unknown" || e.status === "cancelled" || e.status === "preliminary" || e.status === "final" || e.status === "amended" || e.status === "registered" || e.status === "corrected") && (typeof e._status > "u" || i(e._status));
}
function jo(n) {
  const e = n;
  return d(e) && (typeof e.carrierAIDC > "u" || typeof e.carrierAIDC == "string") && (typeof e._carrierAIDC > "u" || i(e._carrierAIDC)) && (typeof e.carrierHRF > "u" || typeof e.carrierHRF == "string") && (typeof e._carrierHRF > "u" || i(e._carrierHRF)) && (typeof e.deviceIdentifier > "u" || typeof e.deviceIdentifier == "string") && (typeof e._deviceIdentifier > "u" || i(e._deviceIdentifier)) && (typeof e.entryType > "u" || e.entryType === "unknown" || e.entryType === "barcode" || e.entryType === "rfid" || e.entryType === "manual" || e.entryType === "card" || e.entryType === "self-reported") && (typeof e._entryType > "u" || i(e._entryType)) && (typeof e.issuer > "u" || typeof e.issuer == "string") && (typeof e._issuer > "u" || i(e._issuer)) && (typeof e.jurisdiction > "u" || typeof e.jurisdiction == "string") && (typeof e._jurisdiction > "u" || i(e._jurisdiction));
}
function Po(n) {
  const e = n;
  return d(e) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (e.type === "other" || e.type === "udi-label-name" || e.type === "user-friendly-name" || e.type === "patient-reported-name" || e.type === "manufacturer-name" || e.type === "model-name") && (typeof e._type > "u" || i(e._type));
}
function Fo(n) {
  const e = n;
  return d(e) && r(e.systemType) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function Ho(n) {
  const e = n;
  return d(e) && (typeof e.component > "u" || a(e.component)) && (typeof e.type > "u" || r(e.type)) && typeof e.value == "string" && (typeof e._value > "u" || i(e._value));
}
function Mo(n) {
  const e = n;
  return d(e) && r(e.type) && (typeof e.valueCode > "u" || Array.isArray(e.valueCode) && e.valueCode.every(
    (t) => r(t)
  )) && (typeof e.valueQuantity > "u" || Array.isArray(e.valueQuantity) && e.valueQuantity.every(
    (t) => u(t)
  ));
}
function be(n) {
  const e = n;
  return f(e) && e.resourceType === "Device" && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => I(t)
  )) && (typeof e.definition > "u" || o(e.definition)) && (typeof e.deviceName > "u" || Array.isArray(e.deviceName) && e.deviceName.every(
    (t) => Po(t)
  )) && (typeof e.distinctIdentifier > "u" || typeof e.distinctIdentifier == "string") && (typeof e._distinctIdentifier > "u" || i(e._distinctIdentifier)) && (typeof e.expirationDate > "u" || typeof e.expirationDate == "string") && (typeof e._expirationDate > "u" || i(e._expirationDate)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.location > "u" || o(e.location)) && (typeof e.lotNumber > "u" || typeof e.lotNumber == "string") && (typeof e._lotNumber > "u" || i(e._lotNumber)) && (typeof e.manufactureDate > "u" || typeof e.manufactureDate == "string") && (typeof e._manufactureDate > "u" || i(e._manufactureDate)) && (typeof e.manufacturer > "u" || typeof e.manufacturer == "string") && (typeof e._manufacturer > "u" || i(e._manufacturer)) && (typeof e.modelNumber > "u" || typeof e.modelNumber == "string") && (typeof e._modelNumber > "u" || i(e._modelNumber)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.owner > "u" || o(e.owner)) && (typeof e.parent > "u" || o(e.parent)) && (typeof e.partNumber > "u" || typeof e.partNumber == "string") && (typeof e._partNumber > "u" || i(e._partNumber)) && (typeof e.patient > "u" || o(e.patient)) && (typeof e.property > "u" || Array.isArray(e.property) && e.property.every(
    (t) => Mo(t)
  )) && (typeof e.safety > "u" || Array.isArray(e.safety) && e.safety.every(
    (t) => r(t)
  )) && (typeof e.serialNumber > "u" || typeof e.serialNumber == "string") && (typeof e._serialNumber > "u" || i(e._serialNumber)) && (typeof e.specialization > "u" || Array.isArray(e.specialization) && e.specialization.every(
    (t) => Fo(t)
  )) && (typeof e.status > "u" || e.status === "active" || e.status === "inactive" || e.status === "entered-in-error" || e.status === "unknown") && (typeof e._status > "u" || i(e._status)) && (typeof e.statusReason > "u" || Array.isArray(e.statusReason) && e.statusReason.every(
    (t) => r(t)
  )) && (typeof e.type > "u" || r(e.type)) && (typeof e.udiCarrier > "u" || Array.isArray(e.udiCarrier) && e.udiCarrier.every(
    (t) => jo(t)
  )) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.version > "u" || Array.isArray(e.version) && e.version.every(
    (t) => Ho(t)
  ));
}
function qo(n) {
  const e = n;
  return d(e) && typeof e.deviceIdentifier == "string" && (typeof e._deviceIdentifier > "u" || i(e._deviceIdentifier)) && typeof e.issuer == "string" && (typeof e._issuer > "u" || i(e._issuer)) && typeof e.jurisdiction == "string" && (typeof e._jurisdiction > "u" || i(e._jurisdiction));
}
function ko(n) {
  const e = n;
  return d(e) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (e.type === "other" || e.type === "udi-label-name" || e.type === "user-friendly-name" || e.type === "patient-reported-name" || e.type === "manufacturer-name" || e.type === "model-name") && (typeof e._type > "u" || i(e._type));
}
function Bo(n) {
  const e = n;
  return d(e) && typeof e.systemType == "string" && (typeof e._systemType > "u" || i(e._systemType)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function Vo(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || Array.isArray(e.description) && e.description.every(
    (t) => r(t)
  )) && r(e.type);
}
function Uo(n) {
  const e = n;
  return d(e) && r(e.type) && (typeof e.valueCode > "u" || Array.isArray(e.valueCode) && e.valueCode.every(
    (t) => r(t)
  )) && (typeof e.valueQuantity > "u" || Array.isArray(e.valueQuantity) && e.valueQuantity.every(
    (t) => u(t)
  ));
}
function No(n) {
  const e = n;
  return d(e) && (typeof e.allergenicIndicator > "u" || e.allergenicIndicator === !1 || e.allergenicIndicator === !0) && (typeof e._allergenicIndicator > "u" || i(e._allergenicIndicator)) && (typeof e.alternate > "u" || e.alternate === !1 || e.alternate === !0) && (typeof e._alternate > "u" || i(e._alternate)) && r(e.substance);
}
function Ie(n) {
  const e = n;
  return f(e) && e.resourceType === "DeviceDefinition" && (typeof e.capability > "u" || Array.isArray(e.capability) && e.capability.every(
    (t) => Vo(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => I(t)
  )) && (typeof e.deviceName > "u" || Array.isArray(e.deviceName) && e.deviceName.every(
    (t) => ko(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.languageCode > "u" || Array.isArray(e.languageCode) && e.languageCode.every(
    (t) => r(t)
  )) && (typeof e.manufacturerString > "u" || typeof e.manufacturerString == "string") && (typeof e._manufacturerString > "u" || i(e._manufacturerString)) && (typeof e.manufacturerReference > "u" || o(e.manufacturerReference)) && (typeof e.material > "u" || Array.isArray(e.material) && e.material.every(
    (t) => No(t)
  )) && (typeof e.modelNumber > "u" || typeof e.modelNumber == "string") && (typeof e._modelNumber > "u" || i(e._modelNumber)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.onlineInformation > "u" || typeof e.onlineInformation == "string") && (typeof e._onlineInformation > "u" || i(e._onlineInformation)) && (typeof e.owner > "u" || o(e.owner)) && (typeof e.parentDevice > "u" || o(e.parentDevice)) && (typeof e.physicalCharacteristics > "u" || En(e.physicalCharacteristics)) && (typeof e.property > "u" || Array.isArray(e.property) && e.property.every(
    (t) => Uo(t)
  )) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.safety > "u" || Array.isArray(e.safety) && e.safety.every(
    (t) => r(t)
  )) && (typeof e.shelfLifeStorage > "u" || Array.isArray(e.shelfLifeStorage) && e.shelfLifeStorage.every(
    (t) => Vn(t)
  )) && (typeof e.specialization > "u" || Array.isArray(e.specialization) && e.specialization.every(
    (t) => Bo(t)
  )) && (typeof e.type > "u" || r(e.type)) && (typeof e.udiDeviceIdentifier > "u" || Array.isArray(e.udiDeviceIdentifier) && e.udiDeviceIdentifier.every(
    (t) => qo(t)
  )) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.version > "u" || Array.isArray(e.version) && e.version.every(
    (t) => typeof t == "string"
  )) && (typeof e._version > "u" || Array.isArray(e._version) && e._version.every(
    (t) => i(t)
  ));
}
function Lo(n) {
  const e = n;
  return d(e) && (typeof e.state > "u" || e.state === "not-calibrated" || e.state === "calibration-required" || e.state === "calibrated" || e.state === "unspecified") && (typeof e._state > "u" || i(e._state)) && (typeof e.time > "u" || typeof e.time == "string") && (typeof e._time > "u" || i(e._time)) && (typeof e.type > "u" || e.type === "unspecified" || e.type === "offset" || e.type === "gain" || e.type === "two-point") && (typeof e._type > "u" || i(e._type));
}
function he(n) {
  const e = n;
  return f(e) && e.resourceType === "DeviceMetric" && (typeof e.calibration > "u" || Array.isArray(e.calibration) && e.calibration.every(
    (t) => Lo(t)
  )) && (e.category === "unspecified" || e.category === "measurement" || e.category === "setting" || e.category === "calculation") && (typeof e._category > "u" || i(e._category)) && (typeof e.color > "u" || e.color === "black" || e.color === "red" || e.color === "green" || e.color === "yellow" || e.color === "blue" || e.color === "magenta" || e.color === "cyan" || e.color === "white") && (typeof e._color > "u" || i(e._color)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.measurementPeriod > "u" || A(e.measurementPeriod)) && (typeof e.operationalStatus > "u" || e.operationalStatus === "entered-in-error" || e.operationalStatus === "on" || e.operationalStatus === "off" || e.operationalStatus === "standby") && (typeof e._operationalStatus > "u" || i(e._operationalStatus)) && (typeof e.parent > "u" || o(e.parent)) && (typeof e.source > "u" || o(e.source)) && r(e.type) && (typeof e.unit > "u" || r(e.unit));
}
function Go(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || r(e.code)) && (typeof e.valueCodeableConcept > "u" || r(e.valueCodeableConcept)) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueRange > "u" || v(e.valueRange)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean));
}
function we(n) {
  const e = n;
  return f(e) && e.resourceType === "DeviceRequest" && (typeof e.authoredOn > "u" || typeof e.authoredOn == "string") && (typeof e._authoredOn > "u" || i(e._authoredOn)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.codeReference > "u" || o(e.codeReference)) && (typeof e.codeCodeableConcept > "u" || r(e.codeCodeableConcept)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.groupIdentifier > "u" || a(e.groupIdentifier)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => i(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => i(t)
  )) && (typeof e.insurance > "u" || Array.isArray(e.insurance) && e.insurance.every(
    (t) => o(t)
  )) && (e.intent === "proposal" || e.intent === "plan" || e.intent === "directive" || e.intent === "order" || e.intent === "original-order" || e.intent === "reflex-order" || e.intent === "filler-order" || e.intent === "instance-order" || e.intent === "option") && (typeof e._intent > "u" || i(e._intent)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || i(e._occurrenceDateTime)) && (typeof e.occurrencePeriod > "u" || y(e.occurrencePeriod)) && (typeof e.occurrenceTiming > "u" || A(e.occurrenceTiming)) && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => Go(t)
  )) && (typeof e.performer > "u" || o(e.performer)) && (typeof e.performerType > "u" || r(e.performerType)) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || i(e._priority)) && (typeof e.priorRequest > "u" || Array.isArray(e.priorRequest) && e.priorRequest.every(
    (t) => o(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.relevantHistory > "u" || Array.isArray(e.relevantHistory) && e.relevantHistory.every(
    (t) => o(t)
  )) && (typeof e.requester > "u" || o(e.requester)) && (typeof e.status > "u" || e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "draft" || e.status === "completed" || e.status === "revoked") && (typeof e._status > "u" || i(e._status)) && o(e.subject) && (typeof e.supportingInfo > "u" || Array.isArray(e.supportingInfo) && e.supportingInfo.every(
    (t) => o(t)
  ));
}
function Re(n) {
  const e = n;
  return f(e) && e.resourceType === "DeviceUseStatement" && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.bodySite > "u" || r(e.bodySite)) && (typeof e.derivedFrom > "u" || Array.isArray(e.derivedFrom) && e.derivedFrom.every(
    (t) => o(t)
  )) && o(e.device) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.recordedOn > "u" || typeof e.recordedOn == "string") && (typeof e._recordedOn > "u" || i(e._recordedOn)) && (typeof e.source > "u" || o(e.source)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "completed" || e.status === "stopped" || e.status === "intended") && (typeof e._status > "u" || i(e._status)) && o(e.subject) && (typeof e.timingTiming > "u" || A(e.timingTiming)) && (typeof e.timingPeriod > "u" || y(e.timingPeriod)) && (typeof e.timingDateTime > "u" || typeof e.timingDateTime == "string") && (typeof e._timingDateTime > "u" || i(e._timingDateTime));
}
function zo(n) {
  const e = n;
  return d(e) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment)) && o(e.link);
}
function Ce(n) {
  const e = n;
  return f(e) && e.resourceType === "DiagnosticReport" && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && r(e.code) && (typeof e.conclusion > "u" || typeof e.conclusion == "string") && (typeof e._conclusion > "u" || i(e._conclusion)) && (typeof e.conclusionCode > "u" || Array.isArray(e.conclusionCode) && e.conclusionCode.every(
    (t) => r(t)
  )) && (typeof e.effectiveDateTime > "u" || typeof e.effectiveDateTime == "string") && (typeof e._effectiveDateTime > "u" || i(e._effectiveDateTime)) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.imagingStudy > "u" || Array.isArray(e.imagingStudy) && e.imagingStudy.every(
    (t) => o(t)
  )) && (typeof e.issued > "u" || typeof e.issued == "string") && (typeof e._issued > "u" || i(e._issued)) && (typeof e.media > "u" || Array.isArray(e.media) && e.media.every(
    (t) => zo(t)
  )) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => o(t)
  )) && (typeof e.presentedForm > "u" || Array.isArray(e.presentedForm) && e.presentedForm.every(
    (t) => g(t)
  )) && (typeof e.result > "u" || Array.isArray(e.result) && e.result.every(
    (t) => o(t)
  )) && (typeof e.resultsInterpreter > "u" || Array.isArray(e.resultsInterpreter) && e.resultsInterpreter.every(
    (t) => o(t)
  )) && (typeof e.specimen > "u" || Array.isArray(e.specimen) && e.specimen.every(
    (t) => o(t)
  )) && (e.status === "entered-in-error" || e.status === "unknown" || e.status === "cancelled" || e.status === "partial" || e.status === "preliminary" || e.status === "final" || e.status === "amended" || e.status === "appended" || e.status === "registered" || e.status === "corrected") && (typeof e._status > "u" || i(e._status)) && (typeof e.subject > "u" || o(e.subject));
}
function Qo(n) {
  const e = n;
  return d(e) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.ref > "u" || o(e.ref));
}
function De(n) {
  const e = n;
  return f(e) && e.resourceType === "DocumentManifest" && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => o(t)
  )) && Array.isArray(e.content) && e.content.every(
    (t) => o(t)
  ) && (typeof e.created > "u" || typeof e.created == "string") && (typeof e._created > "u" || i(e._created)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.masterIdentifier > "u" || a(e.masterIdentifier)) && (typeof e.recipient > "u" || Array.isArray(e.recipient) && e.recipient.every(
    (t) => o(t)
  )) && (typeof e.related > "u" || Array.isArray(e.related) && e.related.every(
    (t) => Qo(t)
  )) && (typeof e.source > "u" || typeof e.source == "string") && (typeof e._source > "u" || i(e._source)) && (e.status === "entered-in-error" || e.status === "current" || e.status === "superseded") && (typeof e._status > "u" || i(e._status)) && (typeof e.subject > "u" || o(e.subject)) && (typeof e.type > "u" || r(e.type));
}
function Wo(n) {
  const e = n;
  return d(e) && (e.code === "replaces" || e.code === "transforms" || e.code === "signs" || e.code === "appends") && (typeof e._code > "u" || i(e._code)) && o(e.target);
}
function Ko(n) {
  const e = n;
  return d(e) && g(e.attachment) && (typeof e.format > "u" || s(e.format));
}
function Jo(n) {
  const e = n;
  return d(e) && (typeof e.encounter > "u" || Array.isArray(e.encounter) && e.encounter.every(
    (t) => o(t)
  )) && (typeof e.event > "u" || Array.isArray(e.event) && e.event.every(
    (t) => r(t)
  )) && (typeof e.facilityType > "u" || r(e.facilityType)) && (typeof e.period > "u" || y(e.period)) && (typeof e.practiceSetting > "u" || r(e.practiceSetting)) && (typeof e.related > "u" || Array.isArray(e.related) && e.related.every(
    (t) => o(t)
  )) && (typeof e.sourcePatientInfo > "u" || o(e.sourcePatientInfo));
}
function Se(n) {
  const e = n;
  return f(e) && e.resourceType === "DocumentReference" && (typeof e.authenticator > "u" || o(e.authenticator)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => o(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && Array.isArray(e.content) && e.content.every(
    (t) => Ko(t)
  ) && (typeof e.context > "u" || Jo(e.context)) && (typeof e.custodian > "u" || o(e.custodian)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.docStatus > "u" || e.docStatus === "entered-in-error" || e.docStatus === "preliminary" || e.docStatus === "final" || e.docStatus === "amended") && (typeof e._docStatus > "u" || i(e._docStatus)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.masterIdentifier > "u" || a(e.masterIdentifier)) && (typeof e.relatesTo > "u" || Array.isArray(e.relatesTo) && e.relatesTo.every(
    (t) => Wo(t)
  )) && (typeof e.securityLabel > "u" || Array.isArray(e.securityLabel) && e.securityLabel.every(
    (t) => r(t)
  )) && (e.status === "entered-in-error" || e.status === "current" || e.status === "superseded") && (typeof e._status > "u" || i(e._status)) && (typeof e.subject > "u" || o(e.subject)) && (typeof e.type > "u" || r(e.type));
}
function f(n) {
  const e = n;
  return Yt(e) && typeof e.resourceType == "string" && (typeof e.contained > "u" || Array.isArray(e.contained) && e.contained.every(
    (t) => bp(t)
  )) && (typeof e.extension > "u" || Array.isArray(e.extension) && e.extension.every(
    (t) => B(t)
  )) && (typeof e.modifierExtension > "u" || Array.isArray(e.modifierExtension) && e.modifierExtension.every(
    (t) => B(t)
  )) && (typeof e.text > "u" || Bn(e.text));
}
function Xo(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.numberOfParticipants > "u" || typeof e.numberOfParticipants == "number") && (typeof e.numberOfStudies > "u" || typeof e.numberOfStudies == "number");
}
function Yo(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.exposureState > "u" || e.exposureState === "exposure" || e.exposureState === "exposure-alternative") && (typeof e._exposureState > "u" || i(e._exposureState)) && o(e.riskEvidenceSynthesis) && (typeof e.variantState > "u" || r(e.variantState));
}
function Zo(n) {
  const e = n;
  return d(e) && (typeof e.from > "u" || typeof e.from == "number") && (typeof e.level > "u" || typeof e.level == "number") && (typeof e.to > "u" || typeof e.to == "number") && (typeof e.type > "u" || r(e.type));
}
function $o(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.precisionEstimate > "u" || Array.isArray(e.precisionEstimate) && e.precisionEstimate.every(
    (t) => Zo(t)
  )) && (typeof e.type > "u" || r(e.type)) && (typeof e.unitOfMeasure > "u" || r(e.unitOfMeasure)) && (typeof e.value > "u" || typeof e.value == "number") && (typeof e.variantState > "u" || r(e.variantState));
}
function ed(n) {
  const e = n;
  return d(e) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.rating > "u" || Array.isArray(e.rating) && e.rating.every(
    (t) => r(t)
  )) && (typeof e.type > "u" || r(e.type));
}
function td(n) {
  const e = n;
  return d(e) && (typeof e.certaintySubcomponent > "u" || Array.isArray(e.certaintySubcomponent) && e.certaintySubcomponent.every(
    (t) => ed(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.rating > "u" || Array.isArray(e.rating) && e.rating.every(
    (t) => r(t)
  ));
}
function Oe(n) {
  const e = n;
  return f(e) && e.resourceType === "EffectEvidenceSynthesis" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || i(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => p(t)
  )) && (typeof e.certainty > "u" || Array.isArray(e.certainty) && e.certainty.every(
    (t) => td(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => p(t)
  )) && (typeof e.effectEstimate > "u" || Array.isArray(e.effectEstimate) && e.effectEstimate.every(
    (t) => $o(t)
  )) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => p(t)
  )) && o(e.exposure) && o(e.exposureAlternative) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || i(e._lastReviewDate)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && o(e.outcome) && o(e.population) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => w(t)
  )) && (typeof e.resultsByExposure > "u" || Array.isArray(e.resultsByExposure) && e.resultsByExposure.every(
    (t) => Yo(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => p(t)
  )) && (typeof e.sampleSize > "u" || Xo(e.sampleSize)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.studyType > "u" || r(e.studyType)) && (typeof e.synthesisType > "u" || r(e.synthesisType)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => r(t)
  )) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function nd(n) {
  const e = n;
  return d(e) && y(e.period) && (e.status === "entered-in-error" || e.status === "unknown" || e.status === "arrived" || e.status === "cancelled" || e.status === "in-progress" || e.status === "planned" || e.status === "triaged" || e.status === "onleave" || e.status === "finished") && (typeof e._status > "u" || i(e._status));
}
function id(n) {
  const e = n;
  return d(e) && s(e.class) && y(e.period);
}
function rd(n) {
  const e = n;
  return d(e) && (typeof e.individual > "u" || o(e.individual)) && (typeof e.period > "u" || y(e.period)) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => r(t)
  ));
}
function od(n) {
  const e = n;
  return d(e) && o(e.condition) && (typeof e.rank > "u" || typeof e.rank == "number") && (typeof e.use > "u" || r(e.use));
}
function dd(n) {
  const e = n;
  return d(e) && (typeof e.admitSource > "u" || r(e.admitSource)) && (typeof e.destination > "u" || o(e.destination)) && (typeof e.dietPreference > "u" || Array.isArray(e.dietPreference) && e.dietPreference.every(
    (t) => r(t)
  )) && (typeof e.dischargeDisposition > "u" || r(e.dischargeDisposition)) && (typeof e.origin > "u" || o(e.origin)) && (typeof e.preAdmissionIdentifier > "u" || a(e.preAdmissionIdentifier)) && (typeof e.reAdmission > "u" || r(e.reAdmission)) && (typeof e.specialArrangement > "u" || Array.isArray(e.specialArrangement) && e.specialArrangement.every(
    (t) => r(t)
  )) && (typeof e.specialCourtesy > "u" || Array.isArray(e.specialCourtesy) && e.specialCourtesy.every(
    (t) => r(t)
  ));
}
function ad(n) {
  const e = n;
  return d(e) && o(e.location) && (typeof e.period > "u" || y(e.period)) && (typeof e.physicalType > "u" || r(e.physicalType)) && (typeof e.status > "u" || e.status === "active" || e.status === "completed" || e.status === "planned" || e.status === "reserved") && (typeof e._status > "u" || i(e._status));
}
function Ee(n) {
  const e = n;
  return f(e) && e.resourceType === "Encounter" && (typeof e.account > "u" || Array.isArray(e.account) && e.account.every(
    (t) => o(t)
  )) && (typeof e.appointment > "u" || Array.isArray(e.appointment) && e.appointment.every(
    (t) => o(t)
  )) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && s(e.class) && (typeof e.classHistory > "u" || Array.isArray(e.classHistory) && e.classHistory.every(
    (t) => id(t)
  )) && (typeof e.diagnosis > "u" || Array.isArray(e.diagnosis) && e.diagnosis.every(
    (t) => od(t)
  )) && (typeof e.episodeOfCare > "u" || Array.isArray(e.episodeOfCare) && e.episodeOfCare.every(
    (t) => o(t)
  )) && (typeof e.hospitalization > "u" || dd(e.hospitalization)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.length > "u" || _(e.length)) && (typeof e.location > "u" || Array.isArray(e.location) && e.location.every(
    (t) => ad(t)
  )) && (typeof e.participant > "u" || Array.isArray(e.participant) && e.participant.every(
    (t) => rd(t)
  )) && (typeof e.partOf > "u" || o(e.partOf)) && (typeof e.period > "u" || y(e.period)) && (typeof e.priority > "u" || r(e.priority)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.serviceProvider > "u" || o(e.serviceProvider)) && (typeof e.serviceType > "u" || r(e.serviceType)) && (e.status === "entered-in-error" || e.status === "unknown" || e.status === "arrived" || e.status === "cancelled" || e.status === "in-progress" || e.status === "planned" || e.status === "triaged" || e.status === "onleave" || e.status === "finished") && (typeof e._status > "u" || i(e._status)) && (typeof e.statusHistory > "u" || Array.isArray(e.statusHistory) && e.statusHistory.every(
    (t) => nd(t)
  )) && (typeof e.subject > "u" || o(e.subject)) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => r(t)
  ));
}
function Te(n) {
  const e = n;
  return f(e) && e.resourceType === "Endpoint" && typeof e.address == "string" && (typeof e._address > "u" || i(e._address)) && s(e.connectionType) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => I(t)
  )) && (typeof e.header > "u" || Array.isArray(e.header) && e.header.every(
    (t) => typeof t == "string"
  )) && (typeof e._header > "u" || Array.isArray(e._header) && e._header.every(
    (t) => i(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.managingOrganization > "u" || o(e.managingOrganization)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.payloadMimeType > "u" || Array.isArray(e.payloadMimeType) && e.payloadMimeType.every(
    (t) => typeof t == "string"
  )) && (typeof e._payloadMimeType > "u" || Array.isArray(e._payloadMimeType) && e._payloadMimeType.every(
    (t) => i(t)
  )) && Array.isArray(e.payloadType) && e.payloadType.every(
    (t) => r(t)
  ) && (typeof e.period > "u" || y(e.period)) && (e.status === "error" || e.status === "active" || e.status === "entered-in-error" || e.status === "suspended" || e.status === "off" || e.status === "test") && (typeof e._status > "u" || i(e._status));
}
function xe(n) {
  const e = n;
  return f(e) && e.resourceType === "EnrollmentRequest" && (typeof e.candidate > "u" || o(e.candidate)) && (typeof e.coverage > "u" || o(e.coverage)) && (typeof e.created > "u" || typeof e.created == "string") && (typeof e._created > "u" || i(e._created)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.insurer > "u" || o(e.insurer)) && (typeof e.provider > "u" || o(e.provider)) && (typeof e.status > "u" || e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || i(e._status));
}
function je(n) {
  const e = n;
  return f(e) && e.resourceType === "EnrollmentResponse" && (typeof e.created > "u" || typeof e.created == "string") && (typeof e._created > "u" || i(e._created)) && (typeof e.disposition > "u" || typeof e.disposition == "string") && (typeof e._disposition > "u" || i(e._disposition)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.organization > "u" || o(e.organization)) && (typeof e.outcome > "u" || e.outcome === "error" || e.outcome === "queued" || e.outcome === "complete" || e.outcome === "partial") && (typeof e._outcome > "u" || i(e._outcome)) && (typeof e.request > "u" || o(e.request)) && (typeof e.requestProvider > "u" || o(e.requestProvider)) && (typeof e.status > "u" || e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || i(e._status));
}
function fd(n) {
  const e = n;
  return d(e) && y(e.period) && (e.status === "active" || e.status === "entered-in-error" || e.status === "cancelled" || e.status === "waitlist" || e.status === "planned" || e.status === "finished" || e.status === "onhold") && (typeof e._status > "u" || i(e._status));
}
function yd(n) {
  const e = n;
  return d(e) && o(e.condition) && (typeof e.rank > "u" || typeof e.rank == "number") && (typeof e.role > "u" || r(e.role));
}
function Pe(n) {
  const e = n;
  return f(e) && e.resourceType === "EpisodeOfCare" && (typeof e.account > "u" || Array.isArray(e.account) && e.account.every(
    (t) => o(t)
  )) && (typeof e.careManager > "u" || o(e.careManager)) && (typeof e.diagnosis > "u" || Array.isArray(e.diagnosis) && e.diagnosis.every(
    (t) => yd(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.managingOrganization > "u" || o(e.managingOrganization)) && o(e.patient) && (typeof e.period > "u" || y(e.period)) && (typeof e.referralRequest > "u" || Array.isArray(e.referralRequest) && e.referralRequest.every(
    (t) => o(t)
  )) && (e.status === "active" || e.status === "entered-in-error" || e.status === "cancelled" || e.status === "waitlist" || e.status === "planned" || e.status === "finished" || e.status === "onhold") && (typeof e._status > "u" || i(e._status)) && (typeof e.statusHistory > "u" || Array.isArray(e.statusHistory) && e.statusHistory.every(
    (t) => fd(t)
  )) && (typeof e.team > "u" || Array.isArray(e.team) && e.team.every(
    (t) => o(t)
  )) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => r(t)
  ));
}
function Fe(n) {
  const e = n;
  return f(e) && e.resourceType === "EventDefinition" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || i(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => p(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => p(t)
  )) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => p(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || i(e._lastReviewDate)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => w(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => p(t)
  )) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.subjectCodeableConcept > "u" || r(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || o(e.subjectReference)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || i(e._subtitle)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => r(t)
  )) && Array.isArray(e.trigger) && e.trigger.every(
    (t) => T(t)
  ) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.usage > "u" || typeof e.usage == "string") && (typeof e._usage > "u" || i(e._usage)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function He(n) {
  const e = n;
  return f(e) && e.resourceType === "Evidence" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || i(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => p(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => p(t)
  )) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => p(t)
  )) && o(e.exposureBackground) && (typeof e.exposureVariant > "u" || Array.isArray(e.exposureVariant) && e.exposureVariant.every(
    (t) => o(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || i(e._lastReviewDate)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.outcome > "u" || Array.isArray(e.outcome) && e.outcome.every(
    (t) => o(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => w(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => p(t)
  )) && (typeof e.shortTitle > "u" || typeof e.shortTitle == "string") && (typeof e._shortTitle > "u" || i(e._shortTitle)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || i(e._subtitle)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => r(t)
  )) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function ud(n) {
  const e = n;
  return d(e) && (typeof e.definitionReference > "u" || o(e.definitionReference)) && (typeof e.definitionCanonical > "u" || typeof e.definitionCanonical == "string") && (typeof e._definitionCanonical > "u" || i(e._definitionCanonical)) && (typeof e.definitionCodeableConcept > "u" || r(e.definitionCodeableConcept)) && (typeof e.definitionExpression > "u" || R(e.definitionExpression)) && (typeof e.definitionDataRequirement > "u" || D(e.definitionDataRequirement)) && (typeof e.definitionTriggerDefinition > "u" || T(e.definitionTriggerDefinition)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.exclude > "u" || e.exclude === !1 || e.exclude === !0) && (typeof e._exclude > "u" || i(e._exclude)) && (typeof e.groupMeasure > "u" || e.groupMeasure === "mean" || e.groupMeasure === "median" || e.groupMeasure === "mean-of-mean" || e.groupMeasure === "mean-of-median" || e.groupMeasure === "median-of-mean" || e.groupMeasure === "median-of-median") && (typeof e._groupMeasure > "u" || i(e._groupMeasure)) && (typeof e.participantEffectiveDateTime > "u" || typeof e.participantEffectiveDateTime == "string") && (typeof e._participantEffectiveDateTime > "u" || i(e._participantEffectiveDateTime)) && (typeof e.participantEffectivePeriod > "u" || y(e.participantEffectivePeriod)) && (typeof e.participantEffectiveDuration > "u" || _(e.participantEffectiveDuration)) && (typeof e.participantEffectiveTiming > "u" || A(e.participantEffectiveTiming)) && (typeof e.timeFromStart > "u" || _(e.timeFromStart)) && (typeof e.usageContext > "u" || Array.isArray(e.usageContext) && e.usageContext.every(
    (t) => m(t)
  ));
}
function Me(n) {
  const e = n;
  return f(e) && e.resourceType === "EvidenceVariable" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || i(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => p(t)
  )) && Array.isArray(e.characteristic) && e.characteristic.every(
    (t) => ud(t)
  ) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => p(t)
  )) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => p(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || i(e._lastReviewDate)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => w(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => p(t)
  )) && (typeof e.shortTitle > "u" || typeof e.shortTitle == "string") && (typeof e._shortTitle > "u" || i(e._shortTitle)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || i(e._subtitle)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => r(t)
  )) && (typeof e.type > "u" || e.type === "dichotomous" || e.type === "continuous" || e.type === "descriptive") && (typeof e._type > "u" || i(e._type)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function pd(n) {
  const e = n;
  return d(e) && typeof e.actorId == "string" && (typeof e._actorId > "u" || i(e._actorId)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (e.type === "person" || e.type === "entity") && (typeof e._type > "u" || i(e._type));
}
function sd(n) {
  const e = n;
  return d(e) && typeof e.description == "string" && (typeof e._description > "u" || i(e._description)) && typeof e.versionId == "string" && (typeof e._versionId > "u" || i(e._versionId));
}
function Dn(n) {
  const e = n;
  return d(e) && typeof e.resourceId == "string" && (typeof e._resourceId > "u" || i(e._resourceId)) && (typeof e.versionId > "u" || typeof e.versionId == "string") && (typeof e._versionId > "u" || i(e._versionId));
}
function cd(n) {
  const e = n;
  return d(e) && (typeof e.containedInstance > "u" || Array.isArray(e.containedInstance) && e.containedInstance.every(
    (t) => Dn(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && typeof e.resourceId == "string" && (typeof e._resourceId > "u" || i(e._resourceId)) && typeof e.resourceType == "string" && (typeof e._resourceType > "u" || i(e._resourceType)) && (typeof e.version > "u" || Array.isArray(e.version) && e.version.every(
    (t) => sd(t)
  ));
}
function ld(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.initiator > "u" || typeof e.initiator == "string") && (typeof e._initiator > "u" || i(e._initiator)) && (typeof e.initiatorActive > "u" || e.initiatorActive === !1 || e.initiatorActive === !0) && (typeof e._initiatorActive > "u" || i(e._initiatorActive)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && typeof e.number == "string" && (typeof e._number > "u" || i(e._number)) && (typeof e.receiver > "u" || typeof e.receiver == "string") && (typeof e._receiver > "u" || i(e._receiver)) && (typeof e.receiverActive > "u" || e.receiverActive === !1 || e.receiverActive === !0) && (typeof e._receiverActive > "u" || i(e._receiverActive)) && (typeof e.request > "u" || Dn(e.request)) && (typeof e.response > "u" || Dn(e.response)) && (typeof e.type > "u" || typeof e.type == "string") && (typeof e._type > "u" || i(e._type));
}
function vd(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.step > "u" || Array.isArray(e.step) && e.step.every(
    (t) => Xn(t)
  )) && typeof e.title == "string" && (typeof e._title > "u" || i(e._title));
}
function Xn(n) {
  const e = n;
  return d(e) && (typeof e.alternative > "u" || Array.isArray(e.alternative) && e.alternative.every(
    (t) => vd(t)
  )) && (typeof e.operation > "u" || ld(e.operation)) && (typeof e.pause > "u" || e.pause === !1 || e.pause === !0) && (typeof e._pause > "u" || i(e._pause)) && (typeof e.process > "u" || Array.isArray(e.process) && e.process.every(
    (t) => Yn(t)
  ));
}
function Yn(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.postConditions > "u" || typeof e.postConditions == "string") && (typeof e._postConditions > "u" || i(e._postConditions)) && (typeof e.preConditions > "u" || typeof e.preConditions == "string") && (typeof e._preConditions > "u" || i(e._preConditions)) && (typeof e.step > "u" || Array.isArray(e.step) && e.step.every(
    (t) => Xn(t)
  )) && typeof e.title == "string" && (typeof e._title > "u" || i(e._title));
}
function qe(n) {
  const e = n;
  return f(e) && e.resourceType === "ExampleScenario" && (typeof e.actor > "u" || Array.isArray(e.actor) && e.actor.every(
    (t) => pd(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.instance > "u" || Array.isArray(e.instance) && e.instance.every(
    (t) => cd(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.process > "u" || Array.isArray(e.process) && e.process.every(
    (t) => Yn(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version)) && (typeof e.workflow > "u" || Array.isArray(e.workflow) && e.workflow.every(
    (t) => typeof t == "string"
  )) && (typeof e._workflow > "u" || Array.isArray(e._workflow) && e._workflow.every(
    (t) => i(t)
  ));
}
function md(n) {
  const e = n;
  return d(e) && (typeof e.claim > "u" || o(e.claim)) && (typeof e.reference > "u" || a(e.reference)) && (typeof e.relationship > "u" || r(e.relationship));
}
function gd(n) {
  const e = n;
  return d(e) && (typeof e.party > "u" || o(e.party)) && (typeof e.type > "u" || r(e.type));
}
function _d(n) {
  const e = n;
  return d(e) && o(e.provider) && (typeof e.qualification > "u" || r(e.qualification)) && (typeof e.responsible > "u" || e.responsible === !1 || e.responsible === !0) && (typeof e._responsible > "u" || i(e._responsible)) && (typeof e.role > "u" || r(e.role)) && typeof e.sequence == "number";
}
function Ad(n) {
  const e = n;
  return d(e) && r(e.category) && (typeof e.code > "u" || r(e.code)) && (typeof e.reason > "u" || s(e.reason)) && typeof e.sequence == "number" && (typeof e.timingDate > "u" || typeof e.timingDate == "string") && (typeof e._timingDate > "u" || i(e._timingDate)) && (typeof e.timingPeriod > "u" || y(e.timingPeriod)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueAttachment > "u" || g(e.valueAttachment)) && (typeof e.valueReference > "u" || o(e.valueReference));
}
function bd(n) {
  const e = n;
  return d(e) && (typeof e.diagnosisCodeableConcept > "u" || r(e.diagnosisCodeableConcept)) && (typeof e.diagnosisReference > "u" || o(e.diagnosisReference)) && (typeof e.onAdmission > "u" || r(e.onAdmission)) && (typeof e.packageCode > "u" || r(e.packageCode)) && typeof e.sequence == "number" && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => r(t)
  ));
}
function Id(n) {
  const e = n;
  return d(e) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.procedureCodeableConcept > "u" || r(e.procedureCodeableConcept)) && (typeof e.procedureReference > "u" || o(e.procedureReference)) && typeof e.sequence == "number" && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => r(t)
  )) && (typeof e.udi > "u" || Array.isArray(e.udi) && e.udi.every(
    (t) => o(t)
  ));
}
function hd(n) {
  const e = n;
  return d(e) && o(e.coverage) && typeof e.focal == "boolean" && (typeof e._focal > "u" || i(e._focal)) && (typeof e.preAuthRef > "u" || Array.isArray(e.preAuthRef) && e.preAuthRef.every(
    (t) => typeof t == "string"
  )) && (typeof e._preAuthRef > "u" || Array.isArray(e._preAuthRef) && e._preAuthRef.every(
    (t) => i(t)
  ));
}
function wd(n) {
  const e = n;
  return d(e) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.locationAddress > "u" || h(e.locationAddress)) && (typeof e.locationReference > "u" || o(e.locationReference)) && (typeof e.type > "u" || r(e.type));
}
function k(n) {
  const e = n;
  return d(e) && (typeof e.amount > "u" || c(e.amount)) && r(e.category) && (typeof e.reason > "u" || r(e.reason)) && (typeof e.value > "u" || typeof e.value == "number");
}
function Rd(n) {
  const e = n;
  return d(e) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => k(t)
  )) && (typeof e.category > "u" || r(e.category)) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => r(t)
  )) && (typeof e.net > "u" || c(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && r(e.productOrService) && (typeof e.programCode > "u" || Array.isArray(e.programCode) && e.programCode.every(
    (t) => r(t)
  )) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.revenue > "u" || r(e.revenue)) && typeof e.sequence == "number" && (typeof e.udi > "u" || Array.isArray(e.udi) && e.udi.every(
    (t) => o(t)
  )) && (typeof e.unitPrice > "u" || c(e.unitPrice));
}
function Cd(n) {
  const e = n;
  return d(e) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => k(t)
  )) && (typeof e.category > "u" || r(e.category)) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => r(t)
  )) && (typeof e.net > "u" || c(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && r(e.productOrService) && (typeof e.programCode > "u" || Array.isArray(e.programCode) && e.programCode.every(
    (t) => r(t)
  )) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.revenue > "u" || r(e.revenue)) && typeof e.sequence == "number" && (typeof e.subDetail > "u" || Array.isArray(e.subDetail) && e.subDetail.every(
    (t) => Rd(t)
  )) && (typeof e.udi > "u" || Array.isArray(e.udi) && e.udi.every(
    (t) => o(t)
  )) && (typeof e.unitPrice > "u" || c(e.unitPrice));
}
function Dd(n) {
  const e = n;
  return d(e) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => k(t)
  )) && (typeof e.bodySite > "u" || r(e.bodySite)) && (typeof e.careTeamSequence > "u" || Array.isArray(e.careTeamSequence) && e.careTeamSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.category > "u" || r(e.category)) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => Cd(t)
  )) && (typeof e.diagnosisSequence > "u" || Array.isArray(e.diagnosisSequence) && e.diagnosisSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.encounter > "u" || Array.isArray(e.encounter) && e.encounter.every(
    (t) => o(t)
  )) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.informationSequence > "u" || Array.isArray(e.informationSequence) && e.informationSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.locationCodeableConcept > "u" || r(e.locationCodeableConcept)) && (typeof e.locationAddress > "u" || h(e.locationAddress)) && (typeof e.locationReference > "u" || o(e.locationReference)) && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => r(t)
  )) && (typeof e.net > "u" || c(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && (typeof e.procedureSequence > "u" || Array.isArray(e.procedureSequence) && e.procedureSequence.every(
    (t) => typeof t == "number"
  )) && r(e.productOrService) && (typeof e.programCode > "u" || Array.isArray(e.programCode) && e.programCode.every(
    (t) => r(t)
  )) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.revenue > "u" || r(e.revenue)) && typeof e.sequence == "number" && (typeof e.servicedDate > "u" || typeof e.servicedDate == "string") && (typeof e._servicedDate > "u" || i(e._servicedDate)) && (typeof e.servicedPeriod > "u" || y(e.servicedPeriod)) && (typeof e.subSite > "u" || Array.isArray(e.subSite) && e.subSite.every(
    (t) => r(t)
  )) && (typeof e.udi > "u" || Array.isArray(e.udi) && e.udi.every(
    (t) => o(t)
  )) && (typeof e.unitPrice > "u" || c(e.unitPrice));
}
function Sd(n) {
  const e = n;
  return d(e) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => k(t)
  )) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => r(t)
  )) && (typeof e.net > "u" || c(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && r(e.productOrService) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.unitPrice > "u" || c(e.unitPrice));
}
function Od(n) {
  const e = n;
  return d(e) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => k(t)
  )) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => r(t)
  )) && (typeof e.net > "u" || c(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && r(e.productOrService) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.subDetail > "u" || Array.isArray(e.subDetail) && e.subDetail.every(
    (t) => Sd(t)
  )) && (typeof e.unitPrice > "u" || c(e.unitPrice));
}
function Ed(n) {
  const e = n;
  return d(e) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => k(t)
  )) && (typeof e.bodySite > "u" || r(e.bodySite)) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => Od(t)
  )) && (typeof e.detailSequence > "u" || Array.isArray(e.detailSequence) && e.detailSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.itemSequence > "u" || Array.isArray(e.itemSequence) && e.itemSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.locationCodeableConcept > "u" || r(e.locationCodeableConcept)) && (typeof e.locationAddress > "u" || h(e.locationAddress)) && (typeof e.locationReference > "u" || o(e.locationReference)) && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => r(t)
  )) && (typeof e.net > "u" || c(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && r(e.productOrService) && (typeof e.programCode > "u" || Array.isArray(e.programCode) && e.programCode.every(
    (t) => r(t)
  )) && (typeof e.provider > "u" || Array.isArray(e.provider) && e.provider.every(
    (t) => o(t)
  )) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.servicedDate > "u" || typeof e.servicedDate == "string") && (typeof e._servicedDate > "u" || i(e._servicedDate)) && (typeof e.servicedPeriod > "u" || y(e.servicedPeriod)) && (typeof e.subDetailSequence > "u" || Array.isArray(e.subDetailSequence) && e.subDetailSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.subSite > "u" || Array.isArray(e.subSite) && e.subSite.every(
    (t) => r(t)
  )) && (typeof e.unitPrice > "u" || c(e.unitPrice));
}
function Td(n) {
  const e = n;
  return d(e) && c(e.amount) && r(e.category);
}
function xd(n) {
  const e = n;
  return d(e) && (typeof e.adjustment > "u" || c(e.adjustment)) && (typeof e.adjustmentReason > "u" || r(e.adjustmentReason)) && (typeof e.amount > "u" || c(e.amount)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.type > "u" || r(e.type));
}
function jd(n) {
  const e = n;
  return d(e) && (typeof e.language > "u" || r(e.language)) && (typeof e.number > "u" || typeof e.number == "number") && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || i(e._text)) && (typeof e.type > "u" || e.type === "display" || e.type === "print" || e.type === "printoper") && (typeof e._type > "u" || i(e._type));
}
function Pd(n) {
  const e = n;
  return d(e) && (typeof e.allowedUnsignedInt > "u" || typeof e.allowedUnsignedInt == "number") && (typeof e.allowedString > "u" || typeof e.allowedString == "string") && (typeof e._allowedString > "u" || i(e._allowedString)) && (typeof e.allowedMoney > "u" || c(e.allowedMoney)) && r(e.type) && (typeof e.usedUnsignedInt > "u" || typeof e.usedUnsignedInt == "number") && (typeof e.usedMoney > "u" || c(e.usedMoney));
}
function Fd(n) {
  const e = n;
  return d(e) && r(e.category) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.excluded > "u" || e.excluded === !1 || e.excluded === !0) && (typeof e._excluded > "u" || i(e._excluded)) && (typeof e.financial > "u" || Array.isArray(e.financial) && e.financial.every(
    (t) => Pd(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.network > "u" || r(e.network)) && (typeof e.term > "u" || r(e.term)) && (typeof e.unit > "u" || r(e.unit));
}
function ke(n) {
  const e = n;
  return f(e) && e.resourceType === "ExplanationOfBenefit" && (typeof e.accident > "u" || wd(e.accident)) && (typeof e.addItem > "u" || Array.isArray(e.addItem) && e.addItem.every(
    (t) => Ed(t)
  )) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => k(t)
  )) && (typeof e.benefitBalance > "u" || Array.isArray(e.benefitBalance) && e.benefitBalance.every(
    (t) => Fd(t)
  )) && (typeof e.benefitPeriod > "u" || y(e.benefitPeriod)) && (typeof e.billablePeriod > "u" || y(e.billablePeriod)) && (typeof e.careTeam > "u" || Array.isArray(e.careTeam) && e.careTeam.every(
    (t) => _d(t)
  )) && (typeof e.claim > "u" || o(e.claim)) && (typeof e.claimResponse > "u" || o(e.claimResponse)) && typeof e.created == "string" && (typeof e._created > "u" || i(e._created)) && (typeof e.diagnosis > "u" || Array.isArray(e.diagnosis) && e.diagnosis.every(
    (t) => bd(t)
  )) && (typeof e.disposition > "u" || typeof e.disposition == "string") && (typeof e._disposition > "u" || i(e._disposition)) && (typeof e.enterer > "u" || o(e.enterer)) && (typeof e.facility > "u" || o(e.facility)) && (typeof e.form > "u" || g(e.form)) && (typeof e.formCode > "u" || r(e.formCode)) && (typeof e.fundsReserve > "u" || r(e.fundsReserve)) && (typeof e.fundsReserveRequested > "u" || r(e.fundsReserveRequested)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && Array.isArray(e.insurance) && e.insurance.every(
    (t) => hd(t)
  ) && o(e.insurer) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => Dd(t)
  )) && (typeof e.originalPrescription > "u" || o(e.originalPrescription)) && (e.outcome === "error" || e.outcome === "queued" || e.outcome === "complete" || e.outcome === "partial") && (typeof e._outcome > "u" || i(e._outcome)) && o(e.patient) && (typeof e.payee > "u" || gd(e.payee)) && (typeof e.payment > "u" || xd(e.payment)) && (typeof e.preAuthRef > "u" || Array.isArray(e.preAuthRef) && e.preAuthRef.every(
    (t) => typeof t == "string"
  )) && (typeof e._preAuthRef > "u" || Array.isArray(e._preAuthRef) && e._preAuthRef.every(
    (t) => i(t)
  )) && (typeof e.preAuthRefPeriod > "u" || Array.isArray(e.preAuthRefPeriod) && e.preAuthRefPeriod.every(
    (t) => y(t)
  )) && (typeof e.precedence > "u" || typeof e.precedence == "number") && (typeof e.prescription > "u" || o(e.prescription)) && (typeof e.priority > "u" || r(e.priority)) && (typeof e.procedure > "u" || Array.isArray(e.procedure) && e.procedure.every(
    (t) => Id(t)
  )) && (typeof e.processNote > "u" || Array.isArray(e.processNote) && e.processNote.every(
    (t) => jd(t)
  )) && o(e.provider) && (typeof e.referral > "u" || o(e.referral)) && (typeof e.related > "u" || Array.isArray(e.related) && e.related.every(
    (t) => md(t)
  )) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || i(e._status)) && (typeof e.subType > "u" || r(e.subType)) && (typeof e.supportingInfo > "u" || Array.isArray(e.supportingInfo) && e.supportingInfo.every(
    (t) => Ad(t)
  )) && (typeof e.total > "u" || Array.isArray(e.total) && e.total.every(
    (t) => Td(t)
  )) && r(e.type) && (e.use === "claim" || e.use === "preauthorization" || e.use === "predetermination") && (typeof e._use > "u" || i(e._use));
}
function Hd(n) {
  const e = n;
  return d(e) && r(e.code) && (typeof e.contributedToDeath > "u" || e.contributedToDeath === !1 || e.contributedToDeath === !0) && (typeof e._contributedToDeath > "u" || i(e._contributedToDeath)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.onsetAge > "u" || C(e.onsetAge)) && (typeof e.onsetRange > "u" || v(e.onsetRange)) && (typeof e.onsetPeriod > "u" || y(e.onsetPeriod)) && (typeof e.onsetString > "u" || typeof e.onsetString == "string") && (typeof e._onsetString > "u" || i(e._onsetString)) && (typeof e.outcome > "u" || r(e.outcome));
}
function Be(n) {
  const e = n;
  return f(e) && e.resourceType === "FamilyMemberHistory" && (typeof e.ageAge > "u" || C(e.ageAge)) && (typeof e.ageRange > "u" || v(e.ageRange)) && (typeof e.ageString > "u" || typeof e.ageString == "string") && (typeof e._ageString > "u" || i(e._ageString)) && (typeof e.bornPeriod > "u" || y(e.bornPeriod)) && (typeof e.bornDate > "u" || typeof e.bornDate == "string") && (typeof e._bornDate > "u" || i(e._bornDate)) && (typeof e.bornString > "u" || typeof e.bornString == "string") && (typeof e._bornString > "u" || i(e._bornString)) && (typeof e.condition > "u" || Array.isArray(e.condition) && e.condition.every(
    (t) => Hd(t)
  )) && (typeof e.dataAbsentReason > "u" || r(e.dataAbsentReason)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.deceasedBoolean > "u" || e.deceasedBoolean === !1 || e.deceasedBoolean === !0) && (typeof e._deceasedBoolean > "u" || i(e._deceasedBoolean)) && (typeof e.deceasedAge > "u" || C(e.deceasedAge)) && (typeof e.deceasedRange > "u" || v(e.deceasedRange)) && (typeof e.deceasedDate > "u" || typeof e.deceasedDate == "string") && (typeof e._deceasedDate > "u" || i(e._deceasedDate)) && (typeof e.deceasedString > "u" || typeof e.deceasedString == "string") && (typeof e._deceasedString > "u" || i(e._deceasedString)) && (typeof e.estimatedAge > "u" || e.estimatedAge === !1 || e.estimatedAge === !0) && (typeof e._estimatedAge > "u" || i(e._estimatedAge)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => i(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => i(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && o(e.patient) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && r(e.relationship) && (typeof e.sex > "u" || r(e.sex)) && (e.status === "entered-in-error" || e.status === "completed" || e.status === "partial" || e.status === "health-unknown") && (typeof e._status > "u" || i(e._status));
}
function Ve(n) {
  const e = n;
  return f(e) && e.resourceType === "Flag" && (typeof e.author > "u" || o(e.author)) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && r(e.code) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.period > "u" || y(e.period)) && (e.status === "active" || e.status === "inactive" || e.status === "entered-in-error") && (typeof e._status > "u" || i(e._status)) && o(e.subject);
}
function Md(n) {
  const e = n;
  return d(e) && (typeof e.detailQuantity > "u" || u(e.detailQuantity)) && (typeof e.detailRange > "u" || v(e.detailRange)) && (typeof e.detailCodeableConcept > "u" || r(e.detailCodeableConcept)) && (typeof e.detailString > "u" || typeof e.detailString == "string") && (typeof e._detailString > "u" || i(e._detailString)) && (typeof e.detailBoolean > "u" || e.detailBoolean === !1 || e.detailBoolean === !0) && (typeof e._detailBoolean > "u" || i(e._detailBoolean)) && (typeof e.detailInteger > "u" || typeof e.detailInteger == "number") && (typeof e.detailRatio > "u" || b(e.detailRatio)) && (typeof e.dueDate > "u" || typeof e.dueDate == "string") && (typeof e._dueDate > "u" || i(e._dueDate)) && (typeof e.dueDuration > "u" || _(e.dueDuration)) && (typeof e.measure > "u" || r(e.measure));
}
function Ue(n) {
  const e = n;
  return f(e) && e.resourceType === "Goal" && (typeof e.achievementStatus > "u" || r(e.achievementStatus)) && (typeof e.addresses > "u" || Array.isArray(e.addresses) && e.addresses.every(
    (t) => o(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && r(e.description) && (typeof e.expressedBy > "u" || o(e.expressedBy)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (e.lifecycleStatus === "active" || e.lifecycleStatus === "entered-in-error" || e.lifecycleStatus === "on-hold" || e.lifecycleStatus === "accepted" || e.lifecycleStatus === "proposed" || e.lifecycleStatus === "cancelled" || e.lifecycleStatus === "completed" || e.lifecycleStatus === "planned" || e.lifecycleStatus === "rejected") && (typeof e._lifecycleStatus > "u" || i(e._lifecycleStatus)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.outcomeCode > "u" || Array.isArray(e.outcomeCode) && e.outcomeCode.every(
    (t) => r(t)
  )) && (typeof e.outcomeReference > "u" || Array.isArray(e.outcomeReference) && e.outcomeReference.every(
    (t) => o(t)
  )) && (typeof e.priority > "u" || r(e.priority)) && (typeof e.startDate > "u" || typeof e.startDate == "string") && (typeof e._startDate > "u" || i(e._startDate)) && (typeof e.startCodeableConcept > "u" || r(e.startCodeableConcept)) && (typeof e.statusDate > "u" || typeof e.statusDate == "string") && (typeof e._statusDate > "u" || i(e._statusDate)) && (typeof e.statusReason > "u" || typeof e.statusReason == "string") && (typeof e._statusReason > "u" || i(e._statusReason)) && o(e.subject) && (typeof e.target > "u" || Array.isArray(e.target) && e.target.every(
    (t) => Md(t)
  ));
}
function qd(n) {
  const e = n;
  return d(e) && (e.code === "Patient" || e.code === "Encounter" || e.code === "RelatedPerson" || e.code === "Practitioner" || e.code === "Device") && (typeof e._code > "u" || i(e._code)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.expression > "u" || typeof e.expression == "string") && (typeof e._expression > "u" || i(e._expression)) && (e.rule === "identical" || e.rule === "matching" || e.rule === "different" || e.rule === "custom") && (typeof e._rule > "u" || i(e._rule)) && (e.use === "condition" || e.use === "requirement") && (typeof e._use > "u" || i(e._use));
}
function kd(n) {
  const e = n;
  return d(e) && (typeof e.compartment > "u" || Array.isArray(e.compartment) && e.compartment.every(
    (t) => qd(t)
  )) && (typeof e.link > "u" || Array.isArray(e.link) && e.link.every(
    (t) => Zn(t)
  )) && (typeof e.params > "u" || typeof e.params == "string") && (typeof e._params > "u" || i(e._params)) && (typeof e.profile > "u" || typeof e.profile == "string") && (typeof e._profile > "u" || i(e._profile)) && typeof e.type == "string" && (typeof e._type > "u" || i(e._type));
}
function Zn(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.max > "u" || typeof e.max == "string") && (typeof e._max > "u" || i(e._max)) && (typeof e.min > "u" || typeof e.min == "number") && (typeof e.path > "u" || typeof e.path == "string") && (typeof e._path > "u" || i(e._path)) && (typeof e.sliceName > "u" || typeof e.sliceName == "string") && (typeof e._sliceName > "u" || i(e._sliceName)) && (typeof e.target > "u" || Array.isArray(e.target) && e.target.every(
    (t) => kd(t)
  ));
}
function Ne(n) {
  const e = n;
  return f(e) && e.resourceType === "GraphDefinition" && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.link > "u" || Array.isArray(e.link) && e.link.every(
    (t) => Zn(t)
  )) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.profile > "u" || typeof e.profile == "string") && (typeof e._profile > "u" || i(e._profile)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && typeof e.start == "string" && (typeof e._start > "u" || i(e._start)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function Bd(n) {
  const e = n;
  return d(e) && r(e.code) && typeof e.exclude == "boolean" && (typeof e._exclude > "u" || i(e._exclude)) && (typeof e.period > "u" || y(e.period)) && (typeof e.valueCodeableConcept > "u" || r(e.valueCodeableConcept)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean)) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueRange > "u" || v(e.valueRange)) && (typeof e.valueReference > "u" || o(e.valueReference));
}
function Vd(n) {
  const e = n;
  return d(e) && o(e.entity) && (typeof e.inactive > "u" || e.inactive === !1 || e.inactive === !0) && (typeof e._inactive > "u" || i(e._inactive)) && (typeof e.period > "u" || y(e.period));
}
function Le(n) {
  const e = n;
  return f(e) && e.resourceType === "Group" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || i(e._active)) && typeof e.actual == "boolean" && (typeof e._actual > "u" || i(e._actual)) && (typeof e.characteristic > "u" || Array.isArray(e.characteristic) && e.characteristic.every(
    (t) => Bd(t)
  )) && (typeof e.code > "u" || r(e.code)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.managingEntity > "u" || o(e.managingEntity)) && (typeof e.member > "u" || Array.isArray(e.member) && e.member.every(
    (t) => Vd(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.quantity > "u" || typeof e.quantity == "number") && (e.type === "practitioner" || e.type === "device" || e.type === "medication" || e.type === "person" || e.type === "animal" || e.type === "substance") && (typeof e._type > "u" || i(e._type));
}
function Ge(n) {
  const e = n;
  return f(e) && e.resourceType === "GuidanceResponse" && (typeof e.dataRequirement > "u" || Array.isArray(e.dataRequirement) && e.dataRequirement.every(
    (t) => D(t)
  )) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.evaluationMessage > "u" || Array.isArray(e.evaluationMessage) && e.evaluationMessage.every(
    (t) => o(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.moduleUri > "u" || typeof e.moduleUri == "string") && (typeof e._moduleUri > "u" || i(e._moduleUri)) && (typeof e.moduleCanonical > "u" || typeof e.moduleCanonical == "string") && (typeof e._moduleCanonical > "u" || i(e._moduleCanonical)) && (typeof e.moduleCodeableConcept > "u" || r(e.moduleCodeableConcept)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || i(e._occurrenceDateTime)) && (typeof e.outputParameters > "u" || o(e.outputParameters)) && (typeof e.performer > "u" || o(e.performer)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.requestIdentifier > "u" || a(e.requestIdentifier)) && (typeof e.result > "u" || o(e.result)) && (e.status === "entered-in-error" || e.status === "in-progress" || e.status === "success" || e.status === "data-requested" || e.status === "data-required" || e.status === "failure") && (typeof e._status > "u" || i(e._status)) && (typeof e.subject > "u" || o(e.subject));
}
function Ud(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || r(e.code)) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment));
}
function Nd(n) {
  const e = n;
  return d(e) && (typeof e.allDay > "u" || e.allDay === !1 || e.allDay === !0) && (typeof e._allDay > "u" || i(e._allDay)) && (typeof e.availableEndTime > "u" || typeof e.availableEndTime == "string") && (typeof e._availableEndTime > "u" || i(e._availableEndTime)) && (typeof e.availableStartTime > "u" || typeof e.availableStartTime == "string") && (typeof e._availableStartTime > "u" || i(e._availableStartTime)) && (typeof e.daysOfWeek > "u" || Array.isArray(e.daysOfWeek) && e.daysOfWeek.every(
    (t) => t === "mon" || t === "tue" || t === "wed" || t === "thu" || t === "fri" || t === "sat" || t === "sun"
  )) && (typeof e._daysOfWeek > "u" || Array.isArray(e._daysOfWeek) && e._daysOfWeek.every(
    (t) => i(t)
  ));
}
function Ld(n) {
  const e = n;
  return d(e) && typeof e.description == "string" && (typeof e._description > "u" || i(e._description)) && (typeof e.during > "u" || y(e.during));
}
function ze(n) {
  const e = n;
  return f(e) && e.resourceType === "HealthcareService" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || i(e._active)) && (typeof e.appointmentRequired > "u" || e.appointmentRequired === !1 || e.appointmentRequired === !0) && (typeof e._appointmentRequired > "u" || i(e._appointmentRequired)) && (typeof e.availabilityExceptions > "u" || typeof e.availabilityExceptions == "string") && (typeof e._availabilityExceptions > "u" || i(e._availabilityExceptions)) && (typeof e.availableTime > "u" || Array.isArray(e.availableTime) && e.availableTime.every(
    (t) => Nd(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && (typeof e.characteristic > "u" || Array.isArray(e.characteristic) && e.characteristic.every(
    (t) => r(t)
  )) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment)) && (typeof e.communication > "u" || Array.isArray(e.communication) && e.communication.every(
    (t) => r(t)
  )) && (typeof e.coverageArea > "u" || Array.isArray(e.coverageArea) && e.coverageArea.every(
    (t) => o(t)
  )) && (typeof e.eligibility > "u" || Array.isArray(e.eligibility) && e.eligibility.every(
    (t) => Ud(t)
  )) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => o(t)
  )) && (typeof e.extraDetails > "u" || typeof e.extraDetails == "string") && (typeof e._extraDetails > "u" || i(e._extraDetails)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.location > "u" || Array.isArray(e.location) && e.location.every(
    (t) => o(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.notAvailable > "u" || Array.isArray(e.notAvailable) && e.notAvailable.every(
    (t) => Ld(t)
  )) && (typeof e.photo > "u" || g(e.photo)) && (typeof e.program > "u" || Array.isArray(e.program) && e.program.every(
    (t) => r(t)
  )) && (typeof e.providedBy > "u" || o(e.providedBy)) && (typeof e.referralMethod > "u" || Array.isArray(e.referralMethod) && e.referralMethod.every(
    (t) => r(t)
  )) && (typeof e.serviceProvisionCode > "u" || Array.isArray(e.serviceProvisionCode) && e.serviceProvisionCode.every(
    (t) => r(t)
  )) && (typeof e.specialty > "u" || Array.isArray(e.specialty) && e.specialty.every(
    (t) => r(t)
  )) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => I(t)
  )) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => r(t)
  ));
}
function Gd(n) {
  const e = n;
  return d(e) && o(e.actor) && (typeof e.function > "u" || r(e.function));
}
function zd(n) {
  const e = n;
  return d(e) && (typeof e.number > "u" || typeof e.number == "number") && s(e.sopClass) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && typeof e.uid == "string" && (typeof e._uid > "u" || i(e._uid));
}
function Qd(n) {
  const e = n;
  return d(e) && (typeof e.bodySite > "u" || s(e.bodySite)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => o(t)
  )) && (typeof e.instance > "u" || Array.isArray(e.instance) && e.instance.every(
    (t) => zd(t)
  )) && (typeof e.laterality > "u" || s(e.laterality)) && s(e.modality) && (typeof e.number > "u" || typeof e.number == "number") && (typeof e.numberOfInstances > "u" || typeof e.numberOfInstances == "number") && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => Gd(t)
  )) && (typeof e.specimen > "u" || Array.isArray(e.specimen) && e.specimen.every(
    (t) => o(t)
  )) && (typeof e.started > "u" || typeof e.started == "string") && (typeof e._started > "u" || i(e._started)) && typeof e.uid == "string" && (typeof e._uid > "u" || i(e._uid));
}
function Qe(n) {
  const e = n;
  return f(e) && e.resourceType === "ImagingStudy" && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => o(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.interpreter > "u" || Array.isArray(e.interpreter) && e.interpreter.every(
    (t) => o(t)
  )) && (typeof e.location > "u" || o(e.location)) && (typeof e.modality > "u" || Array.isArray(e.modality) && e.modality.every(
    (t) => s(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.numberOfInstances > "u" || typeof e.numberOfInstances == "number") && (typeof e.numberOfSeries > "u" || typeof e.numberOfSeries == "number") && (typeof e.procedureCode > "u" || Array.isArray(e.procedureCode) && e.procedureCode.every(
    (t) => r(t)
  )) && (typeof e.procedureReference > "u" || o(e.procedureReference)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.referrer > "u" || o(e.referrer)) && (typeof e.series > "u" || Array.isArray(e.series) && e.series.every(
    (t) => Qd(t)
  )) && (typeof e.started > "u" || typeof e.started == "string") && (typeof e._started > "u" || i(e._started)) && (e.status === "entered-in-error" || e.status === "unknown" || e.status === "cancelled" || e.status === "available" || e.status === "registered") && (typeof e._status > "u" || i(e._status)) && o(e.subject);
}
function Wd(n) {
  const e = n;
  return d(e) && o(e.actor) && (typeof e.function > "u" || r(e.function));
}
function Kd(n) {
  const e = n;
  return d(e) && (typeof e.documentType > "u" || typeof e.documentType == "string") && (typeof e._documentType > "u" || i(e._documentType)) && (typeof e.presentationDate > "u" || typeof e.presentationDate == "string") && (typeof e._presentationDate > "u" || i(e._presentationDate)) && (typeof e.publicationDate > "u" || typeof e.publicationDate == "string") && (typeof e._publicationDate > "u" || i(e._publicationDate)) && (typeof e.reference > "u" || typeof e.reference == "string") && (typeof e._reference > "u" || i(e._reference));
}
function Jd(n) {
  const e = n;
  return d(e) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.detail > "u" || o(e.detail)) && (typeof e.reported > "u" || e.reported === !1 || e.reported === !0) && (typeof e._reported > "u" || i(e._reported));
}
function Xd(n) {
  const e = n;
  return d(e) && (typeof e.authority > "u" || o(e.authority)) && (typeof e.doseNumberPositiveInt > "u" || typeof e.doseNumberPositiveInt == "number") && (typeof e.doseNumberString > "u" || typeof e.doseNumberString == "string") && (typeof e._doseNumberString > "u" || i(e._doseNumberString)) && (typeof e.series > "u" || typeof e.series == "string") && (typeof e._series > "u" || i(e._series)) && (typeof e.seriesDosesPositiveInt > "u" || typeof e.seriesDosesPositiveInt == "number") && (typeof e.seriesDosesString > "u" || typeof e.seriesDosesString == "string") && (typeof e._seriesDosesString > "u" || i(e._seriesDosesString)) && (typeof e.targetDisease > "u" || Array.isArray(e.targetDisease) && e.targetDisease.every(
    (t) => r(t)
  ));
}
function We(n) {
  const e = n;
  return f(e) && e.resourceType === "Immunization" && (typeof e.doseQuantity > "u" || u(e.doseQuantity)) && (typeof e.education > "u" || Array.isArray(e.education) && e.education.every(
    (t) => Kd(t)
  )) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.expirationDate > "u" || typeof e.expirationDate == "string") && (typeof e._expirationDate > "u" || i(e._expirationDate)) && (typeof e.fundingSource > "u" || r(e.fundingSource)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.isSubpotent > "u" || e.isSubpotent === !1 || e.isSubpotent === !0) && (typeof e._isSubpotent > "u" || i(e._isSubpotent)) && (typeof e.location > "u" || o(e.location)) && (typeof e.lotNumber > "u" || typeof e.lotNumber == "string") && (typeof e._lotNumber > "u" || i(e._lotNumber)) && (typeof e.manufacturer > "u" || o(e.manufacturer)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || i(e._occurrenceDateTime)) && (typeof e.occurrenceString > "u" || typeof e.occurrenceString == "string") && (typeof e._occurrenceString > "u" || i(e._occurrenceString)) && o(e.patient) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => Wd(t)
  )) && (typeof e.primarySource > "u" || e.primarySource === !1 || e.primarySource === !0) && (typeof e._primarySource > "u" || i(e._primarySource)) && (typeof e.programEligibility > "u" || Array.isArray(e.programEligibility) && e.programEligibility.every(
    (t) => r(t)
  )) && (typeof e.protocolApplied > "u" || Array.isArray(e.protocolApplied) && e.protocolApplied.every(
    (t) => Xd(t)
  )) && (typeof e.reaction > "u" || Array.isArray(e.reaction) && e.reaction.every(
    (t) => Jd(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.recorded > "u" || typeof e.recorded == "string") && (typeof e._recorded > "u" || i(e._recorded)) && (typeof e.reportOrigin > "u" || r(e.reportOrigin)) && (typeof e.route > "u" || r(e.route)) && (typeof e.site > "u" || r(e.site)) && (e.status === "entered-in-error" || e.status === "completed" || e.status === "not-done") && (typeof e._status > "u" || i(e._status)) && (typeof e.statusReason > "u" || r(e.statusReason)) && (typeof e.subpotentReason > "u" || Array.isArray(e.subpotentReason) && e.subpotentReason.every(
    (t) => r(t)
  )) && r(e.vaccineCode);
}
function Ke(n) {
  const e = n;
  return f(e) && e.resourceType === "ImmunizationEvaluation" && (typeof e.authority > "u" || o(e.authority)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.doseNumberPositiveInt > "u" || typeof e.doseNumberPositiveInt == "number") && (typeof e.doseNumberString > "u" || typeof e.doseNumberString == "string") && (typeof e._doseNumberString > "u" || i(e._doseNumberString)) && r(e.doseStatus) && (typeof e.doseStatusReason > "u" || Array.isArray(e.doseStatusReason) && e.doseStatusReason.every(
    (t) => r(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && o(e.immunizationEvent) && o(e.patient) && (typeof e.series > "u" || typeof e.series == "string") && (typeof e._series > "u" || i(e._series)) && (typeof e.seriesDosesPositiveInt > "u" || typeof e.seriesDosesPositiveInt == "number") && (typeof e.seriesDosesString > "u" || typeof e.seriesDosesString == "string") && (typeof e._seriesDosesString > "u" || i(e._seriesDosesString)) && (e.status === "entered-in-error" || e.status === "completed") && (typeof e._status > "u" || i(e._status)) && r(e.targetDisease);
}
function Yd(n) {
  const e = n;
  return d(e) && r(e.code) && typeof e.value == "string" && (typeof e._value > "u" || i(e._value));
}
function Zd(n) {
  const e = n;
  return d(e) && (typeof e.contraindicatedVaccineCode > "u" || Array.isArray(e.contraindicatedVaccineCode) && e.contraindicatedVaccineCode.every(
    (t) => r(t)
  )) && (typeof e.dateCriterion > "u" || Array.isArray(e.dateCriterion) && e.dateCriterion.every(
    (t) => Yd(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.doseNumberPositiveInt > "u" || typeof e.doseNumberPositiveInt == "number") && (typeof e.doseNumberString > "u" || typeof e.doseNumberString == "string") && (typeof e._doseNumberString > "u" || i(e._doseNumberString)) && (typeof e.forecastReason > "u" || Array.isArray(e.forecastReason) && e.forecastReason.every(
    (t) => r(t)
  )) && r(e.forecastStatus) && (typeof e.series > "u" || typeof e.series == "string") && (typeof e._series > "u" || i(e._series)) && (typeof e.seriesDosesPositiveInt > "u" || typeof e.seriesDosesPositiveInt == "number") && (typeof e.seriesDosesString > "u" || typeof e.seriesDosesString == "string") && (typeof e._seriesDosesString > "u" || i(e._seriesDosesString)) && (typeof e.supportingImmunization > "u" || Array.isArray(e.supportingImmunization) && e.supportingImmunization.every(
    (t) => o(t)
  )) && (typeof e.supportingPatientInformation > "u" || Array.isArray(e.supportingPatientInformation) && e.supportingPatientInformation.every(
    (t) => o(t)
  )) && (typeof e.targetDisease > "u" || r(e.targetDisease)) && (typeof e.vaccineCode > "u" || Array.isArray(e.vaccineCode) && e.vaccineCode.every(
    (t) => r(t)
  ));
}
function Je(n) {
  const e = n;
  return f(e) && e.resourceType === "ImmunizationRecommendation" && (typeof e.authority > "u" || o(e.authority)) && typeof e.date == "string" && (typeof e._date > "u" || i(e._date)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && o(e.patient) && Array.isArray(e.recommendation) && e.recommendation.every(
    (t) => Zd(t)
  );
}
function $d(n) {
  const e = n;
  return d(e) && (typeof e.packageId > "u" || typeof e.packageId == "string") && (typeof e._packageId > "u" || i(e._packageId)) && typeof e.uri == "string" && (typeof e._uri > "u" || i(e._uri)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function ea(n) {
  const e = n;
  return d(e) && typeof e.profile == "string" && (typeof e._profile > "u" || i(e._profile)) && typeof e.type == "string" && (typeof e._type > "u" || i(e._type));
}
function ta(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name));
}
function na(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.exampleBoolean > "u" || e.exampleBoolean === !1 || e.exampleBoolean === !0) && (typeof e._exampleBoolean > "u" || i(e._exampleBoolean)) && (typeof e.exampleCanonical > "u" || typeof e.exampleCanonical == "string") && (typeof e._exampleCanonical > "u" || i(e._exampleCanonical)) && (typeof e.fhirVersion > "u" || Array.isArray(e.fhirVersion) && e.fhirVersion.every(
    (t) => typeof t == "string"
  )) && (typeof e._fhirVersion > "u" || Array.isArray(e._fhirVersion) && e._fhirVersion.every(
    (t) => i(t)
  )) && (typeof e.groupingId > "u" || typeof e.groupingId == "string") && (typeof e._groupingId > "u" || i(e._groupingId)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && o(e.reference);
}
function $n(n) {
  const e = n;
  return d(e) && (e.generation === "generated" || e.generation === "html" || e.generation === "markdown" || e.generation === "xml") && (typeof e._generation > "u" || i(e._generation)) && (typeof e.nameUrl > "u" || typeof e.nameUrl == "string") && (typeof e._nameUrl > "u" || i(e._nameUrl)) && (typeof e.nameReference > "u" || o(e.nameReference)) && (typeof e.page > "u" || Array.isArray(e.page) && e.page.every(
    (t) => $n(t)
  )) && typeof e.title == "string" && (typeof e._title > "u" || i(e._title));
}
function ia(n) {
  const e = n;
  return d(e) && (e.code === "apply" || e.code === "path-resource" || e.code === "path-pages" || e.code === "path-tx-cache" || e.code === "expansion-parameter" || e.code === "rule-broken-links" || e.code === "generate-xml" || e.code === "generate-json" || e.code === "generate-turtle" || e.code === "html-template") && (typeof e._code > "u" || i(e._code)) && typeof e.value == "string" && (typeof e._value > "u" || i(e._value));
}
function ra(n) {
  const e = n;
  return d(e) && typeof e.code == "string" && (typeof e._code > "u" || i(e._code)) && (typeof e.scope > "u" || typeof e.scope == "string") && (typeof e._scope > "u" || i(e._scope)) && typeof e.source == "string" && (typeof e._source > "u" || i(e._source));
}
function oa(n) {
  const e = n;
  return d(e) && (typeof e.grouping > "u" || Array.isArray(e.grouping) && e.grouping.every(
    (t) => ta(t)
  )) && (typeof e.page > "u" || $n(e.page)) && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => ia(t)
  )) && Array.isArray(e.resource) && e.resource.every(
    (t) => na(t)
  ) && (typeof e.template > "u" || Array.isArray(e.template) && e.template.every(
    (t) => ra(t)
  ));
}
function da(n) {
  const e = n;
  return d(e) && (typeof e.exampleBoolean > "u" || e.exampleBoolean === !1 || e.exampleBoolean === !0) && (typeof e._exampleBoolean > "u" || i(e._exampleBoolean)) && (typeof e.exampleCanonical > "u" || typeof e.exampleCanonical == "string") && (typeof e._exampleCanonical > "u" || i(e._exampleCanonical)) && o(e.reference) && (typeof e.relativePath > "u" || typeof e.relativePath == "string") && (typeof e._relativePath > "u" || i(e._relativePath));
}
function aa(n) {
  const e = n;
  return d(e) && (typeof e.anchor > "u" || Array.isArray(e.anchor) && e.anchor.every(
    (t) => typeof t == "string"
  )) && (typeof e._anchor > "u" || Array.isArray(e._anchor) && e._anchor.every(
    (t) => i(t)
  )) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title));
}
function fa(n) {
  const e = n;
  return d(e) && (typeof e.image > "u" || Array.isArray(e.image) && e.image.every(
    (t) => typeof t == "string"
  )) && (typeof e._image > "u" || Array.isArray(e._image) && e._image.every(
    (t) => i(t)
  )) && (typeof e.other > "u" || Array.isArray(e.other) && e.other.every(
    (t) => typeof t == "string"
  )) && (typeof e._other > "u" || Array.isArray(e._other) && e._other.every(
    (t) => i(t)
  )) && (typeof e.page > "u" || Array.isArray(e.page) && e.page.every(
    (t) => aa(t)
  )) && (typeof e.rendering > "u" || typeof e.rendering == "string") && (typeof e._rendering > "u" || i(e._rendering)) && Array.isArray(e.resource) && e.resource.every(
    (t) => da(t)
  );
}
function Xe(n) {
  const e = n;
  return f(e) && e.resourceType === "ImplementationGuide" && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.definition > "u" || oa(e.definition)) && (typeof e.dependsOn > "u" || Array.isArray(e.dependsOn) && e.dependsOn.every(
    (t) => $d(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && Array.isArray(e.fhirVersion) && e.fhirVersion.every(
    (t) => typeof t == "string"
  ) && (typeof e._fhirVersion > "u" || Array.isArray(e._fhirVersion) && e._fhirVersion.every(
    (t) => i(t)
  )) && (typeof e.global > "u" || Array.isArray(e.global) && e.global.every(
    (t) => ea(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.license > "u" || typeof e.license == "string") && (typeof e._license > "u" || i(e._license)) && (typeof e.manifest > "u" || fa(e.manifest)) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && typeof e.packageId == "string" && (typeof e._packageId > "u" || i(e._packageId)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && typeof e.url == "string" && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function ya(n) {
  const e = n;
  return d(e) && (typeof e.address > "u" || h(e.address)) && (typeof e.name > "u" || S(e.name)) && (typeof e.purpose > "u" || r(e.purpose)) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => I(t)
  ));
}
function ua(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || r(e.code)) && (typeof e.value > "u" || u(e.value));
}
function pa(n) {
  const e = n;
  return d(e) && (typeof e.limit > "u" || Array.isArray(e.limit) && e.limit.every(
    (t) => ua(t)
  )) && (typeof e.requirement > "u" || typeof e.requirement == "string") && (typeof e._requirement > "u" || i(e._requirement)) && r(e.type);
}
function sa(n) {
  const e = n;
  return d(e) && Array.isArray(e.benefit) && e.benefit.every(
    (t) => pa(t)
  ) && (typeof e.network > "u" || Array.isArray(e.network) && e.network.every(
    (t) => o(t)
  )) && r(e.type);
}
function ca(n) {
  const e = n;
  return d(e) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment)) && (typeof e.cost > "u" || c(e.cost)) && (typeof e.groupSize > "u" || typeof e.groupSize == "number") && (typeof e.type > "u" || r(e.type));
}
function la(n) {
  const e = n;
  return d(e) && (typeof e.applicability > "u" || r(e.applicability)) && (typeof e.qualifiers > "u" || Array.isArray(e.qualifiers) && e.qualifiers.every(
    (t) => r(t)
  )) && r(e.type) && (typeof e.value > "u" || u(e.value));
}
function va(n) {
  const e = n;
  return d(e) && (typeof e.cost > "u" || Array.isArray(e.cost) && e.cost.every(
    (t) => la(t)
  )) && r(e.type);
}
function ma(n) {
  const e = n;
  return d(e) && (typeof e.benefit > "u" || Array.isArray(e.benefit) && e.benefit.every(
    (t) => va(t)
  )) && r(e.category);
}
function ga(n) {
  const e = n;
  return d(e) && (typeof e.coverageArea > "u" || Array.isArray(e.coverageArea) && e.coverageArea.every(
    (t) => o(t)
  )) && (typeof e.generalCost > "u" || Array.isArray(e.generalCost) && e.generalCost.every(
    (t) => ca(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.network > "u" || Array.isArray(e.network) && e.network.every(
    (t) => o(t)
  )) && (typeof e.specificCost > "u" || Array.isArray(e.specificCost) && e.specificCost.every(
    (t) => ma(t)
  )) && (typeof e.type > "u" || r(e.type));
}
function Ye(n) {
  const e = n;
  return f(e) && e.resourceType === "InsurancePlan" && (typeof e.administeredBy > "u" || o(e.administeredBy)) && (typeof e.alias > "u" || Array.isArray(e.alias) && e.alias.every(
    (t) => typeof t == "string"
  )) && (typeof e._alias > "u" || Array.isArray(e._alias) && e._alias.every(
    (t) => i(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => ya(t)
  )) && (typeof e.coverage > "u" || Array.isArray(e.coverage) && e.coverage.every(
    (t) => sa(t)
  )) && (typeof e.coverageArea > "u" || Array.isArray(e.coverageArea) && e.coverageArea.every(
    (t) => o(t)
  )) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => o(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.network > "u" || Array.isArray(e.network) && e.network.every(
    (t) => o(t)
  )) && (typeof e.ownedBy > "u" || o(e.ownedBy)) && (typeof e.period > "u" || y(e.period)) && (typeof e.plan > "u" || Array.isArray(e.plan) && e.plan.every(
    (t) => ga(t)
  )) && (typeof e.status > "u" || e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => r(t)
  ));
}
function _a(n) {
  const e = n;
  return d(e) && o(e.actor) && (typeof e.role > "u" || r(e.role));
}
function ei(n) {
  const e = n;
  return d(e) && (typeof e.amount > "u" || c(e.amount)) && (typeof e.code > "u" || r(e.code)) && (typeof e.factor > "u" || typeof e.factor == "number") && (e.type === "base" || e.type === "surcharge" || e.type === "deduction" || e.type === "discount" || e.type === "tax" || e.type === "informational") && (typeof e._type > "u" || i(e._type));
}
function Aa(n) {
  const e = n;
  return d(e) && (typeof e.chargeItemReference > "u" || o(e.chargeItemReference)) && (typeof e.chargeItemCodeableConcept > "u" || r(e.chargeItemCodeableConcept)) && (typeof e.priceComponent > "u" || Array.isArray(e.priceComponent) && e.priceComponent.every(
    (t) => ei(t)
  )) && (typeof e.sequence > "u" || typeof e.sequence == "number");
}
function Ze(n) {
  const e = n;
  return f(e) && e.resourceType === "Invoice" && (typeof e.account > "u" || o(e.account)) && (typeof e.cancelledReason > "u" || typeof e.cancelledReason == "string") && (typeof e._cancelledReason > "u" || i(e._cancelledReason)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.issuer > "u" || o(e.issuer)) && (typeof e.lineItem > "u" || Array.isArray(e.lineItem) && e.lineItem.every(
    (t) => Aa(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.participant > "u" || Array.isArray(e.participant) && e.participant.every(
    (t) => _a(t)
  )) && (typeof e.paymentTerms > "u" || typeof e.paymentTerms == "string") && (typeof e._paymentTerms > "u" || i(e._paymentTerms)) && (typeof e.recipient > "u" || o(e.recipient)) && (e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled" || e.status === "issued" || e.status === "balanced") && (typeof e._status > "u" || i(e._status)) && (typeof e.subject > "u" || o(e.subject)) && (typeof e.totalGross > "u" || c(e.totalGross)) && (typeof e.totalNet > "u" || c(e.totalNet)) && (typeof e.totalPriceComponent > "u" || Array.isArray(e.totalPriceComponent) && e.totalPriceComponent.every(
    (t) => ei(t)
  )) && (typeof e.type > "u" || r(e.type));
}
function $e(n) {
  const e = n;
  return f(e) && e.resourceType === "Library" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || i(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => p(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.content > "u" || Array.isArray(e.content) && e.content.every(
    (t) => g(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.dataRequirement > "u" || Array.isArray(e.dataRequirement) && e.dataRequirement.every(
    (t) => D(t)
  )) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => p(t)
  )) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => p(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || i(e._lastReviewDate)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => P(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => w(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => p(t)
  )) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.subjectCodeableConcept > "u" || r(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || o(e.subjectReference)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || i(e._subtitle)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => r(t)
  )) && r(e.type) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.usage > "u" || typeof e.usage == "string") && (typeof e._usage > "u" || i(e._usage)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function ba(n) {
  const e = n;
  return d(e) && o(e.resource) && (e.type === "source" || e.type === "alternate" || e.type === "historical") && (typeof e._type > "u" || i(e._type));
}
function et(n) {
  const e = n;
  return f(e) && e.resourceType === "Linkage" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || i(e._active)) && (typeof e.author > "u" || o(e.author)) && Array.isArray(e.item) && e.item.every(
    (t) => ba(t)
  );
}
function Ia(n) {
  const e = n;
  return d(e) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.deleted > "u" || e.deleted === !1 || e.deleted === !0) && (typeof e._deleted > "u" || i(e._deleted)) && (typeof e.flag > "u" || r(e.flag)) && o(e.item);
}
function tt(n) {
  const e = n;
  return f(e) && e.resourceType === "List" && (typeof e.code > "u" || r(e.code)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.emptyReason > "u" || r(e.emptyReason)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.entry > "u" || Array.isArray(e.entry) && e.entry.every(
    (t) => Ia(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (e.mode === "working" || e.mode === "snapshot" || e.mode === "changes") && (typeof e._mode > "u" || i(e._mode)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.orderedBy > "u" || r(e.orderedBy)) && (typeof e.source > "u" || o(e.source)) && (e.status === "entered-in-error" || e.status === "retired" || e.status === "current") && (typeof e._status > "u" || i(e._status)) && (typeof e.subject > "u" || o(e.subject)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title));
}
function ha(n) {
  const e = n;
  return d(e) && (typeof e.altitude > "u" || typeof e.altitude == "number") && typeof e.latitude == "number" && typeof e.longitude == "number";
}
function wa(n) {
  const e = n;
  return d(e) && (typeof e.allDay > "u" || e.allDay === !1 || e.allDay === !0) && (typeof e._allDay > "u" || i(e._allDay)) && (typeof e.closingTime > "u" || typeof e.closingTime == "string") && (typeof e._closingTime > "u" || i(e._closingTime)) && (typeof e.daysOfWeek > "u" || Array.isArray(e.daysOfWeek) && e.daysOfWeek.every(
    (t) => t === "mon" || t === "tue" || t === "wed" || t === "thu" || t === "fri" || t === "sat" || t === "sun"
  )) && (typeof e._daysOfWeek > "u" || Array.isArray(e._daysOfWeek) && e._daysOfWeek.every(
    (t) => i(t)
  )) && (typeof e.openingTime > "u" || typeof e.openingTime == "string") && (typeof e._openingTime > "u" || i(e._openingTime));
}
function nt(n) {
  const e = n;
  return f(e) && e.resourceType === "Location" && (typeof e.address > "u" || h(e.address)) && (typeof e.alias > "u" || Array.isArray(e.alias) && e.alias.every(
    (t) => typeof t == "string"
  )) && (typeof e._alias > "u" || Array.isArray(e._alias) && e._alias.every(
    (t) => i(t)
  )) && (typeof e.availabilityExceptions > "u" || typeof e.availabilityExceptions == "string") && (typeof e._availabilityExceptions > "u" || i(e._availabilityExceptions)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => o(t)
  )) && (typeof e.hoursOfOperation > "u" || Array.isArray(e.hoursOfOperation) && e.hoursOfOperation.every(
    (t) => wa(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.managingOrganization > "u" || o(e.managingOrganization)) && (typeof e.mode > "u" || e.mode === "instance" || e.mode === "kind") && (typeof e._mode > "u" || i(e._mode)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.operationalStatus > "u" || s(e.operationalStatus)) && (typeof e.partOf > "u" || o(e.partOf)) && (typeof e.physicalType > "u" || r(e.physicalType)) && (typeof e.position > "u" || ha(e.position)) && (typeof e.status > "u" || e.status === "active" || e.status === "inactive" || e.status === "suspended") && (typeof e._status > "u" || i(e._status)) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => I(t)
  )) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => r(t)
  ));
}
function Ra(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || r(e.code)) && R(e.criteria) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description));
}
function Ca(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || r(e.code)) && R(e.criteria) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description));
}
function Da(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || r(e.code)) && (typeof e.component > "u" || Array.isArray(e.component) && e.component.every(
    (t) => Ca(t)
  )) && (typeof e.criteria > "u" || R(e.criteria)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description));
}
function Sa(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || r(e.code)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.population > "u" || Array.isArray(e.population) && e.population.every(
    (t) => Ra(t)
  )) && (typeof e.stratifier > "u" || Array.isArray(e.stratifier) && e.stratifier.every(
    (t) => Da(t)
  ));
}
function Oa(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || r(e.code)) && R(e.criteria) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.usage > "u" || Array.isArray(e.usage) && e.usage.every(
    (t) => r(t)
  ));
}
function it(n) {
  const e = n;
  return f(e) && e.resourceType === "Measure" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || i(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => p(t)
  )) && (typeof e.clinicalRecommendationStatement > "u" || typeof e.clinicalRecommendationStatement == "string") && (typeof e._clinicalRecommendationStatement > "u" || i(e._clinicalRecommendationStatement)) && (typeof e.compositeScoring > "u" || r(e.compositeScoring)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.definition > "u" || Array.isArray(e.definition) && e.definition.every(
    (t) => typeof t == "string"
  )) && (typeof e._definition > "u" || Array.isArray(e._definition) && e._definition.every(
    (t) => i(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.disclaimer > "u" || typeof e.disclaimer == "string") && (typeof e._disclaimer > "u" || i(e._disclaimer)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => p(t)
  )) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => p(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.group > "u" || Array.isArray(e.group) && e.group.every(
    (t) => Sa(t)
  )) && (typeof e.guidance > "u" || typeof e.guidance == "string") && (typeof e._guidance > "u" || i(e._guidance)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.improvementNotation > "u" || r(e.improvementNotation)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || i(e._lastReviewDate)) && (typeof e.library > "u" || Array.isArray(e.library) && e.library.every(
    (t) => typeof t == "string"
  )) && (typeof e._library > "u" || Array.isArray(e._library) && e._library.every(
    (t) => i(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (typeof e.rateAggregation > "u" || typeof e.rateAggregation == "string") && (typeof e._rateAggregation > "u" || i(e._rateAggregation)) && (typeof e.rationale > "u" || typeof e.rationale == "string") && (typeof e._rationale > "u" || i(e._rationale)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => w(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => p(t)
  )) && (typeof e.riskAdjustment > "u" || typeof e.riskAdjustment == "string") && (typeof e._riskAdjustment > "u" || i(e._riskAdjustment)) && (typeof e.scoring > "u" || r(e.scoring)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.subjectCodeableConcept > "u" || r(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || o(e.subjectReference)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || i(e._subtitle)) && (typeof e.supplementalData > "u" || Array.isArray(e.supplementalData) && e.supplementalData.every(
    (t) => Oa(t)
  )) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => r(t)
  )) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => r(t)
  )) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.usage > "u" || typeof e.usage == "string") && (typeof e._usage > "u" || i(e._usage)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function Ea(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || r(e.code)) && (typeof e.count > "u" || typeof e.count == "number") && (typeof e.subjectResults > "u" || o(e.subjectResults));
}
function Ta(n) {
  const e = n;
  return d(e) && r(e.code) && r(e.value);
}
function xa(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || r(e.code)) && (typeof e.count > "u" || typeof e.count == "number") && (typeof e.subjectResults > "u" || o(e.subjectResults));
}
function ja(n) {
  const e = n;
  return d(e) && (typeof e.component > "u" || Array.isArray(e.component) && e.component.every(
    (t) => Ta(t)
  )) && (typeof e.measureScore > "u" || u(e.measureScore)) && (typeof e.population > "u" || Array.isArray(e.population) && e.population.every(
    (t) => xa(t)
  )) && (typeof e.value > "u" || r(e.value));
}
function Pa(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => r(t)
  )) && (typeof e.stratum > "u" || Array.isArray(e.stratum) && e.stratum.every(
    (t) => ja(t)
  ));
}
function Fa(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || r(e.code)) && (typeof e.measureScore > "u" || u(e.measureScore)) && (typeof e.population > "u" || Array.isArray(e.population) && e.population.every(
    (t) => Ea(t)
  )) && (typeof e.stratifier > "u" || Array.isArray(e.stratifier) && e.stratifier.every(
    (t) => Pa(t)
  ));
}
function rt(n) {
  const e = n;
  return f(e) && e.resourceType === "MeasureReport" && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.evaluatedResource > "u" || Array.isArray(e.evaluatedResource) && e.evaluatedResource.every(
    (t) => o(t)
  )) && (typeof e.group > "u" || Array.isArray(e.group) && e.group.every(
    (t) => Fa(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.improvementNotation > "u" || r(e.improvementNotation)) && typeof e.measure == "string" && (typeof e._measure > "u" || i(e._measure)) && y(e.period) && (typeof e.reporter > "u" || o(e.reporter)) && (e.status === "error" || e.status === "pending" || e.status === "complete") && (typeof e._status > "u" || i(e._status)) && (typeof e.subject > "u" || o(e.subject)) && (e.type === "individual" || e.type === "subject-list" || e.type === "summary" || e.type === "data-collection") && (typeof e._type > "u" || i(e._type));
}
function ot(n) {
  const e = n;
  return f(e) && e.resourceType === "Media" && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.bodySite > "u" || r(e.bodySite)) && g(e.content) && (typeof e.createdDateTime > "u" || typeof e.createdDateTime == "string") && (typeof e._createdDateTime > "u" || i(e._createdDateTime)) && (typeof e.createdPeriod > "u" || y(e.createdPeriod)) && (typeof e.device > "u" || o(e.device)) && (typeof e.deviceName > "u" || typeof e.deviceName == "string") && (typeof e._deviceName > "u" || i(e._deviceName)) && (typeof e.duration > "u" || typeof e.duration == "number") && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.frames > "u" || typeof e.frames == "number") && (typeof e.height > "u" || typeof e.height == "number") && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.issued > "u" || typeof e.issued == "string") && (typeof e._issued > "u" || i(e._issued)) && (typeof e.modality > "u" || r(e.modality)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.operator > "u" || o(e.operator)) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => o(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "in-progress" || e.status === "completed" || e.status === "stopped" || e.status === "preparation" || e.status === "not-done") && (typeof e._status > "u" || i(e._status)) && (typeof e.subject > "u" || o(e.subject)) && (typeof e.type > "u" || r(e.type)) && (typeof e.view > "u" || r(e.view)) && (typeof e.width > "u" || typeof e.width == "number");
}
function Ha(n) {
  const e = n;
  return d(e) && (typeof e.isActive > "u" || e.isActive === !1 || e.isActive === !0) && (typeof e._isActive > "u" || i(e._isActive)) && (typeof e.itemCodeableConcept > "u" || r(e.itemCodeableConcept)) && (typeof e.itemReference > "u" || o(e.itemReference)) && (typeof e.strength > "u" || b(e.strength));
}
function Ma(n) {
  const e = n;
  return d(e) && (typeof e.expirationDate > "u" || typeof e.expirationDate == "string") && (typeof e._expirationDate > "u" || i(e._expirationDate)) && (typeof e.lotNumber > "u" || typeof e.lotNumber == "string") && (typeof e._lotNumber > "u" || i(e._lotNumber));
}
function dt(n) {
  const e = n;
  return f(e) && e.resourceType === "Medication" && (typeof e.amount > "u" || b(e.amount)) && (typeof e.batch > "u" || Ma(e.batch)) && (typeof e.code > "u" || r(e.code)) && (typeof e.form > "u" || r(e.form)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.ingredient > "u" || Array.isArray(e.ingredient) && e.ingredient.every(
    (t) => Ha(t)
  )) && (typeof e.manufacturer > "u" || o(e.manufacturer)) && (typeof e.status > "u" || e.status === "active" || e.status === "inactive" || e.status === "entered-in-error") && (typeof e._status > "u" || i(e._status));
}
function qa(n) {
  const e = n;
  return d(e) && o(e.actor) && (typeof e.function > "u" || r(e.function));
}
function ka(n) {
  const e = n;
  return d(e) && (typeof e.dose > "u" || u(e.dose)) && (typeof e.method > "u" || r(e.method)) && (typeof e.rateRatio > "u" || b(e.rateRatio)) && (typeof e.rateQuantity > "u" || u(e.rateQuantity)) && (typeof e.route > "u" || r(e.route)) && (typeof e.site > "u" || r(e.site)) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || i(e._text));
}
function at(n) {
  const e = n;
  return f(e) && e.resourceType === "MedicationAdministration" && (typeof e.category > "u" || r(e.category)) && (typeof e.context > "u" || o(e.context)) && (typeof e.device > "u" || Array.isArray(e.device) && e.device.every(
    (t) => o(t)
  )) && (typeof e.dosage > "u" || ka(e.dosage)) && (typeof e.effectiveDateTime > "u" || typeof e.effectiveDateTime == "string") && (typeof e._effectiveDateTime > "u" || i(e._effectiveDateTime)) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.eventHistory > "u" || Array.isArray(e.eventHistory) && e.eventHistory.every(
    (t) => o(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.instantiates > "u" || Array.isArray(e.instantiates) && e.instantiates.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiates > "u" || Array.isArray(e._instantiates) && e._instantiates.every(
    (t) => i(t)
  )) && (typeof e.medicationCodeableConcept > "u" || r(e.medicationCodeableConcept)) && (typeof e.medicationReference > "u" || o(e.medicationReference)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => o(t)
  )) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => qa(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.request > "u" || o(e.request)) && (e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "in-progress" || e.status === "completed" || e.status === "stopped" || e.status === "not-done") && (typeof e._status > "u" || i(e._status)) && (typeof e.statusReason > "u" || Array.isArray(e.statusReason) && e.statusReason.every(
    (t) => r(t)
  )) && o(e.subject) && (typeof e.supportingInformation > "u" || Array.isArray(e.supportingInformation) && e.supportingInformation.every(
    (t) => o(t)
  ));
}
function Ba(n) {
  const e = n;
  return d(e) && o(e.actor) && (typeof e.function > "u" || r(e.function));
}
function Va(n) {
  const e = n;
  return d(e) && (typeof e.reason > "u" || Array.isArray(e.reason) && e.reason.every(
    (t) => r(t)
  )) && (typeof e.responsibleParty > "u" || Array.isArray(e.responsibleParty) && e.responsibleParty.every(
    (t) => o(t)
  )) && (typeof e.type > "u" || r(e.type)) && typeof e.wasSubstituted == "boolean" && (typeof e._wasSubstituted > "u" || i(e._wasSubstituted));
}
function ft(n) {
  const e = n;
  return f(e) && e.resourceType === "MedicationDispense" && (typeof e.authorizingPrescription > "u" || Array.isArray(e.authorizingPrescription) && e.authorizingPrescription.every(
    (t) => o(t)
  )) && (typeof e.category > "u" || r(e.category)) && (typeof e.context > "u" || o(e.context)) && (typeof e.daysSupply > "u" || u(e.daysSupply)) && (typeof e.destination > "u" || o(e.destination)) && (typeof e.detectedIssue > "u" || Array.isArray(e.detectedIssue) && e.detectedIssue.every(
    (t) => o(t)
  )) && (typeof e.dosageInstruction > "u" || Array.isArray(e.dosageInstruction) && e.dosageInstruction.every(
    (t) => E(t)
  )) && (typeof e.eventHistory > "u" || Array.isArray(e.eventHistory) && e.eventHistory.every(
    (t) => o(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.location > "u" || o(e.location)) && (typeof e.medicationCodeableConcept > "u" || r(e.medicationCodeableConcept)) && (typeof e.medicationReference > "u" || o(e.medicationReference)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => o(t)
  )) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => Ba(t)
  )) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.receiver > "u" || Array.isArray(e.receiver) && e.receiver.every(
    (t) => o(t)
  )) && (e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "declined" || e.status === "cancelled" || e.status === "in-progress" || e.status === "completed" || e.status === "stopped" || e.status === "preparation") && (typeof e._status > "u" || i(e._status)) && (typeof e.statusReasonCodeableConcept > "u" || r(e.statusReasonCodeableConcept)) && (typeof e.statusReasonReference > "u" || o(e.statusReasonReference)) && (typeof e.subject > "u" || o(e.subject)) && (typeof e.substitution > "u" || Va(e.substitution)) && (typeof e.supportingInformation > "u" || Array.isArray(e.supportingInformation) && e.supportingInformation.every(
    (t) => o(t)
  )) && (typeof e.type > "u" || r(e.type)) && (typeof e.whenHandedOver > "u" || typeof e.whenHandedOver == "string") && (typeof e._whenHandedOver > "u" || i(e._whenHandedOver)) && (typeof e.whenPrepared > "u" || typeof e.whenPrepared == "string") && (typeof e._whenPrepared > "u" || i(e._whenPrepared));
}
function Ua(n) {
  const e = n;
  return d(e) && Array.isArray(e.reference) && e.reference.every(
    (t) => o(t)
  ) && r(e.type);
}
function Na(n) {
  const e = n;
  return d(e) && (typeof e.source > "u" || o(e.source)) && (typeof e.type > "u" || r(e.type));
}
function La(n) {
  const e = n;
  return d(e) && (typeof e.isActive > "u" || e.isActive === !1 || e.isActive === !0) && (typeof e._isActive > "u" || i(e._isActive)) && (typeof e.itemCodeableConcept > "u" || r(e.itemCodeableConcept)) && (typeof e.itemReference > "u" || o(e.itemReference)) && (typeof e.strength > "u" || b(e.strength));
}
function Ga(n) {
  const e = n;
  return d(e) && c(e.cost) && (typeof e.source > "u" || typeof e.source == "string") && (typeof e._source > "u" || i(e._source)) && r(e.type);
}
function za(n) {
  const e = n;
  return d(e) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.type > "u" || r(e.type));
}
function Qa(n) {
  const e = n;
  return d(e) && Array.isArray(e.dosage) && e.dosage.every(
    (t) => E(t)
  ) && r(e.type);
}
function Wa(n) {
  const e = n;
  return d(e) && (typeof e.characteristicCodeableConcept > "u" || r(e.characteristicCodeableConcept)) && (typeof e.characteristicQuantity > "u" || u(e.characteristicQuantity)) && (typeof e.value > "u" || Array.isArray(e.value) && e.value.every(
    (t) => typeof t == "string"
  )) && (typeof e._value > "u" || Array.isArray(e._value) && e._value.every(
    (t) => i(t)
  ));
}
function Ka(n) {
  const e = n;
  return d(e) && (typeof e.dosage > "u" || Array.isArray(e.dosage) && e.dosage.every(
    (t) => Qa(t)
  )) && (typeof e.indicationCodeableConcept > "u" || r(e.indicationCodeableConcept)) && (typeof e.indicationReference > "u" || o(e.indicationReference)) && (typeof e.patientCharacteristics > "u" || Array.isArray(e.patientCharacteristics) && e.patientCharacteristics.every(
    (t) => Wa(t)
  ));
}
function Ja(n) {
  const e = n;
  return d(e) && (typeof e.classification > "u" || Array.isArray(e.classification) && e.classification.every(
    (t) => r(t)
  )) && r(e.type);
}
function Xa(n) {
  const e = n;
  return d(e) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.type > "u" || r(e.type));
}
function Ya(n) {
  const e = n;
  return d(e) && (typeof e.type > "u" || r(e.type)) && (typeof e.valueCodeableConcept > "u" || r(e.valueCodeableConcept)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueBase64Binary > "u" || typeof e.valueBase64Binary == "string") && (typeof e._valueBase64Binary > "u" || i(e._valueBase64Binary));
}
function Za(n) {
  const e = n;
  return d(e) && typeof e.allowed == "boolean" && (typeof e._allowed > "u" || i(e._allowed)) && r(e.type);
}
function $a(n) {
  const e = n;
  return d(e) && r(e.schedule);
}
function ef(n) {
  const e = n;
  return d(e) && (typeof e.period > "u" || _(e.period)) && u(e.quantity);
}
function tf(n) {
  const e = n;
  return d(e) && (typeof e.maxDispense > "u" || ef(e.maxDispense)) && o(e.regulatoryAuthority) && (typeof e.schedule > "u" || Array.isArray(e.schedule) && e.schedule.every(
    (t) => $a(t)
  )) && (typeof e.substitution > "u" || Array.isArray(e.substitution) && e.substitution.every(
    (t) => Za(t)
  ));
}
function nf(n) {
  const e = n;
  return d(e) && (typeof e.areaUnderCurve > "u" || Array.isArray(e.areaUnderCurve) && e.areaUnderCurve.every(
    (t) => u(t)
  )) && (typeof e.halfLifePeriod > "u" || _(e.halfLifePeriod)) && (typeof e.lethalDose50 > "u" || Array.isArray(e.lethalDose50) && e.lethalDose50.every(
    (t) => u(t)
  ));
}
function yt(n) {
  const e = n;
  return f(e) && e.resourceType === "MedicationKnowledge" && (typeof e.administrationGuidelines > "u" || Array.isArray(e.administrationGuidelines) && e.administrationGuidelines.every(
    (t) => Ka(t)
  )) && (typeof e.amount > "u" || u(e.amount)) && (typeof e.associatedMedication > "u" || Array.isArray(e.associatedMedication) && e.associatedMedication.every(
    (t) => o(t)
  )) && (typeof e.code > "u" || r(e.code)) && (typeof e.contraindication > "u" || Array.isArray(e.contraindication) && e.contraindication.every(
    (t) => o(t)
  )) && (typeof e.cost > "u" || Array.isArray(e.cost) && e.cost.every(
    (t) => Ga(t)
  )) && (typeof e.doseForm > "u" || r(e.doseForm)) && (typeof e.drugCharacteristic > "u" || Array.isArray(e.drugCharacteristic) && e.drugCharacteristic.every(
    (t) => Ya(t)
  )) && (typeof e.ingredient > "u" || Array.isArray(e.ingredient) && e.ingredient.every(
    (t) => La(t)
  )) && (typeof e.intendedRoute > "u" || Array.isArray(e.intendedRoute) && e.intendedRoute.every(
    (t) => r(t)
  )) && (typeof e.kinetics > "u" || Array.isArray(e.kinetics) && e.kinetics.every(
    (t) => nf(t)
  )) && (typeof e.manufacturer > "u" || o(e.manufacturer)) && (typeof e.medicineClassification > "u" || Array.isArray(e.medicineClassification) && e.medicineClassification.every(
    (t) => Ja(t)
  )) && (typeof e.monitoringProgram > "u" || Array.isArray(e.monitoringProgram) && e.monitoringProgram.every(
    (t) => za(t)
  )) && (typeof e.monograph > "u" || Array.isArray(e.monograph) && e.monograph.every(
    (t) => Na(t)
  )) && (typeof e.packaging > "u" || Xa(e.packaging)) && (typeof e.preparationInstruction > "u" || typeof e.preparationInstruction == "string") && (typeof e._preparationInstruction > "u" || i(e._preparationInstruction)) && (typeof e.productType > "u" || Array.isArray(e.productType) && e.productType.every(
    (t) => r(t)
  )) && (typeof e.regulatory > "u" || Array.isArray(e.regulatory) && e.regulatory.every(
    (t) => tf(t)
  )) && (typeof e.relatedMedicationKnowledge > "u" || Array.isArray(e.relatedMedicationKnowledge) && e.relatedMedicationKnowledge.every(
    (t) => Ua(t)
  )) && (typeof e.status > "u" || e.status === "active" || e.status === "inactive" || e.status === "entered-in-error") && (typeof e._status > "u" || i(e._status)) && (typeof e.synonym > "u" || Array.isArray(e.synonym) && e.synonym.every(
    (t) => typeof t == "string"
  )) && (typeof e._synonym > "u" || Array.isArray(e._synonym) && e._synonym.every(
    (t) => i(t)
  ));
}
function rf(n) {
  const e = n;
  return d(e) && (typeof e.duration > "u" || _(e.duration)) && (typeof e.quantity > "u" || u(e.quantity));
}
function of(n) {
  const e = n;
  return d(e) && (typeof e.dispenseInterval > "u" || _(e.dispenseInterval)) && (typeof e.expectedSupplyDuration > "u" || _(e.expectedSupplyDuration)) && (typeof e.initialFill > "u" || rf(e.initialFill)) && (typeof e.numberOfRepeatsAllowed > "u" || typeof e.numberOfRepeatsAllowed == "number") && (typeof e.performer > "u" || o(e.performer)) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.validityPeriod > "u" || y(e.validityPeriod));
}
function df(n) {
  const e = n;
  return d(e) && (typeof e.allowedBoolean > "u" || e.allowedBoolean === !1 || e.allowedBoolean === !0) && (typeof e._allowedBoolean > "u" || i(e._allowedBoolean)) && (typeof e.allowedCodeableConcept > "u" || r(e.allowedCodeableConcept)) && (typeof e.reason > "u" || r(e.reason));
}
function ut(n) {
  const e = n;
  return f(e) && e.resourceType === "MedicationRequest" && (typeof e.authoredOn > "u" || typeof e.authoredOn == "string") && (typeof e._authoredOn > "u" || i(e._authoredOn)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && (typeof e.courseOfTherapyType > "u" || r(e.courseOfTherapyType)) && (typeof e.detectedIssue > "u" || Array.isArray(e.detectedIssue) && e.detectedIssue.every(
    (t) => o(t)
  )) && (typeof e.dispenseRequest > "u" || of(e.dispenseRequest)) && (typeof e.doNotPerform > "u" || e.doNotPerform === !1 || e.doNotPerform === !0) && (typeof e._doNotPerform > "u" || i(e._doNotPerform)) && (typeof e.dosageInstruction > "u" || Array.isArray(e.dosageInstruction) && e.dosageInstruction.every(
    (t) => E(t)
  )) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.eventHistory > "u" || Array.isArray(e.eventHistory) && e.eventHistory.every(
    (t) => o(t)
  )) && (typeof e.groupIdentifier > "u" || a(e.groupIdentifier)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => i(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => i(t)
  )) && (typeof e.insurance > "u" || Array.isArray(e.insurance) && e.insurance.every(
    (t) => o(t)
  )) && (e.intent === "proposal" || e.intent === "plan" || e.intent === "order" || e.intent === "original-order" || e.intent === "reflex-order" || e.intent === "filler-order" || e.intent === "instance-order" || e.intent === "option") && (typeof e._intent > "u" || i(e._intent)) && (typeof e.medicationCodeableConcept > "u" || r(e.medicationCodeableConcept)) && (typeof e.medicationReference > "u" || o(e.medicationReference)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.performer > "u" || o(e.performer)) && (typeof e.performerType > "u" || r(e.performerType)) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || i(e._priority)) && (typeof e.priorPrescription > "u" || o(e.priorPrescription)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.recorder > "u" || o(e.recorder)) && (typeof e.reportedBoolean > "u" || e.reportedBoolean === !1 || e.reportedBoolean === !0) && (typeof e._reportedBoolean > "u" || i(e._reportedBoolean)) && (typeof e.reportedReference > "u" || o(e.reportedReference)) && (typeof e.requester > "u" || o(e.requester)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "draft" || e.status === "cancelled" || e.status === "completed" || e.status === "stopped") && (typeof e._status > "u" || i(e._status)) && (typeof e.statusReason > "u" || r(e.statusReason)) && o(e.subject) && (typeof e.substitution > "u" || df(e.substitution)) && (typeof e.supportingInformation > "u" || Array.isArray(e.supportingInformation) && e.supportingInformation.every(
    (t) => o(t)
  ));
}
function pt(n) {
  const e = n;
  return f(e) && e.resourceType === "MedicationStatement" && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.category > "u" || r(e.category)) && (typeof e.context > "u" || o(e.context)) && (typeof e.dateAsserted > "u" || typeof e.dateAsserted == "string") && (typeof e._dateAsserted > "u" || i(e._dateAsserted)) && (typeof e.derivedFrom > "u" || Array.isArray(e.derivedFrom) && e.derivedFrom.every(
    (t) => o(t)
  )) && (typeof e.dosage > "u" || Array.isArray(e.dosage) && e.dosage.every(
    (t) => E(t)
  )) && (typeof e.effectiveDateTime > "u" || typeof e.effectiveDateTime == "string") && (typeof e._effectiveDateTime > "u" || i(e._effectiveDateTime)) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.informationSource > "u" || o(e.informationSource)) && (typeof e.medicationCodeableConcept > "u" || r(e.medicationCodeableConcept)) && (typeof e.medicationReference > "u" || o(e.medicationReference)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => o(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "completed" || e.status === "stopped" || e.status === "intended" || e.status === "not-taken") && (typeof e._status > "u" || i(e._status)) && (typeof e.statusReason > "u" || Array.isArray(e.statusReason) && e.statusReason.every(
    (t) => r(t)
  )) && o(e.subject);
}
function af(n) {
  const e = n;
  return d(e) && typeof e.part == "string" && (typeof e._part > "u" || i(e._part)) && s(e.type);
}
function ff(n) {
  const e = n;
  return d(e) && r(e.country) && (typeof e.jurisdiction > "u" || r(e.jurisdiction)) && r(e.language);
}
function yf(n) {
  const e = n;
  return d(e) && (typeof e.countryLanguage > "u" || Array.isArray(e.countryLanguage) && e.countryLanguage.every(
    (t) => ff(t)
  )) && (typeof e.namePart > "u" || Array.isArray(e.namePart) && e.namePart.every(
    (t) => af(t)
  )) && typeof e.productName == "string" && (typeof e._productName > "u" || i(e._productName));
}
function uf(n) {
  const e = n;
  return d(e) && (typeof e.authorisationReferenceNumber > "u" || a(e.authorisationReferenceNumber)) && (typeof e.confidentialityIndicator > "u" || r(e.confidentialityIndicator)) && (typeof e.effectiveDate > "u" || typeof e.effectiveDate == "string") && (typeof e._effectiveDate > "u" || i(e._effectiveDate)) && (typeof e.manufacturer > "u" || Array.isArray(e.manufacturer) && e.manufacturer.every(
    (t) => o(t)
  )) && (typeof e.operationType > "u" || r(e.operationType)) && (typeof e.regulator > "u" || o(e.regulator));
}
function pf(n) {
  const e = n;
  return d(e) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.indicationCodeableConcept > "u" || r(e.indicationCodeableConcept)) && (typeof e.indicationReference > "u" || o(e.indicationReference)) && (typeof e.intendedUse > "u" || r(e.intendedUse)) && (typeof e.species > "u" || r(e.species)) && (typeof e.status > "u" || r(e.status)) && (typeof e.type > "u" || r(e.type));
}
function st(n) {
  const e = n;
  return f(e) && e.resourceType === "MedicinalProduct" && (typeof e.additionalMonitoringIndicator > "u" || r(e.additionalMonitoringIndicator)) && (typeof e.attachedDocument > "u" || Array.isArray(e.attachedDocument) && e.attachedDocument.every(
    (t) => o(t)
  )) && (typeof e.clinicalTrial > "u" || Array.isArray(e.clinicalTrial) && e.clinicalTrial.every(
    (t) => o(t)
  )) && (typeof e.combinedPharmaceuticalDoseForm > "u" || r(e.combinedPharmaceuticalDoseForm)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => o(t)
  )) && (typeof e.crossReference > "u" || Array.isArray(e.crossReference) && e.crossReference.every(
    (t) => a(t)
  )) && (typeof e.domain > "u" || s(e.domain)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.legalStatusOfSupply > "u" || r(e.legalStatusOfSupply)) && (typeof e.manufacturingBusinessOperation > "u" || Array.isArray(e.manufacturingBusinessOperation) && e.manufacturingBusinessOperation.every(
    (t) => uf(t)
  )) && (typeof e.marketingStatus > "u" || Array.isArray(e.marketingStatus) && e.marketingStatus.every(
    (t) => kn(t)
  )) && (typeof e.masterFile > "u" || Array.isArray(e.masterFile) && e.masterFile.every(
    (t) => o(t)
  )) && Array.isArray(e.name) && e.name.every(
    (t) => yf(t)
  ) && (typeof e.packagedMedicinalProduct > "u" || Array.isArray(e.packagedMedicinalProduct) && e.packagedMedicinalProduct.every(
    (t) => o(t)
  )) && (typeof e.paediatricUseIndicator > "u" || r(e.paediatricUseIndicator)) && (typeof e.pharmaceuticalProduct > "u" || Array.isArray(e.pharmaceuticalProduct) && e.pharmaceuticalProduct.every(
    (t) => o(t)
  )) && (typeof e.productClassification > "u" || Array.isArray(e.productClassification) && e.productClassification.every(
    (t) => r(t)
  )) && (typeof e.specialDesignation > "u" || Array.isArray(e.specialDesignation) && e.specialDesignation.every(
    (t) => pf(t)
  )) && (typeof e.specialMeasures > "u" || Array.isArray(e.specialMeasures) && e.specialMeasures.every(
    (t) => typeof t == "string"
  )) && (typeof e._specialMeasures > "u" || Array.isArray(e._specialMeasures) && e._specialMeasures.every(
    (t) => i(t)
  )) && (typeof e.type > "u" || r(e.type));
}
function sf(n) {
  const e = n;
  return d(e) && (typeof e.country > "u" || r(e.country)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.legalStatusOfSupply > "u" || r(e.legalStatusOfSupply)) && (typeof e.validityPeriod > "u" || y(e.validityPeriod));
}
function ti(n) {
  const e = n;
  return d(e) && (typeof e.application > "u" || Array.isArray(e.application) && e.application.every(
    (t) => ti(t)
  )) && (typeof e.datePeriod > "u" || y(e.datePeriod)) && (typeof e.dateDateTime > "u" || typeof e.dateDateTime == "string") && (typeof e._dateDateTime > "u" || i(e._dateDateTime)) && (typeof e.identifier > "u" || a(e.identifier)) && r(e.type);
}
function ct(n) {
  const e = n;
  return f(e) && e.resourceType === "MedicinalProductAuthorization" && (typeof e.country > "u" || Array.isArray(e.country) && e.country.every(
    (t) => r(t)
  )) && (typeof e.dataExclusivityPeriod > "u" || y(e.dataExclusivityPeriod)) && (typeof e.dateOfFirstAuthorization > "u" || typeof e.dateOfFirstAuthorization == "string") && (typeof e._dateOfFirstAuthorization > "u" || i(e._dateOfFirstAuthorization)) && (typeof e.holder > "u" || o(e.holder)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.internationalBirthDate > "u" || typeof e.internationalBirthDate == "string") && (typeof e._internationalBirthDate > "u" || i(e._internationalBirthDate)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.jurisdictionalAuthorization > "u" || Array.isArray(e.jurisdictionalAuthorization) && e.jurisdictionalAuthorization.every(
    (t) => sf(t)
  )) && (typeof e.legalBasis > "u" || r(e.legalBasis)) && (typeof e.procedure > "u" || ti(e.procedure)) && (typeof e.regulator > "u" || o(e.regulator)) && (typeof e.restoreDate > "u" || typeof e.restoreDate == "string") && (typeof e._restoreDate > "u" || i(e._restoreDate)) && (typeof e.status > "u" || r(e.status)) && (typeof e.statusDate > "u" || typeof e.statusDate == "string") && (typeof e._statusDate > "u" || i(e._statusDate)) && (typeof e.subject > "u" || o(e.subject)) && (typeof e.validityPeriod > "u" || y(e.validityPeriod));
}
function cf(n) {
  const e = n;
  return d(e) && (typeof e.medicationCodeableConcept > "u" || r(e.medicationCodeableConcept)) && (typeof e.medicationReference > "u" || o(e.medicationReference)) && r(e.therapyRelationshipType);
}
function lt(n) {
  const e = n;
  return f(e) && e.resourceType === "MedicinalProductContraindication" && (typeof e.comorbidity > "u" || Array.isArray(e.comorbidity) && e.comorbidity.every(
    (t) => r(t)
  )) && (typeof e.disease > "u" || r(e.disease)) && (typeof e.diseaseStatus > "u" || r(e.diseaseStatus)) && (typeof e.otherTherapy > "u" || Array.isArray(e.otherTherapy) && e.otherTherapy.every(
    (t) => cf(t)
  )) && (typeof e.population > "u" || Array.isArray(e.population) && e.population.every(
    (t) => On(t)
  )) && (typeof e.subject > "u" || Array.isArray(e.subject) && e.subject.every(
    (t) => o(t)
  )) && (typeof e.therapeuticIndication > "u" || Array.isArray(e.therapeuticIndication) && e.therapeuticIndication.every(
    (t) => o(t)
  ));
}
function lf(n) {
  const e = n;
  return d(e) && (typeof e.medicationCodeableConcept > "u" || r(e.medicationCodeableConcept)) && (typeof e.medicationReference > "u" || o(e.medicationReference)) && r(e.therapyRelationshipType);
}
function vt(n) {
  const e = n;
  return f(e) && e.resourceType === "MedicinalProductIndication" && (typeof e.comorbidity > "u" || Array.isArray(e.comorbidity) && e.comorbidity.every(
    (t) => r(t)
  )) && (typeof e.diseaseStatus > "u" || r(e.diseaseStatus)) && (typeof e.diseaseSymptomProcedure > "u" || r(e.diseaseSymptomProcedure)) && (typeof e.duration > "u" || u(e.duration)) && (typeof e.intendedEffect > "u" || r(e.intendedEffect)) && (typeof e.otherTherapy > "u" || Array.isArray(e.otherTherapy) && e.otherTherapy.every(
    (t) => lf(t)
  )) && (typeof e.population > "u" || Array.isArray(e.population) && e.population.every(
    (t) => On(t)
  )) && (typeof e.subject > "u" || Array.isArray(e.subject) && e.subject.every(
    (t) => o(t)
  )) && (typeof e.undesirableEffect > "u" || Array.isArray(e.undesirableEffect) && e.undesirableEffect.every(
    (t) => o(t)
  ));
}
function vf(n) {
  const e = n;
  return d(e) && (typeof e.country > "u" || Array.isArray(e.country) && e.country.every(
    (t) => r(t)
  )) && (typeof e.measurementPoint > "u" || typeof e.measurementPoint == "string") && (typeof e._measurementPoint > "u" || i(e._measurementPoint)) && b(e.strength) && (typeof e.strengthLowLimit > "u" || b(e.strengthLowLimit)) && (typeof e.substance > "u" || r(e.substance));
}
function ni(n) {
  const e = n;
  return d(e) && (typeof e.concentration > "u" || b(e.concentration)) && (typeof e.concentrationLowLimit > "u" || b(e.concentrationLowLimit)) && (typeof e.country > "u" || Array.isArray(e.country) && e.country.every(
    (t) => r(t)
  )) && (typeof e.measurementPoint > "u" || typeof e.measurementPoint == "string") && (typeof e._measurementPoint > "u" || i(e._measurementPoint)) && b(e.presentation) && (typeof e.presentationLowLimit > "u" || b(e.presentationLowLimit)) && (typeof e.referenceStrength > "u" || Array.isArray(e.referenceStrength) && e.referenceStrength.every(
    (t) => vf(t)
  ));
}
function mf(n) {
  const e = n;
  return d(e) && r(e.code) && (typeof e.confidentiality > "u" || r(e.confidentiality)) && r(e.group) && (typeof e.strength > "u" || Array.isArray(e.strength) && e.strength.every(
    (t) => ni(t)
  ));
}
function gf(n) {
  const e = n;
  return d(e) && r(e.code) && (typeof e.strength > "u" || Array.isArray(e.strength) && e.strength.every(
    (t) => ni(t)
  ));
}
function mt(n) {
  const e = n;
  return f(e) && e.resourceType === "MedicinalProductIngredient" && (typeof e.allergenicIndicator > "u" || e.allergenicIndicator === !1 || e.allergenicIndicator === !0) && (typeof e._allergenicIndicator > "u" || i(e._allergenicIndicator)) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.manufacturer > "u" || Array.isArray(e.manufacturer) && e.manufacturer.every(
    (t) => o(t)
  )) && r(e.role) && (typeof e.specifiedSubstance > "u" || Array.isArray(e.specifiedSubstance) && e.specifiedSubstance.every(
    (t) => mf(t)
  )) && (typeof e.substance > "u" || gf(e.substance));
}
function _f(n) {
  const e = n;
  return d(e) && (typeof e.itemReference > "u" || o(e.itemReference)) && (typeof e.itemCodeableConcept > "u" || r(e.itemCodeableConcept));
}
function gt(n) {
  const e = n;
  return f(e) && e.resourceType === "MedicinalProductInteraction" && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.effect > "u" || r(e.effect)) && (typeof e.incidence > "u" || r(e.incidence)) && (typeof e.interactant > "u" || Array.isArray(e.interactant) && e.interactant.every(
    (t) => _f(t)
  )) && (typeof e.management > "u" || r(e.management)) && (typeof e.subject > "u" || Array.isArray(e.subject) && e.subject.every(
    (t) => o(t)
  )) && (typeof e.type > "u" || r(e.type));
}
function _t(n) {
  const e = n;
  return f(e) && e.resourceType === "MedicinalProductManufactured" && (typeof e.ingredient > "u" || Array.isArray(e.ingredient) && e.ingredient.every(
    (t) => o(t)
  )) && r(e.manufacturedDoseForm) && (typeof e.manufacturer > "u" || Array.isArray(e.manufacturer) && e.manufacturer.every(
    (t) => o(t)
  )) && (typeof e.otherCharacteristics > "u" || Array.isArray(e.otherCharacteristics) && e.otherCharacteristics.every(
    (t) => r(t)
  )) && (typeof e.physicalCharacteristics > "u" || En(e.physicalCharacteristics)) && u(e.quantity) && (typeof e.unitOfPresentation > "u" || r(e.unitOfPresentation));
}
function Af(n) {
  const e = n;
  return d(e) && (typeof e.immediatePackaging > "u" || a(e.immediatePackaging)) && a(e.outerPackaging);
}
function ii(n) {
  const e = n;
  return d(e) && (typeof e.alternateMaterial > "u" || Array.isArray(e.alternateMaterial) && e.alternateMaterial.every(
    (t) => r(t)
  )) && (typeof e.device > "u" || Array.isArray(e.device) && e.device.every(
    (t) => o(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.manufacturedItem > "u" || Array.isArray(e.manufacturedItem) && e.manufacturedItem.every(
    (t) => o(t)
  )) && (typeof e.manufacturer > "u" || Array.isArray(e.manufacturer) && e.manufacturer.every(
    (t) => o(t)
  )) && (typeof e.material > "u" || Array.isArray(e.material) && e.material.every(
    (t) => r(t)
  )) && (typeof e.otherCharacteristics > "u" || Array.isArray(e.otherCharacteristics) && e.otherCharacteristics.every(
    (t) => r(t)
  )) && (typeof e.packageItem > "u" || Array.isArray(e.packageItem) && e.packageItem.every(
    (t) => ii(t)
  )) && (typeof e.physicalCharacteristics > "u" || En(e.physicalCharacteristics)) && u(e.quantity) && (typeof e.shelfLifeStorage > "u" || Array.isArray(e.shelfLifeStorage) && e.shelfLifeStorage.every(
    (t) => Vn(t)
  )) && r(e.type);
}
function At(n) {
  const e = n;
  return f(e) && e.resourceType === "MedicinalProductPackaged" && (typeof e.batchIdentifier > "u" || Array.isArray(e.batchIdentifier) && e.batchIdentifier.every(
    (t) => Af(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.legalStatusOfSupply > "u" || r(e.legalStatusOfSupply)) && (typeof e.manufacturer > "u" || Array.isArray(e.manufacturer) && e.manufacturer.every(
    (t) => o(t)
  )) && (typeof e.marketingAuthorization > "u" || o(e.marketingAuthorization)) && (typeof e.marketingStatus > "u" || Array.isArray(e.marketingStatus) && e.marketingStatus.every(
    (t) => kn(t)
  )) && Array.isArray(e.packageItem) && e.packageItem.every(
    (t) => ii(t)
  ) && (typeof e.subject > "u" || Array.isArray(e.subject) && e.subject.every(
    (t) => o(t)
  ));
}
function bf(n) {
  const e = n;
  return d(e) && r(e.code) && (typeof e.status > "u" || r(e.status));
}
function If(n) {
  const e = n;
  return d(e) && (typeof e.supportingInformation > "u" || typeof e.supportingInformation == "string") && (typeof e._supportingInformation > "u" || i(e._supportingInformation)) && r(e.tissue) && u(e.value);
}
function hf(n) {
  const e = n;
  return d(e) && r(e.code) && (typeof e.withdrawalPeriod > "u" || Array.isArray(e.withdrawalPeriod) && e.withdrawalPeriod.every(
    (t) => If(t)
  ));
}
function wf(n) {
  const e = n;
  return d(e) && r(e.code) && (typeof e.firstDose > "u" || u(e.firstDose)) && (typeof e.maxDosePerDay > "u" || u(e.maxDosePerDay)) && (typeof e.maxDosePerTreatmentPeriod > "u" || b(e.maxDosePerTreatmentPeriod)) && (typeof e.maxSingleDose > "u" || u(e.maxSingleDose)) && (typeof e.maxTreatmentPeriod > "u" || _(e.maxTreatmentPeriod)) && (typeof e.targetSpecies > "u" || Array.isArray(e.targetSpecies) && e.targetSpecies.every(
    (t) => hf(t)
  ));
}
function bt(n) {
  const e = n;
  return f(e) && e.resourceType === "MedicinalProductPharmaceutical" && r(e.administrableDoseForm) && (typeof e.characteristics > "u" || Array.isArray(e.characteristics) && e.characteristics.every(
    (t) => bf(t)
  )) && (typeof e.device > "u" || Array.isArray(e.device) && e.device.every(
    (t) => o(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.ingredient > "u" || Array.isArray(e.ingredient) && e.ingredient.every(
    (t) => o(t)
  )) && Array.isArray(e.routeOfAdministration) && e.routeOfAdministration.every(
    (t) => wf(t)
  ) && (typeof e.unitOfPresentation > "u" || r(e.unitOfPresentation));
}
function It(n) {
  const e = n;
  return f(e) && e.resourceType === "MedicinalProductUndesirableEffect" && (typeof e.classification > "u" || r(e.classification)) && (typeof e.frequencyOfOccurrence > "u" || r(e.frequencyOfOccurrence)) && (typeof e.population > "u" || Array.isArray(e.population) && e.population.every(
    (t) => On(t)
  )) && (typeof e.subject > "u" || Array.isArray(e.subject) && e.subject.every(
    (t) => o(t)
  )) && (typeof e.symptomConditionEffect > "u" || r(e.symptomConditionEffect));
}
function Rf(n) {
  const e = n;
  return d(e) && typeof e.code == "string" && (typeof e._code > "u" || i(e._code)) && (typeof e.max > "u" || typeof e.max == "string") && (typeof e._max > "u" || i(e._max)) && typeof e.min == "number" && (typeof e.profile > "u" || typeof e.profile == "string") && (typeof e._profile > "u" || i(e._profile));
}
function Cf(n) {
  const e = n;
  return d(e) && typeof e.message == "string" && (typeof e._message > "u" || i(e._message)) && (typeof e.situation > "u" || typeof e.situation == "string") && (typeof e._situation > "u" || i(e._situation));
}
function ht(n) {
  const e = n;
  return f(e) && e.resourceType === "MessageDefinition" && (typeof e.allowedResponse > "u" || Array.isArray(e.allowedResponse) && e.allowedResponse.every(
    (t) => Cf(t)
  )) && (typeof e.base > "u" || typeof e.base == "string") && (typeof e._base > "u" || i(e._base)) && (typeof e.category > "u" || e.category === "consequence" || e.category === "currency" || e.category === "notification") && (typeof e._category > "u" || i(e._category)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && typeof e.date == "string" && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.eventCoding > "u" || s(e.eventCoding)) && (typeof e.eventUri > "u" || typeof e.eventUri == "string") && (typeof e._eventUri > "u" || i(e._eventUri)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.focus > "u" || Array.isArray(e.focus) && e.focus.every(
    (t) => Rf(t)
  )) && (typeof e.graph > "u" || Array.isArray(e.graph) && e.graph.every(
    (t) => typeof t == "string"
  )) && (typeof e._graph > "u" || Array.isArray(e._graph) && e._graph.every(
    (t) => i(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.parent > "u" || Array.isArray(e.parent) && e.parent.every(
    (t) => typeof t == "string"
  )) && (typeof e._parent > "u" || Array.isArray(e._parent) && e._parent.every(
    (t) => i(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (typeof e.replaces > "u" || Array.isArray(e.replaces) && e.replaces.every(
    (t) => typeof t == "string"
  )) && (typeof e._replaces > "u" || Array.isArray(e._replaces) && e._replaces.every(
    (t) => i(t)
  )) && (typeof e.responseRequired > "u" || e.responseRequired === "always" || e.responseRequired === "on-error" || e.responseRequired === "never" || e.responseRequired === "on-success") && (typeof e._responseRequired > "u" || i(e._responseRequired)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function Df(n) {
  const e = n;
  return d(e) && typeof e.endpoint == "string" && (typeof e._endpoint > "u" || i(e._endpoint)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.receiver > "u" || o(e.receiver)) && (typeof e.target > "u" || o(e.target));
}
function Sf(n) {
  const e = n;
  return d(e) && (typeof e.contact > "u" || I(e.contact)) && typeof e.endpoint == "string" && (typeof e._endpoint > "u" || i(e._endpoint)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.software > "u" || typeof e.software == "string") && (typeof e._software > "u" || i(e._software)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function Of(n) {
  const e = n;
  return d(e) && (e.code === "ok" || e.code === "transient-error" || e.code === "fatal-error") && (typeof e._code > "u" || i(e._code)) && (typeof e.details > "u" || o(e.details)) && typeof e.identifier == "string" && (typeof e._identifier > "u" || i(e._identifier));
}
function wt(n) {
  const e = n;
  return f(e) && e.resourceType === "MessageHeader" && (typeof e.author > "u" || o(e.author)) && (typeof e.definition > "u" || typeof e.definition == "string") && (typeof e._definition > "u" || i(e._definition)) && (typeof e.destination > "u" || Array.isArray(e.destination) && e.destination.every(
    (t) => Df(t)
  )) && (typeof e.enterer > "u" || o(e.enterer)) && (typeof e.eventCoding > "u" || s(e.eventCoding)) && (typeof e.eventUri > "u" || typeof e.eventUri == "string") && (typeof e._eventUri > "u" || i(e._eventUri)) && (typeof e.focus > "u" || Array.isArray(e.focus) && e.focus.every(
    (t) => o(t)
  )) && (typeof e.reason > "u" || r(e.reason)) && (typeof e.response > "u" || Of(e.response)) && (typeof e.responsible > "u" || o(e.responsible)) && (typeof e.sender > "u" || o(e.sender)) && Sf(e.source);
}
function Ef(n) {
  const e = n;
  return d(e) && (typeof e.chromosome > "u" || r(e.chromosome)) && (typeof e.genomeBuild > "u" || typeof e.genomeBuild == "string") && (typeof e._genomeBuild > "u" || i(e._genomeBuild)) && (typeof e.orientation > "u" || e.orientation === "sense" || e.orientation === "antisense") && (typeof e._orientation > "u" || i(e._orientation)) && (typeof e.referenceSeqId > "u" || r(e.referenceSeqId)) && (typeof e.referenceSeqPointer > "u" || o(e.referenceSeqPointer)) && (typeof e.referenceSeqString > "u" || typeof e.referenceSeqString == "string") && (typeof e._referenceSeqString > "u" || i(e._referenceSeqString)) && (typeof e.strand > "u" || e.strand === "watson" || e.strand === "crick") && (typeof e._strand > "u" || i(e._strand)) && (typeof e.windowEnd > "u" || typeof e.windowEnd == "number") && (typeof e.windowStart > "u" || typeof e.windowStart == "number");
}
function Tf(n) {
  const e = n;
  return d(e) && (typeof e.cigar > "u" || typeof e.cigar == "string") && (typeof e._cigar > "u" || i(e._cigar)) && (typeof e.end > "u" || typeof e.end == "number") && (typeof e.observedAllele > "u" || typeof e.observedAllele == "string") && (typeof e._observedAllele > "u" || i(e._observedAllele)) && (typeof e.referenceAllele > "u" || typeof e.referenceAllele == "string") && (typeof e._referenceAllele > "u" || i(e._referenceAllele)) && (typeof e.start > "u" || typeof e.start == "number") && (typeof e.variantPointer > "u" || o(e.variantPointer));
}
function xf(n) {
  const e = n;
  return d(e) && (typeof e.fMeasure > "u" || Array.isArray(e.fMeasure) && e.fMeasure.every(
    (t) => typeof t == "number"
  )) && (typeof e.numFN > "u" || Array.isArray(e.numFN) && e.numFN.every(
    (t) => typeof t == "number"
  )) && (typeof e.numFP > "u" || Array.isArray(e.numFP) && e.numFP.every(
    (t) => typeof t == "number"
  )) && (typeof e.numTP > "u" || Array.isArray(e.numTP) && e.numTP.every(
    (t) => typeof t == "number"
  )) && (typeof e.precision > "u" || Array.isArray(e.precision) && e.precision.every(
    (t) => typeof t == "number"
  )) && (typeof e.score > "u" || Array.isArray(e.score) && e.score.every(
    (t) => typeof t == "number"
  )) && (typeof e.sensitivity > "u" || Array.isArray(e.sensitivity) && e.sensitivity.every(
    (t) => typeof t == "number"
  ));
}
function jf(n) {
  const e = n;
  return d(e) && (typeof e.end > "u" || typeof e.end == "number") && (typeof e.fScore > "u" || typeof e.fScore == "number") && (typeof e.gtFP > "u" || typeof e.gtFP == "number") && (typeof e.method > "u" || r(e.method)) && (typeof e.precision > "u" || typeof e.precision == "number") && (typeof e.queryFP > "u" || typeof e.queryFP == "number") && (typeof e.queryTP > "u" || typeof e.queryTP == "number") && (typeof e.recall > "u" || typeof e.recall == "number") && (typeof e.roc > "u" || xf(e.roc)) && (typeof e.score > "u" || u(e.score)) && (typeof e.standardSequence > "u" || r(e.standardSequence)) && (typeof e.start > "u" || typeof e.start == "number") && (typeof e.truthFN > "u" || typeof e.truthFN == "number") && (typeof e.truthTP > "u" || typeof e.truthTP == "number") && (e.type === "unknown" || e.type === "indel" || e.type === "snp") && (typeof e._type > "u" || i(e._type));
}
function Pf(n) {
  const e = n;
  return d(e) && (typeof e.datasetId > "u" || typeof e.datasetId == "string") && (typeof e._datasetId > "u" || i(e._datasetId)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.readsetId > "u" || typeof e.readsetId == "string") && (typeof e._readsetId > "u" || i(e._readsetId)) && (e.type === "other" || e.type === "directlink" || e.type === "openapi" || e.type === "login" || e.type === "oauth") && (typeof e._type > "u" || i(e._type)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.variantsetId > "u" || typeof e.variantsetId == "string") && (typeof e._variantsetId > "u" || i(e._variantsetId));
}
function Ff(n) {
  const e = n;
  return d(e) && (typeof e.end > "u" || typeof e.end == "number") && (typeof e.start > "u" || typeof e.start == "number");
}
function Hf(n) {
  const e = n;
  return d(e) && (typeof e.end > "u" || typeof e.end == "number") && (typeof e.start > "u" || typeof e.start == "number");
}
function Mf(n) {
  const e = n;
  return d(e) && (typeof e.exact > "u" || e.exact === !1 || e.exact === !0) && (typeof e._exact > "u" || i(e._exact)) && (typeof e.inner > "u" || Hf(e.inner)) && (typeof e.length > "u" || typeof e.length == "number") && (typeof e.outer > "u" || Ff(e.outer)) && (typeof e.variantType > "u" || r(e.variantType));
}
function Rt(n) {
  const e = n;
  return f(e) && e.resourceType === "MolecularSequence" && typeof e.coordinateSystem == "number" && (typeof e.device > "u" || o(e.device)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.observedSeq > "u" || typeof e.observedSeq == "string") && (typeof e._observedSeq > "u" || i(e._observedSeq)) && (typeof e.patient > "u" || o(e.patient)) && (typeof e.performer > "u" || o(e.performer)) && (typeof e.pointer > "u" || Array.isArray(e.pointer) && e.pointer.every(
    (t) => o(t)
  )) && (typeof e.quality > "u" || Array.isArray(e.quality) && e.quality.every(
    (t) => jf(t)
  )) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.readCoverage > "u" || typeof e.readCoverage == "number") && (typeof e.referenceSeq > "u" || Ef(e.referenceSeq)) && (typeof e.repository > "u" || Array.isArray(e.repository) && e.repository.every(
    (t) => Pf(t)
  )) && (typeof e.specimen > "u" || o(e.specimen)) && (typeof e.structureVariant > "u" || Array.isArray(e.structureVariant) && e.structureVariant.every(
    (t) => Mf(t)
  )) && (typeof e.type > "u" || e.type === "aa" || e.type === "dna" || e.type === "rna") && (typeof e._type > "u" || i(e._type)) && (typeof e.variant > "u" || Array.isArray(e.variant) && e.variant.every(
    (t) => Tf(t)
  ));
}
function qf(n) {
  const e = n;
  return d(e) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment)) && (typeof e.period > "u" || y(e.period)) && (typeof e.preferred > "u" || e.preferred === !1 || e.preferred === !0) && (typeof e._preferred > "u" || i(e._preferred)) && (e.type === "other" || e.type === "uri" || e.type === "oid" || e.type === "uuid") && (typeof e._type > "u" || i(e._type)) && typeof e.value == "string" && (typeof e._value > "u" || i(e._value));
}
function Ct(n) {
  const e = n;
  return f(e) && e.resourceType === "NamingSystem" && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && typeof e.date == "string" && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (e.kind === "codesystem" || e.kind === "identifier" || e.kind === "root") && (typeof e._kind > "u" || i(e._kind)) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.responsible > "u" || typeof e.responsible == "string") && (typeof e._responsible > "u" || i(e._responsible)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.type > "u" || r(e.type)) && Array.isArray(e.uniqueId) && e.uniqueId.every(
    (t) => qf(t)
  ) && (typeof e.usage > "u" || typeof e.usage == "string") && (typeof e._usage > "u" || i(e._usage)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  ));
}
function kf(n) {
  const e = n;
  return d(e) && (typeof e.amount > "u" || u(e.amount)) && (typeof e.modifier > "u" || r(e.modifier));
}
function Bf(n) {
  const e = n;
  return d(e) && (typeof e.foodType > "u" || r(e.foodType)) && (typeof e.modifier > "u" || r(e.modifier));
}
function Vf(n) {
  const e = n;
  return d(e) && (typeof e.fluidConsistencyType > "u" || Array.isArray(e.fluidConsistencyType) && e.fluidConsistencyType.every(
    (t) => r(t)
  )) && (typeof e.instruction > "u" || typeof e.instruction == "string") && (typeof e._instruction > "u" || i(e._instruction)) && (typeof e.nutrient > "u" || Array.isArray(e.nutrient) && e.nutrient.every(
    (t) => kf(t)
  )) && (typeof e.schedule > "u" || Array.isArray(e.schedule) && e.schedule.every(
    (t) => A(t)
  )) && (typeof e.texture > "u" || Array.isArray(e.texture) && e.texture.every(
    (t) => Bf(t)
  )) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => r(t)
  ));
}
function Uf(n) {
  const e = n;
  return d(e) && (typeof e.instruction > "u" || typeof e.instruction == "string") && (typeof e._instruction > "u" || i(e._instruction)) && (typeof e.productName > "u" || typeof e.productName == "string") && (typeof e._productName > "u" || i(e._productName)) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.schedule > "u" || Array.isArray(e.schedule) && e.schedule.every(
    (t) => A(t)
  )) && (typeof e.type > "u" || r(e.type));
}
function Nf(n) {
  const e = n;
  return d(e) && (typeof e.quantity > "u" || u(e.quantity)) && (typeof e.rateQuantity > "u" || u(e.rateQuantity)) && (typeof e.rateRatio > "u" || b(e.rateRatio)) && (typeof e.schedule > "u" || A(e.schedule));
}
function Lf(n) {
  const e = n;
  return d(e) && (typeof e.additiveProductName > "u" || typeof e.additiveProductName == "string") && (typeof e._additiveProductName > "u" || i(e._additiveProductName)) && (typeof e.additiveType > "u" || r(e.additiveType)) && (typeof e.administration > "u" || Array.isArray(e.administration) && e.administration.every(
    (t) => Nf(t)
  )) && (typeof e.administrationInstruction > "u" || typeof e.administrationInstruction == "string") && (typeof e._administrationInstruction > "u" || i(e._administrationInstruction)) && (typeof e.baseFormulaProductName > "u" || typeof e.baseFormulaProductName == "string") && (typeof e._baseFormulaProductName > "u" || i(e._baseFormulaProductName)) && (typeof e.baseFormulaType > "u" || r(e.baseFormulaType)) && (typeof e.caloricDensity > "u" || u(e.caloricDensity)) && (typeof e.maxVolumeToDeliver > "u" || u(e.maxVolumeToDeliver)) && (typeof e.routeofAdministration > "u" || r(e.routeofAdministration));
}
function Dt(n) {
  const e = n;
  return f(e) && e.resourceType === "NutritionOrder" && (typeof e.allergyIntolerance > "u" || Array.isArray(e.allergyIntolerance) && e.allergyIntolerance.every(
    (t) => o(t)
  )) && typeof e.dateTime == "string" && (typeof e._dateTime > "u" || i(e._dateTime)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.enteralFormula > "u" || Lf(e.enteralFormula)) && (typeof e.excludeFoodModifier > "u" || Array.isArray(e.excludeFoodModifier) && e.excludeFoodModifier.every(
    (t) => r(t)
  )) && (typeof e.foodPreferenceModifier > "u" || Array.isArray(e.foodPreferenceModifier) && e.foodPreferenceModifier.every(
    (t) => r(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.instantiates > "u" || Array.isArray(e.instantiates) && e.instantiates.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiates > "u" || Array.isArray(e._instantiates) && e._instantiates.every(
    (t) => i(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => i(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => i(t)
  )) && (e.intent === "proposal" || e.intent === "plan" || e.intent === "directive" || e.intent === "order" || e.intent === "original-order" || e.intent === "reflex-order" || e.intent === "filler-order" || e.intent === "instance-order" || e.intent === "option") && (typeof e._intent > "u" || i(e._intent)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.oralDiet > "u" || Vf(e.oralDiet)) && (typeof e.orderer > "u" || o(e.orderer)) && o(e.patient) && (e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "draft" || e.status === "completed" || e.status === "revoked") && (typeof e._status > "u" || i(e._status)) && (typeof e.supplement > "u" || Array.isArray(e.supplement) && e.supplement.every(
    (t) => Uf(t)
  ));
}
function ri(n) {
  const e = n;
  return d(e) && (typeof e.age > "u" || v(e.age)) && (typeof e.appliesTo > "u" || Array.isArray(e.appliesTo) && e.appliesTo.every(
    (t) => r(t)
  )) && (typeof e.high > "u" || u(e.high)) && (typeof e.low > "u" || u(e.low)) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || i(e._text)) && (typeof e.type > "u" || r(e.type));
}
function Gf(n) {
  const e = n;
  return d(e) && r(e.code) && (typeof e.dataAbsentReason > "u" || r(e.dataAbsentReason)) && (typeof e.interpretation > "u" || Array.isArray(e.interpretation) && e.interpretation.every(
    (t) => r(t)
  )) && (typeof e.referenceRange > "u" || Array.isArray(e.referenceRange) && e.referenceRange.every(
    (t) => ri(t)
  )) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueCodeableConcept > "u" || r(e.valueCodeableConcept)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueRange > "u" || v(e.valueRange)) && (typeof e.valueRatio > "u" || b(e.valueRatio)) && (typeof e.valueSampledData > "u" || x(e.valueSampledData)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || i(e._valueTime)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || i(e._valueDateTime)) && (typeof e.valuePeriod > "u" || y(e.valuePeriod));
}
function St(n) {
  const e = n;
  return f(e) && e.resourceType === "Observation" && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.bodySite > "u" || r(e.bodySite)) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && r(e.code) && (typeof e.component > "u" || Array.isArray(e.component) && e.component.every(
    (t) => Gf(t)
  )) && (typeof e.dataAbsentReason > "u" || r(e.dataAbsentReason)) && (typeof e.derivedFrom > "u" || Array.isArray(e.derivedFrom) && e.derivedFrom.every(
    (t) => o(t)
  )) && (typeof e.device > "u" || o(e.device)) && (typeof e.effectiveDateTime > "u" || typeof e.effectiveDateTime == "string") && (typeof e._effectiveDateTime > "u" || i(e._effectiveDateTime)) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.effectiveTiming > "u" || A(e.effectiveTiming)) && (typeof e.effectiveInstant > "u" || typeof e.effectiveInstant == "string") && (typeof e._effectiveInstant > "u" || i(e._effectiveInstant)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.focus > "u" || Array.isArray(e.focus) && e.focus.every(
    (t) => o(t)
  )) && (typeof e.hasMember > "u" || Array.isArray(e.hasMember) && e.hasMember.every(
    (t) => o(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.interpretation > "u" || Array.isArray(e.interpretation) && e.interpretation.every(
    (t) => r(t)
  )) && (typeof e.issued > "u" || typeof e.issued == "string") && (typeof e._issued > "u" || i(e._issued)) && (typeof e.method > "u" || r(e.method)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => o(t)
  )) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => o(t)
  )) && (typeof e.referenceRange > "u" || Array.isArray(e.referenceRange) && e.referenceRange.every(
    (t) => ri(t)
  )) && (typeof e.specimen > "u" || o(e.specimen)) && (e.status === "entered-in-error" || e.status === "unknown" || e.status === "cancelled" || e.status === "preliminary" || e.status === "final" || e.status === "amended" || e.status === "registered" || e.status === "corrected") && (typeof e._status > "u" || i(e._status)) && (typeof e.subject > "u" || o(e.subject)) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueCodeableConcept > "u" || r(e.valueCodeableConcept)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueRange > "u" || v(e.valueRange)) && (typeof e.valueRatio > "u" || b(e.valueRatio)) && (typeof e.valueSampledData > "u" || x(e.valueSampledData)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || i(e._valueTime)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || i(e._valueDateTime)) && (typeof e.valuePeriod > "u" || y(e.valuePeriod));
}
function zf(n) {
  const e = n;
  return d(e) && (typeof e.conversionFactor > "u" || typeof e.conversionFactor == "number") && (typeof e.customaryUnit > "u" || r(e.customaryUnit)) && (typeof e.decimalPrecision > "u" || typeof e.decimalPrecision == "number") && (typeof e.unit > "u" || r(e.unit));
}
function Qf(n) {
  const e = n;
  return d(e) && (typeof e.age > "u" || v(e.age)) && (typeof e.appliesTo > "u" || Array.isArray(e.appliesTo) && e.appliesTo.every(
    (t) => r(t)
  )) && (typeof e.category > "u" || e.category === "reference" || e.category === "critical" || e.category === "absolute") && (typeof e._category > "u" || i(e._category)) && (typeof e.condition > "u" || typeof e.condition == "string") && (typeof e._condition > "u" || i(e._condition)) && (typeof e.context > "u" || r(e.context)) && (typeof e.gender > "u" || e.gender === "other" || e.gender === "unknown" || e.gender === "male" || e.gender === "female") && (typeof e._gender > "u" || i(e._gender)) && (typeof e.gestationalAge > "u" || v(e.gestationalAge)) && (typeof e.range > "u" || v(e.range));
}
function Ot(n) {
  const e = n;
  return f(e) && e.resourceType === "ObservationDefinition" && (typeof e.abnormalCodedValueSet > "u" || o(e.abnormalCodedValueSet)) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && r(e.code) && (typeof e.criticalCodedValueSet > "u" || o(e.criticalCodedValueSet)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.method > "u" || r(e.method)) && (typeof e.multipleResultsAllowed > "u" || e.multipleResultsAllowed === !1 || e.multipleResultsAllowed === !0) && (typeof e._multipleResultsAllowed > "u" || i(e._multipleResultsAllowed)) && (typeof e.normalCodedValueSet > "u" || o(e.normalCodedValueSet)) && (typeof e.permittedDataType > "u" || Array.isArray(e.permittedDataType) && e.permittedDataType.every(
    (t) => t === "string" || t === "boolean" || t === "integer" || t === "dateTime" || t === "Quantity" || t === "CodeableConcept" || t === "Range" || t === "Ratio" || t === "SampledData" || t === "time" || t === "Period"
  )) && (typeof e._permittedDataType > "u" || Array.isArray(e._permittedDataType) && e._permittedDataType.every(
    (t) => i(t)
  )) && (typeof e.preferredReportName > "u" || typeof e.preferredReportName == "string") && (typeof e._preferredReportName > "u" || i(e._preferredReportName)) && (typeof e.qualifiedInterval > "u" || Array.isArray(e.qualifiedInterval) && e.qualifiedInterval.every(
    (t) => Qf(t)
  )) && (typeof e.quantitativeDetails > "u" || zf(e.quantitativeDetails)) && (typeof e.validCodedValueSet > "u" || o(e.validCodedValueSet));
}
function Wf(n) {
  const e = n;
  return d(e) && (e.strength === "required" || e.strength === "extensible" || e.strength === "preferred" || e.strength === "example") && (typeof e._strength > "u" || i(e._strength)) && typeof e.valueSet == "string" && (typeof e._valueSet > "u" || i(e._valueSet));
}
function Kf(n) {
  const e = n;
  return d(e) && typeof e.source == "string" && (typeof e._source > "u" || i(e._source)) && (typeof e.sourceId > "u" || typeof e.sourceId == "string") && (typeof e._sourceId > "u" || i(e._sourceId));
}
function oi(n) {
  const e = n;
  return d(e) && (typeof e.binding > "u" || Wf(e.binding)) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || i(e._documentation)) && typeof e.max == "string" && (typeof e._max > "u" || i(e._max)) && typeof e.min == "number" && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.part > "u" || Array.isArray(e.part) && e.part.every(
    (t) => oi(t)
  )) && (typeof e.referencedFrom > "u" || Array.isArray(e.referencedFrom) && e.referencedFrom.every(
    (t) => Kf(t)
  )) && (typeof e.searchType > "u" || e.searchType === "string" || e.searchType === "number" || e.searchType === "date" || e.searchType === "token" || e.searchType === "reference" || e.searchType === "composite" || e.searchType === "quantity" || e.searchType === "uri" || e.searchType === "special") && (typeof e._searchType > "u" || i(e._searchType)) && (typeof e.targetProfile > "u" || Array.isArray(e.targetProfile) && e.targetProfile.every(
    (t) => typeof t == "string"
  )) && (typeof e._targetProfile > "u" || Array.isArray(e._targetProfile) && e._targetProfile.every(
    (t) => i(t)
  )) && (typeof e.type > "u" || typeof e.type == "string") && (typeof e._type > "u" || i(e._type)) && (e.use === "in" || e.use === "out") && (typeof e._use > "u" || i(e._use));
}
function Jf(n) {
  const e = n;
  return d(e) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment)) && (typeof e.parameterName > "u" || Array.isArray(e.parameterName) && e.parameterName.every(
    (t) => typeof t == "string"
  )) && (typeof e._parameterName > "u" || Array.isArray(e._parameterName) && e._parameterName.every(
    (t) => i(t)
  ));
}
function Et(n) {
  const e = n;
  return f(e) && e.resourceType === "OperationDefinition" && (typeof e.affectsState > "u" || e.affectsState === !1 || e.affectsState === !0) && (typeof e._affectsState > "u" || i(e._affectsState)) && (typeof e.base > "u" || typeof e.base == "string") && (typeof e._base > "u" || i(e._base)) && typeof e.code == "string" && (typeof e._code > "u" || i(e._code)) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.inputProfile > "u" || typeof e.inputProfile == "string") && (typeof e._inputProfile > "u" || i(e._inputProfile)) && typeof e.instance == "boolean" && (typeof e._instance > "u" || i(e._instance)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (e.kind === "operation" || e.kind === "query") && (typeof e._kind > "u" || i(e._kind)) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.outputProfile > "u" || typeof e.outputProfile == "string") && (typeof e._outputProfile > "u" || i(e._outputProfile)) && (typeof e.overload > "u" || Array.isArray(e.overload) && e.overload.every(
    (t) => Jf(t)
  )) && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => oi(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (typeof e.resource > "u" || Array.isArray(e.resource) && e.resource.every(
    (t) => typeof t == "string"
  )) && (typeof e._resource > "u" || Array.isArray(e._resource) && e._resource.every(
    (t) => i(t)
  )) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && typeof e.system == "boolean" && (typeof e._system > "u" || i(e._system)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && typeof e.type == "boolean" && (typeof e._type > "u" || i(e._type)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function Xf(n) {
  const e = n;
  return d(e) && typeof e.code == "string" && (typeof e._code > "u" || i(e._code)) && (typeof e.details > "u" || r(e.details)) && (typeof e.diagnostics > "u" || typeof e.diagnostics == "string") && (typeof e._diagnostics > "u" || i(e._diagnostics)) && (typeof e.expression > "u" || Array.isArray(e.expression) && e.expression.every(
    (t) => typeof t == "string"
  )) && (typeof e._expression > "u" || Array.isArray(e._expression) && e._expression.every(
    (t) => i(t)
  )) && (typeof e.location > "u" || Array.isArray(e.location) && e.location.every(
    (t) => typeof t == "string"
  )) && (typeof e._location > "u" || Array.isArray(e._location) && e._location.every(
    (t) => i(t)
  )) && (e.severity === "error" || e.severity === "warning" || e.severity === "fatal" || e.severity === "information") && (typeof e._severity > "u" || i(e._severity));
}
function Tt(n) {
  const e = n;
  return f(e) && e.resourceType === "OperationOutcome" && Array.isArray(e.issue) && e.issue.every(
    (t) => Xf(t)
  );
}
function Yf(n) {
  const e = n;
  return d(e) && (typeof e.address > "u" || h(e.address)) && (typeof e.name > "u" || S(e.name)) && (typeof e.purpose > "u" || r(e.purpose)) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => I(t)
  ));
}
function xt(n) {
  const e = n;
  return f(e) && e.resourceType === "Organization" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || i(e._active)) && (typeof e.address > "u" || Array.isArray(e.address) && e.address.every(
    (t) => h(t)
  )) && (typeof e.alias > "u" || Array.isArray(e.alias) && e.alias.every(
    (t) => typeof t == "string"
  )) && (typeof e._alias > "u" || Array.isArray(e._alias) && e._alias.every(
    (t) => i(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => Yf(t)
  )) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => o(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.partOf > "u" || o(e.partOf)) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => I(t)
  )) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => r(t)
  ));
}
function jt(n) {
  const e = n;
  return f(e) && e.resourceType === "OrganizationAffiliation" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || i(e._active)) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => r(t)
  )) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => o(t)
  )) && (typeof e.healthcareService > "u" || Array.isArray(e.healthcareService) && e.healthcareService.every(
    (t) => o(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.location > "u" || Array.isArray(e.location) && e.location.every(
    (t) => o(t)
  )) && (typeof e.network > "u" || Array.isArray(e.network) && e.network.every(
    (t) => o(t)
  )) && (typeof e.organization > "u" || o(e.organization)) && (typeof e.participatingOrganization > "u" || o(e.participatingOrganization)) && (typeof e.period > "u" || y(e.period)) && (typeof e.specialty > "u" || Array.isArray(e.specialty) && e.specialty.every(
    (t) => r(t)
  )) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => I(t)
  ));
}
function di(n) {
  const e = n;
  return d(e) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.part > "u" || Array.isArray(e.part) && e.part.every(
    (t) => di(t)
  )) && (typeof e.resource > "u" || V(e.resource) || U(e.resource) || N(e.resource) || L(e.resource) || G(e.resource) || z(e.resource) || Q(e.resource) || W(e.resource) || K(e.resource) || J(e.resource) || X(e.resource) || Y(e.resource) || Z(e.resource) || $(e.resource) || ee(e.resource) || te(e.resource) || ne(e.resource) || ie(e.resource) || re(e.resource) || oe(e.resource) || de(e.resource) || ae(e.resource) || fe(e.resource) || ye(e.resource) || ue(e.resource) || pe(e.resource) || se(e.resource) || ce(e.resource) || le(e.resource) || ve(e.resource) || me(e.resource) || ge(e.resource) || _e(e.resource) || Ae(e.resource) || be(e.resource) || Ie(e.resource) || he(e.resource) || we(e.resource) || Re(e.resource) || Ce(e.resource) || De(e.resource) || Se(e.resource) || Oe(e.resource) || Ee(e.resource) || Te(e.resource) || xe(e.resource) || je(e.resource) || Pe(e.resource) || Fe(e.resource) || He(e.resource) || Me(e.resource) || qe(e.resource) || ke(e.resource) || Be(e.resource) || Ve(e.resource) || Ue(e.resource) || Ne(e.resource) || Le(e.resource) || Ge(e.resource) || ze(e.resource) || Qe(e.resource) || We(e.resource) || Ke(e.resource) || Je(e.resource) || Xe(e.resource) || Ye(e.resource) || Ze(e.resource) || $e(e.resource) || et(e.resource) || tt(e.resource) || nt(e.resource) || it(e.resource) || rt(e.resource) || ot(e.resource) || dt(e.resource) || at(e.resource) || ft(e.resource) || yt(e.resource) || ut(e.resource) || pt(e.resource) || st(e.resource) || ct(e.resource) || lt(e.resource) || vt(e.resource) || mt(e.resource) || gt(e.resource) || _t(e.resource) || At(e.resource) || bt(e.resource) || It(e.resource) || ht(e.resource) || wt(e.resource) || Rt(e.resource) || Ct(e.resource) || Dt(e.resource) || St(e.resource) || Ot(e.resource) || Et(e.resource) || Tt(e.resource) || xt(e.resource) || jt(e.resource) || Pt(e.resource) || Ft(e.resource) || Ht(e.resource) || Mt(e.resource) || qt(e.resource) || kt(e.resource) || Bt(e.resource) || Vt(e.resource) || Ut(e.resource) || Nt(e.resource) || Lt(e.resource) || Gt(e.resource) || zt(e.resource) || Qt(e.resource) || Wt(e.resource) || Kt(e.resource) || Jt(e.resource) || Xt(e.resource) || Zt(e.resource) || $t(e.resource) || en(e.resource) || tn(e.resource) || nn(e.resource) || rn(e.resource) || on(e.resource) || dn(e.resource) || an(e.resource) || fn(e.resource) || yn(e.resource) || un(e.resource) || pn(e.resource) || sn(e.resource) || cn(e.resource) || ln(e.resource) || vn(e.resource) || mn(e.resource) || gn(e.resource) || _n(e.resource) || An(e.resource) || bn(e.resource) || In(e.resource) || hn(e.resource) || wn(e.resource) || Rn(e.resource) || Cn(e.resource)) && (typeof e.valueBase64Binary > "u" || typeof e.valueBase64Binary == "string") && (typeof e._valueBase64Binary > "u" || i(e._valueBase64Binary)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean)) && (typeof e.valueCanonical > "u" || typeof e.valueCanonical == "string") && (typeof e._valueCanonical > "u" || i(e._valueCanonical)) && (typeof e.valueCode > "u" || typeof e.valueCode == "string") && (typeof e._valueCode > "u" || i(e._valueCode)) && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || i(e._valueDate)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || i(e._valueDateTime)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueId > "u" || typeof e.valueId == "string") && (typeof e._valueId > "u" || i(e._valueId)) && (typeof e.valueInstant > "u" || typeof e.valueInstant == "string") && (typeof e._valueInstant > "u" || i(e._valueInstant)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueMarkdown > "u" || typeof e.valueMarkdown == "string") && (typeof e._valueMarkdown > "u" || i(e._valueMarkdown)) && (typeof e.valueOid > "u" || typeof e.valueOid == "string") && (typeof e._valueOid > "u" || i(e._valueOid)) && (typeof e.valuePositiveInt > "u" || typeof e.valuePositiveInt == "number") && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || i(e._valueTime)) && (typeof e.valueUnsignedInt > "u" || typeof e.valueUnsignedInt == "number") && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || i(e._valueUri)) && (typeof e.valueUrl > "u" || typeof e.valueUrl == "string") && (typeof e._valueUrl > "u" || i(e._valueUrl)) && (typeof e.valueUuid > "u" || typeof e.valueUuid == "string") && (typeof e._valueUuid > "u" || i(e._valueUuid)) && (typeof e.valueAddress > "u" || h(e.valueAddress)) && (typeof e.valueAge > "u" || C(e.valueAge)) && (typeof e.valueAnnotation > "u" || l(e.valueAnnotation)) && (typeof e.valueAttachment > "u" || g(e.valueAttachment)) && (typeof e.valueCodeableConcept > "u" || r(e.valueCodeableConcept)) && (typeof e.valueCoding > "u" || s(e.valueCoding)) && (typeof e.valueContactPoint > "u" || I(e.valueContactPoint)) && (typeof e.valueCount > "u" || H(e.valueCount)) && (typeof e.valueDistance > "u" || M(e.valueDistance)) && (typeof e.valueDuration > "u" || _(e.valueDuration)) && (typeof e.valueHumanName > "u" || S(e.valueHumanName)) && (typeof e.valueIdentifier > "u" || a(e.valueIdentifier)) && (typeof e.valueMoney > "u" || c(e.valueMoney)) && (typeof e.valuePeriod > "u" || y(e.valuePeriod)) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueRange > "u" || v(e.valueRange)) && (typeof e.valueRatio > "u" || b(e.valueRatio)) && (typeof e.valueReference > "u" || o(e.valueReference)) && (typeof e.valueSampledData > "u" || x(e.valueSampledData)) && (typeof e.valueSignature > "u" || O(e.valueSignature)) && (typeof e.valueTiming > "u" || A(e.valueTiming)) && (typeof e.valueContactDetail > "u" || p(e.valueContactDetail)) && (typeof e.valueContributor > "u" || F(e.valueContributor)) && (typeof e.valueDataRequirement > "u" || D(e.valueDataRequirement)) && (typeof e.valueExpression > "u" || R(e.valueExpression)) && (typeof e.valueParameterDefinition > "u" || P(e.valueParameterDefinition)) && (typeof e.valueRelatedArtifact > "u" || w(e.valueRelatedArtifact)) && (typeof e.valueTriggerDefinition > "u" || T(e.valueTriggerDefinition)) && (typeof e.valueUsageContext > "u" || m(e.valueUsageContext)) && (typeof e.valueDosage > "u" || E(e.valueDosage)) && (typeof e.valueMeta > "u" || j(e.valueMeta));
}
function Pt(n) {
  const e = n;
  return Yt(e) && e.resourceType === "Parameters" && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => di(t)
  ));
}
function Zf(n) {
  const e = n;
  return d(e) && (typeof e.address > "u" || h(e.address)) && (typeof e.gender > "u" || e.gender === "other" || e.gender === "unknown" || e.gender === "male" || e.gender === "female") && (typeof e._gender > "u" || i(e._gender)) && (typeof e.name > "u" || S(e.name)) && (typeof e.organization > "u" || o(e.organization)) && (typeof e.period > "u" || y(e.period)) && (typeof e.relationship > "u" || Array.isArray(e.relationship) && e.relationship.every(
    (t) => r(t)
  )) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => I(t)
  ));
}
function $f(n) {
  const e = n;
  return d(e) && r(e.language) && (typeof e.preferred > "u" || e.preferred === !1 || e.preferred === !0) && (typeof e._preferred > "u" || i(e._preferred));
}
function ey(n) {
  const e = n;
  return d(e) && o(e.other) && (e.type === "replaces" || e.type === "replaced-by" || e.type === "refer" || e.type === "seealso") && (typeof e._type > "u" || i(e._type));
}
function Ft(n) {
  const e = n;
  return f(e) && e.resourceType === "Patient" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || i(e._active)) && (typeof e.address > "u" || Array.isArray(e.address) && e.address.every(
    (t) => h(t)
  )) && (typeof e.birthDate > "u" || typeof e.birthDate == "string") && (typeof e._birthDate > "u" || i(e._birthDate)) && (typeof e.communication > "u" || Array.isArray(e.communication) && e.communication.every(
    (t) => $f(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => Zf(t)
  )) && (typeof e.deceasedBoolean > "u" || e.deceasedBoolean === !1 || e.deceasedBoolean === !0) && (typeof e._deceasedBoolean > "u" || i(e._deceasedBoolean)) && (typeof e.deceasedDateTime > "u" || typeof e.deceasedDateTime == "string") && (typeof e._deceasedDateTime > "u" || i(e._deceasedDateTime)) && (typeof e.gender > "u" || e.gender === "other" || e.gender === "unknown" || e.gender === "male" || e.gender === "female") && (typeof e._gender > "u" || i(e._gender)) && (typeof e.generalPractitioner > "u" || Array.isArray(e.generalPractitioner) && e.generalPractitioner.every(
    (t) => o(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.link > "u" || Array.isArray(e.link) && e.link.every(
    (t) => ey(t)
  )) && (typeof e.managingOrganization > "u" || o(e.managingOrganization)) && (typeof e.maritalStatus > "u" || r(e.maritalStatus)) && (typeof e.multipleBirthBoolean > "u" || e.multipleBirthBoolean === !1 || e.multipleBirthBoolean === !0) && (typeof e._multipleBirthBoolean > "u" || i(e._multipleBirthBoolean)) && (typeof e.multipleBirthInteger > "u" || typeof e.multipleBirthInteger == "number") && (typeof e.name > "u" || Array.isArray(e.name) && e.name.every(
    (t) => S(t)
  )) && (typeof e.photo > "u" || Array.isArray(e.photo) && e.photo.every(
    (t) => g(t)
  )) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => I(t)
  ));
}
function Ht(n) {
  const e = n;
  return f(e) && e.resourceType === "PaymentNotice" && c(e.amount) && typeof e.created == "string" && (typeof e._created > "u" || i(e._created)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.payee > "u" || o(e.payee)) && o(e.payment) && (typeof e.paymentDate > "u" || typeof e.paymentDate == "string") && (typeof e._paymentDate > "u" || i(e._paymentDate)) && (typeof e.paymentStatus > "u" || r(e.paymentStatus)) && (typeof e.provider > "u" || o(e.provider)) && o(e.recipient) && (typeof e.request > "u" || o(e.request)) && (typeof e.response > "u" || o(e.response)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || i(e._status));
}
function ty(n) {
  const e = n;
  return d(e) && (typeof e.amount > "u" || c(e.amount)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.payee > "u" || o(e.payee)) && (typeof e.predecessor > "u" || a(e.predecessor)) && (typeof e.request > "u" || o(e.request)) && (typeof e.response > "u" || o(e.response)) && (typeof e.responsible > "u" || o(e.responsible)) && (typeof e.submitter > "u" || o(e.submitter)) && r(e.type);
}
function ny(n) {
  const e = n;
  return d(e) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || i(e._text)) && (typeof e.type > "u" || e.type === "display" || e.type === "print" || e.type === "printoper") && (typeof e._type > "u" || i(e._type));
}
function Mt(n) {
  const e = n;
  return f(e) && e.resourceType === "PaymentReconciliation" && typeof e.created == "string" && (typeof e._created > "u" || i(e._created)) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => ty(t)
  )) && (typeof e.disposition > "u" || typeof e.disposition == "string") && (typeof e._disposition > "u" || i(e._disposition)) && (typeof e.formCode > "u" || r(e.formCode)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.outcome > "u" || e.outcome === "error" || e.outcome === "queued" || e.outcome === "complete" || e.outcome === "partial") && (typeof e._outcome > "u" || i(e._outcome)) && c(e.paymentAmount) && typeof e.paymentDate == "string" && (typeof e._paymentDate > "u" || i(e._paymentDate)) && (typeof e.paymentIdentifier > "u" || a(e.paymentIdentifier)) && (typeof e.paymentIssuer > "u" || o(e.paymentIssuer)) && (typeof e.period > "u" || y(e.period)) && (typeof e.processNote > "u" || Array.isArray(e.processNote) && e.processNote.every(
    (t) => ny(t)
  )) && (typeof e.request > "u" || o(e.request)) && (typeof e.requestor > "u" || o(e.requestor)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || i(e._status));
}
function iy(n) {
  const e = n;
  return d(e) && (typeof e.assurance > "u" || e.assurance === "level1" || e.assurance === "level2" || e.assurance === "level3" || e.assurance === "level4") && (typeof e._assurance > "u" || i(e._assurance)) && o(e.target);
}
function qt(n) {
  const e = n;
  return f(e) && e.resourceType === "Person" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || i(e._active)) && (typeof e.address > "u" || Array.isArray(e.address) && e.address.every(
    (t) => h(t)
  )) && (typeof e.birthDate > "u" || typeof e.birthDate == "string") && (typeof e._birthDate > "u" || i(e._birthDate)) && (typeof e.gender > "u" || e.gender === "other" || e.gender === "unknown" || e.gender === "male" || e.gender === "female") && (typeof e._gender > "u" || i(e._gender)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.link > "u" || Array.isArray(e.link) && e.link.every(
    (t) => iy(t)
  )) && (typeof e.managingOrganization > "u" || o(e.managingOrganization)) && (typeof e.name > "u" || Array.isArray(e.name) && e.name.every(
    (t) => S(t)
  )) && (typeof e.photo > "u" || g(e.photo)) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => I(t)
  ));
}
function ry(n) {
  const e = n;
  return d(e) && (typeof e.detailQuantity > "u" || u(e.detailQuantity)) && (typeof e.detailRange > "u" || v(e.detailRange)) && (typeof e.detailCodeableConcept > "u" || r(e.detailCodeableConcept)) && (typeof e.due > "u" || _(e.due)) && (typeof e.measure > "u" || r(e.measure));
}
function oy(n) {
  const e = n;
  return d(e) && (typeof e.addresses > "u" || Array.isArray(e.addresses) && e.addresses.every(
    (t) => r(t)
  )) && (typeof e.category > "u" || r(e.category)) && r(e.description) && (typeof e.documentation > "u" || Array.isArray(e.documentation) && e.documentation.every(
    (t) => w(t)
  )) && (typeof e.priority > "u" || r(e.priority)) && (typeof e.start > "u" || r(e.start)) && (typeof e.target > "u" || Array.isArray(e.target) && e.target.every(
    (t) => ry(t)
  ));
}
function dy(n) {
  const e = n;
  return d(e) && (typeof e.expression > "u" || R(e.expression)) && (e.kind === "applicability" || e.kind === "start" || e.kind === "stop") && (typeof e._kind > "u" || i(e._kind));
}
function ay(n) {
  const e = n;
  return d(e) && typeof e.actionId == "string" && (typeof e._actionId > "u" || i(e._actionId)) && (typeof e.offsetDuration > "u" || _(e.offsetDuration)) && (typeof e.offsetRange > "u" || v(e.offsetRange)) && (e.relationship === "before-start" || e.relationship === "before" || e.relationship === "before-end" || e.relationship === "concurrent-with-start" || e.relationship === "concurrent" || e.relationship === "concurrent-with-end" || e.relationship === "after-start" || e.relationship === "after" || e.relationship === "after-end") && (typeof e._relationship > "u" || i(e._relationship));
}
function fy(n) {
  const e = n;
  return d(e) && (typeof e.role > "u" || r(e.role)) && (e.type === "patient" || e.type === "practitioner" || e.type === "related-person" || e.type === "device") && (typeof e._type > "u" || i(e._type));
}
function yy(n) {
  const e = n;
  return d(e) && (typeof e.expression > "u" || R(e.expression)) && (typeof e.path > "u" || typeof e.path == "string") && (typeof e._path > "u" || i(e._path));
}
function ai(n) {
  const e = n;
  return d(e) && (typeof e.action > "u" || Array.isArray(e.action) && e.action.every(
    (t) => ai(t)
  )) && (typeof e.cardinalityBehavior > "u" || e.cardinalityBehavior === "single" || e.cardinalityBehavior === "multiple") && (typeof e._cardinalityBehavior > "u" || i(e._cardinalityBehavior)) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => r(t)
  )) && (typeof e.condition > "u" || Array.isArray(e.condition) && e.condition.every(
    (t) => dy(t)
  )) && (typeof e.definitionCanonical > "u" || typeof e.definitionCanonical == "string") && (typeof e._definitionCanonical > "u" || i(e._definitionCanonical)) && (typeof e.definitionUri > "u" || typeof e.definitionUri == "string") && (typeof e._definitionUri > "u" || i(e._definitionUri)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.documentation > "u" || Array.isArray(e.documentation) && e.documentation.every(
    (t) => w(t)
  )) && (typeof e.dynamicValue > "u" || Array.isArray(e.dynamicValue) && e.dynamicValue.every(
    (t) => yy(t)
  )) && (typeof e.goalId > "u" || Array.isArray(e.goalId) && e.goalId.every(
    (t) => typeof t == "string"
  )) && (typeof e._goalId > "u" || Array.isArray(e._goalId) && e._goalId.every(
    (t) => i(t)
  )) && (typeof e.groupingBehavior > "u" || e.groupingBehavior === "visual-group" || e.groupingBehavior === "logical-group" || e.groupingBehavior === "sentence-group") && (typeof e._groupingBehavior > "u" || i(e._groupingBehavior)) && (typeof e.input > "u" || Array.isArray(e.input) && e.input.every(
    (t) => D(t)
  )) && (typeof e.output > "u" || Array.isArray(e.output) && e.output.every(
    (t) => D(t)
  )) && (typeof e.participant > "u" || Array.isArray(e.participant) && e.participant.every(
    (t) => fy(t)
  )) && (typeof e.precheckBehavior > "u" || e.precheckBehavior === "yes" || e.precheckBehavior === "no") && (typeof e._precheckBehavior > "u" || i(e._precheckBehavior)) && (typeof e.prefix > "u" || typeof e.prefix == "string") && (typeof e._prefix > "u" || i(e._prefix)) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || i(e._priority)) && (typeof e.reason > "u" || Array.isArray(e.reason) && e.reason.every(
    (t) => r(t)
  )) && (typeof e.relatedAction > "u" || Array.isArray(e.relatedAction) && e.relatedAction.every(
    (t) => ay(t)
  )) && (typeof e.requiredBehavior > "u" || e.requiredBehavior === "must" || e.requiredBehavior === "could" || e.requiredBehavior === "must-unless-documented") && (typeof e._requiredBehavior > "u" || i(e._requiredBehavior)) && (typeof e.selectionBehavior > "u" || e.selectionBehavior === "any" || e.selectionBehavior === "all" || e.selectionBehavior === "all-or-none" || e.selectionBehavior === "exactly-one" || e.selectionBehavior === "at-most-one" || e.selectionBehavior === "one-or-more") && (typeof e._selectionBehavior > "u" || i(e._selectionBehavior)) && (typeof e.subjectCodeableConcept > "u" || r(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || o(e.subjectReference)) && (typeof e.textEquivalent > "u" || typeof e.textEquivalent == "string") && (typeof e._textEquivalent > "u" || i(e._textEquivalent)) && (typeof e.timingDateTime > "u" || typeof e.timingDateTime == "string") && (typeof e._timingDateTime > "u" || i(e._timingDateTime)) && (typeof e.timingAge > "u" || C(e.timingAge)) && (typeof e.timingPeriod > "u" || y(e.timingPeriod)) && (typeof e.timingDuration > "u" || _(e.timingDuration)) && (typeof e.timingRange > "u" || v(e.timingRange)) && (typeof e.timingTiming > "u" || A(e.timingTiming)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.transform > "u" || typeof e.transform == "string") && (typeof e._transform > "u" || i(e._transform)) && (typeof e.trigger > "u" || Array.isArray(e.trigger) && e.trigger.every(
    (t) => T(t)
  )) && (typeof e.type > "u" || r(e.type));
}
function kt(n) {
  const e = n;
  return f(e) && e.resourceType === "PlanDefinition" && (typeof e.action > "u" || Array.isArray(e.action) && e.action.every(
    (t) => ai(t)
  )) && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || i(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => p(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => p(t)
  )) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => p(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.goal > "u" || Array.isArray(e.goal) && e.goal.every(
    (t) => oy(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || i(e._lastReviewDate)) && (typeof e.library > "u" || Array.isArray(e.library) && e.library.every(
    (t) => typeof t == "string"
  )) && (typeof e._library > "u" || Array.isArray(e._library) && e._library.every(
    (t) => i(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => w(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => p(t)
  )) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.subjectCodeableConcept > "u" || r(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || o(e.subjectReference)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || i(e._subtitle)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => r(t)
  )) && (typeof e.type > "u" || r(e.type)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.usage > "u" || typeof e.usage == "string") && (typeof e._usage > "u" || i(e._usage)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function uy(n) {
  const e = n;
  return d(e) && r(e.code) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.issuer > "u" || o(e.issuer)) && (typeof e.period > "u" || y(e.period));
}
function Bt(n) {
  const e = n;
  return f(e) && e.resourceType === "Practitioner" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || i(e._active)) && (typeof e.address > "u" || Array.isArray(e.address) && e.address.every(
    (t) => h(t)
  )) && (typeof e.birthDate > "u" || typeof e.birthDate == "string") && (typeof e._birthDate > "u" || i(e._birthDate)) && (typeof e.communication > "u" || Array.isArray(e.communication) && e.communication.every(
    (t) => r(t)
  )) && (typeof e.gender > "u" || e.gender === "other" || e.gender === "unknown" || e.gender === "male" || e.gender === "female") && (typeof e._gender > "u" || i(e._gender)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.name > "u" || Array.isArray(e.name) && e.name.every(
    (t) => S(t)
  )) && (typeof e.photo > "u" || Array.isArray(e.photo) && e.photo.every(
    (t) => g(t)
  )) && (typeof e.qualification > "u" || Array.isArray(e.qualification) && e.qualification.every(
    (t) => uy(t)
  )) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => I(t)
  ));
}
function py(n) {
  const e = n;
  return d(e) && (typeof e.allDay > "u" || e.allDay === !1 || e.allDay === !0) && (typeof e._allDay > "u" || i(e._allDay)) && (typeof e.availableEndTime > "u" || typeof e.availableEndTime == "string") && (typeof e._availableEndTime > "u" || i(e._availableEndTime)) && (typeof e.availableStartTime > "u" || typeof e.availableStartTime == "string") && (typeof e._availableStartTime > "u" || i(e._availableStartTime)) && (typeof e.daysOfWeek > "u" || Array.isArray(e.daysOfWeek) && e.daysOfWeek.every(
    (t) => t === "mon" || t === "tue" || t === "wed" || t === "thu" || t === "fri" || t === "sat" || t === "sun"
  )) && (typeof e._daysOfWeek > "u" || Array.isArray(e._daysOfWeek) && e._daysOfWeek.every(
    (t) => i(t)
  ));
}
function sy(n) {
  const e = n;
  return d(e) && typeof e.description == "string" && (typeof e._description > "u" || i(e._description)) && (typeof e.during > "u" || y(e.during));
}
function Vt(n) {
  const e = n;
  return f(e) && e.resourceType === "PractitionerRole" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || i(e._active)) && (typeof e.availabilityExceptions > "u" || typeof e.availabilityExceptions == "string") && (typeof e._availabilityExceptions > "u" || i(e._availabilityExceptions)) && (typeof e.availableTime > "u" || Array.isArray(e.availableTime) && e.availableTime.every(
    (t) => py(t)
  )) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => r(t)
  )) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => o(t)
  )) && (typeof e.healthcareService > "u" || Array.isArray(e.healthcareService) && e.healthcareService.every(
    (t) => o(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.location > "u" || Array.isArray(e.location) && e.location.every(
    (t) => o(t)
  )) && (typeof e.notAvailable > "u" || Array.isArray(e.notAvailable) && e.notAvailable.every(
    (t) => sy(t)
  )) && (typeof e.organization > "u" || o(e.organization)) && (typeof e.period > "u" || y(e.period)) && (typeof e.practitioner > "u" || o(e.practitioner)) && (typeof e.specialty > "u" || Array.isArray(e.specialty) && e.specialty.every(
    (t) => r(t)
  )) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => I(t)
  ));
}
function cy(n) {
  const e = n;
  return d(e) && o(e.actor) && (typeof e.function > "u" || r(e.function)) && (typeof e.onBehalfOf > "u" || o(e.onBehalfOf));
}
function ly(n) {
  const e = n;
  return d(e) && (typeof e.action > "u" || r(e.action)) && o(e.manipulated);
}
function Ut(n) {
  const e = n;
  return f(e) && e.resourceType === "Procedure" && (typeof e.asserter > "u" || o(e.asserter)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.bodySite > "u" || Array.isArray(e.bodySite) && e.bodySite.every(
    (t) => r(t)
  )) && (typeof e.category > "u" || r(e.category)) && (typeof e.code > "u" || r(e.code)) && (typeof e.complication > "u" || Array.isArray(e.complication) && e.complication.every(
    (t) => r(t)
  )) && (typeof e.complicationDetail > "u" || Array.isArray(e.complicationDetail) && e.complicationDetail.every(
    (t) => o(t)
  )) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.focalDevice > "u" || Array.isArray(e.focalDevice) && e.focalDevice.every(
    (t) => ly(t)
  )) && (typeof e.followUp > "u" || Array.isArray(e.followUp) && e.followUp.every(
    (t) => r(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => i(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => i(t)
  )) && (typeof e.location > "u" || o(e.location)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.outcome > "u" || r(e.outcome)) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => o(t)
  )) && (typeof e.performedDateTime > "u" || typeof e.performedDateTime == "string") && (typeof e._performedDateTime > "u" || i(e._performedDateTime)) && (typeof e.performedPeriod > "u" || y(e.performedPeriod)) && (typeof e.performedString > "u" || typeof e.performedString == "string") && (typeof e._performedString > "u" || i(e._performedString)) && (typeof e.performedAge > "u" || C(e.performedAge)) && (typeof e.performedRange > "u" || v(e.performedRange)) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => cy(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.recorder > "u" || o(e.recorder)) && (typeof e.report > "u" || Array.isArray(e.report) && e.report.every(
    (t) => o(t)
  )) && (e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "in-progress" || e.status === "completed" || e.status === "stopped" || e.status === "preparation" || e.status === "not-done") && (typeof e._status > "u" || i(e._status)) && (typeof e.statusReason > "u" || r(e.statusReason)) && o(e.subject) && (typeof e.usedCode > "u" || Array.isArray(e.usedCode) && e.usedCode.every(
    (t) => r(t)
  )) && (typeof e.usedReference > "u" || Array.isArray(e.usedReference) && e.usedReference.every(
    (t) => o(t)
  ));
}
function fi(n) {
  const e = n;
  return d(e) && (typeof e.onBehalfOf > "u" || o(e.onBehalfOf)) && (typeof e.role > "u" || Array.isArray(e.role) && e.role.every(
    (t) => r(t)
  )) && (typeof e.type > "u" || r(e.type)) && o(e.who);
}
function vy(n) {
  const e = n;
  return d(e) && (typeof e.agent > "u" || Array.isArray(e.agent) && e.agent.every(
    (t) => fi(t)
  )) && (e.role === "source" || e.role === "derivation" || e.role === "revision" || e.role === "quotation" || e.role === "removal") && (typeof e._role > "u" || i(e._role)) && o(e.what);
}
function Nt(n) {
  const e = n;
  return f(e) && e.resourceType === "Provenance" && (typeof e.activity > "u" || r(e.activity)) && Array.isArray(e.agent) && e.agent.every(
    (t) => fi(t)
  ) && (typeof e.entity > "u" || Array.isArray(e.entity) && e.entity.every(
    (t) => vy(t)
  )) && (typeof e.location > "u" || o(e.location)) && (typeof e.occurredPeriod > "u" || y(e.occurredPeriod)) && (typeof e.occurredDateTime > "u" || typeof e.occurredDateTime == "string") && (typeof e._occurredDateTime > "u" || i(e._occurredDateTime)) && (typeof e.policy > "u" || Array.isArray(e.policy) && e.policy.every(
    (t) => typeof t == "string"
  )) && (typeof e._policy > "u" || Array.isArray(e._policy) && e._policy.every(
    (t) => i(t)
  )) && (typeof e.reason > "u" || Array.isArray(e.reason) && e.reason.every(
    (t) => r(t)
  )) && typeof e.recorded == "string" && (typeof e._recorded > "u" || i(e._recorded)) && (typeof e.signature > "u" || Array.isArray(e.signature) && e.signature.every(
    (t) => O(t)
  )) && Array.isArray(e.target) && e.target.every(
    (t) => o(t)
  );
}
function my(n) {
  const e = n;
  return d(e) && (typeof e.answerBoolean > "u" || e.answerBoolean === !1 || e.answerBoolean === !0) && (typeof e._answerBoolean > "u" || i(e._answerBoolean)) && (typeof e.answerDecimal > "u" || typeof e.answerDecimal == "number") && (typeof e.answerInteger > "u" || typeof e.answerInteger == "number") && (typeof e.answerDate > "u" || typeof e.answerDate == "string") && (typeof e._answerDate > "u" || i(e._answerDate)) && (typeof e.answerDateTime > "u" || typeof e.answerDateTime == "string") && (typeof e._answerDateTime > "u" || i(e._answerDateTime)) && (typeof e.answerTime > "u" || typeof e.answerTime == "string") && (typeof e._answerTime > "u" || i(e._answerTime)) && (typeof e.answerString > "u" || typeof e.answerString == "string") && (typeof e._answerString > "u" || i(e._answerString)) && (typeof e.answerCoding > "u" || s(e.answerCoding)) && (typeof e.answerQuantity > "u" || u(e.answerQuantity)) && (typeof e.answerReference > "u" || o(e.answerReference)) && (e.operator === "exists" || e.operator === "<" || e.operator === "<=" || e.operator === ">=" || e.operator === ">" || e.operator === "=" || e.operator === "!=") && (typeof e._operator > "u" || i(e._operator)) && typeof e.question == "string" && (typeof e._question > "u" || i(e._question));
}
function gy(n) {
  const e = n;
  return d(e) && (typeof e.initialSelected > "u" || e.initialSelected === !1 || e.initialSelected === !0) && (typeof e._initialSelected > "u" || i(e._initialSelected)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || i(e._valueDate)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || i(e._valueTime)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueCoding > "u" || s(e.valueCoding)) && (typeof e.valueReference > "u" || o(e.valueReference));
}
function _y(n) {
  const e = n;
  return d(e) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || i(e._valueDate)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || i(e._valueDateTime)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || i(e._valueTime)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || i(e._valueUri)) && (typeof e.valueAttachment > "u" || g(e.valueAttachment)) && (typeof e.valueCoding > "u" || s(e.valueCoding)) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueReference > "u" || o(e.valueReference));
}
function yi(n) {
  const e = n;
  return d(e) && (typeof e.answerOption > "u" || Array.isArray(e.answerOption) && e.answerOption.every(
    (t) => gy(t)
  )) && (typeof e.answerValueSet > "u" || typeof e.answerValueSet == "string") && (typeof e._answerValueSet > "u" || i(e._answerValueSet)) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => s(t)
  )) && (typeof e.definition > "u" || typeof e.definition == "string") && (typeof e._definition > "u" || i(e._definition)) && (typeof e.enableBehavior > "u" || e.enableBehavior === "any" || e.enableBehavior === "all") && (typeof e._enableBehavior > "u" || i(e._enableBehavior)) && (typeof e.enableWhen > "u" || Array.isArray(e.enableWhen) && e.enableWhen.every(
    (t) => my(t)
  )) && (typeof e.initial > "u" || Array.isArray(e.initial) && e.initial.every(
    (t) => _y(t)
  )) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => yi(t)
  )) && typeof e.linkId == "string" && (typeof e._linkId > "u" || i(e._linkId)) && (typeof e.maxLength > "u" || typeof e.maxLength == "number") && (typeof e.prefix > "u" || typeof e.prefix == "string") && (typeof e._prefix > "u" || i(e._prefix)) && (typeof e.readOnly > "u" || e.readOnly === !1 || e.readOnly === !0) && (typeof e._readOnly > "u" || i(e._readOnly)) && (typeof e.repeats > "u" || e.repeats === !1 || e.repeats === !0) && (typeof e._repeats > "u" || i(e._repeats)) && (typeof e.required > "u" || e.required === !1 || e.required === !0) && (typeof e._required > "u" || i(e._required)) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || i(e._text)) && (e.type === "string" || e.type === "boolean" || e.type === "url" || e.type === "date" || e.type === "reference" || e.type === "quantity" || e.type === "display" || e.type === "integer" || e.type === "dateTime" || e.type === "decimal" || e.type === "time" || e.type === "group" || e.type === "question" || e.type === "text" || e.type === "choice" || e.type === "open-choice" || e.type === "attachment") && (typeof e._type > "u" || i(e._type));
}
function Lt(n) {
  const e = n;
  return f(e) && e.resourceType === "Questionnaire" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || i(e._approvalDate)) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => s(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.derivedFrom > "u" || Array.isArray(e.derivedFrom) && e.derivedFrom.every(
    (t) => typeof t == "string"
  )) && (typeof e._derivedFrom > "u" || Array.isArray(e._derivedFrom) && e._derivedFrom.every(
    (t) => i(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => yi(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || i(e._lastReviewDate)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.subjectType > "u" || Array.isArray(e.subjectType) && e.subjectType.every(
    (t) => typeof t == "string"
  )) && (typeof e._subjectType > "u" || Array.isArray(e._subjectType) && e._subjectType.every(
    (t) => i(t)
  )) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function Ay(n) {
  const e = n;
  return d(e) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => xn(t)
  )) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || i(e._valueDate)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || i(e._valueDateTime)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || i(e._valueTime)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || i(e._valueUri)) && (typeof e.valueAttachment > "u" || g(e.valueAttachment)) && (typeof e.valueCoding > "u" || s(e.valueCoding)) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueReference > "u" || o(e.valueReference));
}
function xn(n) {
  const e = n;
  return d(e) && (typeof e.answer > "u" || Array.isArray(e.answer) && e.answer.every(
    (t) => Ay(t)
  )) && (typeof e.definition > "u" || typeof e.definition == "string") && (typeof e._definition > "u" || i(e._definition)) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => xn(t)
  )) && typeof e.linkId == "string" && (typeof e._linkId > "u" || i(e._linkId)) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || i(e._text));
}
function Gt(n) {
  const e = n;
  return f(e) && e.resourceType === "QuestionnaireResponse" && (typeof e.author > "u" || o(e.author)) && (typeof e.authored > "u" || typeof e.authored == "string") && (typeof e._authored > "u" || i(e._authored)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => xn(t)
  )) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => o(t)
  )) && (typeof e.questionnaire > "u" || typeof e.questionnaire == "string") && (typeof e._questionnaire > "u" || i(e._questionnaire)) && (typeof e.source > "u" || o(e.source)) && (e.status === "entered-in-error" || e.status === "in-progress" || e.status === "completed" || e.status === "stopped" || e.status === "amended") && (typeof e._status > "u" || i(e._status)) && (typeof e.subject > "u" || o(e.subject));
}
function by(n) {
  const e = n;
  return d(e) && r(e.language) && (typeof e.preferred > "u" || e.preferred === !1 || e.preferred === !0) && (typeof e._preferred > "u" || i(e._preferred));
}
function zt(n) {
  const e = n;
  return f(e) && e.resourceType === "RelatedPerson" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || i(e._active)) && (typeof e.address > "u" || Array.isArray(e.address) && e.address.every(
    (t) => h(t)
  )) && (typeof e.birthDate > "u" || typeof e.birthDate == "string") && (typeof e._birthDate > "u" || i(e._birthDate)) && (typeof e.communication > "u" || Array.isArray(e.communication) && e.communication.every(
    (t) => by(t)
  )) && (typeof e.gender > "u" || e.gender === "other" || e.gender === "unknown" || e.gender === "male" || e.gender === "female") && (typeof e._gender > "u" || i(e._gender)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.name > "u" || Array.isArray(e.name) && e.name.every(
    (t) => S(t)
  )) && o(e.patient) && (typeof e.period > "u" || y(e.period)) && (typeof e.photo > "u" || Array.isArray(e.photo) && e.photo.every(
    (t) => g(t)
  )) && (typeof e.relationship > "u" || Array.isArray(e.relationship) && e.relationship.every(
    (t) => r(t)
  )) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => I(t)
  ));
}
function Iy(n) {
  const e = n;
  return d(e) && (typeof e.expression > "u" || R(e.expression)) && (e.kind === "applicability" || e.kind === "start" || e.kind === "stop") && (typeof e._kind > "u" || i(e._kind));
}
function hy(n) {
  const e = n;
  return d(e) && typeof e.actionId == "string" && (typeof e._actionId > "u" || i(e._actionId)) && (typeof e.offsetDuration > "u" || _(e.offsetDuration)) && (typeof e.offsetRange > "u" || v(e.offsetRange)) && (e.relationship === "before-start" || e.relationship === "before" || e.relationship === "before-end" || e.relationship === "concurrent-with-start" || e.relationship === "concurrent" || e.relationship === "concurrent-with-end" || e.relationship === "after-start" || e.relationship === "after" || e.relationship === "after-end") && (typeof e._relationship > "u" || i(e._relationship));
}
function ui(n) {
  const e = n;
  return d(e) && (typeof e.action > "u" || Array.isArray(e.action) && e.action.every(
    (t) => ui(t)
  )) && (typeof e.cardinalityBehavior > "u" || e.cardinalityBehavior === "single" || e.cardinalityBehavior === "multiple") && (typeof e._cardinalityBehavior > "u" || i(e._cardinalityBehavior)) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => r(t)
  )) && (typeof e.condition > "u" || Array.isArray(e.condition) && e.condition.every(
    (t) => Iy(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.documentation > "u" || Array.isArray(e.documentation) && e.documentation.every(
    (t) => w(t)
  )) && (typeof e.groupingBehavior > "u" || e.groupingBehavior === "visual-group" || e.groupingBehavior === "logical-group" || e.groupingBehavior === "sentence-group") && (typeof e._groupingBehavior > "u" || i(e._groupingBehavior)) && (typeof e.participant > "u" || Array.isArray(e.participant) && e.participant.every(
    (t) => o(t)
  )) && (typeof e.precheckBehavior > "u" || e.precheckBehavior === "yes" || e.precheckBehavior === "no") && (typeof e._precheckBehavior > "u" || i(e._precheckBehavior)) && (typeof e.prefix > "u" || typeof e.prefix == "string") && (typeof e._prefix > "u" || i(e._prefix)) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || i(e._priority)) && (typeof e.relatedAction > "u" || Array.isArray(e.relatedAction) && e.relatedAction.every(
    (t) => hy(t)
  )) && (typeof e.requiredBehavior > "u" || e.requiredBehavior === "must" || e.requiredBehavior === "could" || e.requiredBehavior === "must-unless-documented") && (typeof e._requiredBehavior > "u" || i(e._requiredBehavior)) && (typeof e.resource > "u" || o(e.resource)) && (typeof e.selectionBehavior > "u" || e.selectionBehavior === "any" || e.selectionBehavior === "all" || e.selectionBehavior === "all-or-none" || e.selectionBehavior === "exactly-one" || e.selectionBehavior === "at-most-one" || e.selectionBehavior === "one-or-more") && (typeof e._selectionBehavior > "u" || i(e._selectionBehavior)) && (typeof e.textEquivalent > "u" || typeof e.textEquivalent == "string") && (typeof e._textEquivalent > "u" || i(e._textEquivalent)) && (typeof e.timingDateTime > "u" || typeof e.timingDateTime == "string") && (typeof e._timingDateTime > "u" || i(e._timingDateTime)) && (typeof e.timingAge > "u" || C(e.timingAge)) && (typeof e.timingPeriod > "u" || y(e.timingPeriod)) && (typeof e.timingDuration > "u" || _(e.timingDuration)) && (typeof e.timingRange > "u" || v(e.timingRange)) && (typeof e.timingTiming > "u" || A(e.timingTiming)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.type > "u" || r(e.type));
}
function Qt(n) {
  const e = n;
  return f(e) && e.resourceType === "RequestGroup" && (typeof e.action > "u" || Array.isArray(e.action) && e.action.every(
    (t) => ui(t)
  )) && (typeof e.author > "u" || o(e.author)) && (typeof e.authoredOn > "u" || typeof e.authoredOn == "string") && (typeof e._authoredOn > "u" || i(e._authoredOn)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.code > "u" || r(e.code)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.groupIdentifier > "u" || a(e.groupIdentifier)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => i(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => i(t)
  )) && (e.intent === "proposal" || e.intent === "plan" || e.intent === "directive" || e.intent === "order" || e.intent === "original-order" || e.intent === "reflex-order" || e.intent === "filler-order" || e.intent === "instance-order" || e.intent === "option") && (typeof e._intent > "u" || i(e._intent)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || i(e._priority)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.replaces > "u" || Array.isArray(e.replaces) && e.replaces.every(
    (t) => o(t)
  )) && (e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "draft" || e.status === "completed" || e.status === "revoked") && (typeof e._status > "u" || i(e._status)) && (typeof e.subject > "u" || o(e.subject));
}
function Wt(n) {
  const e = n;
  return f(e) && e.resourceType === "ResearchDefinition" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || i(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => p(t)
  )) && (typeof e.comment > "u" || Array.isArray(e.comment) && e.comment.every(
    (t) => typeof t == "string"
  )) && (typeof e._comment > "u" || Array.isArray(e._comment) && e._comment.every(
    (t) => i(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => p(t)
  )) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => p(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.exposure > "u" || o(e.exposure)) && (typeof e.exposureAlternative > "u" || o(e.exposureAlternative)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || i(e._lastReviewDate)) && (typeof e.library > "u" || Array.isArray(e.library) && e.library.every(
    (t) => typeof t == "string"
  )) && (typeof e._library > "u" || Array.isArray(e._library) && e._library.every(
    (t) => i(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.outcome > "u" || o(e.outcome)) && o(e.population) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => w(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => p(t)
  )) && (typeof e.shortTitle > "u" || typeof e.shortTitle == "string") && (typeof e._shortTitle > "u" || i(e._shortTitle)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.subjectCodeableConcept > "u" || r(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || o(e.subjectReference)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || i(e._subtitle)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => r(t)
  )) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.usage > "u" || typeof e.usage == "string") && (typeof e._usage > "u" || i(e._usage)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function wy(n) {
  const e = n;
  return d(e) && (typeof e.definitionCodeableConcept > "u" || r(e.definitionCodeableConcept)) && (typeof e.definitionCanonical > "u" || typeof e.definitionCanonical == "string") && (typeof e._definitionCanonical > "u" || i(e._definitionCanonical)) && (typeof e.definitionExpression > "u" || R(e.definitionExpression)) && (typeof e.definitionDataRequirement > "u" || D(e.definitionDataRequirement)) && (typeof e.exclude > "u" || e.exclude === !1 || e.exclude === !0) && (typeof e._exclude > "u" || i(e._exclude)) && (typeof e.participantEffectiveDateTime > "u" || typeof e.participantEffectiveDateTime == "string") && (typeof e._participantEffectiveDateTime > "u" || i(e._participantEffectiveDateTime)) && (typeof e.participantEffectivePeriod > "u" || y(e.participantEffectivePeriod)) && (typeof e.participantEffectiveDuration > "u" || _(e.participantEffectiveDuration)) && (typeof e.participantEffectiveTiming > "u" || A(e.participantEffectiveTiming)) && (typeof e.participantEffectiveDescription > "u" || typeof e.participantEffectiveDescription == "string") && (typeof e._participantEffectiveDescription > "u" || i(e._participantEffectiveDescription)) && (typeof e.participantEffectiveGroupMeasure > "u" || e.participantEffectiveGroupMeasure === "mean" || e.participantEffectiveGroupMeasure === "median" || e.participantEffectiveGroupMeasure === "mean-of-mean" || e.participantEffectiveGroupMeasure === "mean-of-median" || e.participantEffectiveGroupMeasure === "median-of-mean" || e.participantEffectiveGroupMeasure === "median-of-median") && (typeof e._participantEffectiveGroupMeasure > "u" || i(e._participantEffectiveGroupMeasure)) && (typeof e.participantEffectiveTimeFromStart > "u" || _(e.participantEffectiveTimeFromStart)) && (typeof e.studyEffectiveDateTime > "u" || typeof e.studyEffectiveDateTime == "string") && (typeof e._studyEffectiveDateTime > "u" || i(e._studyEffectiveDateTime)) && (typeof e.studyEffectivePeriod > "u" || y(e.studyEffectivePeriod)) && (typeof e.studyEffectiveDuration > "u" || _(e.studyEffectiveDuration)) && (typeof e.studyEffectiveTiming > "u" || A(e.studyEffectiveTiming)) && (typeof e.studyEffectiveDescription > "u" || typeof e.studyEffectiveDescription == "string") && (typeof e._studyEffectiveDescription > "u" || i(e._studyEffectiveDescription)) && (typeof e.studyEffectiveGroupMeasure > "u" || e.studyEffectiveGroupMeasure === "mean" || e.studyEffectiveGroupMeasure === "median" || e.studyEffectiveGroupMeasure === "mean-of-mean" || e.studyEffectiveGroupMeasure === "mean-of-median" || e.studyEffectiveGroupMeasure === "median-of-mean" || e.studyEffectiveGroupMeasure === "median-of-median") && (typeof e._studyEffectiveGroupMeasure > "u" || i(e._studyEffectiveGroupMeasure)) && (typeof e.studyEffectiveTimeFromStart > "u" || _(e.studyEffectiveTimeFromStart)) && (typeof e.unitOfMeasure > "u" || r(e.unitOfMeasure)) && (typeof e.usageContext > "u" || Array.isArray(e.usageContext) && e.usageContext.every(
    (t) => m(t)
  ));
}
function Kt(n) {
  const e = n;
  return f(e) && e.resourceType === "ResearchElementDefinition" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || i(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => p(t)
  )) && Array.isArray(e.characteristic) && e.characteristic.every(
    (t) => wy(t)
  ) && (typeof e.comment > "u" || Array.isArray(e.comment) && e.comment.every(
    (t) => typeof t == "string"
  )) && (typeof e._comment > "u" || Array.isArray(e._comment) && e._comment.every(
    (t) => i(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => p(t)
  )) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => p(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || i(e._lastReviewDate)) && (typeof e.library > "u" || Array.isArray(e.library) && e.library.every(
    (t) => typeof t == "string"
  )) && (typeof e._library > "u" || Array.isArray(e._library) && e._library.every(
    (t) => i(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => w(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => p(t)
  )) && (typeof e.shortTitle > "u" || typeof e.shortTitle == "string") && (typeof e._shortTitle > "u" || i(e._shortTitle)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.subjectCodeableConcept > "u" || r(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || o(e.subjectReference)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || i(e._subtitle)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => r(t)
  )) && (e.type === "outcome" || e.type === "exposure" || e.type === "population") && (typeof e._type > "u" || i(e._type)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.usage > "u" || typeof e.usage == "string") && (typeof e._usage > "u" || i(e._usage)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.variableType > "u" || e.variableType === "dichotomous" || e.variableType === "continuous" || e.variableType === "descriptive") && (typeof e._variableType > "u" || i(e._variableType)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function Ry(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.type > "u" || r(e.type));
}
function Cy(n) {
  const e = n;
  return d(e) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.type > "u" || r(e.type));
}
function Jt(n) {
  const e = n;
  return f(e) && e.resourceType === "ResearchStudy" && (typeof e.arm > "u" || Array.isArray(e.arm) && e.arm.every(
    (t) => Ry(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && (typeof e.condition > "u" || Array.isArray(e.condition) && e.condition.every(
    (t) => r(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.enrollment > "u" || Array.isArray(e.enrollment) && e.enrollment.every(
    (t) => o(t)
  )) && (typeof e.focus > "u" || Array.isArray(e.focus) && e.focus.every(
    (t) => r(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.keyword > "u" || Array.isArray(e.keyword) && e.keyword.every(
    (t) => r(t)
  )) && (typeof e.location > "u" || Array.isArray(e.location) && e.location.every(
    (t) => r(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.objective > "u" || Array.isArray(e.objective) && e.objective.every(
    (t) => Cy(t)
  )) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => o(t)
  )) && (typeof e.period > "u" || y(e.period)) && (typeof e.phase > "u" || r(e.phase)) && (typeof e.primaryPurposeType > "u" || r(e.primaryPurposeType)) && (typeof e.principalInvestigator > "u" || o(e.principalInvestigator)) && (typeof e.protocol > "u" || Array.isArray(e.protocol) && e.protocol.every(
    (t) => o(t)
  )) && (typeof e.reasonStopped > "u" || r(e.reasonStopped)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => w(t)
  )) && (typeof e.site > "u" || Array.isArray(e.site) && e.site.every(
    (t) => o(t)
  )) && (typeof e.sponsor > "u" || o(e.sponsor)) && (e.status === "active" || e.status === "completed" || e.status === "administratively-completed" || e.status === "approved" || e.status === "closed-to-accrual" || e.status === "closed-to-accrual-and-intervention" || e.status === "disapproved" || e.status === "in-review" || e.status === "temporarily-closed-to-accrual" || e.status === "temporarily-closed-to-accrual-and-intervention" || e.status === "withdrawn") && (typeof e._status > "u" || i(e._status)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title));
}
function Xt(n) {
  const e = n;
  return f(e) && e.resourceType === "ResearchSubject" && (typeof e.actualArm > "u" || typeof e.actualArm == "string") && (typeof e._actualArm > "u" || i(e._actualArm)) && (typeof e.assignedArm > "u" || typeof e.assignedArm == "string") && (typeof e._assignedArm > "u" || i(e._assignedArm)) && (typeof e.consent > "u" || o(e.consent)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && o(e.individual) && (typeof e.period > "u" || y(e.period)) && (e.status === "withdrawn" || e.status === "candidate" || e.status === "eligible" || e.status === "follow-up" || e.status === "ineligible" || e.status === "not-registered" || e.status === "off-study" || e.status === "on-study" || e.status === "on-study-intervention" || e.status === "on-study-observation" || e.status === "pending-on-study" || e.status === "potential-candidate" || e.status === "screening") && (typeof e._status > "u" || i(e._status)) && o(e.study);
}
function Yt(n) {
  const e = n;
  return (e !== null && typeof e == "object" || typeof e == "function") && typeof e.resourceType == "string" && (typeof e.id > "u" || typeof e.id == "string") && (typeof e._id > "u" || i(e._id)) && (typeof e.implicitRules > "u" || typeof e.implicitRules == "string") && (typeof e._implicitRules > "u" || i(e._implicitRules)) && (typeof e.language > "u" || typeof e.language == "string") && (typeof e._language > "u" || i(e._language)) && (typeof e.meta > "u" || j(e.meta));
}
function Dy(n) {
  const e = n;
  return d(e) && (typeof e.outcome > "u" || r(e.outcome)) && (typeof e.probabilityDecimal > "u" || typeof e.probabilityDecimal == "number") && (typeof e.probabilityRange > "u" || v(e.probabilityRange)) && (typeof e.qualitativeRisk > "u" || r(e.qualitativeRisk)) && (typeof e.rationale > "u" || typeof e.rationale == "string") && (typeof e._rationale > "u" || i(e._rationale)) && (typeof e.relativeRisk > "u" || typeof e.relativeRisk == "number") && (typeof e.whenPeriod > "u" || y(e.whenPeriod)) && (typeof e.whenRange > "u" || v(e.whenRange));
}
function Zt(n) {
  const e = n;
  return f(e) && e.resourceType === "RiskAssessment" && (typeof e.basedOn > "u" || o(e.basedOn)) && (typeof e.basis > "u" || Array.isArray(e.basis) && e.basis.every(
    (t) => o(t)
  )) && (typeof e.code > "u" || r(e.code)) && (typeof e.condition > "u" || o(e.condition)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.method > "u" || r(e.method)) && (typeof e.mitigation > "u" || typeof e.mitigation == "string") && (typeof e._mitigation > "u" || i(e._mitigation)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || i(e._occurrenceDateTime)) && (typeof e.occurrencePeriod > "u" || y(e.occurrencePeriod)) && (typeof e.parent > "u" || o(e.parent)) && (typeof e.performer > "u" || o(e.performer)) && (typeof e.prediction > "u" || Array.isArray(e.prediction) && e.prediction.every(
    (t) => Dy(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (e.status === "entered-in-error" || e.status === "unknown" || e.status === "cancelled" || e.status === "preliminary" || e.status === "final" || e.status === "amended" || e.status === "registered" || e.status === "corrected") && (typeof e._status > "u" || i(e._status)) && o(e.subject);
}
function Sy(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.numberOfParticipants > "u" || typeof e.numberOfParticipants == "number") && (typeof e.numberOfStudies > "u" || typeof e.numberOfStudies == "number");
}
function Oy(n) {
  const e = n;
  return d(e) && (typeof e.from > "u" || typeof e.from == "number") && (typeof e.level > "u" || typeof e.level == "number") && (typeof e.to > "u" || typeof e.to == "number") && (typeof e.type > "u" || r(e.type));
}
function Ey(n) {
  const e = n;
  return d(e) && (typeof e.denominatorCount > "u" || typeof e.denominatorCount == "number") && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.numeratorCount > "u" || typeof e.numeratorCount == "number") && (typeof e.precisionEstimate > "u" || Array.isArray(e.precisionEstimate) && e.precisionEstimate.every(
    (t) => Oy(t)
  )) && (typeof e.type > "u" || r(e.type)) && (typeof e.unitOfMeasure > "u" || r(e.unitOfMeasure)) && (typeof e.value > "u" || typeof e.value == "number");
}
function Ty(n) {
  const e = n;
  return d(e) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.rating > "u" || Array.isArray(e.rating) && e.rating.every(
    (t) => r(t)
  )) && (typeof e.type > "u" || r(e.type));
}
function xy(n) {
  const e = n;
  return d(e) && (typeof e.certaintySubcomponent > "u" || Array.isArray(e.certaintySubcomponent) && e.certaintySubcomponent.every(
    (t) => Ty(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.rating > "u" || Array.isArray(e.rating) && e.rating.every(
    (t) => r(t)
  ));
}
function $t(n) {
  const e = n;
  return f(e) && e.resourceType === "RiskEvidenceSynthesis" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || i(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => p(t)
  )) && (typeof e.certainty > "u" || Array.isArray(e.certainty) && e.certainty.every(
    (t) => xy(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => p(t)
  )) && (typeof e.effectivePeriod > "u" || y(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => p(t)
  )) && (typeof e.exposure > "u" || o(e.exposure)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || i(e._lastReviewDate)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && o(e.outcome) && o(e.population) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => w(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => p(t)
  )) && (typeof e.riskEstimate > "u" || Ey(e.riskEstimate)) && (typeof e.sampleSize > "u" || Sy(e.sampleSize)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.studyType > "u" || r(e.studyType)) && (typeof e.synthesisType > "u" || r(e.synthesisType)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => r(t)
  )) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function en(n) {
  const e = n;
  return f(e) && e.resourceType === "Schedule" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || i(e._active)) && Array.isArray(e.actor) && e.actor.every(
    (t) => o(t)
  ) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.planningHorizon > "u" || y(e.planningHorizon)) && (typeof e.serviceCategory > "u" || Array.isArray(e.serviceCategory) && e.serviceCategory.every(
    (t) => r(t)
  )) && (typeof e.serviceType > "u" || Array.isArray(e.serviceType) && e.serviceType.every(
    (t) => r(t)
  )) && (typeof e.specialty > "u" || Array.isArray(e.specialty) && e.specialty.every(
    (t) => r(t)
  ));
}
function jy(n) {
  const e = n;
  return d(e) && typeof e.definition == "string" && (typeof e._definition > "u" || i(e._definition)) && typeof e.expression == "string" && (typeof e._expression > "u" || i(e._expression));
}
function tn(n) {
  const e = n;
  return f(e) && e.resourceType === "SearchParameter" && Array.isArray(e.base) && e.base.every(
    (t) => typeof t == "string"
  ) && (typeof e._base > "u" || Array.isArray(e._base) && e._base.every(
    (t) => i(t)
  )) && (typeof e.chain > "u" || Array.isArray(e.chain) && e.chain.every(
    (t) => typeof t == "string"
  )) && (typeof e._chain > "u" || Array.isArray(e._chain) && e._chain.every(
    (t) => i(t)
  )) && typeof e.code == "string" && (typeof e._code > "u" || i(e._code)) && (typeof e.comparator > "u" || Array.isArray(e.comparator) && e.comparator.every(
    (t) => t === "eq" || t === "ne" || t === "gt" || t === "lt" || t === "ge" || t === "le" || t === "sa" || t === "eb" || t === "ap"
  )) && (typeof e._comparator > "u" || Array.isArray(e._comparator) && e._comparator.every(
    (t) => i(t)
  )) && (typeof e.component > "u" || Array.isArray(e.component) && e.component.every(
    (t) => jy(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.derivedFrom > "u" || typeof e.derivedFrom == "string") && (typeof e._derivedFrom > "u" || i(e._derivedFrom)) && typeof e.description == "string" && (typeof e._description > "u" || i(e._description)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.expression > "u" || typeof e.expression == "string") && (typeof e._expression > "u" || i(e._expression)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => t === "type" || t === "in" || t === "not-in" || t === "identifier" || t === "text" || t === "missing" || t === "exact" || t === "contains" || t === "not" || t === "below" || t === "above" || t === "ofType"
  )) && (typeof e._modifier > "u" || Array.isArray(e._modifier) && e._modifier.every(
    (t) => i(t)
  )) && (typeof e.multipleAnd > "u" || e.multipleAnd === !1 || e.multipleAnd === !0) && (typeof e._multipleAnd > "u" || i(e._multipleAnd)) && (typeof e.multipleOr > "u" || e.multipleOr === !1 || e.multipleOr === !0) && (typeof e._multipleOr > "u" || i(e._multipleOr)) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.target > "u" || Array.isArray(e.target) && e.target.every(
    (t) => typeof t == "string"
  )) && (typeof e._target > "u" || Array.isArray(e._target) && e._target.every(
    (t) => i(t)
  )) && (e.type === "string" || e.type === "number" || e.type === "date" || e.type === "token" || e.type === "reference" || e.type === "composite" || e.type === "quantity" || e.type === "uri" || e.type === "special") && (typeof e._type > "u" || i(e._type)) && typeof e.url == "string" && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version)) && (typeof e.xpath > "u" || typeof e.xpath == "string") && (typeof e._xpath > "u" || i(e._xpath)) && (typeof e.xpathUsage > "u" || e.xpathUsage === "other" || e.xpathUsage === "normal" || e.xpathUsage === "phonetic" || e.xpathUsage === "nearby" || e.xpathUsage === "distance") && (typeof e._xpathUsage > "u" || i(e._xpathUsage));
}
function nn(n) {
  const e = n;
  return f(e) && e.resourceType === "ServiceRequest" && (typeof e.asNeededBoolean > "u" || e.asNeededBoolean === !1 || e.asNeededBoolean === !0) && (typeof e._asNeededBoolean > "u" || i(e._asNeededBoolean)) && (typeof e.asNeededCodeableConcept > "u" || r(e.asNeededCodeableConcept)) && (typeof e.authoredOn > "u" || typeof e.authoredOn == "string") && (typeof e._authoredOn > "u" || i(e._authoredOn)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.bodySite > "u" || Array.isArray(e.bodySite) && e.bodySite.every(
    (t) => r(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && (typeof e.code > "u" || r(e.code)) && (typeof e.doNotPerform > "u" || e.doNotPerform === !1 || e.doNotPerform === !0) && (typeof e._doNotPerform > "u" || i(e._doNotPerform)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => i(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => i(t)
  )) && (typeof e.insurance > "u" || Array.isArray(e.insurance) && e.insurance.every(
    (t) => o(t)
  )) && (e.intent === "proposal" || e.intent === "plan" || e.intent === "directive" || e.intent === "order" || e.intent === "original-order" || e.intent === "reflex-order" || e.intent === "filler-order" || e.intent === "instance-order" || e.intent === "option") && (typeof e._intent > "u" || i(e._intent)) && (typeof e.locationCode > "u" || Array.isArray(e.locationCode) && e.locationCode.every(
    (t) => r(t)
  )) && (typeof e.locationReference > "u" || Array.isArray(e.locationReference) && e.locationReference.every(
    (t) => o(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || i(e._occurrenceDateTime)) && (typeof e.occurrencePeriod > "u" || y(e.occurrencePeriod)) && (typeof e.occurrenceTiming > "u" || A(e.occurrenceTiming)) && (typeof e.orderDetail > "u" || Array.isArray(e.orderDetail) && e.orderDetail.every(
    (t) => r(t)
  )) && (typeof e.patientInstruction > "u" || typeof e.patientInstruction == "string") && (typeof e._patientInstruction > "u" || i(e._patientInstruction)) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => o(t)
  )) && (typeof e.performerType > "u" || r(e.performerType)) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || i(e._priority)) && (typeof e.quantityQuantity > "u" || u(e.quantityQuantity)) && (typeof e.quantityRatio > "u" || b(e.quantityRatio)) && (typeof e.quantityRange > "u" || v(e.quantityRange)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.relevantHistory > "u" || Array.isArray(e.relevantHistory) && e.relevantHistory.every(
    (t) => o(t)
  )) && (typeof e.replaces > "u" || Array.isArray(e.replaces) && e.replaces.every(
    (t) => o(t)
  )) && (typeof e.requester > "u" || o(e.requester)) && (typeof e.requisition > "u" || a(e.requisition)) && (typeof e.specimen > "u" || Array.isArray(e.specimen) && e.specimen.every(
    (t) => o(t)
  )) && (e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "draft" || e.status === "completed" || e.status === "revoked") && (typeof e._status > "u" || i(e._status)) && o(e.subject) && (typeof e.supportingInfo > "u" || Array.isArray(e.supportingInfo) && e.supportingInfo.every(
    (t) => o(t)
  ));
}
function rn(n) {
  const e = n;
  return f(e) && e.resourceType === "Slot" && (typeof e.appointmentType > "u" || r(e.appointmentType)) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment)) && typeof e.end == "string" && (typeof e._end > "u" || i(e._end)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.overbooked > "u" || e.overbooked === !1 || e.overbooked === !0) && (typeof e._overbooked > "u" || i(e._overbooked)) && o(e.schedule) && (typeof e.serviceCategory > "u" || Array.isArray(e.serviceCategory) && e.serviceCategory.every(
    (t) => r(t)
  )) && (typeof e.serviceType > "u" || Array.isArray(e.serviceType) && e.serviceType.every(
    (t) => r(t)
  )) && (typeof e.specialty > "u" || Array.isArray(e.specialty) && e.specialty.every(
    (t) => r(t)
  )) && typeof e.start == "string" && (typeof e._start > "u" || i(e._start)) && (e.status === "entered-in-error" || e.status === "busy" || e.status === "free" || e.status === "busy-unavailable" || e.status === "busy-tentative") && (typeof e._status > "u" || i(e._status));
}
function Py(n) {
  const e = n;
  return d(e) && (typeof e.bodySite > "u" || r(e.bodySite)) && (typeof e.collectedDateTime > "u" || typeof e.collectedDateTime == "string") && (typeof e._collectedDateTime > "u" || i(e._collectedDateTime)) && (typeof e.collectedPeriod > "u" || y(e.collectedPeriod)) && (typeof e.collector > "u" || o(e.collector)) && (typeof e.duration > "u" || _(e.duration)) && (typeof e.fastingStatusCodeableConcept > "u" || r(e.fastingStatusCodeableConcept)) && (typeof e.fastingStatusDuration > "u" || _(e.fastingStatusDuration)) && (typeof e.method > "u" || r(e.method)) && (typeof e.quantity > "u" || u(e.quantity));
}
function Fy(n) {
  const e = n;
  return d(e) && (typeof e.additive > "u" || Array.isArray(e.additive) && e.additive.every(
    (t) => o(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.procedure > "u" || r(e.procedure)) && (typeof e.timeDateTime > "u" || typeof e.timeDateTime == "string") && (typeof e._timeDateTime > "u" || i(e._timeDateTime)) && (typeof e.timePeriod > "u" || y(e.timePeriod));
}
function Hy(n) {
  const e = n;
  return d(e) && (typeof e.additiveCodeableConcept > "u" || r(e.additiveCodeableConcept)) && (typeof e.additiveReference > "u" || o(e.additiveReference)) && (typeof e.capacity > "u" || u(e.capacity)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.specimenQuantity > "u" || u(e.specimenQuantity)) && (typeof e.type > "u" || r(e.type));
}
function on(n) {
  const e = n;
  return f(e) && e.resourceType === "Specimen" && (typeof e.accessionIdentifier > "u" || a(e.accessionIdentifier)) && (typeof e.collection > "u" || Py(e.collection)) && (typeof e.condition > "u" || Array.isArray(e.condition) && e.condition.every(
    (t) => r(t)
  )) && (typeof e.container > "u" || Array.isArray(e.container) && e.container.every(
    (t) => Hy(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.parent > "u" || Array.isArray(e.parent) && e.parent.every(
    (t) => o(t)
  )) && (typeof e.processing > "u" || Array.isArray(e.processing) && e.processing.every(
    (t) => Fy(t)
  )) && (typeof e.receivedTime > "u" || typeof e.receivedTime == "string") && (typeof e._receivedTime > "u" || i(e._receivedTime)) && (typeof e.request > "u" || Array.isArray(e.request) && e.request.every(
    (t) => o(t)
  )) && (typeof e.status > "u" || e.status === "entered-in-error" || e.status === "available" || e.status === "unavailable" || e.status === "unsatisfactory") && (typeof e._status > "u" || i(e._status)) && (typeof e.subject > "u" || o(e.subject)) && (typeof e.type > "u" || r(e.type));
}
function My(n) {
  const e = n;
  return d(e) && (typeof e.additiveCodeableConcept > "u" || r(e.additiveCodeableConcept)) && (typeof e.additiveReference > "u" || o(e.additiveReference));
}
function qy(n) {
  const e = n;
  return d(e) && (typeof e.additive > "u" || Array.isArray(e.additive) && e.additive.every(
    (t) => My(t)
  )) && (typeof e.cap > "u" || r(e.cap)) && (typeof e.capacity > "u" || u(e.capacity)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.material > "u" || r(e.material)) && (typeof e.minimumVolumeQuantity > "u" || u(e.minimumVolumeQuantity)) && (typeof e.minimumVolumeString > "u" || typeof e.minimumVolumeString == "string") && (typeof e._minimumVolumeString > "u" || i(e._minimumVolumeString)) && (typeof e.preparation > "u" || typeof e.preparation == "string") && (typeof e._preparation > "u" || i(e._preparation)) && (typeof e.type > "u" || r(e.type));
}
function ky(n) {
  const e = n;
  return d(e) && (typeof e.instruction > "u" || typeof e.instruction == "string") && (typeof e._instruction > "u" || i(e._instruction)) && (typeof e.maxDuration > "u" || _(e.maxDuration)) && (typeof e.temperatureQualifier > "u" || r(e.temperatureQualifier)) && (typeof e.temperatureRange > "u" || v(e.temperatureRange));
}
function By(n) {
  const e = n;
  return d(e) && (typeof e.container > "u" || qy(e.container)) && (typeof e.handling > "u" || Array.isArray(e.handling) && e.handling.every(
    (t) => ky(t)
  )) && (typeof e.isDerived > "u" || e.isDerived === !1 || e.isDerived === !0) && (typeof e._isDerived > "u" || i(e._isDerived)) && (e.preference === "preferred" || e.preference === "alternate") && (typeof e._preference > "u" || i(e._preference)) && (typeof e.rejectionCriterion > "u" || Array.isArray(e.rejectionCriterion) && e.rejectionCriterion.every(
    (t) => r(t)
  )) && (typeof e.requirement > "u" || typeof e.requirement == "string") && (typeof e._requirement > "u" || i(e._requirement)) && (typeof e.retentionTime > "u" || _(e.retentionTime)) && (typeof e.type > "u" || r(e.type));
}
function dn(n) {
  const e = n;
  return f(e) && e.resourceType === "SpecimenDefinition" && (typeof e.collection > "u" || Array.isArray(e.collection) && e.collection.every(
    (t) => r(t)
  )) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.patientPreparation > "u" || Array.isArray(e.patientPreparation) && e.patientPreparation.every(
    (t) => r(t)
  )) && (typeof e.timeAspect > "u" || typeof e.timeAspect == "string") && (typeof e._timeAspect > "u" || i(e._timeAspect)) && (typeof e.typeCollected > "u" || r(e.typeCollected)) && (typeof e.typeTested > "u" || Array.isArray(e.typeTested) && e.typeTested.every(
    (t) => By(t)
  ));
}
function Vy(n) {
  const e = n;
  return d(e) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment)) && typeof e.identity == "string" && (typeof e._identity > "u" || i(e._identity)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.uri > "u" || typeof e.uri == "string") && (typeof e._uri > "u" || i(e._uri));
}
function Uy(n) {
  const e = n;
  return d(e) && typeof e.expression == "string" && (typeof e._expression > "u" || i(e._expression)) && (e.type === "fhirpath" || e.type === "element" || e.type === "extension") && (typeof e._type > "u" || i(e._type));
}
function Ny(n) {
  const e = n;
  return d(e) && Array.isArray(e.element) && e.element.every(
    (t) => qn(t)
  );
}
function Ly(n) {
  const e = n;
  return d(e) && Array.isArray(e.element) && e.element.every(
    (t) => qn(t)
  );
}
function an(n) {
  const e = n;
  return f(e) && e.resourceType === "StructureDefinition" && typeof e.abstract == "boolean" && (typeof e._abstract > "u" || i(e._abstract)) && (typeof e.baseDefinition > "u" || typeof e.baseDefinition == "string") && (typeof e._baseDefinition > "u" || i(e._baseDefinition)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.context > "u" || Array.isArray(e.context) && e.context.every(
    (t) => Uy(t)
  )) && (typeof e.contextInvariant > "u" || Array.isArray(e.contextInvariant) && e.contextInvariant.every(
    (t) => typeof t == "string"
  )) && (typeof e._contextInvariant > "u" || Array.isArray(e._contextInvariant) && e._contextInvariant.every(
    (t) => i(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.derivation > "u" || e.derivation === "specialization" || e.derivation === "constraint") && (typeof e._derivation > "u" || i(e._derivation)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.differential > "u" || Ly(e.differential)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.fhirVersion > "u" || typeof e.fhirVersion == "string") && (typeof e._fhirVersion > "u" || i(e._fhirVersion)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.keyword > "u" || Array.isArray(e.keyword) && e.keyword.every(
    (t) => s(t)
  )) && (e.kind === "logical" || e.kind === "primitive-type" || e.kind === "complex-type" || e.kind === "resource") && (typeof e._kind > "u" || i(e._kind)) && (typeof e.mapping > "u" || Array.isArray(e.mapping) && e.mapping.every(
    (t) => Vy(t)
  )) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (typeof e.snapshot > "u" || Ny(e.snapshot)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && typeof e.type == "string" && (typeof e._type > "u" || i(e._type)) && typeof e.url == "string" && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function Gy(n) {
  const e = n;
  return d(e) && (typeof e.alias > "u" || typeof e.alias == "string") && (typeof e._alias > "u" || i(e._alias)) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || i(e._documentation)) && (e.mode === "source" || e.mode === "queried" || e.mode === "target" || e.mode === "produced") && (typeof e._mode > "u" || i(e._mode)) && typeof e.url == "string" && (typeof e._url > "u" || i(e._url));
}
function zy(n) {
  const e = n;
  return d(e) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || i(e._documentation)) && (e.mode === "source" || e.mode === "target") && (typeof e._mode > "u" || i(e._mode)) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.type > "u" || typeof e.type == "string") && (typeof e._type > "u" || i(e._type));
}
function Qy(n) {
  const e = n;
  return d(e) && (typeof e.check > "u" || typeof e.check == "string") && (typeof e._check > "u" || i(e._check)) && (typeof e.condition > "u" || typeof e.condition == "string") && (typeof e._condition > "u" || i(e._condition)) && typeof e.context == "string" && (typeof e._context > "u" || i(e._context)) && (typeof e.defaultValueBase64Binary > "u" || typeof e.defaultValueBase64Binary == "string") && (typeof e._defaultValueBase64Binary > "u" || i(e._defaultValueBase64Binary)) && (typeof e.defaultValueBoolean > "u" || e.defaultValueBoolean === !1 || e.defaultValueBoolean === !0) && (typeof e._defaultValueBoolean > "u" || i(e._defaultValueBoolean)) && (typeof e.defaultValueCanonical > "u" || typeof e.defaultValueCanonical == "string") && (typeof e._defaultValueCanonical > "u" || i(e._defaultValueCanonical)) && (typeof e.defaultValueCode > "u" || typeof e.defaultValueCode == "string") && (typeof e._defaultValueCode > "u" || i(e._defaultValueCode)) && (typeof e.defaultValueDate > "u" || typeof e.defaultValueDate == "string") && (typeof e._defaultValueDate > "u" || i(e._defaultValueDate)) && (typeof e.defaultValueDateTime > "u" || typeof e.defaultValueDateTime == "string") && (typeof e._defaultValueDateTime > "u" || i(e._defaultValueDateTime)) && (typeof e.defaultValueDecimal > "u" || typeof e.defaultValueDecimal == "number") && (typeof e.defaultValueId > "u" || typeof e.defaultValueId == "string") && (typeof e._defaultValueId > "u" || i(e._defaultValueId)) && (typeof e.defaultValueInstant > "u" || typeof e.defaultValueInstant == "string") && (typeof e._defaultValueInstant > "u" || i(e._defaultValueInstant)) && (typeof e.defaultValueInteger > "u" || typeof e.defaultValueInteger == "number") && (typeof e.defaultValueMarkdown > "u" || typeof e.defaultValueMarkdown == "string") && (typeof e._defaultValueMarkdown > "u" || i(e._defaultValueMarkdown)) && (typeof e.defaultValueOid > "u" || typeof e.defaultValueOid == "string") && (typeof e._defaultValueOid > "u" || i(e._defaultValueOid)) && (typeof e.defaultValuePositiveInt > "u" || typeof e.defaultValuePositiveInt == "number") && (typeof e.defaultValueString > "u" || typeof e.defaultValueString == "string") && (typeof e._defaultValueString > "u" || i(e._defaultValueString)) && (typeof e.defaultValueTime > "u" || typeof e.defaultValueTime == "string") && (typeof e._defaultValueTime > "u" || i(e._defaultValueTime)) && (typeof e.defaultValueUnsignedInt > "u" || typeof e.defaultValueUnsignedInt == "number") && (typeof e.defaultValueUri > "u" || typeof e.defaultValueUri == "string") && (typeof e._defaultValueUri > "u" || i(e._defaultValueUri)) && (typeof e.defaultValueUrl > "u" || typeof e.defaultValueUrl == "string") && (typeof e._defaultValueUrl > "u" || i(e._defaultValueUrl)) && (typeof e.defaultValueUuid > "u" || typeof e.defaultValueUuid == "string") && (typeof e._defaultValueUuid > "u" || i(e._defaultValueUuid)) && (typeof e.defaultValueAddress > "u" || h(e.defaultValueAddress)) && (typeof e.defaultValueAge > "u" || C(e.defaultValueAge)) && (typeof e.defaultValueAnnotation > "u" || l(e.defaultValueAnnotation)) && (typeof e.defaultValueAttachment > "u" || g(e.defaultValueAttachment)) && (typeof e.defaultValueCodeableConcept > "u" || r(e.defaultValueCodeableConcept)) && (typeof e.defaultValueCoding > "u" || s(e.defaultValueCoding)) && (typeof e.defaultValueContactPoint > "u" || I(e.defaultValueContactPoint)) && (typeof e.defaultValueCount > "u" || H(e.defaultValueCount)) && (typeof e.defaultValueDistance > "u" || M(e.defaultValueDistance)) && (typeof e.defaultValueDuration > "u" || _(e.defaultValueDuration)) && (typeof e.defaultValueHumanName > "u" || S(e.defaultValueHumanName)) && (typeof e.defaultValueIdentifier > "u" || a(e.defaultValueIdentifier)) && (typeof e.defaultValueMoney > "u" || c(e.defaultValueMoney)) && (typeof e.defaultValuePeriod > "u" || y(e.defaultValuePeriod)) && (typeof e.defaultValueQuantity > "u" || u(e.defaultValueQuantity)) && (typeof e.defaultValueRange > "u" || v(e.defaultValueRange)) && (typeof e.defaultValueRatio > "u" || b(e.defaultValueRatio)) && (typeof e.defaultValueReference > "u" || o(e.defaultValueReference)) && (typeof e.defaultValueSampledData > "u" || x(e.defaultValueSampledData)) && (typeof e.defaultValueSignature > "u" || O(e.defaultValueSignature)) && (typeof e.defaultValueTiming > "u" || A(e.defaultValueTiming)) && (typeof e.defaultValueContactDetail > "u" || p(e.defaultValueContactDetail)) && (typeof e.defaultValueContributor > "u" || F(e.defaultValueContributor)) && (typeof e.defaultValueDataRequirement > "u" || D(e.defaultValueDataRequirement)) && (typeof e.defaultValueExpression > "u" || R(e.defaultValueExpression)) && (typeof e.defaultValueParameterDefinition > "u" || P(e.defaultValueParameterDefinition)) && (typeof e.defaultValueRelatedArtifact > "u" || w(e.defaultValueRelatedArtifact)) && (typeof e.defaultValueTriggerDefinition > "u" || T(e.defaultValueTriggerDefinition)) && (typeof e.defaultValueUsageContext > "u" || m(e.defaultValueUsageContext)) && (typeof e.defaultValueDosage > "u" || E(e.defaultValueDosage)) && (typeof e.defaultValueMeta > "u" || j(e.defaultValueMeta)) && (typeof e.element > "u" || typeof e.element == "string") && (typeof e._element > "u" || i(e._element)) && (typeof e.listMode > "u" || e.listMode === "first" || e.listMode === "not_first" || e.listMode === "last" || e.listMode === "not_last" || e.listMode === "only_one") && (typeof e._listMode > "u" || i(e._listMode)) && (typeof e.logMessage > "u" || typeof e.logMessage == "string") && (typeof e._logMessage > "u" || i(e._logMessage)) && (typeof e.max > "u" || typeof e.max == "string") && (typeof e._max > "u" || i(e._max)) && (typeof e.min > "u" || typeof e.min == "number") && (typeof e.type > "u" || typeof e.type == "string") && (typeof e._type > "u" || i(e._type)) && (typeof e.variable > "u" || typeof e.variable == "string") && (typeof e._variable > "u" || i(e._variable));
}
function Wy(n) {
  const e = n;
  return d(e) && (typeof e.valueId > "u" || typeof e.valueId == "string") && (typeof e._valueId > "u" || i(e._valueId)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number");
}
function Ky(n) {
  const e = n;
  return d(e) && (typeof e.context > "u" || typeof e.context == "string") && (typeof e._context > "u" || i(e._context)) && (typeof e.contextType > "u" || e.contextType === "type" || e.contextType === "variable") && (typeof e._contextType > "u" || i(e._contextType)) && (typeof e.element > "u" || typeof e.element == "string") && (typeof e._element > "u" || i(e._element)) && (typeof e.listMode > "u" || Array.isArray(e.listMode) && e.listMode.every(
    (t) => t === "first" || t === "last" || t === "share" || t === "collate"
  )) && (typeof e._listMode > "u" || Array.isArray(e._listMode) && e._listMode.every(
    (t) => i(t)
  )) && (typeof e.listRuleId > "u" || typeof e.listRuleId == "string") && (typeof e._listRuleId > "u" || i(e._listRuleId)) && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => Wy(t)
  )) && (typeof e.transform > "u" || e.transform === "create" || e.transform === "reference" || e.transform === "uuid" || e.transform === "copy" || e.transform === "truncate" || e.transform === "escape" || e.transform === "cast" || e.transform === "append" || e.transform === "translate" || e.transform === "dateOp" || e.transform === "pointer" || e.transform === "evaluate" || e.transform === "cc" || e.transform === "c" || e.transform === "qty" || e.transform === "id" || e.transform === "cp") && (typeof e._transform > "u" || i(e._transform)) && (typeof e.variable > "u" || typeof e.variable == "string") && (typeof e._variable > "u" || i(e._variable));
}
function Jy(n) {
  const e = n;
  return d(e) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && Array.isArray(e.variable) && e.variable.every(
    (t) => typeof t == "string"
  ) && (typeof e._variable > "u" || Array.isArray(e._variable) && e._variable.every(
    (t) => i(t)
  ));
}
function pi(n) {
  const e = n;
  return d(e) && (typeof e.dependent > "u" || Array.isArray(e.dependent) && e.dependent.every(
    (t) => Jy(t)
  )) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || i(e._documentation)) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.rule > "u" || Array.isArray(e.rule) && e.rule.every(
    (t) => pi(t)
  )) && Array.isArray(e.source) && e.source.every(
    (t) => Qy(t)
  ) && (typeof e.target > "u" || Array.isArray(e.target) && e.target.every(
    (t) => Ky(t)
  ));
}
function Xy(n) {
  const e = n;
  return d(e) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || i(e._documentation)) && (typeof e.extends > "u" || typeof e.extends == "string") && (typeof e._extends > "u" || i(e._extends)) && Array.isArray(e.input) && e.input.every(
    (t) => zy(t)
  ) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && Array.isArray(e.rule) && e.rule.every(
    (t) => pi(t)
  ) && (e.typeMode === "none" || e.typeMode === "types" || e.typeMode === "type-and-types") && (typeof e._typeMode > "u" || i(e._typeMode));
}
function fn(n) {
  const e = n;
  return f(e) && e.resourceType === "StructureMap" && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && Array.isArray(e.group) && e.group.every(
    (t) => Xy(t)
  ) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.import > "u" || Array.isArray(e.import) && e.import.every(
    (t) => typeof t == "string"
  )) && (typeof e._import > "u" || Array.isArray(e._import) && e._import.every(
    (t) => i(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.structure > "u" || Array.isArray(e.structure) && e.structure.every(
    (t) => Gy(t)
  )) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && typeof e.url == "string" && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function Yy(n) {
  const e = n;
  return d(e) && (typeof e.endpoint > "u" || typeof e.endpoint == "string") && (typeof e._endpoint > "u" || i(e._endpoint)) && (typeof e.header > "u" || Array.isArray(e.header) && e.header.every(
    (t) => typeof t == "string"
  )) && (typeof e._header > "u" || Array.isArray(e._header) && e._header.every(
    (t) => i(t)
  )) && (typeof e.payload > "u" || typeof e.payload == "string") && (typeof e._payload > "u" || i(e._payload)) && (e.type === "email" || e.type === "sms" || e.type === "message" || e.type === "rest-hook" || e.type === "websocket") && (typeof e._type > "u" || i(e._type));
}
function yn(n) {
  const e = n;
  return f(e) && e.resourceType === "Subscription" && Yy(e.channel) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => I(t)
  )) && typeof e.criteria == "string" && (typeof e._criteria > "u" || i(e._criteria)) && (typeof e.end > "u" || typeof e.end == "string") && (typeof e._end > "u" || i(e._end)) && (typeof e.error > "u" || typeof e.error == "string") && (typeof e._error > "u" || i(e._error)) && typeof e.reason == "string" && (typeof e._reason > "u" || i(e._reason)) && (e.status === "error" || e.status === "active" || e.status === "off" || e.status === "requested") && (typeof e._status > "u" || i(e._status));
}
function Zy(n) {
  const e = n;
  return d(e) && (typeof e.expiry > "u" || typeof e.expiry == "string") && (typeof e._expiry > "u" || i(e._expiry)) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.quantity > "u" || u(e.quantity));
}
function $y(n) {
  const e = n;
  return d(e) && (typeof e.quantity > "u" || b(e.quantity)) && (typeof e.substanceCodeableConcept > "u" || r(e.substanceCodeableConcept)) && (typeof e.substanceReference > "u" || o(e.substanceReference));
}
function un(n) {
  const e = n;
  return f(e) && e.resourceType === "Substance" && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => r(t)
  )) && r(e.code) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.ingredient > "u" || Array.isArray(e.ingredient) && e.ingredient.every(
    (t) => $y(t)
  )) && (typeof e.instance > "u" || Array.isArray(e.instance) && e.instance.every(
    (t) => Zy(t)
  )) && (typeof e.status > "u" || e.status === "active" || e.status === "inactive" || e.status === "entered-in-error") && (typeof e._status > "u" || i(e._status));
}
function eu(n) {
  const e = n;
  return d(e) && (typeof e.connectivity > "u" || typeof e.connectivity == "string") && (typeof e._connectivity > "u" || i(e._connectivity)) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.residueSite > "u" || typeof e.residueSite == "string") && (typeof e._residueSite > "u" || i(e._residueSite));
}
function tu(n) {
  const e = n;
  return d(e) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.residueSite > "u" || typeof e.residueSite == "string") && (typeof e._residueSite > "u" || i(e._residueSite));
}
function nu(n) {
  const e = n;
  return d(e) && (typeof e.fivePrime > "u" || r(e.fivePrime)) && (typeof e.length > "u" || typeof e.length == "number") && (typeof e.linkage > "u" || Array.isArray(e.linkage) && e.linkage.every(
    (t) => eu(t)
  )) && (typeof e.sequence > "u" || typeof e.sequence == "string") && (typeof e._sequence > "u" || i(e._sequence)) && (typeof e.sequenceAttachment > "u" || g(e.sequenceAttachment)) && (typeof e.subunit > "u" || typeof e.subunit == "number") && (typeof e.sugar > "u" || Array.isArray(e.sugar) && e.sugar.every(
    (t) => tu(t)
  )) && (typeof e.threePrime > "u" || r(e.threePrime));
}
function pn(n) {
  const e = n;
  return f(e) && e.resourceType === "SubstanceNucleicAcid" && (typeof e.areaOfHybridisation > "u" || typeof e.areaOfHybridisation == "string") && (typeof e._areaOfHybridisation > "u" || i(e._areaOfHybridisation)) && (typeof e.numberOfSubunits > "u" || typeof e.numberOfSubunits == "number") && (typeof e.oligoNucleotideType > "u" || r(e.oligoNucleotideType)) && (typeof e.sequenceType > "u" || r(e.sequenceType)) && (typeof e.subunit > "u" || Array.isArray(e.subunit) && e.subunit.every(
    (t) => nu(t)
  ));
}
function iu(n) {
  const e = n;
  return d(e) && (typeof e.amount > "u" || Tn(e.amount)) && (typeof e.isDefining > "u" || e.isDefining === !1 || e.isDefining === !0) && (typeof e._isDefining > "u" || i(e._isDefining)) && (typeof e.material > "u" || r(e.material)) && (typeof e.type > "u" || r(e.type));
}
function ru(n) {
  const e = n;
  return d(e) && (typeof e.ratioType > "u" || r(e.ratioType)) && (typeof e.startingMaterial > "u" || Array.isArray(e.startingMaterial) && e.startingMaterial.every(
    (t) => iu(t)
  ));
}
function ou(n) {
  const e = n;
  return d(e) && (typeof e.amount > "u" || Tn(e.amount)) && (typeof e.degree > "u" || r(e.degree));
}
function du(n) {
  const e = n;
  return d(e) && (typeof e.attachment > "u" || g(e.attachment)) && (typeof e.representation > "u" || typeof e.representation == "string") && (typeof e._representation > "u" || i(e._representation)) && (typeof e.type > "u" || r(e.type));
}
function au(n) {
  const e = n;
  return d(e) && (typeof e.amount > "u" || Tn(e.amount)) && (typeof e.degreeOfPolymerisation > "u" || Array.isArray(e.degreeOfPolymerisation) && e.degreeOfPolymerisation.every(
    (t) => ou(t)
  )) && (typeof e.orientationOfPolymerisation > "u" || r(e.orientationOfPolymerisation)) && (typeof e.repeatUnit > "u" || typeof e.repeatUnit == "string") && (typeof e._repeatUnit > "u" || i(e._repeatUnit)) && (typeof e.structuralRepresentation > "u" || Array.isArray(e.structuralRepresentation) && e.structuralRepresentation.every(
    (t) => du(t)
  ));
}
function fu(n) {
  const e = n;
  return d(e) && (typeof e.averageMolecularFormula > "u" || typeof e.averageMolecularFormula == "string") && (typeof e._averageMolecularFormula > "u" || i(e._averageMolecularFormula)) && (typeof e.numberOfUnits > "u" || typeof e.numberOfUnits == "number") && (typeof e.repeatUnit > "u" || Array.isArray(e.repeatUnit) && e.repeatUnit.every(
    (t) => au(t)
  )) && (typeof e.repeatUnitAmountType > "u" || r(e.repeatUnitAmountType));
}
function sn(n) {
  const e = n;
  return f(e) && e.resourceType === "SubstancePolymer" && (typeof e.class > "u" || r(e.class)) && (typeof e.copolymerConnectivity > "u" || Array.isArray(e.copolymerConnectivity) && e.copolymerConnectivity.every(
    (t) => r(t)
  )) && (typeof e.geometry > "u" || r(e.geometry)) && (typeof e.modification > "u" || Array.isArray(e.modification) && e.modification.every(
    (t) => typeof t == "string"
  )) && (typeof e._modification > "u" || Array.isArray(e._modification) && e._modification.every(
    (t) => i(t)
  )) && (typeof e.monomerSet > "u" || Array.isArray(e.monomerSet) && e.monomerSet.every(
    (t) => ru(t)
  )) && (typeof e.repeat > "u" || Array.isArray(e.repeat) && e.repeat.every(
    (t) => fu(t)
  ));
}
function yu(n) {
  const e = n;
  return d(e) && (typeof e.cTerminalModification > "u" || typeof e.cTerminalModification == "string") && (typeof e._cTerminalModification > "u" || i(e._cTerminalModification)) && (typeof e.cTerminalModificationId > "u" || a(e.cTerminalModificationId)) && (typeof e.length > "u" || typeof e.length == "number") && (typeof e.nTerminalModification > "u" || typeof e.nTerminalModification == "string") && (typeof e._nTerminalModification > "u" || i(e._nTerminalModification)) && (typeof e.nTerminalModificationId > "u" || a(e.nTerminalModificationId)) && (typeof e.sequence > "u" || typeof e.sequence == "string") && (typeof e._sequence > "u" || i(e._sequence)) && (typeof e.sequenceAttachment > "u" || g(e.sequenceAttachment)) && (typeof e.subunit > "u" || typeof e.subunit == "number");
}
function cn(n) {
  const e = n;
  return f(e) && e.resourceType === "SubstanceProtein" && (typeof e.disulfideLinkage > "u" || Array.isArray(e.disulfideLinkage) && e.disulfideLinkage.every(
    (t) => typeof t == "string"
  )) && (typeof e._disulfideLinkage > "u" || Array.isArray(e._disulfideLinkage) && e._disulfideLinkage.every(
    (t) => i(t)
  )) && (typeof e.numberOfSubunits > "u" || typeof e.numberOfSubunits == "number") && (typeof e.sequenceType > "u" || r(e.sequenceType)) && (typeof e.subunit > "u" || Array.isArray(e.subunit) && e.subunit.every(
    (t) => yu(t)
  ));
}
function uu(n) {
  const e = n;
  return d(e) && (typeof e.gene > "u" || r(e.gene)) && (typeof e.geneSequenceOrigin > "u" || r(e.geneSequenceOrigin)) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => o(t)
  ));
}
function pu(n) {
  const e = n;
  return d(e) && (typeof e.element > "u" || a(e.element)) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => o(t)
  )) && (typeof e.type > "u" || r(e.type));
}
function su(n) {
  const e = n;
  return d(e) && (typeof e.classification > "u" || r(e.classification)) && (typeof e.domain > "u" || r(e.domain)) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => o(t)
  )) && (typeof e.subtype > "u" || Array.isArray(e.subtype) && e.subtype.every(
    (t) => r(t)
  ));
}
function cu(n) {
  const e = n;
  return d(e) && (typeof e.amountQuantity > "u" || u(e.amountQuantity)) && (typeof e.amountRange > "u" || v(e.amountRange)) && (typeof e.amountString > "u" || typeof e.amountString == "string") && (typeof e._amountString > "u" || i(e._amountString)) && (typeof e.amountType > "u" || r(e.amountType)) && (typeof e.interaction > "u" || r(e.interaction)) && (typeof e.organism > "u" || r(e.organism)) && (typeof e.organismType > "u" || r(e.organismType)) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => o(t)
  )) && (typeof e.target > "u" || a(e.target)) && (typeof e.type > "u" || r(e.type));
}
function ln(n) {
  const e = n;
  return f(e) && e.resourceType === "SubstanceReferenceInformation" && (typeof e.classification > "u" || Array.isArray(e.classification) && e.classification.every(
    (t) => su(t)
  )) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment)) && (typeof e.gene > "u" || Array.isArray(e.gene) && e.gene.every(
    (t) => uu(t)
  )) && (typeof e.geneElement > "u" || Array.isArray(e.geneElement) && e.geneElement.every(
    (t) => pu(t)
  )) && (typeof e.target > "u" || Array.isArray(e.target) && e.target.every(
    (t) => cu(t)
  ));
}
function lu(n) {
  const e = n;
  return d(e) && (typeof e.fraction > "u" || typeof e.fraction == "string") && (typeof e._fraction > "u" || i(e._fraction)) && (typeof e.materialType > "u" || r(e.materialType));
}
function vu(n) {
  const e = n;
  return d(e) && (typeof e.authorDescription > "u" || typeof e.authorDescription == "string") && (typeof e._authorDescription > "u" || i(e._authorDescription)) && (typeof e.authorType > "u" || r(e.authorType));
}
function mu(n) {
  const e = n;
  return d(e) && (typeof e.hybridType > "u" || r(e.hybridType)) && (typeof e.maternalOrganismId > "u" || typeof e.maternalOrganismId == "string") && (typeof e._maternalOrganismId > "u" || i(e._maternalOrganismId)) && (typeof e.maternalOrganismName > "u" || typeof e.maternalOrganismName == "string") && (typeof e._maternalOrganismName > "u" || i(e._maternalOrganismName)) && (typeof e.paternalOrganismId > "u" || typeof e.paternalOrganismId == "string") && (typeof e._paternalOrganismId > "u" || i(e._paternalOrganismId)) && (typeof e.paternalOrganismName > "u" || typeof e.paternalOrganismName == "string") && (typeof e._paternalOrganismName > "u" || i(e._paternalOrganismName));
}
function gu(n) {
  const e = n;
  return d(e) && (typeof e.class > "u" || r(e.class)) && (typeof e.kingdom > "u" || r(e.kingdom)) && (typeof e.order > "u" || r(e.order)) && (typeof e.phylum > "u" || r(e.phylum));
}
function _u(n) {
  const e = n;
  return d(e) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => vu(t)
  )) && (typeof e.family > "u" || r(e.family)) && (typeof e.genus > "u" || r(e.genus)) && (typeof e.hybrid > "u" || mu(e.hybrid)) && (typeof e.intraspecificDescription > "u" || typeof e.intraspecificDescription == "string") && (typeof e._intraspecificDescription > "u" || i(e._intraspecificDescription)) && (typeof e.intraspecificType > "u" || r(e.intraspecificType)) && (typeof e.organismGeneral > "u" || gu(e.organismGeneral)) && (typeof e.species > "u" || r(e.species));
}
function Au(n) {
  const e = n;
  return d(e) && (typeof e.part > "u" || r(e.part)) && (typeof e.partLocation > "u" || r(e.partLocation));
}
function vn(n) {
  const e = n;
  return f(e) && e.resourceType === "SubstanceSourceMaterial" && (typeof e.countryOfOrigin > "u" || Array.isArray(e.countryOfOrigin) && e.countryOfOrigin.every(
    (t) => r(t)
  )) && (typeof e.developmentStage > "u" || r(e.developmentStage)) && (typeof e.fractionDescription > "u" || Array.isArray(e.fractionDescription) && e.fractionDescription.every(
    (t) => lu(t)
  )) && (typeof e.geographicalLocation > "u" || Array.isArray(e.geographicalLocation) && e.geographicalLocation.every(
    (t) => typeof t == "string"
  )) && (typeof e._geographicalLocation > "u" || Array.isArray(e._geographicalLocation) && e._geographicalLocation.every(
    (t) => i(t)
  )) && (typeof e.organism > "u" || _u(e.organism)) && (typeof e.organismId > "u" || a(e.organismId)) && (typeof e.organismName > "u" || typeof e.organismName == "string") && (typeof e._organismName > "u" || i(e._organismName)) && (typeof e.parentSubstanceId > "u" || Array.isArray(e.parentSubstanceId) && e.parentSubstanceId.every(
    (t) => a(t)
  )) && (typeof e.parentSubstanceName > "u" || Array.isArray(e.parentSubstanceName) && e.parentSubstanceName.every(
    (t) => typeof t == "string"
  )) && (typeof e._parentSubstanceName > "u" || Array.isArray(e._parentSubstanceName) && e._parentSubstanceName.every(
    (t) => i(t)
  )) && (typeof e.partDescription > "u" || Array.isArray(e.partDescription) && e.partDescription.every(
    (t) => Au(t)
  )) && (typeof e.sourceMaterialClass > "u" || r(e.sourceMaterialClass)) && (typeof e.sourceMaterialState > "u" || r(e.sourceMaterialState)) && (typeof e.sourceMaterialType > "u" || r(e.sourceMaterialType));
}
function bu(n) {
  const e = n;
  return d(e) && (typeof e.amountQuantity > "u" || u(e.amountQuantity)) && (typeof e.amountString > "u" || typeof e.amountString == "string") && (typeof e._amountString > "u" || i(e._amountString)) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.molecularFormula > "u" || typeof e.molecularFormula == "string") && (typeof e._molecularFormula > "u" || i(e._molecularFormula)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.opticalActivity > "u" || r(e.opticalActivity)) && (typeof e.role > "u" || r(e.role)) && (typeof e.stereochemistry > "u" || r(e.stereochemistry));
}
function Iu(n) {
  const e = n;
  return d(e) && (typeof e.amountQuantity > "u" || u(e.amountQuantity)) && (typeof e.amountString > "u" || typeof e.amountString == "string") && (typeof e._amountString > "u" || i(e._amountString)) && (typeof e.category > "u" || r(e.category)) && (typeof e.code > "u" || r(e.code)) && (typeof e.definingSubstanceReference > "u" || o(e.definingSubstanceReference)) && (typeof e.definingSubstanceCodeableConcept > "u" || r(e.definingSubstanceCodeableConcept)) && (typeof e.parameters > "u" || typeof e.parameters == "string") && (typeof e._parameters > "u" || i(e._parameters));
}
function jn(n) {
  const e = n;
  return d(e) && (typeof e.amount > "u" || u(e.amount)) && (typeof e.method > "u" || r(e.method)) && (typeof e.type > "u" || r(e.type));
}
function hu(n) {
  const e = n;
  return d(e) && (typeof e.halfLife > "u" || u(e.halfLife)) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.molecularWeight > "u" || jn(e.molecularWeight)) && (typeof e.name > "u" || r(e.name)) && (typeof e.substitution > "u" || r(e.substitution));
}
function wu(n) {
  const e = n;
  return d(e) && (typeof e.attachment > "u" || g(e.attachment)) && (typeof e.representation > "u" || typeof e.representation == "string") && (typeof e._representation > "u" || i(e._representation)) && (typeof e.type > "u" || r(e.type));
}
function Ru(n) {
  const e = n;
  return d(e) && (typeof e.isotope > "u" || Array.isArray(e.isotope) && e.isotope.every(
    (t) => hu(t)
  )) && (typeof e.molecularFormula > "u" || typeof e.molecularFormula == "string") && (typeof e._molecularFormula > "u" || i(e._molecularFormula)) && (typeof e.molecularFormulaByMoiety > "u" || typeof e.molecularFormulaByMoiety == "string") && (typeof e._molecularFormulaByMoiety > "u" || i(e._molecularFormulaByMoiety)) && (typeof e.molecularWeight > "u" || jn(e.molecularWeight)) && (typeof e.opticalActivity > "u" || r(e.opticalActivity)) && (typeof e.representation > "u" || Array.isArray(e.representation) && e.representation.every(
    (t) => wu(t)
  )) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => o(t)
  )) && (typeof e.stereochemistry > "u" || r(e.stereochemistry));
}
function Cu(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || r(e.code)) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment)) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => o(t)
  )) && (typeof e.status > "u" || r(e.status)) && (typeof e.statusDate > "u" || typeof e.statusDate == "string") && (typeof e._statusDate > "u" || i(e._statusDate));
}
function Du(n) {
  const e = n;
  return d(e) && (typeof e.authority > "u" || r(e.authority)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.status > "u" || r(e.status));
}
function Sn(n) {
  const e = n;
  return d(e) && (typeof e.domain > "u" || Array.isArray(e.domain) && e.domain.every(
    (t) => r(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.language > "u" || Array.isArray(e.language) && e.language.every(
    (t) => r(t)
  )) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.official > "u" || Array.isArray(e.official) && e.official.every(
    (t) => Du(t)
  )) && (typeof e.preferred > "u" || e.preferred === !1 || e.preferred === !0) && (typeof e._preferred > "u" || i(e._preferred)) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => o(t)
  )) && (typeof e.status > "u" || r(e.status)) && (typeof e.synonym > "u" || Array.isArray(e.synonym) && e.synonym.every(
    (t) => Sn(t)
  )) && (typeof e.translation > "u" || Array.isArray(e.translation) && e.translation.every(
    (t) => Sn(t)
  )) && (typeof e.type > "u" || r(e.type));
}
function Su(n) {
  const e = n;
  return d(e) && (typeof e.amountQuantity > "u" || u(e.amountQuantity)) && (typeof e.amountRange > "u" || v(e.amountRange)) && (typeof e.amountRatio > "u" || b(e.amountRatio)) && (typeof e.amountString > "u" || typeof e.amountString == "string") && (typeof e._amountString > "u" || i(e._amountString)) && (typeof e.amountRatioLowLimit > "u" || b(e.amountRatioLowLimit)) && (typeof e.amountType > "u" || r(e.amountType)) && (typeof e.isDefining > "u" || e.isDefining === !1 || e.isDefining === !0) && (typeof e._isDefining > "u" || i(e._isDefining)) && (typeof e.relationship > "u" || r(e.relationship)) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => o(t)
  )) && (typeof e.substanceReference > "u" || o(e.substanceReference)) && (typeof e.substanceCodeableConcept > "u" || r(e.substanceCodeableConcept));
}
function mn(n) {
  const e = n;
  return f(e) && e.resourceType === "SubstanceSpecification" && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => Cu(t)
  )) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || i(e._comment)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.domain > "u" || r(e.domain)) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.moiety > "u" || Array.isArray(e.moiety) && e.moiety.every(
    (t) => bu(t)
  )) && (typeof e.molecularWeight > "u" || Array.isArray(e.molecularWeight) && e.molecularWeight.every(
    (t) => jn(t)
  )) && (typeof e.name > "u" || Array.isArray(e.name) && e.name.every(
    (t) => Sn(t)
  )) && (typeof e.nucleicAcid > "u" || o(e.nucleicAcid)) && (typeof e.polymer > "u" || o(e.polymer)) && (typeof e.property > "u" || Array.isArray(e.property) && e.property.every(
    (t) => Iu(t)
  )) && (typeof e.protein > "u" || o(e.protein)) && (typeof e.referenceInformation > "u" || o(e.referenceInformation)) && (typeof e.relationship > "u" || Array.isArray(e.relationship) && e.relationship.every(
    (t) => Su(t)
  )) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => o(t)
  )) && (typeof e.sourceMaterial > "u" || o(e.sourceMaterial)) && (typeof e.status > "u" || r(e.status)) && (typeof e.structure > "u" || Ru(e.structure)) && (typeof e.type > "u" || r(e.type));
}
function Ou(n) {
  const e = n;
  return d(e) && (typeof e.itemCodeableConcept > "u" || r(e.itemCodeableConcept)) && (typeof e.itemReference > "u" || o(e.itemReference)) && (typeof e.quantity > "u" || u(e.quantity));
}
function gn(n) {
  const e = n;
  return f(e) && e.resourceType === "SupplyDelivery" && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.destination > "u" || o(e.destination)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || i(e._occurrenceDateTime)) && (typeof e.occurrencePeriod > "u" || y(e.occurrencePeriod)) && (typeof e.occurrenceTiming > "u" || A(e.occurrenceTiming)) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => o(t)
  )) && (typeof e.patient > "u" || o(e.patient)) && (typeof e.receiver > "u" || Array.isArray(e.receiver) && e.receiver.every(
    (t) => o(t)
  )) && (typeof e.status > "u" || e.status === "entered-in-error" || e.status === "in-progress" || e.status === "completed" || e.status === "abandoned") && (typeof e._status > "u" || i(e._status)) && (typeof e.suppliedItem > "u" || Ou(e.suppliedItem)) && (typeof e.supplier > "u" || o(e.supplier)) && (typeof e.type > "u" || r(e.type));
}
function Eu(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || r(e.code)) && (typeof e.valueCodeableConcept > "u" || r(e.valueCodeableConcept)) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueRange > "u" || v(e.valueRange)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean));
}
function _n(n) {
  const e = n;
  return f(e) && e.resourceType === "SupplyRequest" && (typeof e.authoredOn > "u" || typeof e.authoredOn == "string") && (typeof e._authoredOn > "u" || i(e._authoredOn)) && (typeof e.category > "u" || r(e.category)) && (typeof e.deliverFrom > "u" || o(e.deliverFrom)) && (typeof e.deliverTo > "u" || o(e.deliverTo)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.itemCodeableConcept > "u" || r(e.itemCodeableConcept)) && (typeof e.itemReference > "u" || o(e.itemReference)) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || i(e._occurrenceDateTime)) && (typeof e.occurrencePeriod > "u" || y(e.occurrencePeriod)) && (typeof e.occurrenceTiming > "u" || A(e.occurrenceTiming)) && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => Eu(t)
  )) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || i(e._priority)) && u(e.quantity) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => o(t)
  )) && (typeof e.requester > "u" || o(e.requester)) && (typeof e.status > "u" || e.status === "active" || e.status === "entered-in-error" || e.status === "unknown" || e.status === "draft" || e.status === "cancelled" || e.status === "completed" || e.status === "suspended") && (typeof e._status > "u" || i(e._status)) && (typeof e.supplier > "u" || Array.isArray(e.supplier) && e.supplier.every(
    (t) => o(t)
  ));
}
function Tu(n) {
  const e = n;
  return d(e) && (typeof e.period > "u" || y(e.period)) && (typeof e.recipient > "u" || Array.isArray(e.recipient) && e.recipient.every(
    (t) => o(t)
  )) && (typeof e.repetitions > "u" || typeof e.repetitions == "number");
}
function xu(n) {
  const e = n;
  return d(e) && r(e.type) && (typeof e.valueBase64Binary > "u" || typeof e.valueBase64Binary == "string") && (typeof e._valueBase64Binary > "u" || i(e._valueBase64Binary)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean)) && (typeof e.valueCanonical > "u" || typeof e.valueCanonical == "string") && (typeof e._valueCanonical > "u" || i(e._valueCanonical)) && (typeof e.valueCode > "u" || typeof e.valueCode == "string") && (typeof e._valueCode > "u" || i(e._valueCode)) && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || i(e._valueDate)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || i(e._valueDateTime)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueId > "u" || typeof e.valueId == "string") && (typeof e._valueId > "u" || i(e._valueId)) && (typeof e.valueInstant > "u" || typeof e.valueInstant == "string") && (typeof e._valueInstant > "u" || i(e._valueInstant)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueMarkdown > "u" || typeof e.valueMarkdown == "string") && (typeof e._valueMarkdown > "u" || i(e._valueMarkdown)) && (typeof e.valueOid > "u" || typeof e.valueOid == "string") && (typeof e._valueOid > "u" || i(e._valueOid)) && (typeof e.valuePositiveInt > "u" || typeof e.valuePositiveInt == "number") && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || i(e._valueTime)) && (typeof e.valueUnsignedInt > "u" || typeof e.valueUnsignedInt == "number") && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || i(e._valueUri)) && (typeof e.valueUrl > "u" || typeof e.valueUrl == "string") && (typeof e._valueUrl > "u" || i(e._valueUrl)) && (typeof e.valueUuid > "u" || typeof e.valueUuid == "string") && (typeof e._valueUuid > "u" || i(e._valueUuid)) && (typeof e.valueAddress > "u" || h(e.valueAddress)) && (typeof e.valueAge > "u" || C(e.valueAge)) && (typeof e.valueAnnotation > "u" || l(e.valueAnnotation)) && (typeof e.valueAttachment > "u" || g(e.valueAttachment)) && (typeof e.valueCodeableConcept > "u" || r(e.valueCodeableConcept)) && (typeof e.valueCoding > "u" || s(e.valueCoding)) && (typeof e.valueContactPoint > "u" || I(e.valueContactPoint)) && (typeof e.valueCount > "u" || H(e.valueCount)) && (typeof e.valueDistance > "u" || M(e.valueDistance)) && (typeof e.valueDuration > "u" || _(e.valueDuration)) && (typeof e.valueHumanName > "u" || S(e.valueHumanName)) && (typeof e.valueIdentifier > "u" || a(e.valueIdentifier)) && (typeof e.valueMoney > "u" || c(e.valueMoney)) && (typeof e.valuePeriod > "u" || y(e.valuePeriod)) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueRange > "u" || v(e.valueRange)) && (typeof e.valueRatio > "u" || b(e.valueRatio)) && (typeof e.valueReference > "u" || o(e.valueReference)) && (typeof e.valueSampledData > "u" || x(e.valueSampledData)) && (typeof e.valueSignature > "u" || O(e.valueSignature)) && (typeof e.valueTiming > "u" || A(e.valueTiming)) && (typeof e.valueContactDetail > "u" || p(e.valueContactDetail)) && (typeof e.valueContributor > "u" || F(e.valueContributor)) && (typeof e.valueDataRequirement > "u" || D(e.valueDataRequirement)) && (typeof e.valueExpression > "u" || R(e.valueExpression)) && (typeof e.valueParameterDefinition > "u" || P(e.valueParameterDefinition)) && (typeof e.valueRelatedArtifact > "u" || w(e.valueRelatedArtifact)) && (typeof e.valueTriggerDefinition > "u" || T(e.valueTriggerDefinition)) && (typeof e.valueUsageContext > "u" || m(e.valueUsageContext)) && (typeof e.valueDosage > "u" || E(e.valueDosage)) && (typeof e.valueMeta > "u" || j(e.valueMeta));
}
function ju(n) {
  const e = n;
  return d(e) && r(e.type) && (typeof e.valueBase64Binary > "u" || typeof e.valueBase64Binary == "string") && (typeof e._valueBase64Binary > "u" || i(e._valueBase64Binary)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean)) && (typeof e.valueCanonical > "u" || typeof e.valueCanonical == "string") && (typeof e._valueCanonical > "u" || i(e._valueCanonical)) && (typeof e.valueCode > "u" || typeof e.valueCode == "string") && (typeof e._valueCode > "u" || i(e._valueCode)) && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || i(e._valueDate)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || i(e._valueDateTime)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueId > "u" || typeof e.valueId == "string") && (typeof e._valueId > "u" || i(e._valueId)) && (typeof e.valueInstant > "u" || typeof e.valueInstant == "string") && (typeof e._valueInstant > "u" || i(e._valueInstant)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueMarkdown > "u" || typeof e.valueMarkdown == "string") && (typeof e._valueMarkdown > "u" || i(e._valueMarkdown)) && (typeof e.valueOid > "u" || typeof e.valueOid == "string") && (typeof e._valueOid > "u" || i(e._valueOid)) && (typeof e.valuePositiveInt > "u" || typeof e.valuePositiveInt == "number") && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || i(e._valueTime)) && (typeof e.valueUnsignedInt > "u" || typeof e.valueUnsignedInt == "number") && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || i(e._valueUri)) && (typeof e.valueUrl > "u" || typeof e.valueUrl == "string") && (typeof e._valueUrl > "u" || i(e._valueUrl)) && (typeof e.valueUuid > "u" || typeof e.valueUuid == "string") && (typeof e._valueUuid > "u" || i(e._valueUuid)) && (typeof e.valueAddress > "u" || h(e.valueAddress)) && (typeof e.valueAge > "u" || C(e.valueAge)) && (typeof e.valueAnnotation > "u" || l(e.valueAnnotation)) && (typeof e.valueAttachment > "u" || g(e.valueAttachment)) && (typeof e.valueCodeableConcept > "u" || r(e.valueCodeableConcept)) && (typeof e.valueCoding > "u" || s(e.valueCoding)) && (typeof e.valueContactPoint > "u" || I(e.valueContactPoint)) && (typeof e.valueCount > "u" || H(e.valueCount)) && (typeof e.valueDistance > "u" || M(e.valueDistance)) && (typeof e.valueDuration > "u" || _(e.valueDuration)) && (typeof e.valueHumanName > "u" || S(e.valueHumanName)) && (typeof e.valueIdentifier > "u" || a(e.valueIdentifier)) && (typeof e.valueMoney > "u" || c(e.valueMoney)) && (typeof e.valuePeriod > "u" || y(e.valuePeriod)) && (typeof e.valueQuantity > "u" || u(e.valueQuantity)) && (typeof e.valueRange > "u" || v(e.valueRange)) && (typeof e.valueRatio > "u" || b(e.valueRatio)) && (typeof e.valueReference > "u" || o(e.valueReference)) && (typeof e.valueSampledData > "u" || x(e.valueSampledData)) && (typeof e.valueSignature > "u" || O(e.valueSignature)) && (typeof e.valueTiming > "u" || A(e.valueTiming)) && (typeof e.valueContactDetail > "u" || p(e.valueContactDetail)) && (typeof e.valueContributor > "u" || F(e.valueContributor)) && (typeof e.valueDataRequirement > "u" || D(e.valueDataRequirement)) && (typeof e.valueExpression > "u" || R(e.valueExpression)) && (typeof e.valueParameterDefinition > "u" || P(e.valueParameterDefinition)) && (typeof e.valueRelatedArtifact > "u" || w(e.valueRelatedArtifact)) && (typeof e.valueTriggerDefinition > "u" || T(e.valueTriggerDefinition)) && (typeof e.valueUsageContext > "u" || m(e.valueUsageContext)) && (typeof e.valueDosage > "u" || E(e.valueDosage)) && (typeof e.valueMeta > "u" || j(e.valueMeta));
}
function An(n) {
  const e = n;
  return f(e) && e.resourceType === "Task" && (typeof e.authoredOn > "u" || typeof e.authoredOn == "string") && (typeof e._authoredOn > "u" || i(e._authoredOn)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => o(t)
  )) && (typeof e.businessStatus > "u" || r(e.businessStatus)) && (typeof e.code > "u" || r(e.code)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.executionPeriod > "u" || y(e.executionPeriod)) && (typeof e.focus > "u" || o(e.focus)) && (typeof e.for > "u" || o(e.for)) && (typeof e.groupIdentifier > "u" || a(e.groupIdentifier)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.input > "u" || Array.isArray(e.input) && e.input.every(
    (t) => xu(t)
  )) && (typeof e.instantiatesCanonical > "u" || typeof e.instantiatesCanonical == "string") && (typeof e._instantiatesCanonical > "u" || i(e._instantiatesCanonical)) && (typeof e.instantiatesUri > "u" || typeof e.instantiatesUri == "string") && (typeof e._instantiatesUri > "u" || i(e._instantiatesUri)) && (typeof e.insurance > "u" || Array.isArray(e.insurance) && e.insurance.every(
    (t) => o(t)
  )) && (e.intent === "unknown" || e.intent === "proposal" || e.intent === "plan" || e.intent === "order" || e.intent === "original-order" || e.intent === "reflex-order" || e.intent === "filler-order" || e.intent === "instance-order" || e.intent === "option") && (typeof e._intent > "u" || i(e._intent)) && (typeof e.lastModified > "u" || typeof e.lastModified == "string") && (typeof e._lastModified > "u" || i(e._lastModified)) && (typeof e.location > "u" || o(e.location)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.output > "u" || Array.isArray(e.output) && e.output.every(
    (t) => ju(t)
  )) && (typeof e.owner > "u" || o(e.owner)) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => o(t)
  )) && (typeof e.performerType > "u" || Array.isArray(e.performerType) && e.performerType.every(
    (t) => r(t)
  )) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || i(e._priority)) && (typeof e.reasonCode > "u" || r(e.reasonCode)) && (typeof e.reasonReference > "u" || o(e.reasonReference)) && (typeof e.relevantHistory > "u" || Array.isArray(e.relevantHistory) && e.relevantHistory.every(
    (t) => o(t)
  )) && (typeof e.requester > "u" || o(e.requester)) && (typeof e.restriction > "u" || Tu(e.restriction)) && (e.status === "entered-in-error" || e.status === "on-hold" || e.status === "draft" || e.status === "accepted" || e.status === "cancelled" || e.status === "in-progress" || e.status === "completed" || e.status === "rejected" || e.status === "requested" || e.status === "received" || e.status === "ready" || e.status === "failed") && (typeof e._status > "u" || i(e._status)) && (typeof e.statusReason > "u" || r(e.statusReason));
}
function Pu(n) {
  const e = n;
  return d(e) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function Fu(n) {
  const e = n;
  return d(e) && typeof e.description == "string" && (typeof e._description > "u" || i(e._description)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url));
}
function Hu(n) {
  const e = n;
  return d(e) && typeof e.code == "string" && (typeof e._code > "u" || i(e._code)) && Array.isArray(e.op) && e.op.every(
    (t) => typeof t == "string"
  ) && (typeof e._op > "u" || Array.isArray(e._op) && e._op.every(
    (t) => i(t)
  ));
}
function Mu(n) {
  const e = n;
  return d(e) && (typeof e.code > "u" || typeof e.code == "string") && (typeof e._code > "u" || i(e._code)) && (typeof e.compositional > "u" || e.compositional === !1 || e.compositional === !0) && (typeof e._compositional > "u" || i(e._compositional)) && (typeof e.filter > "u" || Array.isArray(e.filter) && e.filter.every(
    (t) => Hu(t)
  )) && (typeof e.isDefault > "u" || e.isDefault === !1 || e.isDefault === !0) && (typeof e._isDefault > "u" || i(e._isDefault)) && (typeof e.language > "u" || Array.isArray(e.language) && e.language.every(
    (t) => typeof t == "string"
  )) && (typeof e._language > "u" || Array.isArray(e._language) && e._language.every(
    (t) => i(t)
  )) && (typeof e.property > "u" || Array.isArray(e.property) && e.property.every(
    (t) => typeof t == "string"
  )) && (typeof e._property > "u" || Array.isArray(e._property) && e._property.every(
    (t) => i(t)
  ));
}
function qu(n) {
  const e = n;
  return d(e) && (typeof e.subsumption > "u" || e.subsumption === !1 || e.subsumption === !0) && (typeof e._subsumption > "u" || i(e._subsumption)) && (typeof e.uri > "u" || typeof e.uri == "string") && (typeof e._uri > "u" || i(e._uri)) && (typeof e.version > "u" || Array.isArray(e.version) && e.version.every(
    (t) => Mu(t)
  ));
}
function ku(n) {
  const e = n;
  return d(e) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || i(e._documentation)) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name));
}
function Bu(n) {
  const e = n;
  return d(e) && (typeof e.hierarchical > "u" || e.hierarchical === !1 || e.hierarchical === !0) && (typeof e._hierarchical > "u" || i(e._hierarchical)) && (typeof e.incomplete > "u" || e.incomplete === !1 || e.incomplete === !0) && (typeof e._incomplete > "u" || i(e._incomplete)) && (typeof e.paging > "u" || e.paging === !1 || e.paging === !0) && (typeof e._paging > "u" || i(e._paging)) && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => ku(t)
  )) && (typeof e.textFilter > "u" || typeof e.textFilter == "string") && (typeof e._textFilter > "u" || i(e._textFilter));
}
function Vu(n) {
  const e = n;
  return d(e) && typeof e.translations == "boolean" && (typeof e._translations > "u" || i(e._translations));
}
function Uu(n) {
  const e = n;
  return d(e) && typeof e.needsMap == "boolean" && (typeof e._needsMap > "u" || i(e._needsMap));
}
function Nu(n) {
  const e = n;
  return d(e) && (typeof e.translation > "u" || e.translation === !1 || e.translation === !0) && (typeof e._translation > "u" || i(e._translation));
}
function bn(n) {
  const e = n;
  return f(e) && e.resourceType === "TerminologyCapabilities" && (typeof e.closure > "u" || Nu(e.closure)) && (typeof e.codeSearch > "u" || e.codeSearch === "all" || e.codeSearch === "explicit") && (typeof e._codeSearch > "u" || i(e._codeSearch)) && (typeof e.codeSystem > "u" || Array.isArray(e.codeSystem) && e.codeSystem.every(
    (t) => qu(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && typeof e.date == "string" && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.expansion > "u" || Bu(e.expansion)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.implementation > "u" || Fu(e.implementation)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (e.kind === "instance" || e.kind === "capability" || e.kind === "requirements") && (typeof e._kind > "u" || i(e._kind)) && (typeof e.lockedDate > "u" || e.lockedDate === !1 || e.lockedDate === !0) && (typeof e._lockedDate > "u" || i(e._lockedDate)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (typeof e.software > "u" || Pu(e.software)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.translation > "u" || Uu(e.translation)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.validateCode > "u" || Vu(e.validateCode)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function Lu(n) {
  const e = n;
  return d(e) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || i(e._display)) && (e.type === "client" || e.type === "server" || e.type === "test-engine") && (typeof e._type > "u" || i(e._type)) && typeof e.uri == "string" && (typeof e._uri > "u" || i(e._uri));
}
function Pn(n) {
  const e = n;
  return d(e) && (typeof e.detail > "u" || typeof e.detail == "string") && (typeof e._detail > "u" || i(e._detail)) && (typeof e.message > "u" || typeof e.message == "string") && (typeof e._message > "u" || i(e._message)) && (e.result === "error" || e.result === "warning" || e.result === "pass" || e.result === "skip" || e.result === "fail") && (typeof e._result > "u" || i(e._result));
}
function si(n) {
  const e = n;
  return d(e) && (typeof e.detail > "u" || typeof e.detail == "string") && (typeof e._detail > "u" || i(e._detail)) && (typeof e.message > "u" || typeof e.message == "string") && (typeof e._message > "u" || i(e._message)) && (e.result === "error" || e.result === "warning" || e.result === "pass" || e.result === "skip" || e.result === "fail") && (typeof e._result > "u" || i(e._result));
}
function Gu(n) {
  const e = n;
  return d(e) && (typeof e.assert > "u" || si(e.assert)) && (typeof e.operation > "u" || Pn(e.operation));
}
function zu(n) {
  const e = n;
  return d(e) && Array.isArray(e.action) && e.action.every(
    (t) => Gu(t)
  );
}
function Qu(n) {
  const e = n;
  return d(e) && (typeof e.assert > "u" || si(e.assert)) && (typeof e.operation > "u" || Pn(e.operation));
}
function Wu(n) {
  const e = n;
  return d(e) && Array.isArray(e.action) && e.action.every(
    (t) => Qu(t)
  ) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name));
}
function Ku(n) {
  const e = n;
  return d(e) && Pn(e.operation);
}
function Ju(n) {
  const e = n;
  return d(e) && Array.isArray(e.action) && e.action.every(
    (t) => Ku(t)
  );
}
function In(n) {
  const e = n;
  return f(e) && e.resourceType === "TestReport" && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.issued > "u" || typeof e.issued == "string") && (typeof e._issued > "u" || i(e._issued)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.participant > "u" || Array.isArray(e.participant) && e.participant.every(
    (t) => Lu(t)
  )) && (e.result === "pending" || e.result === "pass" || e.result === "fail") && (typeof e._result > "u" || i(e._result)) && (typeof e.score > "u" || typeof e.score == "number") && (typeof e.setup > "u" || zu(e.setup)) && (e.status === "entered-in-error" || e.status === "in-progress" || e.status === "completed" || e.status === "stopped" || e.status === "waiting") && (typeof e._status > "u" || i(e._status)) && (typeof e.teardown > "u" || Ju(e.teardown)) && (typeof e.test > "u" || Array.isArray(e.test) && e.test.every(
    (t) => Wu(t)
  )) && (typeof e.tester > "u" || typeof e.tester == "string") && (typeof e._tester > "u" || i(e._tester)) && o(e.testScript);
}
function Xu(n) {
  const e = n;
  return d(e) && typeof e.index == "number" && s(e.profile);
}
function Yu(n) {
  const e = n;
  return d(e) && typeof e.index == "number" && s(e.profile);
}
function Zu(n) {
  const e = n;
  return d(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && typeof e.url == "string" && (typeof e._url > "u" || i(e._url));
}
function $u(n) {
  const e = n;
  return d(e) && typeof e.capabilities == "string" && (typeof e._capabilities > "u" || i(e._capabilities)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.destination > "u" || typeof e.destination == "number") && (typeof e.link > "u" || Array.isArray(e.link) && e.link.every(
    (t) => typeof t == "string"
  )) && (typeof e._link > "u" || Array.isArray(e._link) && e._link.every(
    (t) => i(t)
  )) && (typeof e.origin > "u" || Array.isArray(e.origin) && e.origin.every(
    (t) => typeof t == "number"
  )) && typeof e.required == "boolean" && (typeof e._required > "u" || i(e._required)) && typeof e.validated == "boolean" && (typeof e._validated > "u" || i(e._validated));
}
function ep(n) {
  const e = n;
  return d(e) && Array.isArray(e.capability) && e.capability.every(
    (t) => $u(t)
  ) && (typeof e.link > "u" || Array.isArray(e.link) && e.link.every(
    (t) => Zu(t)
  ));
}
function tp(n) {
  const e = n;
  return d(e) && typeof e.autocreate == "boolean" && (typeof e._autocreate > "u" || i(e._autocreate)) && typeof e.autodelete == "boolean" && (typeof e._autodelete > "u" || i(e._autodelete)) && (typeof e.resource > "u" || o(e.resource));
}
function np(n) {
  const e = n;
  return d(e) && (typeof e.defaultValue > "u" || typeof e.defaultValue == "string") && (typeof e._defaultValue > "u" || i(e._defaultValue)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.expression > "u" || typeof e.expression == "string") && (typeof e._expression > "u" || i(e._expression)) && (typeof e.headerField > "u" || typeof e.headerField == "string") && (typeof e._headerField > "u" || i(e._headerField)) && (typeof e.hint > "u" || typeof e.hint == "string") && (typeof e._hint > "u" || i(e._hint)) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.path > "u" || typeof e.path == "string") && (typeof e._path > "u" || i(e._path)) && (typeof e.sourceId > "u" || typeof e.sourceId == "string") && (typeof e._sourceId > "u" || i(e._sourceId));
}
function ip(n) {
  const e = n;
  return d(e) && typeof e.field == "string" && (typeof e._field > "u" || i(e._field)) && typeof e.value == "string" && (typeof e._value > "u" || i(e._value));
}
function Fn(n) {
  const e = n;
  return d(e) && (typeof e.accept > "u" || typeof e.accept == "string") && (typeof e._accept > "u" || i(e._accept)) && (typeof e.contentType > "u" || typeof e.contentType == "string") && (typeof e._contentType > "u" || i(e._contentType)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.destination > "u" || typeof e.destination == "number") && typeof e.encodeRequestUrl == "boolean" && (typeof e._encodeRequestUrl > "u" || i(e._encodeRequestUrl)) && (typeof e.label > "u" || typeof e.label == "string") && (typeof e._label > "u" || i(e._label)) && (typeof e.method > "u" || e.method === "patch" || e.method === "delete" || e.method === "get" || e.method === "options" || e.method === "post" || e.method === "put" || e.method === "head") && (typeof e._method > "u" || i(e._method)) && (typeof e.origin > "u" || typeof e.origin == "number") && (typeof e.params > "u" || typeof e.params == "string") && (typeof e._params > "u" || i(e._params)) && (typeof e.requestHeader > "u" || Array.isArray(e.requestHeader) && e.requestHeader.every(
    (t) => ip(t)
  )) && (typeof e.requestId > "u" || typeof e.requestId == "string") && (typeof e._requestId > "u" || i(e._requestId)) && (typeof e.resource > "u" || typeof e.resource == "string") && (typeof e._resource > "u" || i(e._resource)) && (typeof e.responseId > "u" || typeof e.responseId == "string") && (typeof e._responseId > "u" || i(e._responseId)) && (typeof e.sourceId > "u" || typeof e.sourceId == "string") && (typeof e._sourceId > "u" || i(e._sourceId)) && (typeof e.targetId > "u" || typeof e.targetId == "string") && (typeof e._targetId > "u" || i(e._targetId)) && (typeof e.type > "u" || s(e.type)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url));
}
function ci(n) {
  const e = n;
  return d(e) && (typeof e.compareToSourceExpression > "u" || typeof e.compareToSourceExpression == "string") && (typeof e._compareToSourceExpression > "u" || i(e._compareToSourceExpression)) && (typeof e.compareToSourceId > "u" || typeof e.compareToSourceId == "string") && (typeof e._compareToSourceId > "u" || i(e._compareToSourceId)) && (typeof e.compareToSourcePath > "u" || typeof e.compareToSourcePath == "string") && (typeof e._compareToSourcePath > "u" || i(e._compareToSourcePath)) && (typeof e.contentType > "u" || typeof e.contentType == "string") && (typeof e._contentType > "u" || i(e._contentType)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.direction > "u" || e.direction === "response" || e.direction === "request") && (typeof e._direction > "u" || i(e._direction)) && (typeof e.expression > "u" || typeof e.expression == "string") && (typeof e._expression > "u" || i(e._expression)) && (typeof e.headerField > "u" || typeof e.headerField == "string") && (typeof e._headerField > "u" || i(e._headerField)) && (typeof e.label > "u" || typeof e.label == "string") && (typeof e._label > "u" || i(e._label)) && (typeof e.minimumId > "u" || typeof e.minimumId == "string") && (typeof e._minimumId > "u" || i(e._minimumId)) && (typeof e.navigationLinks > "u" || e.navigationLinks === !1 || e.navigationLinks === !0) && (typeof e._navigationLinks > "u" || i(e._navigationLinks)) && (typeof e.operator > "u" || e.operator === "empty" || e.operator === "in" || e.operator === "contains" || e.operator === "equals" || e.operator === "notEquals" || e.operator === "notIn" || e.operator === "greaterThan" || e.operator === "lessThan" || e.operator === "notEmpty" || e.operator === "notContains" || e.operator === "eval") && (typeof e._operator > "u" || i(e._operator)) && (typeof e.path > "u" || typeof e.path == "string") && (typeof e._path > "u" || i(e._path)) && (typeof e.requestMethod > "u" || e.requestMethod === "patch" || e.requestMethod === "delete" || e.requestMethod === "get" || e.requestMethod === "options" || e.requestMethod === "post" || e.requestMethod === "put" || e.requestMethod === "head") && (typeof e._requestMethod > "u" || i(e._requestMethod)) && (typeof e.requestURL > "u" || typeof e.requestURL == "string") && (typeof e._requestURL > "u" || i(e._requestURL)) && (typeof e.resource > "u" || typeof e.resource == "string") && (typeof e._resource > "u" || i(e._resource)) && (typeof e.response > "u" || e.response === "okay" || e.response === "created" || e.response === "noContent" || e.response === "notModified" || e.response === "bad" || e.response === "forbidden" || e.response === "notFound" || e.response === "methodNotAllowed" || e.response === "conflict" || e.response === "gone" || e.response === "preconditionFailed" || e.response === "unprocessable") && (typeof e._response > "u" || i(e._response)) && (typeof e.responseCode > "u" || typeof e.responseCode == "string") && (typeof e._responseCode > "u" || i(e._responseCode)) && (typeof e.sourceId > "u" || typeof e.sourceId == "string") && (typeof e._sourceId > "u" || i(e._sourceId)) && (typeof e.validateProfileId > "u" || typeof e.validateProfileId == "string") && (typeof e._validateProfileId > "u" || i(e._validateProfileId)) && (typeof e.value > "u" || typeof e.value == "string") && (typeof e._value > "u" || i(e._value)) && typeof e.warningOnly == "boolean" && (typeof e._warningOnly > "u" || i(e._warningOnly));
}
function rp(n) {
  const e = n;
  return d(e) && (typeof e.assert > "u" || ci(e.assert)) && (typeof e.operation > "u" || Fn(e.operation));
}
function op(n) {
  const e = n;
  return d(e) && Array.isArray(e.action) && e.action.every(
    (t) => rp(t)
  );
}
function dp(n) {
  const e = n;
  return d(e) && (typeof e.assert > "u" || ci(e.assert)) && (typeof e.operation > "u" || Fn(e.operation));
}
function ap(n) {
  const e = n;
  return d(e) && Array.isArray(e.action) && e.action.every(
    (t) => dp(t)
  ) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name));
}
function fp(n) {
  const e = n;
  return d(e) && Fn(e.operation);
}
function yp(n) {
  const e = n;
  return d(e) && Array.isArray(e.action) && e.action.every(
    (t) => fp(t)
  );
}
function hn(n) {
  const e = n;
  return f(e) && e.resourceType === "TestScript" && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.destination > "u" || Array.isArray(e.destination) && e.destination.every(
    (t) => Yu(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.fixture > "u" || Array.isArray(e.fixture) && e.fixture.every(
    (t) => tp(t)
  )) && (typeof e.identifier > "u" || a(e.identifier)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.metadata > "u" || ep(e.metadata)) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.origin > "u" || Array.isArray(e.origin) && e.origin.every(
    (t) => Xu(t)
  )) && (typeof e.profile > "u" || Array.isArray(e.profile) && e.profile.every(
    (t) => o(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (typeof e.setup > "u" || op(e.setup)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.teardown > "u" || yp(e.teardown)) && (typeof e.test > "u" || Array.isArray(e.test) && e.test.every(
    (t) => ap(t)
  )) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && typeof e.url == "string" && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.variable > "u" || Array.isArray(e.variable) && e.variable.every(
    (t) => np(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function li(n) {
  const e = n;
  return d(e) && (typeof e.language > "u" || typeof e.language == "string") && (typeof e._language > "u" || i(e._language)) && (typeof e.use > "u" || s(e.use)) && typeof e.value == "string" && (typeof e._value > "u" || i(e._value));
}
function up(n) {
  const e = n;
  return d(e) && typeof e.code == "string" && (typeof e._code > "u" || i(e._code)) && (typeof e.designation > "u" || Array.isArray(e.designation) && e.designation.every(
    (t) => li(t)
  )) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || i(e._display));
}
function pp(n) {
  const e = n;
  return d(e) && (e.op === "exists" || e.op === "in" || e.op === "=" || e.op === "is-a" || e.op === "descendent-of" || e.op === "is-not-a" || e.op === "regex" || e.op === "not-in" || e.op === "generalizes") && (typeof e._op > "u" || i(e._op)) && typeof e.property == "string" && (typeof e._property > "u" || i(e._property)) && typeof e.value == "string" && (typeof e._value > "u" || i(e._value));
}
function Mn(n) {
  const e = n;
  return d(e) && (typeof e.concept > "u" || Array.isArray(e.concept) && e.concept.every(
    (t) => up(t)
  )) && (typeof e.filter > "u" || Array.isArray(e.filter) && e.filter.every(
    (t) => pp(t)
  )) && (typeof e.system > "u" || typeof e.system == "string") && (typeof e._system > "u" || i(e._system)) && (typeof e.valueSet > "u" || Array.isArray(e.valueSet) && e.valueSet.every(
    (t) => typeof t == "string"
  )) && (typeof e._valueSet > "u" || Array.isArray(e._valueSet) && e._valueSet.every(
    (t) => i(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function sp(n) {
  const e = n;
  return d(e) && (typeof e.exclude > "u" || Array.isArray(e.exclude) && e.exclude.every(
    (t) => Mn(t)
  )) && (typeof e.inactive > "u" || e.inactive === !1 || e.inactive === !0) && (typeof e._inactive > "u" || i(e._inactive)) && Array.isArray(e.include) && e.include.every(
    (t) => Mn(t)
  ) && (typeof e.lockedDate > "u" || typeof e.lockedDate == "string") && (typeof e._lockedDate > "u" || i(e._lockedDate));
}
function cp(n) {
  const e = n;
  return d(e) && typeof e.name == "string" && (typeof e._name > "u" || i(e._name)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || i(e._valueString)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || i(e._valueBoolean)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || i(e._valueUri)) && (typeof e.valueCode > "u" || typeof e.valueCode == "string") && (typeof e._valueCode > "u" || i(e._valueCode)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || i(e._valueDateTime));
}
function vi(n) {
  const e = n;
  return d(e) && (typeof e.abstract > "u" || e.abstract === !1 || e.abstract === !0) && (typeof e._abstract > "u" || i(e._abstract)) && (typeof e.code > "u" || typeof e.code == "string") && (typeof e._code > "u" || i(e._code)) && (typeof e.contains > "u" || Array.isArray(e.contains) && e.contains.every(
    (t) => vi(t)
  )) && (typeof e.designation > "u" || Array.isArray(e.designation) && e.designation.every(
    (t) => li(t)
  )) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || i(e._display)) && (typeof e.inactive > "u" || e.inactive === !1 || e.inactive === !0) && (typeof e._inactive > "u" || i(e._inactive)) && (typeof e.system > "u" || typeof e.system == "string") && (typeof e._system > "u" || i(e._system)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function lp(n) {
  const e = n;
  return d(e) && (typeof e.contains > "u" || Array.isArray(e.contains) && e.contains.every(
    (t) => vi(t)
  )) && (typeof e.identifier > "u" || typeof e.identifier == "string") && (typeof e._identifier > "u" || i(e._identifier)) && (typeof e.offset > "u" || typeof e.offset == "number") && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => cp(t)
  )) && typeof e.timestamp == "string" && (typeof e._timestamp > "u" || i(e._timestamp)) && (typeof e.total > "u" || typeof e.total == "number");
}
function wn(n) {
  const e = n;
  return f(e) && e.resourceType === "ValueSet" && (typeof e.compose > "u" || sp(e.compose)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => p(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || i(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || i(e._description)) && (typeof e.expansion > "u" || lp(e.expansion)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || i(e._experimental)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && (typeof e.immutable > "u" || e.immutable === !1 || e.immutable === !0) && (typeof e._immutable > "u" || i(e._immutable)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => r(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || i(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || i(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || i(e._purpose)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || i(e._status)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || i(e._title)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || i(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => m(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || i(e._version));
}
function vp(n) {
  const e = n;
  return d(e) && (typeof e.canPushUpdates > "u" || r(e.canPushUpdates)) && (typeof e.communicationMethod > "u" || Array.isArray(e.communicationMethod) && e.communicationMethod.every(
    (t) => r(t)
  )) && (typeof e.pushTypeAvailable > "u" || Array.isArray(e.pushTypeAvailable) && e.pushTypeAvailable.every(
    (t) => r(t)
  )) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => r(t)
  )) && (typeof e.validationDate > "u" || typeof e.validationDate == "string") && (typeof e._validationDate > "u" || i(e._validationDate)) && (typeof e.validationStatus > "u" || r(e.validationStatus)) && (typeof e.who > "u" || o(e.who));
}
function mp(n) {
  const e = n;
  return d(e) && (typeof e.communicationMethod > "u" || r(e.communicationMethod)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || i(e._date)) && (typeof e.onBehalfOf > "u" || o(e.onBehalfOf)) && (typeof e.proxyIdentityCertificate > "u" || typeof e.proxyIdentityCertificate == "string") && (typeof e._proxyIdentityCertificate > "u" || i(e._proxyIdentityCertificate)) && (typeof e.proxySignature > "u" || O(e.proxySignature)) && (typeof e.sourceIdentityCertificate > "u" || typeof e.sourceIdentityCertificate == "string") && (typeof e._sourceIdentityCertificate > "u" || i(e._sourceIdentityCertificate)) && (typeof e.sourceSignature > "u" || O(e.sourceSignature)) && (typeof e.who > "u" || o(e.who));
}
function gp(n) {
  const e = n;
  return d(e) && (typeof e.attestationSignature > "u" || O(e.attestationSignature)) && (typeof e.identityCertificate > "u" || typeof e.identityCertificate == "string") && (typeof e._identityCertificate > "u" || i(e._identityCertificate)) && o(e.organization);
}
function Rn(n) {
  const e = n;
  return f(e) && e.resourceType === "VerificationResult" && (typeof e.attestation > "u" || mp(e.attestation)) && (typeof e.failureAction > "u" || r(e.failureAction)) && (typeof e.frequency > "u" || A(e.frequency)) && (typeof e.lastPerformed > "u" || typeof e.lastPerformed == "string") && (typeof e._lastPerformed > "u" || i(e._lastPerformed)) && (typeof e.need > "u" || r(e.need)) && (typeof e.nextScheduled > "u" || typeof e.nextScheduled == "string") && (typeof e._nextScheduled > "u" || i(e._nextScheduled)) && (typeof e.primarySource > "u" || Array.isArray(e.primarySource) && e.primarySource.every(
    (t) => vp(t)
  )) && (e.status === "attested" || e.status === "validated" || e.status === "in-process" || e.status === "req-revalid" || e.status === "val-fail" || e.status === "reval-fail") && (typeof e._status > "u" || i(e._status)) && (typeof e.statusDate > "u" || typeof e.statusDate == "string") && (typeof e._statusDate > "u" || i(e._statusDate)) && (typeof e.target > "u" || Array.isArray(e.target) && e.target.every(
    (t) => o(t)
  )) && (typeof e.targetLocation > "u" || Array.isArray(e.targetLocation) && e.targetLocation.every(
    (t) => typeof t == "string"
  )) && (typeof e._targetLocation > "u" || Array.isArray(e._targetLocation) && e._targetLocation.every(
    (t) => i(t)
  )) && (typeof e.validationProcess > "u" || Array.isArray(e.validationProcess) && e.validationProcess.every(
    (t) => r(t)
  )) && (typeof e.validationType > "u" || r(e.validationType)) && (typeof e.validator > "u" || Array.isArray(e.validator) && e.validator.every(
    (t) => gp(t)
  ));
}
function _p(n) {
  const e = n;
  return d(e) && typeof e.amount == "number" && (e.base === "in" || e.base === "out" || e.base === "up" || e.base === "down") && (typeof e._base > "u" || i(e._base));
}
function Ap(n) {
  const e = n;
  return d(e) && (typeof e.add > "u" || typeof e.add == "number") && (typeof e.axis > "u" || typeof e.axis == "number") && (typeof e.backCurve > "u" || typeof e.backCurve == "number") && (typeof e.brand > "u" || typeof e.brand == "string") && (typeof e._brand > "u" || i(e._brand)) && (typeof e.color > "u" || typeof e.color == "string") && (typeof e._color > "u" || i(e._color)) && (typeof e.cylinder > "u" || typeof e.cylinder == "number") && (typeof e.diameter > "u" || typeof e.diameter == "number") && (typeof e.duration > "u" || u(e.duration)) && (e.eye === "right" || e.eye === "left") && (typeof e._eye > "u" || i(e._eye)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => l(t)
  )) && (typeof e.power > "u" || typeof e.power == "number") && (typeof e.prism > "u" || Array.isArray(e.prism) && e.prism.every(
    (t) => _p(t)
  )) && r(e.product) && (typeof e.sphere > "u" || typeof e.sphere == "number");
}
function Cn(n) {
  const e = n;
  return f(e) && e.resourceType === "VisionPrescription" && typeof e.created == "string" && (typeof e._created > "u" || i(e._created)) && typeof e.dateWritten == "string" && (typeof e._dateWritten > "u" || i(e._dateWritten)) && (typeof e.encounter > "u" || o(e.encounter)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => a(t)
  )) && Array.isArray(e.lensSpecification) && e.lensSpecification.every(
    (t) => Ap(t)
  ) && o(e.patient) && o(e.prescriber) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || i(e._status));
}
function bp(n) {
  const e = n;
  return V(e) || U(e) || N(e) || L(e) || G(e) || z(e) || Q(e) || W(e) || K(e) || J(e) || X(e) || Y(e) || Z(e) || $(e) || ee(e) || te(e) || ne(e) || ie(e) || re(e) || oe(e) || de(e) || ae(e) || fe(e) || ye(e) || ue(e) || pe(e) || se(e) || ce(e) || le(e) || ve(e) || me(e) || ge(e) || _e(e) || Ae(e) || be(e) || Ie(e) || he(e) || we(e) || Re(e) || Ce(e) || De(e) || Se(e) || Oe(e) || Ee(e) || Te(e) || xe(e) || je(e) || Pe(e) || Fe(e) || He(e) || Me(e) || qe(e) || ke(e) || Be(e) || Ve(e) || Ue(e) || Ne(e) || Le(e) || Ge(e) || ze(e) || Qe(e) || We(e) || Ke(e) || Je(e) || Xe(e) || Ye(e) || Ze(e) || $e(e) || et(e) || tt(e) || nt(e) || it(e) || rt(e) || ot(e) || dt(e) || at(e) || ft(e) || yt(e) || ut(e) || pt(e) || st(e) || ct(e) || lt(e) || vt(e) || mt(e) || gt(e) || _t(e) || At(e) || bt(e) || It(e) || ht(e) || wt(e) || Rt(e) || Ct(e) || Dt(e) || St(e) || Ot(e) || Et(e) || Tt(e) || xt(e) || jt(e) || Pt(e) || Ft(e) || Ht(e) || Mt(e) || qt(e) || kt(e) || Bt(e) || Vt(e) || Ut(e) || Nt(e) || Lt(e) || Gt(e) || zt(e) || Qt(e) || Wt(e) || Kt(e) || Jt(e) || Xt(e) || Zt(e) || $t(e) || en(e) || tn(e) || nn(e) || rn(e) || on(e) || dn(e) || an(e) || fn(e) || yn(e) || un(e) || pn(e) || sn(e) || cn(e) || ln(e) || vn(e) || mn(e) || gn(e) || _n(e) || An(e) || bn(e) || In(e) || hn(e) || wn(e) || Rn(e) || Cn(e);
}
const Ip = (n) => {
  if (h(n))
    return n;
  throw new Error("Invalid FHIR type");
}, hp = (n) => {
  if (C(n))
    return n;
  throw new Error("Invalid FHIR type");
}, wp = (n) => {
  if (l(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Rp = (n) => {
  if (g(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Cp = (n) => {
  if (d(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Dp = (n) => {
  if (r(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Sp = (n) => {
  if (s(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Op = (n) => {
  if (p(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ep = (n) => {
  if (I(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Tp = (n) => {
  if (F(n))
    return n;
  throw new Error("Invalid FHIR type");
}, xp = (n) => {
  if (H(n))
    return n;
  throw new Error("Invalid FHIR type");
}, jp = (n) => {
  if (mi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Pp = (n) => {
  if (gi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Fp = (n) => {
  if (_i(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Hp = (n) => {
  if (D(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Mp = (n) => {
  if (M(n))
    return n;
  throw new Error("Invalid FHIR type");
}, qp = (n) => {
  if (Ai(n))
    return n;
  throw new Error("Invalid FHIR type");
}, kp = (n) => {
  if (E(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Bp = (n) => {
  if (_(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Vp = (n) => {
  if (i(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Up = (n) => {
  if (bi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Np = (n) => {
  if (Ii(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Lp = (n) => {
  if (hi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Gp = (n) => {
  if (wi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, zp = (n) => {
  if (Ri(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Qp = (n) => {
  if (Ci(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Wp = (n) => {
  if (Di(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Kp = (n) => {
  if (Si(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Jp = (n) => {
  if (qn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Xp = (n) => {
  if (R(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Yp = (n) => {
  if (B(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Zp = (n) => {
  if (S(n))
    return n;
  throw new Error("Invalid FHIR type");
}, $p = (n) => {
  if (a(n))
    return n;
  throw new Error("Invalid FHIR type");
}, es = (n) => {
  if (kn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ts = (n) => {
  if (j(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ns = (n) => {
  if (c(n))
    return n;
  throw new Error("Invalid FHIR type");
}, is = (n) => {
  if (Bn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, rs = (n) => {
  if (P(n))
    return n;
  throw new Error("Invalid FHIR type");
}, os = (n) => {
  if (y(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ds = (n) => {
  if (On(n))
    return n;
  throw new Error("Invalid FHIR type");
}, as = (n) => {
  if (En(n))
    return n;
  throw new Error("Invalid FHIR type");
}, fs = (n) => {
  if (Vn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ys = (n) => {
  if (u(n))
    return n;
  throw new Error("Invalid FHIR type");
}, us = (n) => {
  if (v(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ps = (n) => {
  if (b(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ss = (n) => {
  if (o(n))
    return n;
  throw new Error("Invalid FHIR type");
}, cs = (n) => {
  if (w(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ls = (n) => {
  if (x(n))
    return n;
  throw new Error("Invalid FHIR type");
}, vs = (n) => {
  if (O(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ms = (n) => {
  if (Oi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, gs = (n) => {
  if (Tn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, _s = (n) => {
  if (Ei(n))
    return n;
  throw new Error("Invalid FHIR type");
}, As = (n) => {
  if (A(n))
    return n;
  throw new Error("Invalid FHIR type");
}, bs = (n) => {
  if (T(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Is = (n) => {
  if (m(n))
    return n;
  throw new Error("Invalid FHIR type");
}, hs = (n) => {
  if (Ti(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ws = (n) => {
  if (xi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Rs = (n) => {
  if (V(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Cs = (n) => {
  if (ji(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ds = (n) => {
  if (Pi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ss = (n) => {
  if (U(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Os = (n) => {
  if (Fi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Es = (n) => {
  if (Hi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ts = (n) => {
  if (N(n))
    return n;
  throw new Error("Invalid FHIR type");
}, xs = (n) => {
  if (Mi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, js = (n) => {
  if (L(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ps = (n) => {
  if (qi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Fs = (n) => {
  if (G(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Hs = (n) => {
  if (z(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ms = (n) => {
  if (ki(n))
    return n;
  throw new Error("Invalid FHIR type");
}, qs = (n) => {
  if (Bi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ks = (n) => {
  if (Vi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Bs = (n) => {
  if (Ui(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Vs = (n) => {
  if (Ni(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Us = (n) => {
  if (Q(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ns = (n) => {
  if (W(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ls = (n) => {
  if (K(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Gs = (n) => {
  if (Li(n))
    return n;
  throw new Error("Invalid FHIR type");
}, zs = (n) => {
  if (Gi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Qs = (n) => {
  if (zi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ws = (n) => {
  if (Qi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ks = (n) => {
  if (J(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Js = (n) => {
  if (X(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Xs = (n) => {
  if (Un(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ys = (n) => {
  if (Wi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Zs = (n) => {
  if (Ki(n))
    return n;
  throw new Error("Invalid FHIR type");
}, $s = (n) => {
  if (Ji(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ec = (n) => {
  if (Xi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, tc = (n) => {
  if (Y(n))
    return n;
  throw new Error("Invalid FHIR type");
}, nc = (n) => {
  if (Yi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ic = (n) => {
  if (Zi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, rc = (n) => {
  if ($i(n))
    return n;
  throw new Error("Invalid FHIR type");
}, oc = (n) => {
  if (er(n))
    return n;
  throw new Error("Invalid FHIR type");
}, dc = (n) => {
  if (Nn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ac = (n) => {
  if (Ln(n))
    return n;
  throw new Error("Invalid FHIR type");
}, fc = (n) => {
  if (tr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, yc = (n) => {
  if (nr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, uc = (n) => {
  if (ir(n))
    return n;
  throw new Error("Invalid FHIR type");
}, pc = (n) => {
  if (rr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, sc = (n) => {
  if (or(n))
    return n;
  throw new Error("Invalid FHIR type");
}, cc = (n) => {
  if (dr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, lc = (n) => {
  if (ar(n))
    return n;
  throw new Error("Invalid FHIR type");
}, vc = (n) => {
  if (Z(n))
    return n;
  throw new Error("Invalid FHIR type");
}, mc = (n) => {
  if (fr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, gc = (n) => {
  if (yr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, _c = (n) => {
  if ($(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ac = (n) => {
  if (ur(n))
    return n;
  throw new Error("Invalid FHIR type");
}, bc = (n) => {
  if (ee(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ic = (n) => {
  if (pr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, hc = (n) => {
  if (te(n))
    return n;
  throw new Error("Invalid FHIR type");
}, wc = (n) => {
  if (sr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Rc = (n) => {
  if (ne(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Cc = (n) => {
  if (Gn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Dc = (n) => {
  if (cr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Sc = (n) => {
  if (lr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Oc = (n) => {
  if (ie(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ec = (n) => {
  if (vr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Tc = (n) => {
  if (mr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, xc = (n) => {
  if (gr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, jc = (n) => {
  if (_r(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Pc = (n) => {
  if (Ar(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Fc = (n) => {
  if (br(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Hc = (n) => {
  if (Ir(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Mc = (n) => {
  if (hr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, qc = (n) => {
  if (wr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, kc = (n) => {
  if (Rr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Bc = (n) => {
  if (Cr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Vc = (n) => {
  if (re(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Uc = (n) => {
  if (q(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Nc = (n) => {
  if (Dr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Lc = (n) => {
  if (Sr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Gc = (n) => {
  if (Or(n))
    return n;
  throw new Error("Invalid FHIR type");
}, zc = (n) => {
  if (Er(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Qc = (n) => {
  if (Tr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Wc = (n) => {
  if (xr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Kc = (n) => {
  if (jr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Jc = (n) => {
  if (Pr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Xc = (n) => {
  if (Fr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Yc = (n) => {
  if (Hr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Zc = (n) => {
  if (Mr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, $c = (n) => {
  if (oe(n))
    return n;
  throw new Error("Invalid FHIR type");
}, el = (n) => {
  if (qr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, tl = (n) => {
  if (kr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, nl = (n) => {
  if (de(n))
    return n;
  throw new Error("Invalid FHIR type");
}, il = (n) => {
  if (Br(n))
    return n;
  throw new Error("Invalid FHIR type");
}, rl = (n) => {
  if (Vr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ol = (n) => {
  if (Ur(n))
    return n;
  throw new Error("Invalid FHIR type");
}, dl = (n) => {
  if (Nr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, al = (n) => {
  if (zn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, fl = (n) => {
  if (ae(n))
    return n;
  throw new Error("Invalid FHIR type");
}, yl = (n) => {
  if (Lr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ul = (n) => {
  if (fe(n))
    return n;
  throw new Error("Invalid FHIR type");
}, pl = (n) => {
  if (Gr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, sl = (n) => {
  if (ye(n))
    return n;
  throw new Error("Invalid FHIR type");
}, cl = (n) => {
  if (zr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ll = (n) => {
  if (ue(n))
    return n;
  throw new Error("Invalid FHIR type");
}, vl = (n) => {
  if (Qr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ml = (n) => {
  if (Wr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, gl = (n) => {
  if (Kr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, _l = (n) => {
  if (Qn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Al = (n) => {
  if (pe(n))
    return n;
  throw new Error("Invalid FHIR type");
}, bl = (n) => {
  if (Hn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Il = (n) => {
  if (Jr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, hl = (n) => {
  if (Xr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, wl = (n) => {
  if (Yr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Rl = (n) => {
  if (Zr(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Cl = (n) => {
  if (se(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Dl = (n) => {
  if ($r(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Sl = (n) => {
  if (eo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ol = (n) => {
  if (ce(n))
    return n;
  throw new Error("Invalid FHIR type");
}, El = (n) => {
  if (to(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Tl = (n) => {
  if (no(n))
    return n;
  throw new Error("Invalid FHIR type");
}, xl = (n) => {
  if (io(n))
    return n;
  throw new Error("Invalid FHIR type");
}, jl = (n) => {
  if (ro(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Pl = (n) => {
  if (Wn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Fl = (n) => {
  if (le(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Hl = (n) => {
  if (oo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ml = (n) => {
  if (ao(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ql = (n) => {
  if (fo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, kl = (n) => {
  if (Kn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Bl = (n) => {
  if (yo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Vl = (n) => {
  if (uo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ul = (n) => {
  if (po(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Nl = (n) => {
  if (so(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ll = (n) => {
  if (co(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Gl = (n) => {
  if (lo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, zl = (n) => {
  if (Jn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ql = (n) => {
  if (vo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Wl = (n) => {
  if (mo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Kl = (n) => {
  if (go(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Jl = (n) => {
  if (_o(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Xl = (n) => {
  if (ve(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Yl = (n) => {
  if (Ao(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Zl = (n) => {
  if (bo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, $l = (n) => {
  if (Io(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ev = (n) => {
  if (me(n))
    return n;
  throw new Error("Invalid FHIR type");
}, tv = (n) => {
  if (ho(n))
    return n;
  throw new Error("Invalid FHIR type");
}, nv = (n) => {
  if (wo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, iv = (n) => {
  if (Ro(n))
    return n;
  throw new Error("Invalid FHIR type");
}, rv = (n) => {
  if (Co(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ov = (n) => {
  if (ge(n))
    return n;
  throw new Error("Invalid FHIR type");
}, dv = (n) => {
  if (Do(n))
    return n;
  throw new Error("Invalid FHIR type");
}, av = (n) => {
  if (So(n))
    return n;
  throw new Error("Invalid FHIR type");
}, fv = (n) => {
  if (Oo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, yv = (n) => {
  if (Eo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, uv = (n) => {
  if (_e(n))
    return n;
  throw new Error("Invalid FHIR type");
}, pv = (n) => {
  if (To(n))
    return n;
  throw new Error("Invalid FHIR type");
}, sv = (n) => {
  if (xo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, cv = (n) => {
  if (Ae(n))
    return n;
  throw new Error("Invalid FHIR type");
}, lv = (n) => {
  if (jo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, vv = (n) => {
  if (Po(n))
    return n;
  throw new Error("Invalid FHIR type");
}, mv = (n) => {
  if (Fo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, gv = (n) => {
  if (Ho(n))
    return n;
  throw new Error("Invalid FHIR type");
}, _v = (n) => {
  if (Mo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Av = (n) => {
  if (be(n))
    return n;
  throw new Error("Invalid FHIR type");
}, bv = (n) => {
  if (qo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Iv = (n) => {
  if (ko(n))
    return n;
  throw new Error("Invalid FHIR type");
}, hv = (n) => {
  if (Bo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, wv = (n) => {
  if (Vo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Rv = (n) => {
  if (Uo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Cv = (n) => {
  if (No(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Dv = (n) => {
  if (Ie(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Sv = (n) => {
  if (Lo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ov = (n) => {
  if (he(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ev = (n) => {
  if (Go(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Tv = (n) => {
  if (we(n))
    return n;
  throw new Error("Invalid FHIR type");
}, xv = (n) => {
  if (Re(n))
    return n;
  throw new Error("Invalid FHIR type");
}, jv = (n) => {
  if (zo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Pv = (n) => {
  if (Ce(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Fv = (n) => {
  if (Qo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Hv = (n) => {
  if (De(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Mv = (n) => {
  if (Wo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, qv = (n) => {
  if (Ko(n))
    return n;
  throw new Error("Invalid FHIR type");
}, kv = (n) => {
  if (Jo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Bv = (n) => {
  if (Se(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Vv = (n) => {
  if (f(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Uv = (n) => {
  if (Xo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Nv = (n) => {
  if (Yo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Lv = (n) => {
  if (Zo(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Gv = (n) => {
  if ($o(n))
    return n;
  throw new Error("Invalid FHIR type");
}, zv = (n) => {
  if (ed(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Qv = (n) => {
  if (td(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Wv = (n) => {
  if (Oe(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Kv = (n) => {
  if (nd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Jv = (n) => {
  if (id(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Xv = (n) => {
  if (rd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Yv = (n) => {
  if (od(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Zv = (n) => {
  if (dd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, $v = (n) => {
  if (ad(n))
    return n;
  throw new Error("Invalid FHIR type");
}, em = (n) => {
  if (Ee(n))
    return n;
  throw new Error("Invalid FHIR type");
}, tm = (n) => {
  if (Te(n))
    return n;
  throw new Error("Invalid FHIR type");
}, nm = (n) => {
  if (xe(n))
    return n;
  throw new Error("Invalid FHIR type");
}, im = (n) => {
  if (je(n))
    return n;
  throw new Error("Invalid FHIR type");
}, rm = (n) => {
  if (fd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, om = (n) => {
  if (yd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, dm = (n) => {
  if (Pe(n))
    return n;
  throw new Error("Invalid FHIR type");
}, am = (n) => {
  if (Fe(n))
    return n;
  throw new Error("Invalid FHIR type");
}, fm = (n) => {
  if (He(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ym = (n) => {
  if (ud(n))
    return n;
  throw new Error("Invalid FHIR type");
}, um = (n) => {
  if (Me(n))
    return n;
  throw new Error("Invalid FHIR type");
}, pm = (n) => {
  if (pd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, sm = (n) => {
  if (sd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, cm = (n) => {
  if (Dn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, lm = (n) => {
  if (cd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, vm = (n) => {
  if (ld(n))
    return n;
  throw new Error("Invalid FHIR type");
}, mm = (n) => {
  if (vd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, gm = (n) => {
  if (Xn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, _m = (n) => {
  if (Yn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Am = (n) => {
  if (qe(n))
    return n;
  throw new Error("Invalid FHIR type");
}, bm = (n) => {
  if (md(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Im = (n) => {
  if (gd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, hm = (n) => {
  if (_d(n))
    return n;
  throw new Error("Invalid FHIR type");
}, wm = (n) => {
  if (Ad(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Rm = (n) => {
  if (bd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Cm = (n) => {
  if (Id(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Dm = (n) => {
  if (hd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Sm = (n) => {
  if (wd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Om = (n) => {
  if (k(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Em = (n) => {
  if (Rd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Tm = (n) => {
  if (Cd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, xm = (n) => {
  if (Dd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, jm = (n) => {
  if (Sd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Pm = (n) => {
  if (Od(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Fm = (n) => {
  if (Ed(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Hm = (n) => {
  if (Td(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Mm = (n) => {
  if (xd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, qm = (n) => {
  if (jd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, km = (n) => {
  if (Pd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Bm = (n) => {
  if (Fd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Vm = (n) => {
  if (ke(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Um = (n) => {
  if (Hd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Nm = (n) => {
  if (Be(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Lm = (n) => {
  if (Ve(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Gm = (n) => {
  if (Md(n))
    return n;
  throw new Error("Invalid FHIR type");
}, zm = (n) => {
  if (Ue(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Qm = (n) => {
  if (qd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Wm = (n) => {
  if (kd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Km = (n) => {
  if (Zn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Jm = (n) => {
  if (Ne(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Xm = (n) => {
  if (Bd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ym = (n) => {
  if (Vd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Zm = (n) => {
  if (Le(n))
    return n;
  throw new Error("Invalid FHIR type");
}, $m = (n) => {
  if (Ge(n))
    return n;
  throw new Error("Invalid FHIR type");
}, eg = (n) => {
  if (Ud(n))
    return n;
  throw new Error("Invalid FHIR type");
}, tg = (n) => {
  if (Nd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ng = (n) => {
  if (Ld(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ig = (n) => {
  if (ze(n))
    return n;
  throw new Error("Invalid FHIR type");
}, rg = (n) => {
  if (Gd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, og = (n) => {
  if (zd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, dg = (n) => {
  if (Qd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ag = (n) => {
  if (Qe(n))
    return n;
  throw new Error("Invalid FHIR type");
}, fg = (n) => {
  if (Wd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, yg = (n) => {
  if (Kd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ug = (n) => {
  if (Jd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, pg = (n) => {
  if (Xd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, sg = (n) => {
  if (We(n))
    return n;
  throw new Error("Invalid FHIR type");
}, cg = (n) => {
  if (Ke(n))
    return n;
  throw new Error("Invalid FHIR type");
}, lg = (n) => {
  if (Yd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, vg = (n) => {
  if (Zd(n))
    return n;
  throw new Error("Invalid FHIR type");
}, mg = (n) => {
  if (Je(n))
    return n;
  throw new Error("Invalid FHIR type");
}, gg = (n) => {
  if ($d(n))
    return n;
  throw new Error("Invalid FHIR type");
}, _g = (n) => {
  if (ea(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ag = (n) => {
  if (ta(n))
    return n;
  throw new Error("Invalid FHIR type");
}, bg = (n) => {
  if (na(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ig = (n) => {
  if ($n(n))
    return n;
  throw new Error("Invalid FHIR type");
}, hg = (n) => {
  if (ia(n))
    return n;
  throw new Error("Invalid FHIR type");
}, wg = (n) => {
  if (ra(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Rg = (n) => {
  if (oa(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Cg = (n) => {
  if (da(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Dg = (n) => {
  if (aa(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Sg = (n) => {
  if (fa(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Og = (n) => {
  if (Xe(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Eg = (n) => {
  if (ya(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Tg = (n) => {
  if (ua(n))
    return n;
  throw new Error("Invalid FHIR type");
}, xg = (n) => {
  if (pa(n))
    return n;
  throw new Error("Invalid FHIR type");
}, jg = (n) => {
  if (sa(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Pg = (n) => {
  if (ca(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Fg = (n) => {
  if (la(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Hg = (n) => {
  if (va(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Mg = (n) => {
  if (ma(n))
    return n;
  throw new Error("Invalid FHIR type");
}, qg = (n) => {
  if (ga(n))
    return n;
  throw new Error("Invalid FHIR type");
}, kg = (n) => {
  if (Ye(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Bg = (n) => {
  if (_a(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Vg = (n) => {
  if (ei(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ug = (n) => {
  if (Aa(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ng = (n) => {
  if (Ze(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Lg = (n) => {
  if ($e(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Gg = (n) => {
  if (ba(n))
    return n;
  throw new Error("Invalid FHIR type");
}, zg = (n) => {
  if (et(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Qg = (n) => {
  if (Ia(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Wg = (n) => {
  if (tt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Kg = (n) => {
  if (ha(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Jg = (n) => {
  if (wa(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Xg = (n) => {
  if (nt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Yg = (n) => {
  if (Ra(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Zg = (n) => {
  if (Ca(n))
    return n;
  throw new Error("Invalid FHIR type");
}, $g = (n) => {
  if (Da(n))
    return n;
  throw new Error("Invalid FHIR type");
}, e_ = (n) => {
  if (Sa(n))
    return n;
  throw new Error("Invalid FHIR type");
}, t_ = (n) => {
  if (Oa(n))
    return n;
  throw new Error("Invalid FHIR type");
}, n_ = (n) => {
  if (it(n))
    return n;
  throw new Error("Invalid FHIR type");
}, i_ = (n) => {
  if (Ea(n))
    return n;
  throw new Error("Invalid FHIR type");
}, r_ = (n) => {
  if (Ta(n))
    return n;
  throw new Error("Invalid FHIR type");
}, o_ = (n) => {
  if (xa(n))
    return n;
  throw new Error("Invalid FHIR type");
}, d_ = (n) => {
  if (ja(n))
    return n;
  throw new Error("Invalid FHIR type");
}, a_ = (n) => {
  if (Pa(n))
    return n;
  throw new Error("Invalid FHIR type");
}, f_ = (n) => {
  if (Fa(n))
    return n;
  throw new Error("Invalid FHIR type");
}, y_ = (n) => {
  if (rt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, u_ = (n) => {
  if (ot(n))
    return n;
  throw new Error("Invalid FHIR type");
}, p_ = (n) => {
  if (Ha(n))
    return n;
  throw new Error("Invalid FHIR type");
}, s_ = (n) => {
  if (Ma(n))
    return n;
  throw new Error("Invalid FHIR type");
}, c_ = (n) => {
  if (dt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, l_ = (n) => {
  if (qa(n))
    return n;
  throw new Error("Invalid FHIR type");
}, v_ = (n) => {
  if (ka(n))
    return n;
  throw new Error("Invalid FHIR type");
}, m_ = (n) => {
  if (at(n))
    return n;
  throw new Error("Invalid FHIR type");
}, g_ = (n) => {
  if (Ba(n))
    return n;
  throw new Error("Invalid FHIR type");
}, __ = (n) => {
  if (Va(n))
    return n;
  throw new Error("Invalid FHIR type");
}, A_ = (n) => {
  if (ft(n))
    return n;
  throw new Error("Invalid FHIR type");
}, b_ = (n) => {
  if (Ua(n))
    return n;
  throw new Error("Invalid FHIR type");
}, I_ = (n) => {
  if (Na(n))
    return n;
  throw new Error("Invalid FHIR type");
}, h_ = (n) => {
  if (La(n))
    return n;
  throw new Error("Invalid FHIR type");
}, w_ = (n) => {
  if (Ga(n))
    return n;
  throw new Error("Invalid FHIR type");
}, R_ = (n) => {
  if (za(n))
    return n;
  throw new Error("Invalid FHIR type");
}, C_ = (n) => {
  if (Qa(n))
    return n;
  throw new Error("Invalid FHIR type");
}, D_ = (n) => {
  if (Wa(n))
    return n;
  throw new Error("Invalid FHIR type");
}, S_ = (n) => {
  if (Ka(n))
    return n;
  throw new Error("Invalid FHIR type");
}, O_ = (n) => {
  if (Ja(n))
    return n;
  throw new Error("Invalid FHIR type");
}, E_ = (n) => {
  if (Xa(n))
    return n;
  throw new Error("Invalid FHIR type");
}, T_ = (n) => {
  if (Ya(n))
    return n;
  throw new Error("Invalid FHIR type");
}, x_ = (n) => {
  if (Za(n))
    return n;
  throw new Error("Invalid FHIR type");
}, j_ = (n) => {
  if ($a(n))
    return n;
  throw new Error("Invalid FHIR type");
}, P_ = (n) => {
  if (ef(n))
    return n;
  throw new Error("Invalid FHIR type");
}, F_ = (n) => {
  if (tf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, H_ = (n) => {
  if (nf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, M_ = (n) => {
  if (yt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, q_ = (n) => {
  if (rf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, k_ = (n) => {
  if (of(n))
    return n;
  throw new Error("Invalid FHIR type");
}, B_ = (n) => {
  if (df(n))
    return n;
  throw new Error("Invalid FHIR type");
}, V_ = (n) => {
  if (ut(n))
    return n;
  throw new Error("Invalid FHIR type");
}, U_ = (n) => {
  if (pt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, N_ = (n) => {
  if (af(n))
    return n;
  throw new Error("Invalid FHIR type");
}, L_ = (n) => {
  if (ff(n))
    return n;
  throw new Error("Invalid FHIR type");
}, G_ = (n) => {
  if (yf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, z_ = (n) => {
  if (uf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Q_ = (n) => {
  if (pf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, W_ = (n) => {
  if (st(n))
    return n;
  throw new Error("Invalid FHIR type");
}, K_ = (n) => {
  if (sf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, J_ = (n) => {
  if (ti(n))
    return n;
  throw new Error("Invalid FHIR type");
}, X_ = (n) => {
  if (ct(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Y_ = (n) => {
  if (cf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Z_ = (n) => {
  if (lt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, $_ = (n) => {
  if (lf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, eA = (n) => {
  if (vt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, tA = (n) => {
  if (vf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, nA = (n) => {
  if (ni(n))
    return n;
  throw new Error("Invalid FHIR type");
}, iA = (n) => {
  if (mf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, rA = (n) => {
  if (gf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, oA = (n) => {
  if (mt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, dA = (n) => {
  if (_f(n))
    return n;
  throw new Error("Invalid FHIR type");
}, aA = (n) => {
  if (gt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, fA = (n) => {
  if (_t(n))
    return n;
  throw new Error("Invalid FHIR type");
}, yA = (n) => {
  if (Af(n))
    return n;
  throw new Error("Invalid FHIR type");
}, uA = (n) => {
  if (ii(n))
    return n;
  throw new Error("Invalid FHIR type");
}, pA = (n) => {
  if (At(n))
    return n;
  throw new Error("Invalid FHIR type");
}, sA = (n) => {
  if (bf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, cA = (n) => {
  if (If(n))
    return n;
  throw new Error("Invalid FHIR type");
}, lA = (n) => {
  if (hf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, vA = (n) => {
  if (wf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, mA = (n) => {
  if (bt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, gA = (n) => {
  if (It(n))
    return n;
  throw new Error("Invalid FHIR type");
}, _A = (n) => {
  if (Rf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, AA = (n) => {
  if (Cf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, bA = (n) => {
  if (ht(n))
    return n;
  throw new Error("Invalid FHIR type");
}, IA = (n) => {
  if (Df(n))
    return n;
  throw new Error("Invalid FHIR type");
}, hA = (n) => {
  if (Sf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, wA = (n) => {
  if (Of(n))
    return n;
  throw new Error("Invalid FHIR type");
}, RA = (n) => {
  if (wt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, CA = (n) => {
  if (Ef(n))
    return n;
  throw new Error("Invalid FHIR type");
}, DA = (n) => {
  if (Tf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, SA = (n) => {
  if (xf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, OA = (n) => {
  if (jf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, EA = (n) => {
  if (Pf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, TA = (n) => {
  if (Ff(n))
    return n;
  throw new Error("Invalid FHIR type");
}, xA = (n) => {
  if (Hf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, jA = (n) => {
  if (Mf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, PA = (n) => {
  if (Rt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, FA = (n) => {
  if (qf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, HA = (n) => {
  if (Ct(n))
    return n;
  throw new Error("Invalid FHIR type");
}, MA = (n) => {
  if (kf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, qA = (n) => {
  if (Bf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, kA = (n) => {
  if (Vf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, BA = (n) => {
  if (Uf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, VA = (n) => {
  if (Nf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, UA = (n) => {
  if (Lf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, NA = (n) => {
  if (Dt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, LA = (n) => {
  if (ri(n))
    return n;
  throw new Error("Invalid FHIR type");
}, GA = (n) => {
  if (Gf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, zA = (n) => {
  if (St(n))
    return n;
  throw new Error("Invalid FHIR type");
}, QA = (n) => {
  if (zf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, WA = (n) => {
  if (Qf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, KA = (n) => {
  if (Ot(n))
    return n;
  throw new Error("Invalid FHIR type");
}, JA = (n) => {
  if (Wf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, XA = (n) => {
  if (Kf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, YA = (n) => {
  if (oi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ZA = (n) => {
  if (Jf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, $A = (n) => {
  if (Et(n))
    return n;
  throw new Error("Invalid FHIR type");
}, eb = (n) => {
  if (Xf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, tb = (n) => {
  if (Tt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, nb = (n) => {
  if (Yf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ib = (n) => {
  if (xt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, rb = (n) => {
  if (jt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ob = (n) => {
  if (di(n))
    return n;
  throw new Error("Invalid FHIR type");
}, db = (n) => {
  if (Pt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ab = (n) => {
  if (Zf(n))
    return n;
  throw new Error("Invalid FHIR type");
}, fb = (n) => {
  if ($f(n))
    return n;
  throw new Error("Invalid FHIR type");
}, yb = (n) => {
  if (ey(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ub = (n) => {
  if (Ft(n))
    return n;
  throw new Error("Invalid FHIR type");
}, pb = (n) => {
  if (Ht(n))
    return n;
  throw new Error("Invalid FHIR type");
}, sb = (n) => {
  if (ty(n))
    return n;
  throw new Error("Invalid FHIR type");
}, cb = (n) => {
  if (ny(n))
    return n;
  throw new Error("Invalid FHIR type");
}, lb = (n) => {
  if (Mt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, vb = (n) => {
  if (iy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, mb = (n) => {
  if (qt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, gb = (n) => {
  if (ry(n))
    return n;
  throw new Error("Invalid FHIR type");
}, _b = (n) => {
  if (oy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ab = (n) => {
  if (dy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, bb = (n) => {
  if (ay(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ib = (n) => {
  if (fy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, hb = (n) => {
  if (yy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, wb = (n) => {
  if (ai(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Rb = (n) => {
  if (kt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Cb = (n) => {
  if (uy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Db = (n) => {
  if (Bt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Sb = (n) => {
  if (py(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ob = (n) => {
  if (sy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Eb = (n) => {
  if (Vt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Tb = (n) => {
  if (cy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, xb = (n) => {
  if (ly(n))
    return n;
  throw new Error("Invalid FHIR type");
}, jb = (n) => {
  if (Ut(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Pb = (n) => {
  if (fi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Fb = (n) => {
  if (vy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Hb = (n) => {
  if (Nt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Mb = (n) => {
  if (my(n))
    return n;
  throw new Error("Invalid FHIR type");
}, qb = (n) => {
  if (gy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, kb = (n) => {
  if (_y(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Bb = (n) => {
  if (yi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Vb = (n) => {
  if (Lt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ub = (n) => {
  if (Ay(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Nb = (n) => {
  if (xn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Lb = (n) => {
  if (Gt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Gb = (n) => {
  if (by(n))
    return n;
  throw new Error("Invalid FHIR type");
}, zb = (n) => {
  if (zt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Qb = (n) => {
  if (Iy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Wb = (n) => {
  if (hy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Kb = (n) => {
  if (ui(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Jb = (n) => {
  if (Qt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Xb = (n) => {
  if (Wt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Yb = (n) => {
  if (wy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Zb = (n) => {
  if (Kt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, $b = (n) => {
  if (Ry(n))
    return n;
  throw new Error("Invalid FHIR type");
}, eI = (n) => {
  if (Cy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, tI = (n) => {
  if (Jt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, nI = (n) => {
  if (Xt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, iI = (n) => {
  if (Yt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, rI = (n) => {
  if (Dy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, oI = (n) => {
  if (Zt(n))
    return n;
  throw new Error("Invalid FHIR type");
}, dI = (n) => {
  if (Sy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, aI = (n) => {
  if (Oy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, fI = (n) => {
  if (Ey(n))
    return n;
  throw new Error("Invalid FHIR type");
}, yI = (n) => {
  if (Ty(n))
    return n;
  throw new Error("Invalid FHIR type");
}, uI = (n) => {
  if (xy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, pI = (n) => {
  if ($t(n))
    return n;
  throw new Error("Invalid FHIR type");
}, sI = (n) => {
  if (en(n))
    return n;
  throw new Error("Invalid FHIR type");
}, cI = (n) => {
  if (jy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, lI = (n) => {
  if (tn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, vI = (n) => {
  if (nn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, mI = (n) => {
  if (rn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, gI = (n) => {
  if (Py(n))
    return n;
  throw new Error("Invalid FHIR type");
}, _I = (n) => {
  if (Fy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, AI = (n) => {
  if (Hy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, bI = (n) => {
  if (on(n))
    return n;
  throw new Error("Invalid FHIR type");
}, II = (n) => {
  if (My(n))
    return n;
  throw new Error("Invalid FHIR type");
}, hI = (n) => {
  if (qy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, wI = (n) => {
  if (ky(n))
    return n;
  throw new Error("Invalid FHIR type");
}, RI = (n) => {
  if (By(n))
    return n;
  throw new Error("Invalid FHIR type");
}, CI = (n) => {
  if (dn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, DI = (n) => {
  if (Vy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, SI = (n) => {
  if (Uy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, OI = (n) => {
  if (Ny(n))
    return n;
  throw new Error("Invalid FHIR type");
}, EI = (n) => {
  if (Ly(n))
    return n;
  throw new Error("Invalid FHIR type");
}, TI = (n) => {
  if (an(n))
    return n;
  throw new Error("Invalid FHIR type");
}, xI = (n) => {
  if (Gy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, jI = (n) => {
  if (zy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, PI = (n) => {
  if (Qy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, FI = (n) => {
  if (Wy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, HI = (n) => {
  if (Ky(n))
    return n;
  throw new Error("Invalid FHIR type");
}, MI = (n) => {
  if (Jy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, qI = (n) => {
  if (pi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, kI = (n) => {
  if (Xy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, BI = (n) => {
  if (fn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, VI = (n) => {
  if (Yy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, UI = (n) => {
  if (yn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, NI = (n) => {
  if (Zy(n))
    return n;
  throw new Error("Invalid FHIR type");
}, LI = (n) => {
  if ($y(n))
    return n;
  throw new Error("Invalid FHIR type");
}, GI = (n) => {
  if (un(n))
    return n;
  throw new Error("Invalid FHIR type");
}, zI = (n) => {
  if (eu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, QI = (n) => {
  if (tu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, WI = (n) => {
  if (nu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, KI = (n) => {
  if (pn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, JI = (n) => {
  if (iu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, XI = (n) => {
  if (ru(n))
    return n;
  throw new Error("Invalid FHIR type");
}, YI = (n) => {
  if (ou(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ZI = (n) => {
  if (du(n))
    return n;
  throw new Error("Invalid FHIR type");
}, $I = (n) => {
  if (au(n))
    return n;
  throw new Error("Invalid FHIR type");
}, eh = (n) => {
  if (fu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, th = (n) => {
  if (sn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, nh = (n) => {
  if (yu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ih = (n) => {
  if (cn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, rh = (n) => {
  if (uu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, oh = (n) => {
  if (pu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, dh = (n) => {
  if (su(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ah = (n) => {
  if (cu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, fh = (n) => {
  if (ln(n))
    return n;
  throw new Error("Invalid FHIR type");
}, yh = (n) => {
  if (lu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, uh = (n) => {
  if (vu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ph = (n) => {
  if (mu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, sh = (n) => {
  if (gu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ch = (n) => {
  if (_u(n))
    return n;
  throw new Error("Invalid FHIR type");
}, lh = (n) => {
  if (Au(n))
    return n;
  throw new Error("Invalid FHIR type");
}, vh = (n) => {
  if (vn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, mh = (n) => {
  if (bu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, gh = (n) => {
  if (Iu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, _h = (n) => {
  if (jn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ah = (n) => {
  if (hu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, bh = (n) => {
  if (wu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ih = (n) => {
  if (Ru(n))
    return n;
  throw new Error("Invalid FHIR type");
}, hh = (n) => {
  if (Cu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, wh = (n) => {
  if (Du(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Rh = (n) => {
  if (Sn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ch = (n) => {
  if (Su(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Dh = (n) => {
  if (mn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Sh = (n) => {
  if (Ou(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Oh = (n) => {
  if (gn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Eh = (n) => {
  if (Eu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Th = (n) => {
  if (_n(n))
    return n;
  throw new Error("Invalid FHIR type");
}, xh = (n) => {
  if (Tu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, jh = (n) => {
  if (xu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ph = (n) => {
  if (ju(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Fh = (n) => {
  if (An(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Hh = (n) => {
  if (Pu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Mh = (n) => {
  if (Fu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, qh = (n) => {
  if (Hu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, kh = (n) => {
  if (Mu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Bh = (n) => {
  if (qu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Vh = (n) => {
  if (ku(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Uh = (n) => {
  if (Bu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Nh = (n) => {
  if (Vu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Lh = (n) => {
  if (Uu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Gh = (n) => {
  if (Nu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, zh = (n) => {
  if (bn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Qh = (n) => {
  if (Lu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Wh = (n) => {
  if (Pn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Kh = (n) => {
  if (si(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Jh = (n) => {
  if (Gu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Xh = (n) => {
  if (zu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Yh = (n) => {
  if (Qu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Zh = (n) => {
  if (Wu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, $h = (n) => {
  if (Ku(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ew = (n) => {
  if (Ju(n))
    return n;
  throw new Error("Invalid FHIR type");
}, tw = (n) => {
  if (In(n))
    return n;
  throw new Error("Invalid FHIR type");
}, nw = (n) => {
  if (Xu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, iw = (n) => {
  if (Yu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, rw = (n) => {
  if (Zu(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ow = (n) => {
  if ($u(n))
    return n;
  throw new Error("Invalid FHIR type");
}, dw = (n) => {
  if (ep(n))
    return n;
  throw new Error("Invalid FHIR type");
}, aw = (n) => {
  if (tp(n))
    return n;
  throw new Error("Invalid FHIR type");
}, fw = (n) => {
  if (np(n))
    return n;
  throw new Error("Invalid FHIR type");
}, yw = (n) => {
  if (ip(n))
    return n;
  throw new Error("Invalid FHIR type");
}, uw = (n) => {
  if (Fn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, pw = (n) => {
  if (ci(n))
    return n;
  throw new Error("Invalid FHIR type");
}, sw = (n) => {
  if (rp(n))
    return n;
  throw new Error("Invalid FHIR type");
}, cw = (n) => {
  if (op(n))
    return n;
  throw new Error("Invalid FHIR type");
}, lw = (n) => {
  if (dp(n))
    return n;
  throw new Error("Invalid FHIR type");
}, vw = (n) => {
  if (ap(n))
    return n;
  throw new Error("Invalid FHIR type");
}, mw = (n) => {
  if (fp(n))
    return n;
  throw new Error("Invalid FHIR type");
}, gw = (n) => {
  if (yp(n))
    return n;
  throw new Error("Invalid FHIR type");
}, _w = (n) => {
  if (hn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Aw = (n) => {
  if (li(n))
    return n;
  throw new Error("Invalid FHIR type");
}, bw = (n) => {
  if (up(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Iw = (n) => {
  if (pp(n))
    return n;
  throw new Error("Invalid FHIR type");
}, hw = (n) => {
  if (Mn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, ww = (n) => {
  if (sp(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Rw = (n) => {
  if (cp(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Cw = (n) => {
  if (vi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Dw = (n) => {
  if (lp(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Sw = (n) => {
  if (wn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ow = (n) => {
  if (vp(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Ew = (n) => {
  if (mp(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Tw = (n) => {
  if (gp(n))
    return n;
  throw new Error("Invalid FHIR type");
}, xw = (n) => {
  if (Rn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, jw = (n) => {
  if (_p(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Pw = (n) => {
  if (Ap(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Fw = (n) => {
  if (Cn(n))
    return n;
  throw new Error("Invalid FHIR type");
}, Hw = (n) => {
  if (bp(n))
    return n;
  throw new Error("Invalid FHIR type");
};
export {
  V as isAccount,
  Ti as isAccountCoverage,
  xi as isAccountGuarantor,
  U as isActivityDefinition,
  Pi as isActivityDefinitionDynamicValue,
  ji as isActivityDefinitionParticipant,
  h as isAddress,
  N as isAdverseEvent,
  Hi as isAdverseEventSuspectEntity,
  Fi as isAdverseEventSuspectEntityCausality,
  C as isAge,
  L as isAllergyIntolerance,
  Mi as isAllergyIntoleranceReaction,
  l as isAnnotation,
  G as isAppointment,
  qi as isAppointmentParticipant,
  z as isAppointmentResponse,
  g as isAttachment,
  Q as isAuditEvent,
  Bi as isAuditEventAgent,
  ki as isAuditEventAgentNetwork,
  Ni as isAuditEventEntity,
  Ui as isAuditEventEntityDetail,
  Vi as isAuditEventSource,
  d as isBackboneElement,
  W as isBasic,
  K as isBinary,
  J as isBiologicallyDerivedProduct,
  Li as isBiologicallyDerivedProductCollection,
  zi as isBiologicallyDerivedProductManipulation,
  Gi as isBiologicallyDerivedProductProcessing,
  Qi as isBiologicallyDerivedProductStorage,
  X as isBodyStructure,
  Y as isBundle,
  Xi as isBundleEntry,
  Ki as isBundleEntryRequest,
  Ji as isBundleEntryResponse,
  Wi as isBundleEntrySearch,
  Un as isBundleLink,
  Z as isCapabilityStatement,
  ar as isCapabilityStatementDocument,
  Zi as isCapabilityStatementImplementation,
  dr as isCapabilityStatementMessaging,
  rr as isCapabilityStatementMessagingEndpoint,
  or as isCapabilityStatementMessagingSupportedMessage,
  ir as isCapabilityStatementRest,
  nr as isCapabilityStatementRestInteraction,
  tr as isCapabilityStatementRestResource,
  er as isCapabilityStatementRestResourceInteraction,
  Ln as isCapabilityStatementRestResourceOperation,
  Nn as isCapabilityStatementRestResourceSearchParam,
  $i as isCapabilityStatementRestSecurity,
  Yi as isCapabilityStatementSoftware,
  $ as isCarePlan,
  yr as isCarePlanActivity,
  fr as isCarePlanActivityDetail,
  ee as isCareTeam,
  ur as isCareTeamParticipant,
  te as isCatalogEntry,
  pr as isCatalogEntryRelatedEntry,
  ne as isChargeItem,
  ie as isChargeItemDefinition,
  Gn as isChargeItemDefinitionApplicability,
  lr as isChargeItemDefinitionPropertyGroup,
  cr as isChargeItemDefinitionPropertyGroupPriceComponent,
  sr as isChargeItemPerformer,
  re as isClaim,
  hr as isClaimAccident,
  gr as isClaimCareTeam,
  Ar as isClaimDiagnosis,
  Ir as isClaimInsurance,
  Cr as isClaimItem,
  Rr as isClaimItemDetail,
  wr as isClaimItemDetailSubDetail,
  mr as isClaimPayee,
  br as isClaimProcedure,
  vr as isClaimRelated,
  oe as isClaimResponse,
  xr as isClaimResponseAddItem,
  Tr as isClaimResponseAddItemDetail,
  Er as isClaimResponseAddItemDetailSubDetail,
  Mr as isClaimResponseError,
  Hr as isClaimResponseInsurance,
  Or as isClaimResponseItem,
  q as isClaimResponseItemAdjudication,
  Sr as isClaimResponseItemDetail,
  Dr as isClaimResponseItemDetailSubDetail,
  Pr as isClaimResponsePayment,
  Fr as isClaimResponseProcessNote,
  jr as isClaimResponseTotal,
  _r as isClaimSupportingInfo,
  de as isClinicalImpression,
  kr as isClinicalImpressionFinding,
  qr as isClinicalImpressionInvestigation,
  ae as isCodeSystem,
  zn as isCodeSystemConcept,
  Ur as isCodeSystemConceptDesignation,
  Nr as isCodeSystemConceptProperty,
  Br as isCodeSystemFilter,
  Vr as isCodeSystemProperty,
  r as isCodeableConcept,
  s as isCoding,
  fe as isCommunication,
  Lr as isCommunicationPayload,
  ye as isCommunicationRequest,
  Gr as isCommunicationRequestPayload,
  ue as isCompartmentDefinition,
  zr as isCompartmentDefinitionResource,
  pe as isComposition,
  Qr as isCompositionAttester,
  Kr as isCompositionEvent,
  Wr as isCompositionRelatesTo,
  Qn as isCompositionSection,
  se as isConceptMap,
  Zr as isConceptMapGroup,
  Xr as isConceptMapGroupElement,
  Jr as isConceptMapGroupElementTarget,
  Hn as isConceptMapGroupElementTargetDependsOn,
  Yr as isConceptMapGroupUnmapped,
  ce as isCondition,
  eo as isConditionEvidence,
  $r as isConditionStage,
  le as isConsent,
  to as isConsentPolicy,
  Wn as isConsentProvision,
  io as isConsentProvisionActor,
  ro as isConsentProvisionData,
  no as isConsentVerification,
  p as isContactDetail,
  I as isContactPoint,
  ve as isContract,
  oo as isContractContentDefinition,
  mo as isContractFriendly,
  go as isContractLegal,
  _o as isContractRule,
  vo as isContractSigner,
  Jn as isContractTerm,
  lo as isContractTermAction,
  co as isContractTermActionSubject,
  so as isContractTermAsset,
  uo as isContractTermAssetContext,
  po as isContractTermAssetValuedItem,
  yo as isContractTermOffer,
  Kn as isContractTermOfferAnswer,
  fo as isContractTermOfferParty,
  ao as isContractTermSecurityLabel,
  F as isContributor,
  H as isCount,
  me as isCoverage,
  Ao as isCoverageClass,
  Io as isCoverageCostToBeneficiary,
  bo as isCoverageCostToBeneficiaryException,
  ge as isCoverageEligibilityRequest,
  wo as isCoverageEligibilityRequestInsurance,
  Co as isCoverageEligibilityRequestItem,
  Ro as isCoverageEligibilityRequestItemDiagnosis,
  ho as isCoverageEligibilityRequestSupportingInfo,
  _e as isCoverageEligibilityResponse,
  Eo as isCoverageEligibilityResponseError,
  Oo as isCoverageEligibilityResponseInsurance,
  So as isCoverageEligibilityResponseInsuranceItem,
  Do as isCoverageEligibilityResponseInsuranceItemBenefit,
  D as isDataRequirement,
  mi as isDataRequirementCodeFilter,
  gi as isDataRequirementDateFilter,
  _i as isDataRequirementSort,
  Ae as isDetectedIssue,
  To as isDetectedIssueEvidence,
  xo as isDetectedIssueMitigation,
  be as isDevice,
  Ie as isDeviceDefinition,
  Vo as isDeviceDefinitionCapability,
  ko as isDeviceDefinitionDeviceName,
  No as isDeviceDefinitionMaterial,
  Uo as isDeviceDefinitionProperty,
  Bo as isDeviceDefinitionSpecialization,
  qo as isDeviceDefinitionUdiDeviceIdentifier,
  Po as isDeviceDeviceName,
  he as isDeviceMetric,
  Lo as isDeviceMetricCalibration,
  Mo as isDeviceProperty,
  we as isDeviceRequest,
  Go as isDeviceRequestParameter,
  Fo as isDeviceSpecialization,
  jo as isDeviceUdiCarrier,
  Re as isDeviceUseStatement,
  Ho as isDeviceVersion,
  Ce as isDiagnosticReport,
  zo as isDiagnosticReportMedia,
  M as isDistance,
  De as isDocumentManifest,
  Qo as isDocumentManifestRelated,
  Se as isDocumentReference,
  Ko as isDocumentReferenceContent,
  Jo as isDocumentReferenceContext,
  Wo as isDocumentReferenceRelatesTo,
  f as isDomainResource,
  E as isDosage,
  Ai as isDosageDoseAndRate,
  _ as isDuration,
  Oe as isEffectEvidenceSynthesis,
  td as isEffectEvidenceSynthesisCertainty,
  ed as isEffectEvidenceSynthesisCertaintyCertaintySubcomponent,
  $o as isEffectEvidenceSynthesisEffectEstimate,
  Zo as isEffectEvidenceSynthesisEffectEstimatePrecisionEstimate,
  Yo as isEffectEvidenceSynthesisResultsByExposure,
  Xo as isEffectEvidenceSynthesisSampleSize,
  i as isElement,
  qn as isElementDefinition,
  hi as isElementDefinitionBase,
  Di as isElementDefinitionBinding,
  Ci as isElementDefinitionConstraint,
  Ri as isElementDefinitionExample,
  Si as isElementDefinitionMapping,
  Ii as isElementDefinitionSlicing,
  bi as isElementDefinitionSlicingDiscriminator,
  wi as isElementDefinitionType,
  Ee as isEncounter,
  id as isEncounterClassHistory,
  od as isEncounterDiagnosis,
  dd as isEncounterHospitalization,
  ad as isEncounterLocation,
  rd as isEncounterParticipant,
  nd as isEncounterStatusHistory,
  Te as isEndpoint,
  xe as isEnrollmentRequest,
  je as isEnrollmentResponse,
  Pe as isEpisodeOfCare,
  yd as isEpisodeOfCareDiagnosis,
  fd as isEpisodeOfCareStatusHistory,
  Fe as isEventDefinition,
  He as isEvidence,
  Me as isEvidenceVariable,
  ud as isEvidenceVariableCharacteristic,
  qe as isExampleScenario,
  pd as isExampleScenarioActor,
  cd as isExampleScenarioInstance,
  Dn as isExampleScenarioInstanceContainedInstance,
  sd as isExampleScenarioInstanceVersion,
  Yn as isExampleScenarioProcess,
  Xn as isExampleScenarioProcessStep,
  vd as isExampleScenarioProcessStepAlternative,
  ld as isExampleScenarioProcessStepOperation,
  ke as isExplanationOfBenefit,
  wd as isExplanationOfBenefitAccident,
  Ed as isExplanationOfBenefitAddItem,
  Od as isExplanationOfBenefitAddItemDetail,
  Sd as isExplanationOfBenefitAddItemDetailSubDetail,
  Fd as isExplanationOfBenefitBenefitBalance,
  Pd as isExplanationOfBenefitBenefitBalanceFinancial,
  _d as isExplanationOfBenefitCareTeam,
  bd as isExplanationOfBenefitDiagnosis,
  hd as isExplanationOfBenefitInsurance,
  Dd as isExplanationOfBenefitItem,
  k as isExplanationOfBenefitItemAdjudication,
  Cd as isExplanationOfBenefitItemDetail,
  Rd as isExplanationOfBenefitItemDetailSubDetail,
  gd as isExplanationOfBenefitPayee,
  xd as isExplanationOfBenefitPayment,
  Id as isExplanationOfBenefitProcedure,
  jd as isExplanationOfBenefitProcessNote,
  md as isExplanationOfBenefitRelated,
  Ad as isExplanationOfBenefitSupportingInfo,
  Td as isExplanationOfBenefitTotal,
  R as isExpression,
  B as isExtension,
  Be as isFamilyMemberHistory,
  Hd as isFamilyMemberHistoryCondition,
  bp as isFhirResource,
  Ve as isFlag,
  Ue as isGoal,
  Md as isGoalTarget,
  Ne as isGraphDefinition,
  Zn as isGraphDefinitionLink,
  kd as isGraphDefinitionLinkTarget,
  qd as isGraphDefinitionLinkTargetCompartment,
  Le as isGroup,
  Bd as isGroupCharacteristic,
  Vd as isGroupMember,
  Ge as isGuidanceResponse,
  ze as isHealthcareService,
  Nd as isHealthcareServiceAvailableTime,
  Ud as isHealthcareServiceEligibility,
  Ld as isHealthcareServiceNotAvailable,
  S as isHumanName,
  a as isIdentifier,
  Qe as isImagingStudy,
  Qd as isImagingStudySeries,
  zd as isImagingStudySeriesInstance,
  Gd as isImagingStudySeriesPerformer,
  We as isImmunization,
  Kd as isImmunizationEducation,
  Ke as isImmunizationEvaluation,
  Wd as isImmunizationPerformer,
  Xd as isImmunizationProtocolApplied,
  Jd as isImmunizationReaction,
  Je as isImmunizationRecommendation,
  Zd as isImmunizationRecommendationRecommendation,
  Yd as isImmunizationRecommendationRecommendationDateCriterion,
  Xe as isImplementationGuide,
  oa as isImplementationGuideDefinition,
  ta as isImplementationGuideDefinitionGrouping,
  $n as isImplementationGuideDefinitionPage,
  ia as isImplementationGuideDefinitionParameter,
  na as isImplementationGuideDefinitionResource,
  ra as isImplementationGuideDefinitionTemplate,
  $d as isImplementationGuideDependsOn,
  ea as isImplementationGuideGlobal,
  fa as isImplementationGuideManifest,
  aa as isImplementationGuideManifestPage,
  da as isImplementationGuideManifestResource,
  Ye as isInsurancePlan,
  ya as isInsurancePlanContact,
  sa as isInsurancePlanCoverage,
  pa as isInsurancePlanCoverageBenefit,
  ua as isInsurancePlanCoverageBenefitLimit,
  ga as isInsurancePlanPlan,
  ca as isInsurancePlanPlanGeneralCost,
  ma as isInsurancePlanPlanSpecificCost,
  va as isInsurancePlanPlanSpecificCostBenefit,
  la as isInsurancePlanPlanSpecificCostBenefitCost,
  Ze as isInvoice,
  Aa as isInvoiceLineItem,
  ei as isInvoiceLineItemPriceComponent,
  _a as isInvoiceParticipant,
  $e as isLibrary,
  et as isLinkage,
  ba as isLinkageItem,
  tt as isList,
  Ia as isListEntry,
  nt as isLocation,
  wa as isLocationHoursOfOperation,
  ha as isLocationPosition,
  kn as isMarketingStatus,
  it as isMeasure,
  Sa as isMeasureGroup,
  Ra as isMeasureGroupPopulation,
  Da as isMeasureGroupStratifier,
  Ca as isMeasureGroupStratifierComponent,
  rt as isMeasureReport,
  Fa as isMeasureReportGroup,
  Ea as isMeasureReportGroupPopulation,
  Pa as isMeasureReportGroupStratifier,
  ja as isMeasureReportGroupStratifierStratum,
  Ta as isMeasureReportGroupStratifierStratumComponent,
  xa as isMeasureReportGroupStratifierStratumPopulation,
  Oa as isMeasureSupplementalData,
  ot as isMedia,
  dt as isMedication,
  at as isMedicationAdministration,
  ka as isMedicationAdministrationDosage,
  qa as isMedicationAdministrationPerformer,
  Ma as isMedicationBatch,
  ft as isMedicationDispense,
  Ba as isMedicationDispensePerformer,
  Va as isMedicationDispenseSubstitution,
  Ha as isMedicationIngredient,
  yt as isMedicationKnowledge,
  Ka as isMedicationKnowledgeAdministrationGuidelines,
  Qa as isMedicationKnowledgeAdministrationGuidelinesDosage,
  Wa as isMedicationKnowledgeAdministrationGuidelinesPatientCharacteristics,
  Ga as isMedicationKnowledgeCost,
  Ya as isMedicationKnowledgeDrugCharacteristic,
  La as isMedicationKnowledgeIngredient,
  nf as isMedicationKnowledgeKinetics,
  Ja as isMedicationKnowledgeMedicineClassification,
  za as isMedicationKnowledgeMonitoringProgram,
  Na as isMedicationKnowledgeMonograph,
  Xa as isMedicationKnowledgePackaging,
  tf as isMedicationKnowledgeRegulatory,
  ef as isMedicationKnowledgeRegulatoryMaxDispense,
  $a as isMedicationKnowledgeRegulatorySchedule,
  Za as isMedicationKnowledgeRegulatorySubstitution,
  Ua as isMedicationKnowledgeRelatedMedicationKnowledge,
  ut as isMedicationRequest,
  of as isMedicationRequestDispenseRequest,
  rf as isMedicationRequestDispenseRequestInitialFill,
  df as isMedicationRequestSubstitution,
  pt as isMedicationStatement,
  st as isMedicinalProduct,
  ct as isMedicinalProductAuthorization,
  sf as isMedicinalProductAuthorizationJurisdictionalAuthorization,
  ti as isMedicinalProductAuthorizationProcedure,
  lt as isMedicinalProductContraindication,
  cf as isMedicinalProductContraindicationOtherTherapy,
  vt as isMedicinalProductIndication,
  lf as isMedicinalProductIndicationOtherTherapy,
  mt as isMedicinalProductIngredient,
  mf as isMedicinalProductIngredientSpecifiedSubstance,
  ni as isMedicinalProductIngredientSpecifiedSubstanceStrength,
  vf as isMedicinalProductIngredientSpecifiedSubstanceStrengthReferenceStrength,
  gf as isMedicinalProductIngredientSubstance,
  gt as isMedicinalProductInteraction,
  _f as isMedicinalProductInteractionInteractant,
  _t as isMedicinalProductManufactured,
  uf as isMedicinalProductManufacturingBusinessOperation,
  yf as isMedicinalProductName,
  ff as isMedicinalProductNameCountryLanguage,
  af as isMedicinalProductNameNamePart,
  At as isMedicinalProductPackaged,
  Af as isMedicinalProductPackagedBatchIdentifier,
  ii as isMedicinalProductPackagedPackageItem,
  bt as isMedicinalProductPharmaceutical,
  bf as isMedicinalProductPharmaceuticalCharacteristics,
  wf as isMedicinalProductPharmaceuticalRouteOfAdministration,
  hf as isMedicinalProductPharmaceuticalRouteOfAdministrationTargetSpecies,
  If as isMedicinalProductPharmaceuticalRouteOfAdministrationTargetSpeciesWithdrawalPeriod,
  pf as isMedicinalProductSpecialDesignation,
  It as isMedicinalProductUndesirableEffect,
  ht as isMessageDefinition,
  Cf as isMessageDefinitionAllowedResponse,
  Rf as isMessageDefinitionFocus,
  wt as isMessageHeader,
  Df as isMessageHeaderDestination,
  Of as isMessageHeaderResponse,
  Sf as isMessageHeaderSource,
  j as isMeta,
  Rt as isMolecularSequence,
  jf as isMolecularSequenceQuality,
  xf as isMolecularSequenceQualityRoc,
  Ef as isMolecularSequenceReferenceSeq,
  Pf as isMolecularSequenceRepository,
  Mf as isMolecularSequenceStructureVariant,
  Hf as isMolecularSequenceStructureVariantInner,
  Ff as isMolecularSequenceStructureVariantOuter,
  Tf as isMolecularSequenceVariant,
  c as isMoney,
  Ct as isNamingSystem,
  qf as isNamingSystemUniqueId,
  Bn as isNarrative,
  Dt as isNutritionOrder,
  Lf as isNutritionOrderEnteralFormula,
  Nf as isNutritionOrderEnteralFormulaAdministration,
  Vf as isNutritionOrderOralDiet,
  kf as isNutritionOrderOralDietNutrient,
  Bf as isNutritionOrderOralDietTexture,
  Uf as isNutritionOrderSupplement,
  St as isObservation,
  Gf as isObservationComponent,
  Ot as isObservationDefinition,
  Qf as isObservationDefinitionQualifiedInterval,
  zf as isObservationDefinitionQuantitativeDetails,
  ri as isObservationReferenceRange,
  Et as isOperationDefinition,
  Jf as isOperationDefinitionOverload,
  oi as isOperationDefinitionParameter,
  Wf as isOperationDefinitionParameterBinding,
  Kf as isOperationDefinitionParameterReferencedFrom,
  Tt as isOperationOutcome,
  Xf as isOperationOutcomeIssue,
  xt as isOrganization,
  jt as isOrganizationAffiliation,
  Yf as isOrganizationContact,
  P as isParameterDefinition,
  Pt as isParameters,
  di as isParametersParameter,
  Ft as isPatient,
  $f as isPatientCommunication,
  Zf as isPatientContact,
  ey as isPatientLink,
  Ht as isPaymentNotice,
  Mt as isPaymentReconciliation,
  ty as isPaymentReconciliationDetail,
  ny as isPaymentReconciliationProcessNote,
  y as isPeriod,
  qt as isPerson,
  iy as isPersonLink,
  kt as isPlanDefinition,
  ai as isPlanDefinitionAction,
  dy as isPlanDefinitionActionCondition,
  yy as isPlanDefinitionActionDynamicValue,
  fy as isPlanDefinitionActionParticipant,
  ay as isPlanDefinitionActionRelatedAction,
  oy as isPlanDefinitionGoal,
  ry as isPlanDefinitionGoalTarget,
  On as isPopulation,
  Bt as isPractitioner,
  uy as isPractitionerQualification,
  Vt as isPractitionerRole,
  py as isPractitionerRoleAvailableTime,
  sy as isPractitionerRoleNotAvailable,
  Ut as isProcedure,
  ly as isProcedureFocalDevice,
  cy as isProcedurePerformer,
  En as isProdCharacteristic,
  Vn as isProductShelfLife,
  Nt as isProvenance,
  fi as isProvenanceAgent,
  vy as isProvenanceEntity,
  u as isQuantity,
  Lt as isQuestionnaire,
  yi as isQuestionnaireItem,
  gy as isQuestionnaireItemAnswerOption,
  my as isQuestionnaireItemEnableWhen,
  _y as isQuestionnaireItemInitial,
  Gt as isQuestionnaireResponse,
  xn as isQuestionnaireResponseItem,
  Ay as isQuestionnaireResponseItemAnswer,
  v as isRange,
  b as isRatio,
  o as isReference,
  w as isRelatedArtifact,
  zt as isRelatedPerson,
  by as isRelatedPersonCommunication,
  Qt as isRequestGroup,
  ui as isRequestGroupAction,
  Iy as isRequestGroupActionCondition,
  hy as isRequestGroupActionRelatedAction,
  Wt as isResearchDefinition,
  Kt as isResearchElementDefinition,
  wy as isResearchElementDefinitionCharacteristic,
  Jt as isResearchStudy,
  Ry as isResearchStudyArm,
  Cy as isResearchStudyObjective,
  Xt as isResearchSubject,
  Yt as isResource,
  Zt as isRiskAssessment,
  Dy as isRiskAssessmentPrediction,
  $t as isRiskEvidenceSynthesis,
  xy as isRiskEvidenceSynthesisCertainty,
  Ty as isRiskEvidenceSynthesisCertaintyCertaintySubcomponent,
  Ey as isRiskEvidenceSynthesisRiskEstimate,
  Oy as isRiskEvidenceSynthesisRiskEstimatePrecisionEstimate,
  Sy as isRiskEvidenceSynthesisSampleSize,
  x as isSampledData,
  en as isSchedule,
  tn as isSearchParameter,
  jy as isSearchParameterComponent,
  nn as isServiceRequest,
  O as isSignature,
  rn as isSlot,
  on as isSpecimen,
  Py as isSpecimenCollection,
  Hy as isSpecimenContainer,
  dn as isSpecimenDefinition,
  By as isSpecimenDefinitionTypeTested,
  qy as isSpecimenDefinitionTypeTestedContainer,
  My as isSpecimenDefinitionTypeTestedContainerAdditive,
  ky as isSpecimenDefinitionTypeTestedHandling,
  Fy as isSpecimenProcessing,
  an as isStructureDefinition,
  Uy as isStructureDefinitionContext,
  Ly as isStructureDefinitionDifferential,
  Vy as isStructureDefinitionMapping,
  Ny as isStructureDefinitionSnapshot,
  fn as isStructureMap,
  Xy as isStructureMapGroup,
  zy as isStructureMapGroupInput,
  pi as isStructureMapGroupRule,
  Jy as isStructureMapGroupRuleDependent,
  Qy as isStructureMapGroupRuleSource,
  Ky as isStructureMapGroupRuleTarget,
  Wy as isStructureMapGroupRuleTargetParameter,
  Gy as isStructureMapStructure,
  yn as isSubscription,
  Yy as isSubscriptionChannel,
  un as isSubstance,
  Tn as isSubstanceAmount,
  Oi as isSubstanceAmountReferenceRange,
  $y as isSubstanceIngredient,
  Zy as isSubstanceInstance,
  pn as isSubstanceNucleicAcid,
  nu as isSubstanceNucleicAcidSubunit,
  eu as isSubstanceNucleicAcidSubunitLinkage,
  tu as isSubstanceNucleicAcidSubunitSugar,
  sn as isSubstancePolymer,
  ru as isSubstancePolymerMonomerSet,
  iu as isSubstancePolymerMonomerSetStartingMaterial,
  fu as isSubstancePolymerRepeat,
  au as isSubstancePolymerRepeatRepeatUnit,
  ou as isSubstancePolymerRepeatRepeatUnitDegreeOfPolymerisation,
  du as isSubstancePolymerRepeatRepeatUnitStructuralRepresentation,
  cn as isSubstanceProtein,
  yu as isSubstanceProteinSubunit,
  ln as isSubstanceReferenceInformation,
  su as isSubstanceReferenceInformationClassification,
  uu as isSubstanceReferenceInformationGene,
  pu as isSubstanceReferenceInformationGeneElement,
  cu as isSubstanceReferenceInformationTarget,
  vn as isSubstanceSourceMaterial,
  lu as isSubstanceSourceMaterialFractionDescription,
  _u as isSubstanceSourceMaterialOrganism,
  vu as isSubstanceSourceMaterialOrganismAuthor,
  mu as isSubstanceSourceMaterialOrganismHybrid,
  gu as isSubstanceSourceMaterialOrganismOrganismGeneral,
  Au as isSubstanceSourceMaterialPartDescription,
  mn as isSubstanceSpecification,
  Cu as isSubstanceSpecificationCode,
  bu as isSubstanceSpecificationMoiety,
  Sn as isSubstanceSpecificationName,
  Du as isSubstanceSpecificationNameOfficial,
  Iu as isSubstanceSpecificationProperty,
  Su as isSubstanceSpecificationRelationship,
  Ru as isSubstanceSpecificationStructure,
  hu as isSubstanceSpecificationStructureIsotope,
  jn as isSubstanceSpecificationStructureIsotopeMolecularWeight,
  wu as isSubstanceSpecificationStructureRepresentation,
  gn as isSupplyDelivery,
  Ou as isSupplyDeliverySuppliedItem,
  _n as isSupplyRequest,
  Eu as isSupplyRequestParameter,
  An as isTask,
  xu as isTaskInput,
  ju as isTaskOutput,
  Tu as isTaskRestriction,
  bn as isTerminologyCapabilities,
  Nu as isTerminologyCapabilitiesClosure,
  qu as isTerminologyCapabilitiesCodeSystem,
  Mu as isTerminologyCapabilitiesCodeSystemVersion,
  Hu as isTerminologyCapabilitiesCodeSystemVersionFilter,
  Bu as isTerminologyCapabilitiesExpansion,
  ku as isTerminologyCapabilitiesExpansionParameter,
  Fu as isTerminologyCapabilitiesImplementation,
  Pu as isTerminologyCapabilitiesSoftware,
  Uu as isTerminologyCapabilitiesTranslation,
  Vu as isTerminologyCapabilitiesValidateCode,
  In as isTestReport,
  Lu as isTestReportParticipant,
  zu as isTestReportSetup,
  Gu as isTestReportSetupAction,
  si as isTestReportSetupActionAssert,
  Pn as isTestReportSetupActionOperation,
  Ju as isTestReportTeardown,
  Ku as isTestReportTeardownAction,
  Wu as isTestReportTest,
  Qu as isTestReportTestAction,
  hn as isTestScript,
  Yu as isTestScriptDestination,
  tp as isTestScriptFixture,
  ep as isTestScriptMetadata,
  $u as isTestScriptMetadataCapability,
  Zu as isTestScriptMetadataLink,
  Xu as isTestScriptOrigin,
  op as isTestScriptSetup,
  rp as isTestScriptSetupAction,
  ci as isTestScriptSetupActionAssert,
  Fn as isTestScriptSetupActionOperation,
  ip as isTestScriptSetupActionOperationRequestHeader,
  yp as isTestScriptTeardown,
  fp as isTestScriptTeardownAction,
  ap as isTestScriptTest,
  dp as isTestScriptTestAction,
  np as isTestScriptVariable,
  A as isTiming,
  Ei as isTimingRepeat,
  T as isTriggerDefinition,
  m as isUsageContext,
  wn as isValueSet,
  sp as isValueSetCompose,
  Mn as isValueSetComposeInclude,
  up as isValueSetComposeIncludeConcept,
  li as isValueSetComposeIncludeConceptDesignation,
  pp as isValueSetComposeIncludeFilter,
  lp as isValueSetExpansion,
  vi as isValueSetExpansionContains,
  cp as isValueSetExpansionParameter,
  Rn as isVerificationResult,
  mp as isVerificationResultAttestation,
  vp as isVerificationResultPrimarySource,
  gp as isVerificationResultValidator,
  Cn as isVisionPrescription,
  Ap as isVisionPrescriptionLensSpecification,
  _p as isVisionPrescriptionLensSpecificationPrism,
  Rs as validateAccount,
  hs as validateAccountCoverage,
  ws as validateAccountGuarantor,
  Ss as validateActivityDefinition,
  Ds as validateActivityDefinitionDynamicValue,
  Cs as validateActivityDefinitionParticipant,
  Ip as validateAddress,
  Ts as validateAdverseEvent,
  Es as validateAdverseEventSuspectEntity,
  Os as validateAdverseEventSuspectEntityCausality,
  hp as validateAge,
  js as validateAllergyIntolerance,
  xs as validateAllergyIntoleranceReaction,
  wp as validateAnnotation,
  Fs as validateAppointment,
  Ps as validateAppointmentParticipant,
  Hs as validateAppointmentResponse,
  Rp as validateAttachment,
  Us as validateAuditEvent,
  qs as validateAuditEventAgent,
  Ms as validateAuditEventAgentNetwork,
  Vs as validateAuditEventEntity,
  Bs as validateAuditEventEntityDetail,
  ks as validateAuditEventSource,
  Cp as validateBackboneElement,
  Ns as validateBasic,
  Ls as validateBinary,
  Ks as validateBiologicallyDerivedProduct,
  Gs as validateBiologicallyDerivedProductCollection,
  Qs as validateBiologicallyDerivedProductManipulation,
  zs as validateBiologicallyDerivedProductProcessing,
  Ws as validateBiologicallyDerivedProductStorage,
  Js as validateBodyStructure,
  tc as validateBundle,
  ec as validateBundleEntry,
  Zs as validateBundleEntryRequest,
  $s as validateBundleEntryResponse,
  Ys as validateBundleEntrySearch,
  Xs as validateBundleLink,
  vc as validateCapabilityStatement,
  lc as validateCapabilityStatementDocument,
  ic as validateCapabilityStatementImplementation,
  cc as validateCapabilityStatementMessaging,
  pc as validateCapabilityStatementMessagingEndpoint,
  sc as validateCapabilityStatementMessagingSupportedMessage,
  uc as validateCapabilityStatementRest,
  yc as validateCapabilityStatementRestInteraction,
  fc as validateCapabilityStatementRestResource,
  oc as validateCapabilityStatementRestResourceInteraction,
  ac as validateCapabilityStatementRestResourceOperation,
  dc as validateCapabilityStatementRestResourceSearchParam,
  rc as validateCapabilityStatementRestSecurity,
  nc as validateCapabilityStatementSoftware,
  _c as validateCarePlan,
  gc as validateCarePlanActivity,
  mc as validateCarePlanActivityDetail,
  bc as validateCareTeam,
  Ac as validateCareTeamParticipant,
  hc as validateCatalogEntry,
  Ic as validateCatalogEntryRelatedEntry,
  Rc as validateChargeItem,
  Oc as validateChargeItemDefinition,
  Cc as validateChargeItemDefinitionApplicability,
  Sc as validateChargeItemDefinitionPropertyGroup,
  Dc as validateChargeItemDefinitionPropertyGroupPriceComponent,
  wc as validateChargeItemPerformer,
  Vc as validateClaim,
  Mc as validateClaimAccident,
  xc as validateClaimCareTeam,
  Pc as validateClaimDiagnosis,
  Hc as validateClaimInsurance,
  Bc as validateClaimItem,
  kc as validateClaimItemDetail,
  qc as validateClaimItemDetailSubDetail,
  Tc as validateClaimPayee,
  Fc as validateClaimProcedure,
  Ec as validateClaimRelated,
  $c as validateClaimResponse,
  Wc as validateClaimResponseAddItem,
  Qc as validateClaimResponseAddItemDetail,
  zc as validateClaimResponseAddItemDetailSubDetail,
  Zc as validateClaimResponseError,
  Yc as validateClaimResponseInsurance,
  Gc as validateClaimResponseItem,
  Uc as validateClaimResponseItemAdjudication,
  Lc as validateClaimResponseItemDetail,
  Nc as validateClaimResponseItemDetailSubDetail,
  Jc as validateClaimResponsePayment,
  Xc as validateClaimResponseProcessNote,
  Kc as validateClaimResponseTotal,
  jc as validateClaimSupportingInfo,
  nl as validateClinicalImpression,
  tl as validateClinicalImpressionFinding,
  el as validateClinicalImpressionInvestigation,
  fl as validateCodeSystem,
  al as validateCodeSystemConcept,
  ol as validateCodeSystemConceptDesignation,
  dl as validateCodeSystemConceptProperty,
  il as validateCodeSystemFilter,
  rl as validateCodeSystemProperty,
  Dp as validateCodeableConcept,
  Sp as validateCoding,
  ul as validateCommunication,
  yl as validateCommunicationPayload,
  sl as validateCommunicationRequest,
  pl as validateCommunicationRequestPayload,
  ll as validateCompartmentDefinition,
  cl as validateCompartmentDefinitionResource,
  Al as validateComposition,
  vl as validateCompositionAttester,
  gl as validateCompositionEvent,
  ml as validateCompositionRelatesTo,
  _l as validateCompositionSection,
  Cl as validateConceptMap,
  Rl as validateConceptMapGroup,
  hl as validateConceptMapGroupElement,
  Il as validateConceptMapGroupElementTarget,
  bl as validateConceptMapGroupElementTargetDependsOn,
  wl as validateConceptMapGroupUnmapped,
  Ol as validateCondition,
  Sl as validateConditionEvidence,
  Dl as validateConditionStage,
  Fl as validateConsent,
  El as validateConsentPolicy,
  Pl as validateConsentProvision,
  xl as validateConsentProvisionActor,
  jl as validateConsentProvisionData,
  Tl as validateConsentVerification,
  Op as validateContactDetail,
  Ep as validateContactPoint,
  Xl as validateContract,
  Hl as validateContractContentDefinition,
  Wl as validateContractFriendly,
  Kl as validateContractLegal,
  Jl as validateContractRule,
  Ql as validateContractSigner,
  zl as validateContractTerm,
  Gl as validateContractTermAction,
  Ll as validateContractTermActionSubject,
  Nl as validateContractTermAsset,
  Vl as validateContractTermAssetContext,
  Ul as validateContractTermAssetValuedItem,
  Bl as validateContractTermOffer,
  kl as validateContractTermOfferAnswer,
  ql as validateContractTermOfferParty,
  Ml as validateContractTermSecurityLabel,
  Tp as validateContributor,
  xp as validateCount,
  ev as validateCoverage,
  Yl as validateCoverageClass,
  $l as validateCoverageCostToBeneficiary,
  Zl as validateCoverageCostToBeneficiaryException,
  ov as validateCoverageEligibilityRequest,
  nv as validateCoverageEligibilityRequestInsurance,
  rv as validateCoverageEligibilityRequestItem,
  iv as validateCoverageEligibilityRequestItemDiagnosis,
  tv as validateCoverageEligibilityRequestSupportingInfo,
  uv as validateCoverageEligibilityResponse,
  yv as validateCoverageEligibilityResponseError,
  fv as validateCoverageEligibilityResponseInsurance,
  av as validateCoverageEligibilityResponseInsuranceItem,
  dv as validateCoverageEligibilityResponseInsuranceItemBenefit,
  Hp as validateDataRequirement,
  jp as validateDataRequirementCodeFilter,
  Pp as validateDataRequirementDateFilter,
  Fp as validateDataRequirementSort,
  cv as validateDetectedIssue,
  pv as validateDetectedIssueEvidence,
  sv as validateDetectedIssueMitigation,
  Av as validateDevice,
  Dv as validateDeviceDefinition,
  wv as validateDeviceDefinitionCapability,
  Iv as validateDeviceDefinitionDeviceName,
  Cv as validateDeviceDefinitionMaterial,
  Rv as validateDeviceDefinitionProperty,
  hv as validateDeviceDefinitionSpecialization,
  bv as validateDeviceDefinitionUdiDeviceIdentifier,
  vv as validateDeviceDeviceName,
  Ov as validateDeviceMetric,
  Sv as validateDeviceMetricCalibration,
  _v as validateDeviceProperty,
  Tv as validateDeviceRequest,
  Ev as validateDeviceRequestParameter,
  mv as validateDeviceSpecialization,
  lv as validateDeviceUdiCarrier,
  xv as validateDeviceUseStatement,
  gv as validateDeviceVersion,
  Pv as validateDiagnosticReport,
  jv as validateDiagnosticReportMedia,
  Mp as validateDistance,
  Hv as validateDocumentManifest,
  Fv as validateDocumentManifestRelated,
  Bv as validateDocumentReference,
  qv as validateDocumentReferenceContent,
  kv as validateDocumentReferenceContext,
  Mv as validateDocumentReferenceRelatesTo,
  Vv as validateDomainResource,
  kp as validateDosage,
  qp as validateDosageDoseAndRate,
  Bp as validateDuration,
  Wv as validateEffectEvidenceSynthesis,
  Qv as validateEffectEvidenceSynthesisCertainty,
  zv as validateEffectEvidenceSynthesisCertaintyCertaintySubcomponent,
  Gv as validateEffectEvidenceSynthesisEffectEstimate,
  Lv as validateEffectEvidenceSynthesisEffectEstimatePrecisionEstimate,
  Nv as validateEffectEvidenceSynthesisResultsByExposure,
  Uv as validateEffectEvidenceSynthesisSampleSize,
  Vp as validateElement,
  Jp as validateElementDefinition,
  Lp as validateElementDefinitionBase,
  Wp as validateElementDefinitionBinding,
  Qp as validateElementDefinitionConstraint,
  zp as validateElementDefinitionExample,
  Kp as validateElementDefinitionMapping,
  Np as validateElementDefinitionSlicing,
  Up as validateElementDefinitionSlicingDiscriminator,
  Gp as validateElementDefinitionType,
  em as validateEncounter,
  Jv as validateEncounterClassHistory,
  Yv as validateEncounterDiagnosis,
  Zv as validateEncounterHospitalization,
  $v as validateEncounterLocation,
  Xv as validateEncounterParticipant,
  Kv as validateEncounterStatusHistory,
  tm as validateEndpoint,
  nm as validateEnrollmentRequest,
  im as validateEnrollmentResponse,
  dm as validateEpisodeOfCare,
  om as validateEpisodeOfCareDiagnosis,
  rm as validateEpisodeOfCareStatusHistory,
  am as validateEventDefinition,
  fm as validateEvidence,
  um as validateEvidenceVariable,
  ym as validateEvidenceVariableCharacteristic,
  Am as validateExampleScenario,
  pm as validateExampleScenarioActor,
  lm as validateExampleScenarioInstance,
  cm as validateExampleScenarioInstanceContainedInstance,
  sm as validateExampleScenarioInstanceVersion,
  _m as validateExampleScenarioProcess,
  gm as validateExampleScenarioProcessStep,
  mm as validateExampleScenarioProcessStepAlternative,
  vm as validateExampleScenarioProcessStepOperation,
  Vm as validateExplanationOfBenefit,
  Sm as validateExplanationOfBenefitAccident,
  Fm as validateExplanationOfBenefitAddItem,
  Pm as validateExplanationOfBenefitAddItemDetail,
  jm as validateExplanationOfBenefitAddItemDetailSubDetail,
  Bm as validateExplanationOfBenefitBenefitBalance,
  km as validateExplanationOfBenefitBenefitBalanceFinancial,
  hm as validateExplanationOfBenefitCareTeam,
  Rm as validateExplanationOfBenefitDiagnosis,
  Dm as validateExplanationOfBenefitInsurance,
  xm as validateExplanationOfBenefitItem,
  Om as validateExplanationOfBenefitItemAdjudication,
  Tm as validateExplanationOfBenefitItemDetail,
  Em as validateExplanationOfBenefitItemDetailSubDetail,
  Im as validateExplanationOfBenefitPayee,
  Mm as validateExplanationOfBenefitPayment,
  Cm as validateExplanationOfBenefitProcedure,
  qm as validateExplanationOfBenefitProcessNote,
  bm as validateExplanationOfBenefitRelated,
  wm as validateExplanationOfBenefitSupportingInfo,
  Hm as validateExplanationOfBenefitTotal,
  Xp as validateExpression,
  Yp as validateExtension,
  Nm as validateFamilyMemberHistory,
  Um as validateFamilyMemberHistoryCondition,
  Hw as validateFhirResource,
  Lm as validateFlag,
  zm as validateGoal,
  Gm as validateGoalTarget,
  Jm as validateGraphDefinition,
  Km as validateGraphDefinitionLink,
  Wm as validateGraphDefinitionLinkTarget,
  Qm as validateGraphDefinitionLinkTargetCompartment,
  Zm as validateGroup,
  Xm as validateGroupCharacteristic,
  Ym as validateGroupMember,
  $m as validateGuidanceResponse,
  ig as validateHealthcareService,
  tg as validateHealthcareServiceAvailableTime,
  eg as validateHealthcareServiceEligibility,
  ng as validateHealthcareServiceNotAvailable,
  Zp as validateHumanName,
  $p as validateIdentifier,
  ag as validateImagingStudy,
  dg as validateImagingStudySeries,
  og as validateImagingStudySeriesInstance,
  rg as validateImagingStudySeriesPerformer,
  sg as validateImmunization,
  yg as validateImmunizationEducation,
  cg as validateImmunizationEvaluation,
  fg as validateImmunizationPerformer,
  pg as validateImmunizationProtocolApplied,
  ug as validateImmunizationReaction,
  mg as validateImmunizationRecommendation,
  vg as validateImmunizationRecommendationRecommendation,
  lg as validateImmunizationRecommendationRecommendationDateCriterion,
  Og as validateImplementationGuide,
  Rg as validateImplementationGuideDefinition,
  Ag as validateImplementationGuideDefinitionGrouping,
  Ig as validateImplementationGuideDefinitionPage,
  hg as validateImplementationGuideDefinitionParameter,
  bg as validateImplementationGuideDefinitionResource,
  wg as validateImplementationGuideDefinitionTemplate,
  gg as validateImplementationGuideDependsOn,
  _g as validateImplementationGuideGlobal,
  Sg as validateImplementationGuideManifest,
  Dg as validateImplementationGuideManifestPage,
  Cg as validateImplementationGuideManifestResource,
  kg as validateInsurancePlan,
  Eg as validateInsurancePlanContact,
  jg as validateInsurancePlanCoverage,
  xg as validateInsurancePlanCoverageBenefit,
  Tg as validateInsurancePlanCoverageBenefitLimit,
  qg as validateInsurancePlanPlan,
  Pg as validateInsurancePlanPlanGeneralCost,
  Mg as validateInsurancePlanPlanSpecificCost,
  Hg as validateInsurancePlanPlanSpecificCostBenefit,
  Fg as validateInsurancePlanPlanSpecificCostBenefitCost,
  Ng as validateInvoice,
  Ug as validateInvoiceLineItem,
  Vg as validateInvoiceLineItemPriceComponent,
  Bg as validateInvoiceParticipant,
  Lg as validateLibrary,
  zg as validateLinkage,
  Gg as validateLinkageItem,
  Wg as validateList,
  Qg as validateListEntry,
  Xg as validateLocation,
  Jg as validateLocationHoursOfOperation,
  Kg as validateLocationPosition,
  es as validateMarketingStatus,
  n_ as validateMeasure,
  e_ as validateMeasureGroup,
  Yg as validateMeasureGroupPopulation,
  $g as validateMeasureGroupStratifier,
  Zg as validateMeasureGroupStratifierComponent,
  y_ as validateMeasureReport,
  f_ as validateMeasureReportGroup,
  i_ as validateMeasureReportGroupPopulation,
  a_ as validateMeasureReportGroupStratifier,
  d_ as validateMeasureReportGroupStratifierStratum,
  r_ as validateMeasureReportGroupStratifierStratumComponent,
  o_ as validateMeasureReportGroupStratifierStratumPopulation,
  t_ as validateMeasureSupplementalData,
  u_ as validateMedia,
  c_ as validateMedication,
  m_ as validateMedicationAdministration,
  v_ as validateMedicationAdministrationDosage,
  l_ as validateMedicationAdministrationPerformer,
  s_ as validateMedicationBatch,
  A_ as validateMedicationDispense,
  g_ as validateMedicationDispensePerformer,
  __ as validateMedicationDispenseSubstitution,
  p_ as validateMedicationIngredient,
  M_ as validateMedicationKnowledge,
  S_ as validateMedicationKnowledgeAdministrationGuidelines,
  C_ as validateMedicationKnowledgeAdministrationGuidelinesDosage,
  D_ as validateMedicationKnowledgeAdministrationGuidelinesPatientCharacteristics,
  w_ as validateMedicationKnowledgeCost,
  T_ as validateMedicationKnowledgeDrugCharacteristic,
  h_ as validateMedicationKnowledgeIngredient,
  H_ as validateMedicationKnowledgeKinetics,
  O_ as validateMedicationKnowledgeMedicineClassification,
  R_ as validateMedicationKnowledgeMonitoringProgram,
  I_ as validateMedicationKnowledgeMonograph,
  E_ as validateMedicationKnowledgePackaging,
  F_ as validateMedicationKnowledgeRegulatory,
  P_ as validateMedicationKnowledgeRegulatoryMaxDispense,
  j_ as validateMedicationKnowledgeRegulatorySchedule,
  x_ as validateMedicationKnowledgeRegulatorySubstitution,
  b_ as validateMedicationKnowledgeRelatedMedicationKnowledge,
  V_ as validateMedicationRequest,
  k_ as validateMedicationRequestDispenseRequest,
  q_ as validateMedicationRequestDispenseRequestInitialFill,
  B_ as validateMedicationRequestSubstitution,
  U_ as validateMedicationStatement,
  W_ as validateMedicinalProduct,
  X_ as validateMedicinalProductAuthorization,
  K_ as validateMedicinalProductAuthorizationJurisdictionalAuthorization,
  J_ as validateMedicinalProductAuthorizationProcedure,
  Z_ as validateMedicinalProductContraindication,
  Y_ as validateMedicinalProductContraindicationOtherTherapy,
  eA as validateMedicinalProductIndication,
  $_ as validateMedicinalProductIndicationOtherTherapy,
  oA as validateMedicinalProductIngredient,
  iA as validateMedicinalProductIngredientSpecifiedSubstance,
  nA as validateMedicinalProductIngredientSpecifiedSubstanceStrength,
  tA as validateMedicinalProductIngredientSpecifiedSubstanceStrengthReferenceStrength,
  rA as validateMedicinalProductIngredientSubstance,
  aA as validateMedicinalProductInteraction,
  dA as validateMedicinalProductInteractionInteractant,
  fA as validateMedicinalProductManufactured,
  z_ as validateMedicinalProductManufacturingBusinessOperation,
  G_ as validateMedicinalProductName,
  L_ as validateMedicinalProductNameCountryLanguage,
  N_ as validateMedicinalProductNameNamePart,
  pA as validateMedicinalProductPackaged,
  yA as validateMedicinalProductPackagedBatchIdentifier,
  uA as validateMedicinalProductPackagedPackageItem,
  mA as validateMedicinalProductPharmaceutical,
  sA as validateMedicinalProductPharmaceuticalCharacteristics,
  vA as validateMedicinalProductPharmaceuticalRouteOfAdministration,
  lA as validateMedicinalProductPharmaceuticalRouteOfAdministrationTargetSpecies,
  cA as validateMedicinalProductPharmaceuticalRouteOfAdministrationTargetSpeciesWithdrawalPeriod,
  Q_ as validateMedicinalProductSpecialDesignation,
  gA as validateMedicinalProductUndesirableEffect,
  bA as validateMessageDefinition,
  AA as validateMessageDefinitionAllowedResponse,
  _A as validateMessageDefinitionFocus,
  RA as validateMessageHeader,
  IA as validateMessageHeaderDestination,
  wA as validateMessageHeaderResponse,
  hA as validateMessageHeaderSource,
  ts as validateMeta,
  PA as validateMolecularSequence,
  OA as validateMolecularSequenceQuality,
  SA as validateMolecularSequenceQualityRoc,
  CA as validateMolecularSequenceReferenceSeq,
  EA as validateMolecularSequenceRepository,
  jA as validateMolecularSequenceStructureVariant,
  xA as validateMolecularSequenceStructureVariantInner,
  TA as validateMolecularSequenceStructureVariantOuter,
  DA as validateMolecularSequenceVariant,
  ns as validateMoney,
  HA as validateNamingSystem,
  FA as validateNamingSystemUniqueId,
  is as validateNarrative,
  NA as validateNutritionOrder,
  UA as validateNutritionOrderEnteralFormula,
  VA as validateNutritionOrderEnteralFormulaAdministration,
  kA as validateNutritionOrderOralDiet,
  MA as validateNutritionOrderOralDietNutrient,
  qA as validateNutritionOrderOralDietTexture,
  BA as validateNutritionOrderSupplement,
  zA as validateObservation,
  GA as validateObservationComponent,
  KA as validateObservationDefinition,
  WA as validateObservationDefinitionQualifiedInterval,
  QA as validateObservationDefinitionQuantitativeDetails,
  LA as validateObservationReferenceRange,
  $A as validateOperationDefinition,
  ZA as validateOperationDefinitionOverload,
  YA as validateOperationDefinitionParameter,
  JA as validateOperationDefinitionParameterBinding,
  XA as validateOperationDefinitionParameterReferencedFrom,
  tb as validateOperationOutcome,
  eb as validateOperationOutcomeIssue,
  ib as validateOrganization,
  rb as validateOrganizationAffiliation,
  nb as validateOrganizationContact,
  rs as validateParameterDefinition,
  db as validateParameters,
  ob as validateParametersParameter,
  ub as validatePatient,
  fb as validatePatientCommunication,
  ab as validatePatientContact,
  yb as validatePatientLink,
  pb as validatePaymentNotice,
  lb as validatePaymentReconciliation,
  sb as validatePaymentReconciliationDetail,
  cb as validatePaymentReconciliationProcessNote,
  os as validatePeriod,
  mb as validatePerson,
  vb as validatePersonLink,
  Rb as validatePlanDefinition,
  wb as validatePlanDefinitionAction,
  Ab as validatePlanDefinitionActionCondition,
  hb as validatePlanDefinitionActionDynamicValue,
  Ib as validatePlanDefinitionActionParticipant,
  bb as validatePlanDefinitionActionRelatedAction,
  _b as validatePlanDefinitionGoal,
  gb as validatePlanDefinitionGoalTarget,
  ds as validatePopulation,
  Db as validatePractitioner,
  Cb as validatePractitionerQualification,
  Eb as validatePractitionerRole,
  Sb as validatePractitionerRoleAvailableTime,
  Ob as validatePractitionerRoleNotAvailable,
  jb as validateProcedure,
  xb as validateProcedureFocalDevice,
  Tb as validateProcedurePerformer,
  as as validateProdCharacteristic,
  fs as validateProductShelfLife,
  Hb as validateProvenance,
  Pb as validateProvenanceAgent,
  Fb as validateProvenanceEntity,
  ys as validateQuantity,
  Vb as validateQuestionnaire,
  Bb as validateQuestionnaireItem,
  qb as validateQuestionnaireItemAnswerOption,
  Mb as validateQuestionnaireItemEnableWhen,
  kb as validateQuestionnaireItemInitial,
  Lb as validateQuestionnaireResponse,
  Nb as validateQuestionnaireResponseItem,
  Ub as validateQuestionnaireResponseItemAnswer,
  us as validateRange,
  ps as validateRatio,
  ss as validateReference,
  cs as validateRelatedArtifact,
  zb as validateRelatedPerson,
  Gb as validateRelatedPersonCommunication,
  Jb as validateRequestGroup,
  Kb as validateRequestGroupAction,
  Qb as validateRequestGroupActionCondition,
  Wb as validateRequestGroupActionRelatedAction,
  Xb as validateResearchDefinition,
  Zb as validateResearchElementDefinition,
  Yb as validateResearchElementDefinitionCharacteristic,
  tI as validateResearchStudy,
  $b as validateResearchStudyArm,
  eI as validateResearchStudyObjective,
  nI as validateResearchSubject,
  iI as validateResource,
  oI as validateRiskAssessment,
  rI as validateRiskAssessmentPrediction,
  pI as validateRiskEvidenceSynthesis,
  uI as validateRiskEvidenceSynthesisCertainty,
  yI as validateRiskEvidenceSynthesisCertaintyCertaintySubcomponent,
  fI as validateRiskEvidenceSynthesisRiskEstimate,
  aI as validateRiskEvidenceSynthesisRiskEstimatePrecisionEstimate,
  dI as validateRiskEvidenceSynthesisSampleSize,
  ls as validateSampledData,
  sI as validateSchedule,
  lI as validateSearchParameter,
  cI as validateSearchParameterComponent,
  vI as validateServiceRequest,
  vs as validateSignature,
  mI as validateSlot,
  bI as validateSpecimen,
  gI as validateSpecimenCollection,
  AI as validateSpecimenContainer,
  CI as validateSpecimenDefinition,
  RI as validateSpecimenDefinitionTypeTested,
  hI as validateSpecimenDefinitionTypeTestedContainer,
  II as validateSpecimenDefinitionTypeTestedContainerAdditive,
  wI as validateSpecimenDefinitionTypeTestedHandling,
  _I as validateSpecimenProcessing,
  TI as validateStructureDefinition,
  SI as validateStructureDefinitionContext,
  EI as validateStructureDefinitionDifferential,
  DI as validateStructureDefinitionMapping,
  OI as validateStructureDefinitionSnapshot,
  BI as validateStructureMap,
  kI as validateStructureMapGroup,
  jI as validateStructureMapGroupInput,
  qI as validateStructureMapGroupRule,
  MI as validateStructureMapGroupRuleDependent,
  PI as validateStructureMapGroupRuleSource,
  HI as validateStructureMapGroupRuleTarget,
  FI as validateStructureMapGroupRuleTargetParameter,
  xI as validateStructureMapStructure,
  UI as validateSubscription,
  VI as validateSubscriptionChannel,
  GI as validateSubstance,
  gs as validateSubstanceAmount,
  ms as validateSubstanceAmountReferenceRange,
  LI as validateSubstanceIngredient,
  NI as validateSubstanceInstance,
  KI as validateSubstanceNucleicAcid,
  WI as validateSubstanceNucleicAcidSubunit,
  zI as validateSubstanceNucleicAcidSubunitLinkage,
  QI as validateSubstanceNucleicAcidSubunitSugar,
  th as validateSubstancePolymer,
  XI as validateSubstancePolymerMonomerSet,
  JI as validateSubstancePolymerMonomerSetStartingMaterial,
  eh as validateSubstancePolymerRepeat,
  $I as validateSubstancePolymerRepeatRepeatUnit,
  YI as validateSubstancePolymerRepeatRepeatUnitDegreeOfPolymerisation,
  ZI as validateSubstancePolymerRepeatRepeatUnitStructuralRepresentation,
  ih as validateSubstanceProtein,
  nh as validateSubstanceProteinSubunit,
  fh as validateSubstanceReferenceInformation,
  dh as validateSubstanceReferenceInformationClassification,
  rh as validateSubstanceReferenceInformationGene,
  oh as validateSubstanceReferenceInformationGeneElement,
  ah as validateSubstanceReferenceInformationTarget,
  vh as validateSubstanceSourceMaterial,
  yh as validateSubstanceSourceMaterialFractionDescription,
  ch as validateSubstanceSourceMaterialOrganism,
  uh as validateSubstanceSourceMaterialOrganismAuthor,
  ph as validateSubstanceSourceMaterialOrganismHybrid,
  sh as validateSubstanceSourceMaterialOrganismOrganismGeneral,
  lh as validateSubstanceSourceMaterialPartDescription,
  Dh as validateSubstanceSpecification,
  hh as validateSubstanceSpecificationCode,
  mh as validateSubstanceSpecificationMoiety,
  Rh as validateSubstanceSpecificationName,
  wh as validateSubstanceSpecificationNameOfficial,
  gh as validateSubstanceSpecificationProperty,
  Ch as validateSubstanceSpecificationRelationship,
  Ih as validateSubstanceSpecificationStructure,
  Ah as validateSubstanceSpecificationStructureIsotope,
  _h as validateSubstanceSpecificationStructureIsotopeMolecularWeight,
  bh as validateSubstanceSpecificationStructureRepresentation,
  Oh as validateSupplyDelivery,
  Sh as validateSupplyDeliverySuppliedItem,
  Th as validateSupplyRequest,
  Eh as validateSupplyRequestParameter,
  Fh as validateTask,
  jh as validateTaskInput,
  Ph as validateTaskOutput,
  xh as validateTaskRestriction,
  zh as validateTerminologyCapabilities,
  Gh as validateTerminologyCapabilitiesClosure,
  Bh as validateTerminologyCapabilitiesCodeSystem,
  kh as validateTerminologyCapabilitiesCodeSystemVersion,
  qh as validateTerminologyCapabilitiesCodeSystemVersionFilter,
  Uh as validateTerminologyCapabilitiesExpansion,
  Vh as validateTerminologyCapabilitiesExpansionParameter,
  Mh as validateTerminologyCapabilitiesImplementation,
  Hh as validateTerminologyCapabilitiesSoftware,
  Lh as validateTerminologyCapabilitiesTranslation,
  Nh as validateTerminologyCapabilitiesValidateCode,
  tw as validateTestReport,
  Qh as validateTestReportParticipant,
  Xh as validateTestReportSetup,
  Jh as validateTestReportSetupAction,
  Kh as validateTestReportSetupActionAssert,
  Wh as validateTestReportSetupActionOperation,
  ew as validateTestReportTeardown,
  $h as validateTestReportTeardownAction,
  Zh as validateTestReportTest,
  Yh as validateTestReportTestAction,
  _w as validateTestScript,
  iw as validateTestScriptDestination,
  aw as validateTestScriptFixture,
  dw as validateTestScriptMetadata,
  ow as validateTestScriptMetadataCapability,
  rw as validateTestScriptMetadataLink,
  nw as validateTestScriptOrigin,
  cw as validateTestScriptSetup,
  sw as validateTestScriptSetupAction,
  pw as validateTestScriptSetupActionAssert,
  uw as validateTestScriptSetupActionOperation,
  yw as validateTestScriptSetupActionOperationRequestHeader,
  gw as validateTestScriptTeardown,
  mw as validateTestScriptTeardownAction,
  vw as validateTestScriptTest,
  lw as validateTestScriptTestAction,
  fw as validateTestScriptVariable,
  As as validateTiming,
  _s as validateTimingRepeat,
  bs as validateTriggerDefinition,
  Is as validateUsageContext,
  Sw as validateValueSet,
  ww as validateValueSetCompose,
  hw as validateValueSetComposeInclude,
  bw as validateValueSetComposeIncludeConcept,
  Aw as validateValueSetComposeIncludeConceptDesignation,
  Iw as validateValueSetComposeIncludeFilter,
  Dw as validateValueSetExpansion,
  Cw as validateValueSetExpansionContains,
  Rw as validateValueSetExpansionParameter,
  xw as validateVerificationResult,
  Ew as validateVerificationResultAttestation,
  Ow as validateVerificationResultPrimarySource,
  Tw as validateVerificationResultValidator,
  Fw as validateVisionPrescription,
  Pw as validateVisionPrescriptionLensSpecification,
  jw as validateVisionPrescriptionLensSpecificationPrism
};
